import ADMINPARKING from './adminParking/fr'
import AUTH from './auth/fr'
import CALENDAR from './calendar/fr'
import CAREER from './carriere/fr'
import CHAT from './chat/fr'
import COMMUNITY from './community/fr'
import DICTIONNAIRE from './dictionnaire/fr'
import DOCUMENT from './document/fr'
import EVENT from './event/fr'
import FICHEPOSTE from './ficheposte/fr'
import FORMATIONS from './formations/fr'
import GENERAL from './general/fr'
import IDEA from './idea/fr'
import LEAVE from './leave/fr'
import NEWSLETTER from './newsletter/fr'
import ONBOARDING from './onboarding/fr'
import OSPLANNER from './osplanner/fr'
import PROJECT from './project/fr'
import QUESTION_REPONSE from './question-reponse/fr'
import REMUNERATION_TRANSLATIONS from './remuneration/fr'
import SURVEY from './surveys/fr'
import TACHEADMINSTRATIVE from './tache_administrative/fr'
import TEMPS from './temps/fr'
import TRANSPORT from './transport/fr'
import USER_PROFILE from './user-profile/fr'
import USERDETAILS from './user/fr'
import FORFAIT from './forfait/fr'
// Le vocabulaire de l'import IA reste modulaire tout en étant exposé dans le dictionnaire français existant.
import COLLABORATOR from './collaborator-ai-import/fr'
export const locale = {
  lang: 'fr',
  data: {
    // Ce namespace dédié évite toute collision avec les anciennes clés COLLAB de l'écran historique.
    COLLABORATOR,
    TRANSLATOR: {
      SELECT: 'choisissez votre langue',
    },
    BSI: {
      LIST: {
        TITLE: 'Liste des campagnes BSI',
        CREATE: 'Générer une nouvelle campagne BSI',
        CAMPAIGN_NAME: 'Nom de la campagne',
        UPDATED_AT: 'Mise à jour',
        CREATED_BY: 'Créé par',
        DOWNLOAD_SUCCESS: 'Votre document a été bien téléchargé !',
        CAMPAIGN_DUPLICATED: 'Campagne dupliquée avec succès !',
        ERROR_DUPLICATE_CAMPAIGN: 'Erreur lors de la duplication de la campagne',
        CAMPAIGN_NAME_UPDATED: 'Nom de la campagne mis à jour avec succès !',
        ERROR_UPDATE_CAMPAIGN_NAME: 'Erreur lors de la mise à jour du nom de la campagne',
      },
      GENERATE: {
        CHOOSE_MODEL_TITLE: 'Choisissez votre modèle',
        LOADING: 'Chargement...',
        LOADING_TEMPLATES: 'Chargement des modèles...',
        RETRY: 'Réessayer',
        EMPTY: 'Aucun modèle disponible.',
        DECRYPTING: 'Décryptage...',
        DECRYPTING_IN_PROGRESS: 'Décryptage en cours...',
        CHOOSE_TEMPLATE: 'Choisir le modèle',
        PREVIEW: 'Aperçu',
        NO_PREVIEW: 'Aucun aperçu disponible pour ce modèle',
        CHOOSE_THIS_TEMPLATE: 'Choisir ce modèle',
        LOAD_ERROR: 'Erreur de chargement des modèles',
      },
      GENERATE_DOCUMENT: {
        TITLE: 'Génération du BSI',
        PHOTO: 'PHOTO',
        NAME: 'NOM ET PRÉNOM',
        FILTER_COLLABORATOR: 'Collaborateur',
        SEARCH_BY_COLLABORATOR_NAME: 'Rechercher par nom du collaborateur...',
        STATUS: 'STATUT',
        ALL_STATUSES: 'Tous les statuts',
        READ_FILTER: 'Lecture',
        ALL_READ_STATUSES: 'Tous les statuts de lecture',
        READ_COLUMN: 'LU',
        READ_YES: 'Lu',
        READ_NO: 'Non lu',
        ACTIONS: 'ACTIONS',
        DELETE_COLLAB_CONFIRM: 'Êtes-vous sûr de vouloir supprimer {{name}} ?',
        STATUS_DRAFT: 'Brouillon',
        STATUS_READY: 'Prêt à l\'envoi',
        STATUS_SENT: 'Envoyé',
        READY_SUCCESS: 'BSI marqué comme prêt à l\'envoi !',
        READY_ERROR: 'Erreur lors du passage du BSI au statut prêt à l\'envoi',
        SEND_SUCCESS: 'BSI envoyé avec succès !',
        SEND_ERROR: "Erreur lors de l'envoi du BSI",
        RETURN_TO_DRAFT_SUCCESS: 'BSI retourné au brouillon avec succès !',
        RETURN_TO_DRAFT_ERROR: 'Erreur lors du retour du BSI au brouillon',
        SEND_ALL: 'Envoyer à tous',
        SEND_ALL_CONFIRM: 'Êtes-vous sûr de vouloir envoyer les BSI à tous les collaborateurs ?',
        SEND_ALL_SUCCESS: 'Tous les BSI ont été envoyés avec succès !',
        SEND_ALL_MISSING_PDF: '{{count}} collaborateur(s) ignoré(s) : document non encore généré',
        NO_DOCS_TO_SEND: 'Aucun document à envoyer',
      },
      ADD_COLLAB: {
        TITLE: "Ajout d'un collaborateur",
        TARGET_LABEL: 'Cible:',
        SELECT_LABEL: 'Sélectionner:',
        TARGET_SINGLE: 'Collaborateur unique',
        TARGET_SITE: 'Site(s)',
        TARGET_SERVICE: 'Service(s)',
        TARGET_TEAM: 'Équipe(s)',
        TARGET_FONCTION: 'Fonction(s)',
        TARGET_ALL: 'Tous les employés',
        TARGET_PLACEHOLDER_SITE: 'Sélectionner un ou plusieurs sites',
        TARGET_PLACEHOLDER_SERVICE: 'Sélectionner un ou plusieurs services',
        TARGET_PLACEHOLDER_TEAM: 'Sélectionner une ou plusieurs équipes',
        TARGET_PLACEHOLDER_FONCTION: 'Sélectionner une ou plusieurs fonctions',
        EMPLOYEE_LABEL: 'Collaborateur:',
        PREVIEW: 'Prévisualiser',
        PREVIEW_COUNT: '{{count}} collaborateur(s)',
        CANCEL: 'Annuler',
        ADD: 'Ajouter',
      },
      SERVICE: {
        ERROR_LOAD_TEMPLATES: 'Erreur lors du chargement des templates',
        ERROR_CONNECT_SERVER: 'Impossible de se connecter au serveur.',
        ERROR_LOAD_TEMPLATE: 'Erreur lors du chargement du template',
        ERROR_CONNECT_SERVER_BACKEND_3001: 'Impossible de se connecter au serveur. Vérifiez que le backend est démarré sur le port 3001.',
        ERROR_TEMPLATE_NOT_FOUND: "Template non trouvé. Vérifiez l'UUID.",
        ERROR_SAVE: "Erreur lors de l'enregistrement",
        ERROR_DECRYPT: 'Erreur lors du décryptage du fichier',
      },
      DELETE: {
        TITLE: 'Supprimer la campagne',
        CONFIRM: 'Êtes-vous sûr de vouloir supprimer la campagne',
        IRREVERSIBLE: 'Cette action est irréversible.',
        IMPOSSIBLE: 'Suppression impossible.',
        DELETING: 'Suppression en cours...',
      },
      MODIFY: {
        TITLE: 'Gestion du BSI',
        STEP_CHOOSE_TEMPLATE: 'Choix du modèle',
        STEP_MODIFY_PREVIEW: 'Modification et visualisation',
        STEP_DOCUMENT: 'du document',
        STEP_GENERATE_DOCUMENT: 'Génération du document',
        EDITS_TITLE: 'Modifications',
        LIVE_PREVIEW_TITLE: 'Aperçu en temps réel',
        LOAD_TEMPLATE_ERROR: 'Erreur chargement template',
        LOAD_ERROR: 'Erreur lors du chargement',
        CONFIRM_NEXT_STEP: "Passer à l'étape suivante?",
        SAVED: 'Enregistré !',
        SAVE_SUCCESS: 'Document sauvegardé avec succès',
        VARIABLES_PLACEHOLDER: 'Variables',
        VARIABLES_SEARCH_PLACEHOLDER: 'Rechercher...',
        VARIABLES_NO_RESULTS: 'Aucun résultat trouvé',
        COLLABORATOR_PLACEHOLDER: '--',
        LOGO_TITLE: 'Logo du BSI',
        LOGO_HELP: 'Le logo est affiché en haut à droite sur chaque page du template.',
        LOGO_UPLOAD: 'Téléverser un logo',
        LOGO_FORMAT_INFO: 'Formats image acceptés. Taille maximale : 200 Ko.',
        LOGO_PREVIEW: 'Aperçu du logo',
        LOGO_SIZE: 'Taille du logo',
        LOGO_POSITION_TOP_RIGHT: 'Haut droite',
        LOGO_FORMAT_ERROR: 'Le fichier du logo doit être une image valide.',
        LOGO_SIZE_EXCEEDED: 'Le logo dépasse la taille maximale autorisée de 200 Ko.',
        CHART_DEBUG: {
          TITLE: 'Graphiques',
          HIDE: 'Masquer',
          SHOW: 'Afficher les graphiques',
          HINT: 'Ajoutez <code>?debugCharts=1</code> à l’URL pour l’afficher par défaut.',
          REMUNERATION: 'Rémunération',
          FIXE: 'Fixe',
          VARIABLE_INDIVIDUELLE: 'Variable indiv.',
          VARIABLE_COLLECTIVE: 'Variable coll.',
          CHARGES_SOCIALES: 'Charges sociales',
          EMPLOYEUR: 'Employeur',
          EMPLOYE: 'Employé',
          POLE_EMPLOI: 'Pôle emploi',
          RETRAITE: 'Retraite',
          SANTE: 'Santé',
          PREVOYANCE: 'Prévoyance',
        },
      },
    },
    CV: {
      UPLOADED_BY: 'Telechargé par',
      HIST_DOC: 'Historique des documents',
      DETAILSCANDIDATE: 'Détails candidat',
      METIER: 'Métier',
      POST: 'Poste Appliqué',
      CORRESPONDANCE: 'Correspondance',
      MAJ: 'MISE À JOUR ',
      VOIR: 'Voir',
      PROFIL: 'Profil du candidat',
      ANNEXP: 'Années d’expérience',
      OFFER: "Ajouter une offre d'emploi",
      VOIRDETAILS: 'Détails et modification du contrat',
      TYPECONTRAT: 'Type de contrat',
      NOMENTREPRISE: "Nom de l'entreprise",
      ADRESSEENTREPRISE: "Adresse de l'entreprise",
      TEMP_WORKER_GROUP: {
        TITLE: "Travailleur temporaire / Mise à disposition par un groupement d'employeurs",
        COMPANY_NAME: "Nom de l'entreprise",
        COMPANY_ADDRESS: "Adresse de l'entreprise",
      },
      MOTIFDEBUTCONTRAT: 'Motif de début du contrat',
      Temps: 'Temps',
      NOMBREHEURES: "Nombre d'heures",
      CATEGORIE: 'Catégorie socio-professionnelle',
      Matricule: 'Matricule',
      MOTIFFINCONTRAT: 'Motif de fin du contrat',
      DATE_FIN_PERIODE_ESSAI_1: "Date fin de première période d'essai",
      DATE_FIN_PERIODE_ESSAI_2: "Date fin de deuxième période d'essai",
      RENSEIGNER_PERIODE_ESSAI_1: "Veuillez d'abord renseigner la date de fin de première période d'essai",
      GROUPECONGE: 'Groupe de congés',
      ADDCONTRAT: 'Ajouter un contrat',
      CONTRAT: 'Contrat',
      CONTRACT_DATE_CONFLICT: 'Problème de chevauchement de dates de contrats.',
      MESOFFRESEMPLOI: "Mes Offres d'emploi",
      Titre: 'Titre',
      FICHEPOSTE: 'Fiche de poste',
      DATEDEBUT: 'Date de début',
      DATEFIN: 'Date de fin',
      CANDIDATURERECU: 'Candidatures reçues',
      PUBLIER: "Publier l'offre dans le portail",
      COPIER: 'Copier le lien du portail',
      NAVIGATE: 'Ouvrir la page du portail',
      FERMER: 'Fermer cette offre',
      TOASTFERMER: "L'offre d'emploi a été fermée avec succès",
      // La zone de découverte distingue la recherche IA de l'affinage local des résultats.
      AI_SEARCH_PLACEHOLDER: 'Décrivez le profil que vous recherchez...',
      SEARCH_ACTION: 'Rechercher',
      CLEAR_SEARCH: 'Effacer la recherche',
      SEARCH_PLACEHOLDER: 'Rechercher un CV...',
      FILTER_JOB: 'Poste appliqué',
      FILTER_NO_JOB: 'Aucun poste',
      FILTER_SKILLS: 'Compétences',
      FILTER_COUNTRY: 'Pays',
      FILTER_CITY: 'Ville',
      NO_RESULTS: 'Aucun CV ne correspond à votre recherche.',
      RESULTS_FOUND: 'CV trouvés',
      CLARIFY_TITLE: 'Préciser votre recherche',
      CLARIFY_SUBTITLE: 'Pour obtenir des résultats plus pertinents, veuillez préciser votre demande :',
      CLARIFY_INTRO: 'Pour affiner votre recherche pour',
      CLARIFY_ANSWER_LABEL: 'Votre réponse :',
      CLARIFY_ANSWER_PLACEHOLDER: 'Ex: Je cherche un développeur Angular avec 3 ans d\'expérience, basé à Paris, en CDI...',
      SEARCH_ANYWAY: 'Rechercher quand même',
      IMPROVE_SEARCH: 'Lancer la recherche améliorée',
      // Libellés accessibles des colonnes visuellement sans titre dans la liste des candidats.
      FAVORITE: 'Favori',
      PHOTO: 'Photo',
      FAVORITE_CANDIDATE: 'Candidat favori',
      NOT_FAVORITE_CANDIDATE: 'Candidat non favori',
      CANDIDATE_PHOTO_ALT: 'Photo de {{name}}',
      FAVORITES_ONLY: 'Favoris uniquement',
      // Les cartes reflètent les candidats récents et les candidatures rattachées aux offres actives.
      STATISTICS: {
        NEW_CANDIDATES_30_DAYS: 'Candidats ajoutés (30 jours)',
        IN_PROCESS: 'Candidats en process',
        HIRED: 'Candidats embauchés',
        OVERDUE: 'Candidats en retard',
      },
      // Libellés de sélection et de traitement groupé des candidats de la CVthèque.
      BULK_ACTIONS: {
        CANDIDATE_SELECTED: 'candidat sélectionné',
        CANDIDATES_SELECTED: 'candidats sélectionnés',
        ASSIGN_SELECTED: 'Assigner une offre',
        DELETE_SELECTED: 'Supprimer la sélection',
        SELECT_VISIBLE: 'Sélectionner tous les candidats visibles',
        SELECT_CANDIDATE: 'Sélectionner le candidat',
        ASSIGN_TITLE: 'Assigner une offre aux candidats sélectionnés',
        SELECT_OFFER: 'Sélectionnez une offre',
        SELECT_OFFERS: 'Sélectionnez les offres',
        PROGRESS: '{{processed}} / {{total}} candidats traités',
        ASSIGN: 'Assigner',
        CLOSE: 'Fermer',
        ASSIGN_SUCCESS: '{{count}} candidats ont été assignés avec succès.',
        ASSIGN_PARTIAL: '{{success}} candidats assignés, {{failed}} échecs. Les candidats en échec restent sélectionnés.',
        DELETE_TITLE: 'Supprimer les candidats sélectionnés',
        DELETE_CONFIRMATION: 'Êtes-vous sûr de vouloir supprimer tous les candidats sélectionnés ?',
        DELETE_SUCCESS: '{{count}} candidats ont été supprimés avec succès.',
        DELETE_PARTIAL: '{{success}} candidats supprimés, {{failed}} échecs. Les candidats en échec restent sélectionnés.',
      },
      CLARA_FILTER: {
        TITLE: 'Filtre des candidats de l’étape',
        AVATAR_ALT: 'Clara, assistante de recrutement',
        OPEN: 'Ouvrir Clara pour l’étape {{section}}',
        DISCUSS: 'Discuter avec Clara',
        CLOSE: 'Fermer Clara',
        // Libellés de suppression de l’historique sans réinitialisation du filtre actif.
        CLEAR_HISTORY: 'Vider l’historique de la discussion',
        CLEAR_HISTORY_TITLE: 'Vider la discussion avec Clara',
        CLEAR_HISTORY_CONFIRMATION: 'Voulez-vous vraiment supprimer tout l’historique de cette discussion ? Le filtre actif et les candidats affichés ne seront pas modifiés.',
        CLEAR_HISTORY_ACTION: 'Vider la discussion',
        SECTION: 'Étape sélectionnée',
        INPUT_LABEL: 'Critères professionnels pour Clara',
        PLACEHOLDER: 'Ex. Montre-moi jusqu’à 5 candidats maîtrisant Angular avec 3 ans d’expérience...',
        // La dictée Clara utilise uniquement le STT natif du navigateur/système et ne déclenche aucun envoi automatique.
        DICTATION: {
          START: 'Dicter l’instruction',
          STOP: 'Arrêter la dictée',
          WAITING: 'Écoute en cours, transcription en attente…',
          LISTENING: 'Dictée en cours…',
          UNSUPPORTED: 'La dictée vocale native n’est pas prise en charge par ce navigateur.',
          HTTPS_REQUIRED: 'La dictée vocale nécessite une connexion HTTPS sécurisée.',
          PERMISSION_DENIED: 'L’accès au microphone a été refusé. Autorisez-le dans les paramètres du navigateur.',
          MICROPHONE_UNAVAILABLE: 'Aucun microphone disponible n’a pu être utilisé.',
          RECOGNITION_ERROR: 'La dictée vocale a été interrompue. Veuillez réessayer.',
          START_ERROR: 'Impossible de démarrer la dictée vocale.',
        },
        SEND: 'Envoyer',
        LOADING: 'Un petit instant, j’analyse les profils…',
        RESET: 'Réinitialiser',
        REAPPLY: 'Réappliquer',
        REAPPLY_REQUEST: 'Réapplique les critères professionnels actifs sans les modifier.',
        ACTIVE: 'Critères actifs',
        ACTIVE_FILTER_SINGULAR: '1 filtre actif',
        ACTIVE_FILTER_PLURAL: '{{count}} filtres actifs',
        STALE: 'À réappliquer',
        STALE_HELP: 'La population de cette étape a changé. Tous les candidats sont affichés jusqu’à la réapplication explicite du filtre.',
        STATE_INVALID: 'Nouvelle recherche nécessaire',
        STATE_INVALID_SHORT: 'Recherche à renouveler',
        STATE_INVALID_HELP: 'Cette recherche n’est plus utilisable. Décrivez une nouvelle recherche pour continuer.',
        NO_ACTIVE_CRITERIA: 'Aucun critère actif.',
        COUNT: '{{filtered}} sur {{total}} candidats affichés',
        WELCOME: 'Décrivez votre recherche. Je travaillerai uniquement avec les candidats de cette étape.',
        // Le texte fixe du radar rappelle que la visualisation reste une aide explicative et non un classement.
        RADAR_TITLE: 'Comparaison des candidats',
        RADAR_HINT: 'Comparaison visuelle fondée sur les éléments documentés des profils. Elle ne constitue ni un classement ni une décision automatique.',
        RADAR_CANVAS_FALLBACK: 'Graphique radar de comparaison des candidats.',
        // Les déplacements Clara restent des plans explicites soumis à confirmation humaine.
        MOVEMENT: {
          TITLE: 'Déplacements proposés',
          WARNING: 'Aucun candidat ne sera déplacé avant votre confirmation.',
          CONFIRM: 'Confirmer ({{count}})',
          CONFIRMATION: 'Nombre de déplacements à confirmer : {{count}}. Cette action modifiera immédiatement les colonnes du Kanban.',
          AUTO_EMAIL: 'Cette étape peut déclencher l’envoi automatique prévu par le processus de recrutement.',
          EXECUTING: 'Déplacements en cours…',
          MOVED_COUNT: '{{moved}} déplacement(s) effectué(s) sur {{total}}.',
          STATUS: {
            PENDING: 'À confirmer',
            EXECUTING: 'En cours',
            COMPLETED: 'Terminé',
            PARTIAL: 'Partiel',
            FAILED: 'Échec',
            STALE: 'Expiré',
          },
          TOASTS: {
            SUCCESS: '{{moved}} déplacement(s) effectué(s).',
            PARTIAL: '{{moved}} déplacement(s) effectué(s) sur {{total}}. Le Kanban a été rechargé.',
            FAILED: 'Aucun déplacement n’a pu être effectué. Le Kanban a été rechargé.',
            STALE: 'Le Kanban a changé depuis la proposition de Clara. Demandez-lui de préparer un nouveau déplacement.',
          },
        },
        // Les actions proposées par Clara sont des boutons explicites complétés par une saisie libre du recruteur.
        SUGGESTIONS: {
          TITLE: 'Choisissez une suite',
          CUSTOM_LABEL: 'Autre demande',
          CUSTOM_PLACEHOLDER: 'Écrivez votre propre instruction…',
          CUSTOM_SEND: 'Envoyer cette instruction à Clara',
        },
        STRICT_MATCHES: 'J’ai trouvé {{matching}} candidats sur {{total}} qui correspondent à votre recherche.',
        STRICT_MATCHES_SINGULAR: 'J’ai trouvé 1 candidat sur {{total}} qui correspond à votre recherche.',
        STRICT_LIMITED: 'J’ai trouvé {{matching}} candidats sur {{total}} qui correspondent à votre recherche. Je vous affiche les {{displayed}} premiers.',
        STRICT_FEWER: 'J’ai trouvé {{matching}} candidats sur {{total}} qui correspondent à votre recherche, soit moins que les {{requested}} demandés.',
        STRICT_FEWER_SINGULAR: 'J’ai trouvé 1 candidat sur {{total}} qui correspond à votre recherche, soit moins que les {{requested}} demandés.',
        STRICT_EXACT: 'J’ai trouvé {{matching}} candidats sur {{total}} qui correspondent à votre recherche.',
        STRICT_EXACT_SINGULAR: 'J’ai trouvé 1 candidat sur {{total}} qui correspond à votre recherche.',
        NO_MATCHES: 'Je n’ai trouvé aucun candidat correspondant à votre recherche dans cette étape.',
        GENERIC_RESPONSE: 'Je n’ai pas modifié les candidats affichés.',
        FILTER_RESET: 'J’ai réinitialisé la recherche. Tous les candidats de cette étape sont de nouveau affichés.',
        RESULT_DISCARDED: 'Le résultat de Clara a été écarté, car la population de l’étape ou l’état signé n’a pas pu être validé. Tous les candidats restent visibles.',
        CRITERIA_REQUIRED: 'Indiquez au moins un critère professionnel objectif avant de demander un nombre de candidats.',
        // Explain non-mutating clarification and provider safety refusals directly inside the Clara discussion.
        CLARIFICATION_REQUIRED: 'Précisez l’action souhaitée. Le filtre et les candidats affichés restent inchangés.',
        GUARDRAIL_BLOCKED: 'Je n’ai pas pu traiter cette demande, car elle a été bloquée par les règles de sécurité du service IA. Le filtre et les candidats affichés restent inchangés.',
        CANDIDATE_FALLBACK: 'Candidat',
        PROTECTED_IGNORED: {
          MIXED: 'Je n’ai pas utilisé {{categories}} pour cette recherche.\nJ’ai filtré les candidats uniquement selon les critères professionnels de votre demande : {{criteria}}.',
          MIXED_FALLBACK: 'Je n’ai pas utilisé {{categories}} pour cette recherche.\nLes résultats reposent uniquement sur les autres critères professionnels de votre demande.',
          ONLY: 'Je ne peux pas filtrer les candidats selon {{categories}}. Vous pouvez plutôt utiliser leur expérience, leurs compétences ou leurs certifications.',
          GENERIC: 'Je ne peux pas utiliser ce critère pour filtrer les candidats. Vous pouvez plutôt choisir un critère professionnel.',
          RESULTS: {
            MATCHES: 'J’ai trouvé {{matching}} candidats sur {{total}} qui correspondent à ces critères professionnels.',
            MATCHES_SINGULAR: 'J’ai trouvé 1 candidat sur {{total}} qui correspond à ces critères professionnels.',
            LIMITED: 'J’ai trouvé {{matching}} candidats sur {{total}} qui correspondent à ces critères professionnels. Je vous affiche les {{displayed}} premiers.',
            FEWER: 'J’ai trouvé {{matching}} candidats sur {{total}} qui correspondent à ces critères professionnels, soit moins que les {{requested}} demandés.',
            FEWER_SINGULAR: 'J’ai trouvé 1 candidat sur {{total}} qui correspond à ces critères professionnels, soit moins que les {{requested}} demandés.',
            NO_MATCHES: 'Je n’ai trouvé aucun candidat correspondant à ces critères professionnels dans cette étape.',
          },
          CATEGORIES: {
            AGE: 'l’âge ou la date de naissance',
            GENDER: 'le sexe, le genre ou la grossesse',
            ORIGIN: 'l’origine, la couleur ou l’ethnie',
            RELIGION: 'la religion ou les croyances',
            HEALTH: 'le handicap ou la santé',
            PERSONAL: 'la situation familiale, matrimoniale ou personnelle',
            ORIENTATION: 'l’orientation sexuelle',
            IDENTITY: 'le nom ou l’identité',
            APPEARANCE: 'la photo ou l’apparence physique',
            GENERIC: 'un critère non professionnel',
          },
        },
        POLICY: {
          WARNING: 'Attention : Fonder un recrutement sur {{categories}} n’est pas seulement discriminatoire : c’est interdit par la loi.',
          // Explain that an explicit disability/RQTH criterion was applied while keeping a human compliance check.
          INCLUSION_WARNING: 'Ce critère explicite de handicap ou de RQTH a été appliqué. Vérifiez qu’il correspond à une mesure d’inclusion ou à une priorité d’embauche autorisée dans votre contexte.',
          BLOCKED_DETAIL: 'Je ne peux pas appliquer cette demande. Les candidats affichés et les critères actuels restent inchangés.',
        },
        ERRORS: {
          CRITERIA_REQUIRED: 'Des critères professionnels valides sont requis.',
          LIMIT_200: 'Cette étape dépasse la limite de 200 candidats et ne peut pas être filtrée par Clara.',
          QUOTA: 'Le quota IA disponible est insuffisant pour cette analyse.',
          RATE_LIMIT: 'Trop de demandes ont été envoyées à Clara. Patientez brièvement, puis réessayez.',
          TIMEOUT: 'L’analyse a expiré. Le filtre précédent reste inchangé.',
          INVALID_STATE: 'Cette session Clara est invalide. Réinitialisez le filtre, puis appliquez-le de nouveau.',
          STATE_EXPIRED: 'Cette session Clara a expiré. Réinitialisez le filtre, puis appliquez-le de nouveau.',
          STATE_UNAVAILABLE: 'L’état signé de Clara est indisponible. Réinitialisez le filtre ou décrivez-en un nouveau.',
          POPULATION_CHANGED: 'Cette étape a changé pendant l’analyse. Les candidats ont été actualisés ; réappliquez le filtre.',
          CONTENT_TOO_LARGE: 'Le contenu candidat requis pour cette analyse est trop volumineux pour être traité intégralement par Clara.',
          // Keep a dedicated panel fallback if a safety refusal cannot be rendered as a chat event.
          GUARDRAIL_BLOCKED: 'La demande a été bloquée par les règles de sécurité du service IA. Le filtre précédent reste inchangé.',
          GENERIC: 'Clara ne peut pas appliquer ce filtre pour le moment. Le filtre précédent reste inchangé.',
        },
        TOASTS: {
          APPLIED: 'Le filtre Clara a été appliqué à cette étape.',
          RESET: 'Le filtre Clara a été réinitialisé.',
          HISTORY_CLEARED: 'L’historique de la discussion Clara a été supprimé. Le filtre actif est conservé.',
          INFO: 'Clara a conservé l’état actuel du filtre.',
          RESULT_DISCARDED: 'Le résultat obsolète de Clara a été écarté. Tous les candidats restent visibles.',
          PROTECTED: 'Les critères protégés ont été ignorés.',
          ALERT: 'Clara a appliqué la demande avec un avertissement.',
          BLOCKED: 'Clara a bloqué ce critère et conservé les résultats actuels.',
          // Notify the recruiter without presenting a provider guardrail as a temporary technical failure.
          GUARDRAIL_BLOCKED: 'Demande bloquée par les règles de sécurité du service IA. Le filtre actuel est conservé.',
          ERROR_CRITERIA_REQUIRED: 'Ajoutez au moins un critère professionnel valide.',
          ERROR_LIMIT_200: 'Clara peut analyser au maximum 200 candidats par étape.',
          ERROR_QUOTA: 'Quota IA insuffisant pour filtrer les candidats.',
          ERROR_RATE_LIMIT: 'Trop de demandes Clara. Patientez brièvement, puis réessayez.',
          ERROR_TIMEOUT: 'Le délai d’analyse de Clara est dépassé.',
          ERROR_INVALID_STATE: 'La session Clara est invalide. Réinitialisez et appliquez de nouveau le filtre.',
          ERROR_STATE_EXPIRED: 'La session Clara a expiré. Réinitialisez et appliquez de nouveau le filtre.',
          ERROR_STATE_UNAVAILABLE: 'L’état signé de Clara est indisponible. Réinitialisez ou démarrez un nouveau filtre.',
          ERROR_POPULATION_CHANGED: 'La population de l’étape a changé. Les candidats ont été actualisés.',
          ERROR_CONTENT_TOO_LARGE: 'Le contenu candidat est trop volumineux pour être analysé par Clara.',
          ERROR_GENERIC: 'Impossible d’appliquer le filtre Clara.',
        },
        ADVISORY: 'Clara est un outil d’aide au filtrage. Le recruteur reste responsable de l’évaluation et de toute décision.',
      },
      // Le seuil est un filtre local indépendant de Clara et n’altère jamais son état signé.
      KANBAN_SCORE_THRESHOLD: {
        LABEL: 'Seuil score total pour {{section}}',
        HELP: 'Afficher les candidats dont score_total est supérieur ou égal à ce seuil. 0 affiche tous les candidats.',
      },
      // Le déplacement groupé réutilise les mutations unitaires existantes et peut donc produire un résultat partiel.
      KANBAN_BULK_MOVE: {
        OPEN: 'Déplacer les {{count}} candidats visibles de {{section}}',
        TITLE: 'Déplacer les candidats filtrés',
        SUMMARY: '{{count}} candidat(s) visible(s) dans {{source}} avec un seuil de {{threshold}} %.',
        TARGET: 'Colonne de destination',
        SELECT_TARGET: 'Sélectionner une colonne',
        AUTO_EMAIL_WARNING: 'Cette destination peut déclencher les emails automatiques configurés pour chaque candidat.',
        NON_ATOMIC_WARNING: 'Les déplacements sont effectués l’un après l’autre. En cas d’erreur, certains candidats peuvent avoir été déplacés avant l’arrêt.',
        CONFIRM: 'Déplacer ({{count}})',
        PROGRESS: 'Déplacement groupé en cours.',
        SUCCESS: '{{moved}} candidat(s) déplacé(s).',
        PARTIAL: '{{moved}} candidat(s) déplacé(s) sur {{total}}. Le Kanban a été actualisé.',
        FAILED: 'Aucun candidat n’a pu être déplacé. Le Kanban a été actualisé.',
        STALE: 'La colonne ou le workflow a changé. Actualisez le Kanban avant de recommencer.',
      },
      // Le comparatif candidats couvre tous les libellés internes, publics, modaux, erreurs et états vides.
      CANDIDATE_COMPARISON: {
        // Ce libellé court évite de surcharger les cartes candidat.
        ADD: 'Comparer',
        REMOVE: 'Retirer {{name}} du comparatif',
        SELECTED: 'Sélectionné',
        LIMIT_REACHED: 'Vous pouvez comparer au maximum 5 candidats.',
        MINIMUM_REQUIRED: 'Sélectionnez au moins 2 candidats pour lancer un comparatif.',
        COMPARE: 'Comparer',
        HISTORY: 'Comparatifs enregistrés',
        GENERATE_TITLE: 'Générer un comparatif de candidats',
        // Les demandes explicites de classement ou recommandation restent possibles via les instructions complémentaires.
        AI_HINT: 'Clara crée un tableau factuel à partir des parcours disponibles. Vous pouvez demander un classement, un score ou une recommandation dans les instructions complémentaires ; la décision finale reste humaine.',
        CUSTOM_INSTRUCTIONS: 'Instructions complémentaires (facultatif)',
        CUSTOM_INSTRUCTIONS_PLACEHOLDER: 'Ex. Ajoute une section sur les environnements internationaux et détaille les certifications utiles au poste.',
        ANONYMIZE: 'Anonymiser les candidats',
        ANONYMIZE_HINT: 'Le nom, la photo et les coordonnées seront retirés. La date de naissance et l’âge restent disponibles.',
        GENERATING: 'Génération en cours…',
        // La progression est une estimation temporelle de trente-cinq secondes par candidat comparé.
        GENERATING_PROGRESS: 'Génération en cours — {{percent}} %',
        CANCEL: 'Annuler',
        CLOSE: 'Fermer',
        LIST_TITLE: 'Historique des comparatifs',
        LIST_HINT: 'Retrouvez les comparatifs encore disponibles pour cette offre.',
        DETAIL_TITLE: 'Comparatif de candidats',
        OPEN: 'Ouvrir',
        DELETE: 'Supprimer',
        DELETE_TITLE: 'Supprimer le comparatif',
        DELETE_CONFIRMATION: 'Voulez-vous supprimer définitivement ce comparatif et ses liens de partage ?',
        DELETE_SUCCESS: 'Le comparatif a été supprimé.',
        DELETE_FAILED: 'Le comparatif n’a pas pu être supprimé.',
        ANONYMIZED: 'Anonymisé',
        EXPIRES_AT: 'Expire le',
        CREATED_AT: 'Créé le',
        CREATED_BY: 'Créé par',
        CANDIDATES: 'candidats',
        RECEIVED_COMMENTS: 'Commentaires reçus',
        BACK_TO_CANDIDATES: 'Retour aux candidats',
        BACK_TO_HISTORY: 'Retour aux comparatifs',
        LOADING: 'Chargement du comparatif…',
        LOAD_FAILED: 'Impossible de charger ce comparatif.',
        EMPTY_HISTORY: 'Aucun comparatif enregistré',
        EMPTY_HISTORY_HINT: 'Sélectionnez 2 à 5 candidats dans le Kanban pour créer le premier comparatif.',
        PREVIOUS: 'Précédent',
        NEXT: 'Suivant',
        PAGE: 'Page {{page}}',
        PAGINATION: 'Pagination des comparatifs',
        TABLE_LABEL: 'Tableau comparatif des candidats',
        // Cet avertissement rappelle explicitement que le comparatif ne remplace jamais la décision humaine.
        HUMAN_DECISION_NOTICE: 'Ce comparatif est une aide factuelle à la décision. L’IA n’est pas conçue pour recommander, classer ou sélectionner des candidats. La décision finale doit toujours être prise par une personne habilitée.',
        // Les radars comparent une adéquation relative à l’offre et neutralisent explicitement les axes non exigés.
        RADAR_REGION: 'Comparaison visuelle des candidats avec les exigences de l’offre',
        RADAR_HINT: 'Chaque score mesure l’adéquation avec l’offre sur 5. La ligne en pointillés représente une exigence entièrement satisfaite ; un axe sans exigence explicite attribue 5/5 à tous les candidats.',
        RADAR_TARGET: 'Exigence satisfaite (5/5)',
        RADAR_NOT_REQUIRED: 'aucune exigence explicite, score neutralisé à 5/5',
        RADAR_CANVAS_FALLBACK: 'Le graphique radar ne peut pas être affiché dans ce navigateur.',
        CRITERION: 'Critère',
        NOT_AVAILABLE: 'Non renseigné',
        EXPORT_PDF: 'Exporter en PDF',
        EXPORT_FAILED: 'L’export PDF n’a pas pu être généré.',
        SHARE: 'Partager',
        SHARE_TITLE: 'Partager le comparatif',
        SHARE_HINT: 'Sélectionnez les collaborateurs autorisés. Chacun recevra par e-mail un lien temporaire protégé par un code.',
        LINK_VALIDITY_HOURS: 'Durée de validité (heures)',
        LINK_VALIDITY_HINT: 'Entre 1 et 720 heures. La durée par défaut est de 72 heures.',
        NOTIFICATION_RECIPIENTS: 'Collaborateurs autorisés',
        SEARCH_COLLABORATORS: 'Rechercher un collaborateur…',
        REMOVE_RECIPIENT: 'Retirer {{name}} des destinataires autorisés',
        CREATE_LINK: 'Créer un lien',
        COPY_LINK: 'Copier le lien',
        REVOKE_LINK: 'Révoquer',
        LINK_CREATED: 'Le lien public a été créé.',
        LINK_CREATED_AND_SENT: 'Le lien sécurisé a été créé et envoyé aux destinataires.',
        LINK_COPIED: 'Le lien public a été copié.',
        LINK_REVOKED: 'Le lien public a été révoqué.',
        SHARE_FAILED: 'Impossible de créer le lien public.',
        COPY_FAILED: 'Impossible de copier le lien.',
        REVOKE_FAILED: 'Impossible de révoquer le lien.',
        SHARES_LOAD_FAILED: 'Impossible de charger les liens existants.',
        ACTIVE_LINKS: 'Liens créés',
        NO_LINKS: 'Aucun lien public n’a encore été créé.',
        ACTIVE: 'Actif',
        REVOKED: 'Révoqué',
        RECIPIENTS: 'destinataires',
        PUBLIC_BADGE: 'Consultation externe sécurisée',
        PUBLIC_TITLE: 'Comparatif de candidats',
        PUBLIC_PAGE_TITLE: 'Comparatif de candidats – {{offer}}',
        // Un partage peut contenir une analyse décisionnelle demandée par le recruteur, sans remplacer sa responsabilité finale.
        PUBLIC_HINT: 'Ce comparatif peut inclure un classement ou une recommandation demandé par le recruteur. Il constitue une aide à la décision et ne remplace pas la décision humaine finale.',
        EXPIRED_OR_INVALID: 'Ce lien n’est plus disponible',
        EXPIRED_OR_INVALID_HINT: 'Le lien est invalide, expiré ou a été révoqué. Contactez la personne qui vous l’a transmis.',
        COMMENTS_TITLE: 'Donner un avis par candidat',
        COMMENTS_HINT: 'Votre commentaire est privé et transmis à l’équipe de recrutement. Les commentaires précédents et les notes RH ne sont pas affichés.',
        // Ces libellés sont réservés au détail authentifié et ne sont jamais utilisés sur la page publique.
        INTERNAL_COMMENTS_TITLE: 'Commentaires externes reçus',
        INTERNAL_COMMENTS_HINT: 'Ces commentaires sont visibles uniquement par l’équipe de recrutement depuis ce comparatif.',
        NO_INTERNAL_COMMENTS: 'Aucun commentaire externe n’a encore été reçu pour ce comparatif.',
        COMMENT_AUTHOR: 'Par',
        COMMENT: 'Commenter',
        NAME: 'Nom complet',
        EMAIL: 'Adresse e-mail',
        VERIFICATION_HINT: 'Saisissez l’adresse e-mail à laquelle ce comparatif a été envoyé.',
        SECURE_ACCESS: 'Accès sécurisé',
        SECURE_ACCESS_TITLE: 'Vérifiez votre adresse e-mail',
        SECURE_ACCESS_HINT: 'Pour consulter ce comparatif, saisissez l’adresse e-mail sélectionnée par la personne qui l’a partagé. Un code de vérification vous sera envoyé.',
        SEND_CODE: 'Envoyer le code',
        CODE_SENT: 'Si l’adresse peut recevoir le message, un code de vérification a été envoyé.',
        CODE_HINT: 'Saisissez le code à six chiffres reçu par e-mail. Il est valable 10 minutes.',
        VERIFICATION_CODE: 'Code de vérification',
        VERIFY: 'Vérifier',
        BACK: 'Retour',
        INVALID_CODE: 'Le code est invalide ou expiré.',
        VERIFICATION_FAILED: 'La vérification ne peut pas être démarrée pour le moment.',
        VISITOR_SESSION_EXPIRED: 'Votre accès a expiré. Vérifiez de nouveau votre adresse e-mail.',
        COMMENT_PRIVATE_HINT: 'Le commentaire sera conservé dans ce comparatif et ne sera pas affiché aux personnes qui consultent le lien public.',
        COMMENT_EDITABLE_HINT: 'Vous pouvez modifier ce commentaire tant que cette page reste ouverte. Il ne sera plus affiché si vous revenez plus tard.',
        SEND_COMMENT: 'Envoyer le commentaire',
        EDIT_COMMENT: 'Modifier le commentaire',
        UPDATE_COMMENT: 'Mettre à jour le commentaire',
        COMMENT_SENT: 'Commentaire envoyé',
        COMMENT_UPDATED: 'Commentaire mis à jour',
        COMMENT_FAILED: 'Le commentaire n’a pas pu être envoyé.',
        COMMENT_UPDATE_FAILED: 'Le commentaire n’a pas pu être mis à jour.',
        GENERATION_FAILED: 'La génération du comparatif a échoué.',
        QUOTA_EXCEEDED: 'Les crédits disponibles sont insuffisants pour ce comparatif.',
        TEMPORARY_FAILURE: 'Le service est temporairement indisponible. Réessayez dans quelques instants.',
        INPUT_TOO_LARGE: 'Les données cumulées des candidats sont trop volumineuses pour ce comparatif.',
      },
    },
    OFFRE: {
      SELECTEDCRITERE: 'Critères de sélection',
      CRITERESPLACEHOLDER:
        "Le candidat doit venir d'une grande école, doit avoir au moins 5 ans d'expérience après le diplôme, etc...",
      CRITERS:
        "Saisissez ici les critères spécifiques que les candidats doivent remplir pour ce poste. Par exemple : diplôme requis, type d'école, années d'expérience minimum, compétences spécifiques, etc.Ces informations aident à préciser vos attentes et orienter les candidatures.",
      COMPETENCES: 'Compétences',
      COMPETENCES_INFO: 'Veuillez sélectionner une compétence parmi celles proposées dans la liste.',
    },

    MENU: {
      ENREGISTRER: 'Enregistrer',
      PAUSE: 'Pause',
      TRAVAIL: 'Travail',
      DURRETRAVAIL: 'durée',
      PERIODE: 'Période',
      TOASTERALERT: 'Veuillez enregistrer les modifications avant cette action.',
      HEURETRAVAIL: 'heures',
      DETAILS: 'Details',
      MES_COURRIERS: 'Mes Courriers',
      MES_BSI: 'Mes BSI',
      ET: 'et',
      DUREE: 'durée',
      JOUR: 'Jour',
      NOM: 'nom',
      PRENOM: 'prénom',
      IMAGE: 'image',
      NONVALID: 'Non valide',
      ENATTENTE: 'En attente',
      VALIDER: 'Valide',
      SUIVITEMPS: 'Suivi des temps',
      SELECTUSER: 'Choisir le collaborateur',
      ADDSUIVITEMPS: 'Déclarer des activités',
      DECLARER_ALERTE: 'Déclarer une alerte',
      SUIVI_TEMPS_SUBTITLE: 'Déclarez vos heures de travail',
      HORAIRES: 'Horaires',
      PROJET: 'Projet',
      SELECT_PROJET: 'Sélectionner un projet...',
      AUCUN: 'Aucun',
      TEMPSEQUIPE: 'Temps de mon équipe',

      ADDSUIVITEMPSSUCCESS: 'date ajoutée avec succès',
      DATEFIN: 'Date de fin',
      SUIVITEMPSMSG:
        'Es-tu sûr(e) de vouloir terminer ta journée? En confirmant, le temps sera enregistré et tu ne pourras plus redémarrer le compteur.',
      TEMPS: 'Temps',
      MESTEMPS: 'Mes temps',
      HEURES_DEPASSEES: 'Dépassement des heures contractuelles',
      JOURS_CONSECUTIFS_DEPASSES: 'Dépassement des jours consécutifs autorisés',
      MES_REMUNERATIONS: 'Mes Rémunérations',

      GESTIONTEMPS: 'Temps',
      PARAMETRE: 'Paramètres',
      SECURITY: 'Sécurité',
      FLEXISPACE: 'Flexispace',
      TASKS: 'Mes tâches',
      CAREER: 'Ma Carrière',
      MY_OBJECTIVES: 'Mes Objectifs',
      CAREERS_MANAGEMENT: 'Gestion des carrières',
      SKILLS_MANAGEMENT: 'Compétences',
      MY_FLEXISPACE: 'Mon Flexispace',
      MESCOLLEGUES: 'Mes collègues',
      MESCONGES: 'Mes congés',
      Annuaire: 'Annuaire',
      MY_EVENT: 'Mes événements',
      Events: 'Événements',
      Useridea: 'La boîte à idées',
      AdminIdea: 'Idées',
      Entretiens: 'Entretiens',
      PREONBOARDING: 'Pré-boarding & Onboarding',
      SUIVRE: 'Suivre',
      FORMATIONDASH: 'Formation',
      PLANNIFIERDASH: 'Planifier',
      NEW: 'Nouveau',
      ACTIONS: 'Actes',
      CREATE_POST: 'Créer un nouveau Post',
      PAGES: 'Pages',
      FEATURES: 'Fonctionnalités',
      BUILDER: 'Applications',
      DASHBOARD: 'Tableau de Bord',
      USER_PROFIL: 'Profil du collaborateur',
      COLLAB: 'Collaborateurs',
      ENTRE: 'Entreprise',
      SITE: 'Sites',
      SERVICE: 'Services',
      EQUIPE: 'Equipes',
      EQUIPETR: 'Equipes transverses',
      ACTIVITY: 'Rendez-vous',
      MATERIAL: 'Matériels',
      MY_ACTIVITY: 'Mes Rendez-vous',
      MesEnquetes: 'Mes Enquêtes',
      STRATEGIE: 'Libre service',
      COMMUNITY: 'Communautés',
      MY_COMMUNITIES: 'Mes Communautés',
      REPORTING: 'Reporting',
      // Keep the preview status visible everywhere the experimental module appears in navigation.
      REPORT_AI: 'Report IA (experimental)',
      ALERTS: 'Alertes',
      GERER: 'Gérer',
      Catalogue: 'Catalogue',
      GERERMAJ: 'GERER',
      RENSEIGNER: 'SE RENSEIGNER',
      GENERERDOC: 'Génération des documents',
      DOCUMENTS: 'Documents',
      MESDOCUMENTS: 'Mes documents',
      RECRUTER: 'RECRUTER',
      OFFRES: "Offres d'emploi",
      FICHES_POSTE: 'Fiches de poste',
      EXPORT: 'Export',
      IMPORT: 'Import',
      LEAVE: 'Congés',
      Cibler: 'Cibler',
      Attributions: 'Attributions',
      Enquetes: 'Enquêtes',
      Quizs: 'Quizs',
      Sondages: 'Sondages',
      AGIR: 'AGIR ET ORGANISER',
      Communications: 'Communications',
      Alertes_des_collaborateurs: 'Alertes des collaborateurs',
      ANALYZE: 'ANALYSER ET ANTICIPER',
      Prev: 'Prévisions',
      FORMATIONS: 'Formations',
      onboarding: 'Mon onboarding',
      LIEN: 'Liens entre entités',
      GENERAL: 'Général',
      NEW_COLLABORATOR: 'Nouveau collaborateur',
      STRATEGIES: 'Stratégies',
      AIDE: 'AIDE',
      MANAGE: 'To manage',
      NEWS: 'Nouveautés ✨',
      CONTACT: 'Contacter le support',
      DOCUMENTATION: 'Support et Documentation',
      JEUX: 'Jeux',
      CAMPAGNES: 'Campagnes',
      ListeDesJeux: 'Liste des jeux',
      sondage: 'Sondage',
      MES_QUESTIONS: 'Mes Questions',
      RECEIVED_QUESTIONS: 'Questions Reçues',
      MES_FORMATIONS: 'Mes Formations',
      MES_TACHES: 'Mes tâches',
      MES_SONDAGES: 'Mes sondages',
      MES_QUIZ: 'Mes quiz',
      MES_ENQUETES: 'Mes enquêtes',
      MES_ENTRETIENS: 'Mes entretiens',
      MES_DOCUMENTS_A_SIGNER: 'Mes documents à signer',
      INTEGRATION_EXTERNE: 'Intégrations externes',
      MODELISATION: 'Gestion des espaces',
      OSP_RULES: 'Gestion des règles',
      PARKING: 'Gestion des parkings',
      OSP_RESV_ADMIN: 'Gestion des emplacements',
      ATTENTEVALIDATION: 'En attente de validation',
      GESTIONPROJETS: 'Gestion des projets',
      GESTION_ALERTES: 'Gestion des alertes',
      ALERTES: 'Mes alertes',
      CREER_NOUVEAU_PROJET: 'Créer un nouveau projet',
      REMUNERATION: 'Gestion des rémunérations',
      OBJECTIFS: 'Objectifs',
      LEFT: 'Gauche',
      CENTER: 'Centre',
      RIGHT: 'Droite',
    },
    OBJECTIFS: {
      PAGE_TITLE: 'Les objectifs de',
      ANNUAL_OBJECTIVES: 'Objectifs annuels',
      TEAM_OBJECTIVES: 'Objectifs collectif',
      INDIVIDUAL_OBJECTIVES: 'Objectifs individuels',
      FILTER_SITE: 'Site',
      FILTER_SERVICE: 'Service',
      FILTER_TEAM: 'Équipe',
      CREATE_OBJECTIVE: 'Créer un objectif',
      EDIT_OBJECTIVE: 'Modifier l\'objectif',
      DELETE_OBJECTIVE: 'Supprimer l\'objectif',
      DUPLICATE_OBJECTIVE: 'Créer une copie',
      OBJECTIVE_TITLE: 'Intitulé',
      OBJECTIVE_TYPE: 'Type d\'objectif',
      INDIVIDUAL: 'Objectif individuel',
      COLLECTIVE: 'Objectif collectif',
      ASSIGNED_TO: 'Assigné à',
      PERIOD: 'Pour la période',
      YEAR: 'Année',
      WEIGHTING: 'Sélectionner la pondération',
      STEPS: 'Étapes',
      STEPS_DESCRIPTION: 'Décrire les étapes pour évaluer l\'atteinte de l\'objectif',
      ADD_STEP: 'Ajouter une étape',
      NO_STEPS: 'Aucune étape. Si vous en avez les droits, cliquez sur «Modifier l\'objectif» ou «Modifier la proposition» pour en ajouter.',
      STATUS: 'Statut',
      PROGRESS: 'Avancement',
      LINKED_OBJECTIVES: 'objectifs rattachés',
      COMMENT: 'Commentaire',
      COMMENT_PLACEHOLDER: 'Votre commentaire',
      SEND: 'Envoyer',
      SHOW_HISTORY: 'Afficher tout l\'historique',
      CREATED_OBJECTIVE: 'a créé l\'objectif.',
      SEE_MORE: 'voir plus',
      SHOW_LESS: 'voir moins',
      OBJECTIVES_COUNT: 'objectifs',
      OBJECTIVE_COUNT: 'objectif',
      LINKED_USERS: 'Collaborateurs liés',
      SEARCH_LINKED_USERS: 'Rechercher un collaborateur',
      NO_LINKED_USERS: 'Aucun collaborateur trouvé',
      STATUS_ACHIEVABLE: 'Réalisable',
      STATUS_AT_RISK: 'À risque',
      STATUS_BLOCKED: 'Bloqué',
      STATUS_COMPLETED: 'Terminé',
      REQUIRED_FIELDS: 'Champs obligatoires',
      CLOSE: 'Fermer',
      KPI: 'Indicateur clé (KPI)',
      MY_OBJECTIVES: 'Mes objectifs',
      MY_TEAM: 'Mon équipe',
      NO_OBJECTIVES: 'Aucun objectif pour le moment.',
      FILTER_COLLABORATOR: 'Collaborateur',
      FILTER_COLLABORATOR_PLACEHOLDER: 'Nom du collaborateur',
      FILTER_AVANCEMENT: 'Atteinte minimum',
      FILTER_AVANCEMENT_PLACEHOLDER: 'Ex: 50',
      UNKNOWN_YEAR: 'Année pas assignée',
    },
    INTERVIEWS: {
      PLANNER: {
        CREATE_ERROR: "L'entretien n'a pas pu être planifié. Vérifiez la liste des entretiens avant de réessayer pour éviter les doublons. Si le problème persiste, contactez un administrateur.",
        ERROR_EMPLOYEE_INACTIVE: "Un collaborateur évalué a un compte inactif. Demandez à un administrateur de le réactiver avant d'enregistrer cet entretien, ou sélectionnez un collaborateur actif lors de la création.",
        ERROR_PRINCIPAL_MANAGER_INACTIVE: 'Le manager principal a un compte inactif. Sélectionnez un manager principal actif ou demandez à un administrateur de réactiver son compte.',
        ERROR_ADDITIONAL_MANAGER_INACTIVE: 'Un manager additionnel a un compte inactif. Retirez ou remplacez les managers additionnels inactifs, ou demandez à un administrateur de réactiver leurs comptes.',
        ERROR_PARTICIPANT_UNAVAILABLE: 'Un participant sélectionné est indisponible. Vérifiez le collaborateur, le manager principal et les managers additionnels, puis sélectionnez des comptes disponibles ou contactez un administrateur.',
        ERROR_DATE: "La date de l'entretien est invalide. Sélectionnez une date valide dans le calendrier.",
        ERROR_TIME: "L'heure de l'entretien est invalide. Saisissez une heure au format HH:mm.",
        ERROR_TIMEZONE: "Le fuseau horaire du collaborateur ne peut pas être déterminé. Demandez à un administrateur de vérifier le fuseau horaire de son site avant d'enregistrer.",
        ERROR_LOCAL_TIME: "Cette heure n'existe pas dans le fuseau horaire du collaborateur en raison du changement d'heure. Sélectionnez une autre heure.",
        ERROR_NOTICE: "Saisissez un nombre entier positif de mois de préavis avant d'enregistrer.",
        ERROR_RECURRENCE: 'Saisissez un nombre entier positif de mois pour la récurrence, ou désactivez la récurrence.',
        ERROR_TEMPLATE: 'Le modèle de document sélectionné est indisponible. Rechargez les modèles disponibles et sélectionnez un modèle accessible.',
        ERROR_TYPE: "Le type d'entretien sélectionné est indisponible. Rechargez les types disponibles et sélectionnez-en un à nouveau.",
        ERROR_TEMPLATE_TYPE: "Le modèle de document ne correspond pas au type d'entretien. Sélectionnez un modèle appartenant au type choisi.",
        ERROR_TARGET: 'La cible sélectionnée est indisponible. Rechargez et sélectionnez un site, un service, une équipe ou un collaborateur disponible.',
        ERROR_NO_EMPLOYEES: "Aucun collaborateur actif n'a été trouvé pour cette cible. Sélectionnez une autre cible ou demandez à un administrateur de vérifier les comptes.",
        ERROR_STATUS: "Cet entretien ne peut plus être modifié dans son état actuel. Rechargez la liste des entretiens pour vérifier son statut.",
        ERROR_CONFLICT: "L'entretien a changé pendant l'enregistrement. Rechargez la liste des entretiens et vérifiez son état actuel avant de réessayer.",
        ERROR_NETWORK: "Le serveur est injoignable. Vérifiez votre connexion et la liste des entretiens avant de réessayer pour éviter une création en double.",
        ERROR_INPUT: "Certaines informations de l'entretien sont invalides. Vérifiez les participants, le document et les champs de planification avant de réessayer.",
        ERROR_SESSION: "Votre session n'est plus valide. Reconnectez-vous avant d'enregistrer l'entretien.",
        ERROR_FORBIDDEN: "Vous n'avez pas l'autorisation d'effectuer cette action sur l'entretien. Contactez un administrateur ou le manager principal autorisé.",
        ERROR_UNAVAILABLE: "L'entretien ou une ressource sélectionnée n'est plus disponible. Rechargez la liste des entretiens et les sélections disponibles avant de réessayer.",
        CREATE_TITLE: 'Planifier un entretien',
        EDIT_TITLE: "Modifier l'entretien",
        EDIT_DOCUMENT: 'Modifier le document',
        SAVE: 'Enregistrer les modifications',
        REQUIRED_FIELDS: "Veuillez compléter les informations de l'entretien.",
        CREATE_SUCCESS: 'Entretien planifié pour {{count}} collaborateur(s).',
        UPDATE_SUCCESS: 'Entretien mis à jour avec succès.',
        UPDATE_ERROR: "Impossible de modifier l'entretien. Vérifiez son statut et vos droits, puis réessayez.",
        CHANGE_EMPLOYEE_TITLE: 'Changer le collaborateur ?',
        CHANGE_EMPLOYEE_MESSAGE: "Le changement de collaborateur réinitialisera les réponses et les validations de cet entretien. Les autres modifications conservent les réponses et validations existantes. Confirmez-vous ce changement ?",
        CHANGE_EMPLOYEE_CONFIRM: 'Changer et réinitialiser',
        REPLACE_EMPLOYEE_TITLE: "Remplacer l'entretien et conserver l'ancien ?",
        REPLACE_EMPLOYEE_MESSAGE: "Cet entretien contient des données liées au collaborateur actuel et ne peut pas être réattribué directement. En confirmant, l'ancien entretien sera annulé et ses données resteront conservées sous l'ancien collaborateur. Ses feedbacks en attente et ses invitations calendrier seront annulés selon le fonctionnement existant. Un nouvel entretien vierge, avec un nouvel identifiant, sera créé pour le collaborateur sélectionné, sans reprendre les réponses, validations, documents, signatures ni historiques de l'ancien. Le modèle enregistré sélectionné sera utilisé ; les modifications locales du document ne seront pas transférées. Les demandes de signature externes ne seront pas révoquées. Annuler laisse l'ancien entretien inchangé et ce planificateur ouvert.",
        REPLACE_EMPLOYEE_CONFIRM: "Remplacer et conserver l'ancien",
        REPLACE_EMPLOYEE_SUCCESS: "Un nouvel entretien a été créé pour le collaborateur sélectionné. L'ancien entretien a été annulé et ses données conservées sous l'ancien collaborateur.",
        REPLACE_EMPLOYEE_ERROR: "Le remplacement de l'entretien n'a pas pu être confirmé. Vérifiez la liste des entretiens avant de réessayer.",
        REPLACEMENT_CHILD_BLOCKED: "Le collaborateur de ce sous-entretien ne peut pas être remplacé directement. Recréez le feedback pour le bon collaborateur depuis l'entretien parent. Ce sous-entretien reste inchangé.",
        REPLACEMENT_CONFLICT: "L'entretien a changé pendant le remplacement. Rechargez la liste des entretiens pour vérifier son état avant de réessayer.",
        REPLACEMENT_CALENDAR_UNCERTAIN: "Le remplacement est enregistré, mais l'envoi des invitations ou annulations calendrier ne peut pas être confirmé. Vérifiez les calendriers des participants ; aucun nouvel envoi automatique n'a été effectué lors de cette nouvelle tentative.",
        EMPLOYEE_CHANGE_BLOCKED: "Le collaborateur ne peut pas être changé : cet entretien contient des documents, signatures, feedbacks ou historiques liés au collaborateur actuel. Les autres informations restent modifiables.",
        TEMPLATE_IMAGE_ONLY: "Pour utiliser une nouvelle image de fond, sélectionnez un modèle qui contient cette image. Le modèle partagé n'est pas modifié depuis cet entretien.",
      },
      // Shared location labels keep every interview-instance screen aligned with the persisted values.
      LOCATION: 'Lieu',
      LOCATION_ONSITE: 'Présentiel',
      LOCATION_REMOTE: 'Visioconférence',
      LOCATION_FORM: 'Formulaire',
      // Translate the complete payroll-backed interview field and its authorization feedback.
      PAYROLL_TEMPLATE_FORBIDDEN: "Cette action nécessite le statut d'administrateur de paie, car le modèle contient un champ de rémunération.",
      SCHEDULING_ERROR: "Erreur lors de la planification de l'entretien.",
      // La planification et l'invitation Outlook utilisent le fuseau du site du collaborateur évalué.
      COLLABORATOR_TIMEZONE_INFO: "Le fuseau horaire choisi pour cet entretien est celui du collaborateur : {{timeZone}}.",
      REMUNERATION: {
        FIELD_TYPE: 'Rémunération',
        CONFIG_TITLE: 'Données de rémunération',
        CONFIG_HELP: "Sélectionnez un onglet unique et les colonnes à capturer lors de la création de l'entretien.",
        ONGLET_LABEL: 'Onglet de paie',
        COLUMNS_LABEL: 'Colonnes visibles',
        SEARCH_COLUMNS: 'Rechercher une colonne',
        SELECTED_COLUMNS: '{{ count }} colonne(s) sélectionnée(s)',
        LOADING_ONGLETS: 'Chargement des onglets accessibles...',
        LOADING_COLUMNS: 'Chargement des colonnes...',
        NO_ONGLETS: 'Aucun onglet de paie accessible.',
        NO_COLUMNS: 'Aucune colonne ne correspond à cette recherche.',
        UNAVAILABLE_COLUMNS: 'Ces colonnes enregistrées ne sont plus disponibles et doivent être désélectionnées :',
        DESELECT_COLUMN: 'Désélectionner',
        ONGLETS_LOAD_ERROR: 'Impossible de charger les onglets de paie accessibles.',
        COLUMNS_LOAD_ERROR: 'Impossible de charger les colonnes de cet onglet.',
        CONFIG_REQUIRED: 'Sélectionnez un onglet de paie et au moins une colonne avant d’enregistrer le modèle.',
        CONFIG_INVALID: 'La configuration de rémunération est invalide ou référence des onglets ou colonnes de paie indisponibles. Mettez à jour les champs de rémunération du modèle source, puis réessayez.',
        API_FAILURE: 'Les données de rémunération n’ont pas pu être traitées. Réessayez plus tard ou contactez votre administrateur de paie.',
        CLEANUP_WARNING: 'Références de paie indisponibles écartées de la préparation des entretiens : {{removedColumns}} référence(s) de colonne et {{removedFields}} champ(s) de rémunération. Un champ entier est écarté si son onglet est indisponible ou si aucune colonne utilisable ne reste. Ces compteurs concernent les configurations vérifiées, pas les collaborateurs. Le modèle partagé reste inchangé ; mettez à jour le modèle source.',
        ALLOW_COMMENT: 'Autoriser un commentaire',
        ALLOW_COMMENT_HELP: 'Le manager et le collaborateur disposent chacun de leur propre commentaire facultatif.',
        COMMENT_LABEL: 'Commentaire',
        COMMENT_PLACEHOLDER: 'Ajouter un commentaire facultatif',
        NO_ACCESS_TITLE: 'Accès à la rémunération restreint',
        NO_ACCESS_DESCRIPTION: 'Le statut administrateur de paie est requis pour consulter ces informations de rémunération dans l’aperçu.',
        CONFIGURED_TITLE: 'Colonnes de rémunération configurées',
        CONFIGURED_DESCRIPTION: "Les colonnes de l’onglet {{ onglet }} seront capturées lors de la création de l’entretien. Aucune donnée salarié n’est chargée dans cet aperçu.",
        EMPTY_SNAPSHOT: 'Aucune donnée de rémunération n’est disponible dans cet instantané.',
        CAPTURED_AT: 'Capturé le {{ date }}',
      },
      ADD_SKILL_CUSTOM: 'Ajouter "{{skill}}" comme nouvelle compétence',
      COLLABORATOR: 'Collaborateur',
      SKILLS_MAX_STARS: "Nombre d'étoiles maximum",
      NO_SELECTION: 'Aucune sélection',
      NO_OPTIONS: 'Aucune option. Ajoutez-en ci-dessous.',
      OPTION_PLACEHOLDER: 'Nouvelle option...',
      ADD_TEXT_OPTION: 'Ajouter une option',
      MANAGE_TABS: {
        INTERVIEWS: 'Entretiens',
        RECURRENT: 'Entretiens récurrents',
        CAMPAIGNS: 'Campagnes',
        SETTINGS: 'Paramètres',
      },
      // Traduire la préférence personnelle de rappel affichée uniquement dans Mes entretiens.
      REMINDER_NOTIFICATIONS: {
        ENABLE_LABEL: 'Envoyer les emails de rappel',
        ENABLE_HELP: 'Ce choix personnel concerne uniquement les emails de rappel. Les emails de planification, de reprogrammation et de validation restent envoyés.',
        STATUS_ENABLED: 'Recevoir les emails de rappels : Activé',
        STATUS_DISABLED: 'Recevoir les emails de rappels : Désactivé',
        ENABLE_ACTION: 'Recevoir les rappels',
        DISABLE_ACTION: 'Ne pas recevoir les rappels',
        CONTROL_ARIA_LABEL: 'Modifier la réception des emails de rappel',
        LOADING: 'Rappels…',
        CONFIRM_TITLE: 'Désactiver les rappels ?',
        RESPONSIBILITY_STATEMENT: 'Je suis responsable du respect des délais conformément au calendrier de la campagne d’évaluation de l’année considérée.',
        ACKNOWLEDGEMENT_LABEL: 'Je reconnais et accepte cette responsabilité.',
        ACKNOWLEDGEMENT_REQUIRED: 'Vous devez reconnaître cette responsabilité pour désactiver les emails de rappel.',
        CONFIRM_HELP: 'En confirmant, je reconnais et accepte cette responsabilité. Les autres emails liés à l’entretien resteront actifs.',
        CONFIRM_DISABLE_ACTION: 'Je reconnais et désactive les rappels',
        SAVE_SUCCESS: 'Votre préférence pour les emails de rappel a été enregistrée.',
        SAVE_ERROR: 'Impossible d’enregistrer votre préférence pour les emails de rappel.',
        LOAD_ERROR: 'Impossible de charger votre préférence pour les emails de rappel.',
      },
      // Report calendar delivery separately so successful interview writes remain successful.
      CALENDAR_DELIVERY: {
        SUCCESS: 'Les notifications calendrier ont été envoyées avec succès.',
        PARTIAL_WARNING: 'La notification calendrier n’a été envoyée qu’à {{sent}} participant(s) sur {{attempted}}. L’entretien a bien été enregistré.',
        FAILED_WARNING: 'La notification calendrier n’a pu être envoyée à aucun participant. L’entretien a bien été enregistré.',
      },
      // Traduire la gestion des types d'entretien et la nouvelle action de renommage.
      TYPE_SETTINGS: {
        AVAILABLE_TYPES: "Types d'entretien disponibles",
        RENAME_TITLE: "Renommer le type d'entretien",
        NAME_LABEL: "Nom du type d'entretien",
        NAME_PLACEHOLDER: 'Ex. Annual Performance Review',
        ADD_LABEL: "Ajouter un nouveau type d'entretien",
        LOAD_ERROR: "Impossible de charger les types d'entretien.",
        ADD_SUCCESS: "Le type d'entretien a été ajouté avec succès.",
        ADD_ERROR: "Impossible d'ajouter le type d'entretien.",
        RENAME_SUCCESS: "Le type d'entretien a été renommé avec succès.",
        RENAME_ERROR: "Impossible de renommer le type d'entretien.",
        DUPLICATE_ERROR: "Un type d'entretien portant ce nom existe déjà.",
        DELETE_TITLE: "Supprimer le type d'entretien",
        DELETE_CONFIRMATION: "Êtes-vous sûr de vouloir supprimer le type d'entretien « {{name}} » ?",
        DELETE_SUCCESS: "Le type d'entretien a été supprimé avec succès.",
        DELETE_ERROR: "Impossible de supprimer le type d'entretien.",
      },
      IMPORTED_PREVIEW: {
        OBJECTIVE_PERIODS: {
          ASSESSED: 'Bilan des objectifs',
          PLANNED: 'Objectifs à venir',
          UNKNOWN_PERIOD: 'Période à préciser',
          SOURCE_PERIOD: 'Période dans le document',
          DEADLINE: 'Échéance',
          RESULT: 'Résultat',
          RESULT_ATTAINED: 'Atteint',
          RESULT_PARTIAL: 'Partiellement atteint',
          RESULT_NOT_ATTAINED: 'Non atteint',
          RESULT_UNKNOWN: 'Non précisé',
          PROGRESS_UNKNOWN: 'Non précisé',
        },
        LABEL: 'Entretien importé',
        HELP: 'Entretien historique importé. Cet aperçu ne vaut pas validation ni signature des participants.',
        SOURCE_CONTENT: 'Contenu du document importé',
        SECTION: 'Section {{number}}',
        CONTENT_UNAVAILABLE: 'Le contenu importé n’est pas disponible dans l’aperçu. Vous pouvez consulter le PDF joint lorsqu’il est disponible.',
        SOURCE_PDF: 'Import PDF',
        SOURCE_EXCEL: 'Import Excel',
        OPEN_SOURCE: 'Voir le PDF joint',
        EXPORT: 'Exporter en PDF',
        LOAD_ERROR: 'Impossible de charger l’aperçu de cet entretien.',
        EXPORT_ERROR: 'Impossible de générer le PDF de cet entretien. Veuillez réessayer.',
        FONT_ERROR: 'La police du PDF ne permet pas d’afficher tous les caractères de l’entretien. Aucun PDF incomplet n’a été téléchargé. L’aperçu reste disponible.',
        ANALYSIS_UNAVAILABLE: 'Aucune analyse d’entretien exploitable n’est encore disponible pour cet import Excel. La source originale est conservée.',
        ANALYSIS_STALE: 'Le texte source Excel a été modifié après l’analyse. L’ancienne analyse n’est pas présentée comme le contenu actuel de l’entretien.',
        QUESTIONNAIRE: {
          PARTIAL: 'Ce compte rendu est incomplet : certaines questions ou réponses sources n’ont pas pu être affichées de façon fiable. Demandez à un administrateur de vérifier les libellés des questions et la préparation de l’import. La source originale est conservée.',
          STALE: 'La source a changé. Ce questionnaire est indisponible.',
          UNAVAILABLE: 'Questionnaire indisponible.',
          COLLABORATOR: 'Collaborateur',
          MANAGER: 'Manager',
          COMMENT: 'Commentaire',
          EVALUATION: 'Évaluation',
        },
        REPORT: {
          TITLE: 'Compte rendu d’entretien importé',
          SOURCE_PARTICIPANTS: 'Identité extraite du document',
          ASSIGNED_ACCOUNTS: 'Rattachement dans l’application',
          ASSIGNED_HELP: 'Ces comptes déterminent le rattachement et l’accès dans l’application. Ils ne désignent pas nécessairement les auteurs du document source.',
          SOURCE_DATE: 'Date d’entretien extraite',
          SOURCE_PERIOD: 'Période évaluée',
          GENERAL_INFORMATION: 'Informations du document',
          OBJECTIVES: 'Objectifs',
          NO_OBJECTIVES: 'Aucun objectif retenu dans les données d’import.',
          OBJECTIVES_UNAVAILABLE: 'Les objectifs structurés ne sont pas disponibles. Les informations d’objectifs présentes dans la source restent dans le contenu du document ou les références sources.',
          OBJECTIVES_REVIEW_REQUIRED: 'Le statut de vérification de cette liste d’objectifs n’est pas confirmé.',
          OBJECTIVE_SYNC_FAILED: 'La synchronisation des objectifs a signalé une erreur. Les données d’objectifs enregistrées avec l’entretien restent affichées ici.',
          OBJECTIVE_REVIEWED: 'Liste d’objectifs enregistrée lors de l’import',
          SOURCE_AUTHOR: 'Auteur indiqué dans la source',
          RECORD: 'Entrée {{number}}',
          SOURCE_NOTICE: 'Mention présente dans le document source',
          STRUCTURE_UNAVAILABLE: 'Certaines informations sources n’ont pas pu être structurées de façon fiable. Elles restent disponibles dans les références sources et le PDF joint.',
          SOURCE_TEXT_CHANGED: 'Le texte source a été modifié après l’extraction. Les anciennes réponses structurées ne remplacent pas le texte actuel.',
          SOURCE_REVIEW_REQUIRED: 'Certaines informations sources nécessitent une clarification. Consultez les détails sources conservés.',
          ADDITIONAL_CONTENT: 'Autres informations du document',
          SOURCE_REFERENCES: 'Références sources complémentaires',
          SOURCE_REFERENCES_HELP: 'Les détails d’origine sont conservés séparément du compte rendu et des objectifs retenus. Ils ne sont inclus dans le PDF que si vous le choisissez.',
          SOURCE_UNKNOWN: 'Non précisé dans la source',
          REFRESH: 'Actualiser le compte rendu',
          REFRESH_ERROR: 'Impossible d’actualiser le compte rendu.',
          INCLUDE_REFERENCES: 'Inclure les références sources complémentaires dans le PDF',
          LEGACY_FORMAT: 'Cette réponse utilise l’ancien affichage des données sources. Actualisez le compte rendu après le chargement de la mise à jour du backend.',
        },
      },
      IMPORT: {
        TAB: 'Import',
        EXCEL_INSTRUCTIONS: {
          TITLE: 'Consignes pour ce fichier',
          OPTIONAL: 'Consignes facultatives pour interpréter cet Excel',
          OPTIONAL_BADGE: 'Facultatif',
          UPLOAD_HELP: 'Facultatif : précisez ce qu’il faut retenir dans les brouillons et les objectifs. Laissez vide pour l’import habituel.',
          COMPACT_PRIVATE: 'Consignes privées ; fichier original inchangé.',
          DEFAULT_HELP: 'Sans consignes = import habituel.',
          SCOPE_HELP: 'Ajoutez une règle de lecture ou un filtre sur les objectifs si nécessaire.',
          PLACEHOLDER: 'Exemple : ne retenir que les nouveaux objectifs et leurs KPI.',
          REVIEW_NOTICE: 'Vérifiez l’interprétation de l’IA avant de confirmer. Les réponses originales ne sont pas réécrites.',
          WARNINGS_TITLE: 'Points d’attention ({{count}})',
          WARNINGS_HELP: 'Ces traitements sémantiques ne sont réclamés par aucune consigne. La préparation reste possible ; vérifiez-les avant de confirmer.',
          CHARACTER_COUNT: '{{count}} / {{max}} caractères',
          STATUS_EMPTY: 'Sans consignes',
          STATUS_SAVED: 'Consignes actuelles',
          STATUS_DIRTY: 'Modifications non enregistrées',
          STATUS_READ_ONLY: 'Lecture seule',
          POLICY: {
            TITLE: 'Nouveaux objectifs à créer',
            STANDARD_TITLE: 'Objectifs : extraction habituelle.',
            STANDARD_HELP: 'Cette analyse ne contient pas de règle de sélection des objectifs. Si vous attendiez un filtrage des objectifs ou des années, précisez les consignes puis relancez l’analyse avant de préparer les brouillons.',
            HELP: 'Ces règles sélectionnent les objectifs à proposer, pas le contenu à retirer du compte rendu. Les réponses originales et les anciens objectifs restent dans l’historique de l’entretien, sauf si vous excluez ce contenu séparément.',
            PHASE: 'Période des objectifs',
            PLANNED_ONLY: 'Objectifs nouveaux / à venir uniquement',
            TARGET_YEAR: 'Filtre d’année pour les nouveaux objectifs',
            ANY_YEAR: 'Aucun filtre d’année',
            CATEGORIES_TITLE: 'Catégories autorisées',
            SOURCE_KINDS_TITLE: 'Contenus sources autorisés',
            SOURCE_REFS: 'Sections sources utilisées pour proposer des objectifs',
            ALL_INCLUDED: 'Toutes les sections sources incluses',
            NONE: 'Aucune',
            MISSING_YEAR: 'Lorsque la source ne précise pas d’année',
            MISSING_REVIEW: 'À vérifier. Ne pas déduire d’année.',
            MISSING_CONTEXT: 'Utiliser {{year}} uniquement en l’absence d’année source, selon cette consigne enregistrée :',
            YEAR_HELP: 'Le filtre d’année ne change jamais l’année source. Une année explicite dans la source est prioritaire sur celle fournie dans les consignes.',
            REVIEW_HELP: 'Les objectifs et KPI proposés par l’IA restent à vérifier. Confirmez cette interprétation ci-dessous, puis vérifiez les objectifs proposés dans chaque brouillon.',
            CATEGORIES: { performance: 'Performance', management: 'Management', delegation: 'Délégation', development: 'Développement', career: 'Carrière', posture: 'Posture professionnelle', other: 'Autre' },
            SOURCE_KINDS: { explicit_goal: 'Objectifs explicites', actionable_context: 'Actions décrites dans les réponses ou commentaires' },
          },
          PRIVATE_HELP: 'Consignes privées, absentes du compte rendu.',
          EXAMPLES_TITLE: 'Exemples de consignes utiles',
          EXAMPLES: 'Ne retenir que les nouveaux objectifs et leurs KPI ; garder les anciens dans l’historique.\nConserver les anciens et les nouveaux objectifs, avec les années de la source.\nUtiliser la feuille Entretiens comme liste principale et le matricule comme clé d’identité.\nL’évaluateur est le manager.',
          TOO_LONG: 'Utilisez au maximum 4096 caractères (16 Kio), sans caractères de contrôle masqués. Votre texte n’a pas été raccourci.',
          BATCH_TOO_LONG: 'Le total des consignes Excel dépasse 64 Kio. Raccourcissez les consignes ou sélectionnez moins de fichiers avant de créer le lot.',
          RETRY_CREATE: 'Réessayer la création du lot',
          RETRY_CREATE_HELP: 'La création du lot a échoué. Vos fichiers et consignes restent sélectionnés. Modifiez les consignes si nécessaire, puis réessayez : les fichiers déjà téléversés seront réutilisés sans nouvel upload.',
          SAVE: 'Enregistrer les consignes',
          SAVE_HELP: 'Enregistre ce texte pour ce fichier uniquement. Ne lance pas l’analyse et ne modifie pas les entretiens importés.',
          SAVED: 'Consignes enregistrées. Lancez explicitement l’analyse pour utiliser cette version.',
          SAVE_ERROR: 'Les consignes n’ont pas pu être enregistrées. Vos modifications sont conservées.',
          STALE: 'Cette source a changé ou n’est plus modifiable. Fermez puis rouvrez-la pour charger la version actuelle. Votre texte non enregistré reste disponible ici.',
          ANALYSE: 'Analyser avec ces consignes',
          ANALYSE_HELP: 'Met à jour l’analyse avec le texte ci-dessus. Aucun entretien n’est importé.',
          ANALYSIS_STARTED: 'Analyse du fichier lancée avec la version enregistrée des consignes.',
          ANALYSIS_ERROR: 'L’analyse n’a pas pu être lancée. Les consignes enregistrées sont conservées.',
          ANALYSIS_REQUIRED: 'Ces consignes sont enregistrées. Cliquez sur « Analyser avec ces consignes », puis vérifiez le résultat.',
          ANALYSIS_REQUIRED_STATUS: 'Consignes enregistrées à analyser',
          IMPORTED_UNCHANGED: 'Modifier les consignes ne change jamais les entretiens déjà importés. Les brouillons préparés doivent d’abord être abandonnés explicitement avec l’action de réinitialisation existante ; une source comportant des entretiens importés ne peut plus être modifiée.',
          READ_ONLY: 'Les consignes de cette source sont en lecture seule. Revenez à sa fiche pour réinitialiser explicitement les brouillons préparés, si cette action est disponible. Les entretiens importés ne peuvent pas être réinitialisés ici.',
          MAPPING_DIRTY: 'La configuration contient des modifications non vérifiées. Vérifiez-la ou fermez sans enregistrer avant de modifier ou d’analyser les consignes.',
          DIRTY: 'Consignes modifiées. Cliquez sur « Analyser avec ces consignes » avant de préparer les brouillons.',
          DISCARD_TITLE: 'Abandonner les consignes non enregistrées ?',
          DISCARD_HELP: 'Seul le texte non enregistré sera abandonné. Aucun brouillon préparé ni entretien importé ne sera supprimé.',
          DISCARD: 'Abandonner le texte et fermer',
          REVIEW_TITLE: 'Ce que l’IA a compris',
          APPLIED_TITLE: 'Interprétation appliquée aux brouillons préparés',
          REVIEW_HELP: 'Vérifiez ce que l’analyse propose pour ce fichier avant de préparer les brouillons privés.',
          NOT_READY: 'L’analyse doit être refaite. Vérifiez vos consignes puis cliquez sur « Analyser avec ces consignes ». Aucun brouillon ne peut encore être préparé.',
          SUMMARY: {
            YEAR_FILTER: 'Seuls les objectifs pour {{year}} seront proposés.',
            MISSING_YEAR_CONTEXT: 'Sans année indiquée dans la source, utiliser {{year}} selon les consignes enregistrées.',
            MISSING_YEAR_REVIEW: 'Les objectifs sans année source devront être vérifiés.',
            REPORT_RETAINED: 'Les réponses sources et les anciens objectifs restent dans le compte rendu. Sélectionner de nouveaux objectifs ne supprime pas cet historique.',
            REPORT_EXCLUSIONS: 'Le compte rendu exclut {{sheets}} feuille(s). {{fields}} autre(s) champ(s) ne figurent pas dans les réponses (historique, métadonnées ou contenu exclu). Les autres réponses sont conservées ; la sélection des objectifs est un filtre distinct.',
            EXCLUDED_SHEETS: 'Feuilles exclues du compte rendu :',
            ANALYSIS_CHECKED: 'L’analyse enregistrée ne contient pas de consignes non résolues. Cela ne remplace pas votre vérification.',
          },
          IMPORT_HELP: 'Vérifiez les entretiens détectés et l’interprétation des consignes enregistrées avant de préparer les brouillons privés.',
          CONFLICT_REASONS: {
            duplicate_reference: 'L’IA a défini plusieurs fois le même champ source. Ses règles doivent être rendues cohérentes avant de préparer les brouillons.',
            non_objective_period: 'L’IA a attribué une année ou une période d’objectif à un champ qui n’est pas un objectif. C’est une erreur dans les règles générées, pas une modification de vos données sources.',
            excluded_field_annotation: 'L’IA a attribué un rôle de réponse ou une référence de question à un champ qu’elle a exclu du compte rendu. Ces règles générées sont incohérentes.',
            self_question_reference: 'L’IA utilise un champ comme sa propre question au lieu de le relier à la bonne question ou au bon en-tête.',
            ignored_question_reference: 'L’IA utilise un champ ignoré comme référence de question. Ce lien doit être corrigé sans annuler l’exclusion.',
            ignored_year_reference: 'L’IA utilise un champ ignoré comme référence d’année. L’analyse reste bloquée plutôt que de supprimer l’année source ou d’en choisir une autre automatiquement.',
            inconsistent_group_phase: 'L’IA a attribué des périodes contradictoires au même objectif : bilan et objectif à venir. L’application ne choisit pas arbitrairement une période.',
            inconsistent_group_year_reference: 'L’IA a relié le même objectif à des références d’année incompatibles. L’application ne choisit pas arbitrairement l’une de ces références.',
            inconsistent_group_default_year: 'L’IA a attribué des années de contexte différentes au même objectif. L’application ne choisit pas arbitrairement une année.',
          },
          DIAGNOSTICS: {
            GENERIC: 'L’analyse n’a pas fourni d’interprétation exploitable. Relancez l’analyse avec les consignes enregistrées ; approuver les en-têtes ne suffit pas à résoudre ce problème.',
            CODE: 'Code de diagnostic :',
            LOCATION: 'Champ(s) source concerné(s) :',
            INTERVIEW_INTERPRETATION_INVALID: 'La structure ou le format de l’interprétation proposée est invalide et ne peut pas être validé. Relancez l’analyse du fichier ; aucun brouillon ne peut encore être préparé.',
            INTERVIEW_INTERPRETATION_REQUIRED: 'L’analyse n’a pas fourni de règles d’interprétation pour les consignes enregistrées. Relancez l’analyse du fichier ; aucun brouillon n’a été préparé.',
            INTERVIEW_INTERPRETATION_LIMIT: 'L’interprétation dépasse une limite de taille ou de nombre de règles prise en charge. Vérifiez la portée des consignes puis relancez l’analyse du fichier.',
            INTERVIEW_INTERPRETATION_REFERENCE: 'Une référence de cellule ou de colonne proposée ne correspond pas à la disposition du fichier. Cela peut aussi concerner une référence de question ou d’année. Relancez l’analyse pour corriger les références.',
            INTERVIEW_INTERPRETATION_COVERAGE: 'L’analyse a fourni des liens incohérents avec les consignes, par exemple des doublons ou des numéros de consigne invalides. Relancez l’analyse pour reconstruire ces liens.',
            INTERVIEW_INTERPRETATION_CONFLICT: 'L’interprétation proposée contient des règles de champs ou des références contradictoires. Vérifiez les consignes puis relancez l’analyse du fichier.',
            INTERVIEW_INTERPRETATION_HEADER_CONFLICT: 'Une règle proposée contredit un en-tête explicite de la source, comme le rôle de réponse, l’importance, l’avancement ou l’année d’un objectif. Vérifiez les consignes puis relancez l’analyse du fichier.',
            INTERVIEW_INTERPRETATION_GROUP: 'Les groupes d’objectifs proposés sont invalides ou incomplets, par exemple à cause de titres manquants ou de champs en double. Relancez l’analyse avant de préparer les brouillons.',
            INTERVIEW_INTERPRETATION_DEFAULT_YEAR: 'Une année par défaut proposée est invalide ou absente des consignes enregistrées. Précisez l’année souhaitée puis relancez l’analyse ; les années explicites de la source restent inchangées.',
            INTERVIEW_INTERPRETATION_EMPTY_HEADER: 'Une référence de question ou d’année proposée vise un en-tête vide dans la source. Vérifiez les en-têtes du fichier puis relancez l’analyse.',
            INTERVIEW_INTERPRETATION_SHEET_COVERAGE: 'L’analyse n’a pas pris en compte toutes les feuilles incluses. Relancez l’analyse pour traiter correctement les feuilles incluses et exclues.',
            INTERVIEW_INTERPRETATION_IGNORED_SHEET: 'Les règles proposées utilisent encore une feuille exclue de la configuration. Relancez l’analyse pour prendre en compte cette exclusion.',
            INTERVIEW_INTERPRETATION_EXCLUDED_FIELDS: 'L’interprétation proposée exclut une feuille mais utilise encore ses champs. Relancez l’analyse pour corriger ces règles contradictoires.',
            INTERVIEW_INTERPRETATION_COVERAGE_REFERENCE: 'L’analyse associe une consigne à une référence de feuille ou de champ invalide. Relancez l’analyse pour corriger les références.',
            INTERVIEW_INTERPRETATION_COVERAGE_STATUS: 'L’analyse n’a pas fourni de résultat valide pour une consigne. Vérifiez sa formulation puis relancez l’analyse.',
            INTERVIEW_INTERPRETATION_OBJECTIVE_POLICY: 'Les règles de sélection des objectifs sont invalides ou incomplètes. Précisez les consignes et relancez l’analyse avant de confirmer.',
            INTERVIEW_INTERPRETATION_OBJECTIVE_POLICY_REFERENCE: 'Une règle de sélection des objectifs vise une section source non incluse ou inutilisable. Vérifiez les références sources et relancez l’analyse.',
            INTERVIEW_INTERPRETATION_OBJECTIVE_POLICY_EMPTY: 'L’analyse ne peut sélectionner aucun nouvel objectif avec ces règles. Vérifiez vos consignes puis relancez l’analyse.',
          },
          IDENTITY: 'Clé d’identité et champs associés',
          NONE: 'Aucune clé ni aucun champ explicite',
          QUESTION_REF: 'Référence de la question',
          YEAR_REF: 'Référence de l’année source',
          GROUP: 'Groupe d’objectifs',
          DEFAULT_YEAR: 'Année {{year}} par défaut uniquement si absente de la source',
          SHEET_SCOPE: 'Inclusion de la feuille',
          SOURCE_YEAR_HELP: 'Une année explicite de la source est toujours prioritaire. Une année par défaut constitue uniquement un contexte administratif, jamais un fait de la source ni un décalage automatique vers l’année actuelle.',
          HEADERS_REQUIRED: 'Vérifiez d’abord les questions détectées ci-dessous, puis confirmez cette interprétation. Aucun libellé n’est approuvé automatiquement.',
          HEADER_CONFLICT: 'La règle proposée contredit un en-tête explicite de la source, par exemple un rôle de réponse, une importance, un avancement ou une année d’objectif. Corrigez les consignes ou la configuration, puis relancez explicitement l’analyse.',
          REVIEW_HEADERS: 'Vérifier les questions',
          CONFIRM: 'Ce résumé correspond à mes consignes.',
          CONSENT_HELP: 'En confirmant, vous autorisez l’utilisation des questions détectées pour préparer les brouillons privés.',
          CONSENT_CHANGED: 'Le fichier ou l’analyse a changé pendant la confirmation. Vérifiez le résumé mis à jour avant de confirmer à nouveau.',
          HEADERS_UNSAFE: 'Les questions détectées ne peuvent pas être utilisées de façon sûre. Vérifiez le fichier source puis relancez l’analyse avant de confirmer.',
          DISPLAY: { include: 'Incluse', exclude: 'Exclue' },
          ROLES: { collaborator: 'Réponse du collaborateur', manager: 'Réponse du manager' },
          PHASES: { assessed: 'Objectifs évalués', planned: 'Objectifs prévus', unknown: 'Période d’objectif non indiquée' },
          COVERAGE: { mapped: 'Règle proposée associée à cette consigne', unsupported: 'Consigne non prise en charge', ambiguous: 'Consigne ambiguë', conflict: 'Consigne contradictoire', unresolved: 'Consigne non résolue', unclaimed_rule: 'Règle non associée à une consigne', uncovered_source: 'Contenu source sans règle d’interprétation', empty_question: 'La question référencée est vide dans la source' },
          KINDS: { answer: 'Réponse', comment: 'Commentaire', report_comment: 'Commentaire du compte rendu (hors sources d’objectifs)', evaluation: 'Évaluation', objective_title: 'Titre de l’objectif', objective_header_title: 'Titre de l’objectif depuis l’en-tête complet', objective_header_title_suffix: 'Titre de l’objectif depuis l’en-tête après le premier " - "', objective_description: 'Description de l’objectif', objective_comment: 'Commentaire de l’objectif', objective_kpi: 'KPI de l’objectif', objective_deadline: 'Échéance de l’objectif', objective_result: 'Résultat de l’objectif', objective_progress: 'Avancement de l’objectif', objective_importance: 'Importance de l’objectif', objective_year: 'Année de l’objectif', objective_context: 'Contexte de l’objectif', metadata: 'Métadonnées', history: 'Historique exclu des réponses', ignore: 'Champ ignoré' },
        },
        WORKFLOW_STEP_UPLOAD: 'Étape 1 · Upload',
        WORKFLOW_STEP_PROCESS: 'Étape 2 · Traitement',
        WORKFLOW_STEP_REVIEW: 'Vérification',
        PAGE_TITLE: 'Vérifier les entretiens importés',
        PAGE_SUBTITLE: 'Importez des fichiers PDF ou Excel, vérifiez la structure des classeurs et les brouillons extraits, puis validez les entretiens terminés.',
        REVIEW_WAITING_TITLE: 'Analyse des fichiers terminée',
        REVIEW_WAITING_HELP: 'Vérifiez l’aperçu pour créer les brouillons d’entretien. Aucun brouillon n’a encore été créé.',
        REVIEW_CORRECTION_TITLE: 'L’import nécessite une correction',
        REVIEW_CORRECTION_HELP: 'Aucun brouillon d’entretien n’a encore été créé. Vérifiez les fichiers marqués « Correction nécessaire » avant de continuer.',
        REVIEW_SOURCE_BUTTON: 'Vérifier l’import',
        REVIEW_SOURCE_HELP: 'Vérifiez l’aperçu avant de créer les brouillons d’entretien.',
        REVIEW_SOURCES_HELP: 'Vérifiez chaque fichier à l’aide des cartes ci-dessous.',
        REVIEW_DETECTED_COUNT: '{{count}} entretiens détectés dans l’aperçu',
        REVIEW_DIAGNOSTIC_DETAILS: 'Détails techniques',
        REVIEW_READY_STATUS: 'Vérification nécessaire',
        REVIEW_CORRECTION_STATUS: 'Correction nécessaire',
        REVIEW_SOURCE_CORRECTION_HELP: 'La création des brouillons est bloquée pour ce fichier. Vérifiez l’aperçu ou relancez l’analyse.',
        REVIEW_SOURCE_FAILED_HELP: 'L’analyse du fichier a échoué. Relancez l’analyse pour continuer.',
        REVIEW_SOURCE_DIAGNOSTIC_HELP: 'Un problème a été détecté dans ce fichier. Consultez les détails ci-dessous.',
        REVIEW_SOURCE_PROCESSING_HELP: 'Attendez la fin de l’analyse du fichier avant de vérifier l’aperçu.',
        REVIEW_PAGE_HELP: 'Vérifiez chaque brouillon privé, complétez les informations manquantes, puis importez explicitement votre sélection. La préparation des fichiers ne crée jamais de vrais entretiens.',
        REVIEW_ADD_FILES: 'Ajouter des fichiers',
        REVIEW_UPLOAD_HELP: 'Choisissez une campagne et des fichiers pour préparer des brouillons privés. Vérifiez puis importez explicitement les entretiens sélectionnés ; cette étape ne crée aucun vrai entretien.',
        REVIEW_READY_TO_IMPORT: 'Prêt à importer',
        REVIEW_IMPORTED: 'Importé',
        REVIEW_IMPORTED_WITH_WARNINGS: 'Importé avec avertissements',
        REVIEW_IMPORT_FAILED: 'Échec de l’import',
        ANALYSIS_QUEUED: 'En attente d’analyse',
        ANALYSIS_FAILED: 'Analyse / préparation échouée',
        ANALYSIS_QUEUE_HELP: 'Les brouillons sont en cours de chargement ou d’analyse en arrière-plan. Les statuts se mettent à jour automatiquement. Aucun entretien n’est importé à cette étape.',
        REVIEW_TABLE_TITLE: 'Vérification métier',
        REVIEW_TABLE_CAPTION: 'Tous les brouillons de ce lot, y compris ceux en cours de traitement et déjà importés.',
        REVIEW_PRIVATE_HELP: 'Les brouillons préparés restent privés jusqu’à leur import. Ouvrez un entretien pour lire son contenu, corriger ses informations et relire explicitement ses objectifs.',
        VISIBILITY_TITLE: 'Visibilité après import',
        VISIBILITY_MANAGER_ONLY: 'Manager uniquement',
        VISIBILITY_MANAGER_COLLABORATOR: 'Manager et collaborateur',
        VISIBILITY_HELP: 'Ce choix est enregistré pour ce lot et appliqué lors de la confirmation des entretiens. Les brouillons restent privés. Les entretiens déjà importés ne sont pas modifiés.',
        VISIBILITY_NOT_SAVED: 'Le serveur n’a pas confirmé la visibilité choisie pour le lot. La visibilité manager uniquement est utilisée jusqu’au chargement du réglage enregistré.',
        VISIBILITY_CONFIRM: 'Visibilité après import : {{visibility}}.',
        VISIBILITY_CHANGED: 'La visibilité a changé pendant la confirmation. Vérifiez le choix et confirmez à nouveau l’import.',
        REVIEW_PREPARED_STATUS: 'Brouillons privés préparés',
        REVIEW_PRIVATE_COUNT: '{{count}} brouillons privés générés. La préparation ne constitue pas une validation finale.',
        REVIEW_SOURCE_SUMMARY_HELP: 'Préparation des fichiers et anomalies uniquement. Vérifiez les entretiens réels dans le tableau ci-dessous.',
        REVIEW_SOURCE_ADVANCED: 'Actions avancées du fichier',
        REVIEW_SOURCE_ROLES_HELP: 'La liste principale définit les entretiens. Les feuilles complémentaires ajoutent du contenu à ces entretiens sans en créer d’autres. Les en-têtes partagés fournissent uniquement des libellés.',
        REVIEW_ROLE_PRIMARY: 'Liste principale des entretiens',
        REVIEW_ROLE_IGNORED: 'Exclue de la préparation',
        REVIEW_ROLE_SUPPORTING: 'Contenu complémentaire',
        REVIEW_ROLE_LEGACY: 'Rôle de feuille non explicite (ancienne interprétation)',
        REVIEW_LEGACY_MAPPING: 'Ce fichier utilise une ancienne interprétation confirmée. Ses brouillons restent disponibles ; la réinitialisation automatique de l’interprétation n’est pas prise en charge.',
        REVIEW_SOURCE_SAMPLE: 'Échantillon du fichier (3 enregistrements maximum, pas la liste à vérifier)',
        REVIEW_RESET_TITLE: 'Changer l’interprétation du fichier',
        REVIEW_RESET_ACTION: 'Changer l’interprétation du fichier',
        REVIEW_RESET_CONFIRM: 'Cette action abandonne TOUS les brouillons privés non importés issus de ce fichier et TOUTES leurs modifications. Aucun vrai entretien n’est supprimé. Vous devrez choisir à nouveau la liste principale des entretiens. Cette action est bloquée si un entretien est déjà importé ou en cours d’import. Continuer ?',
        REVIEW_RESET_ERROR: 'Impossible de réinitialiser ce fichier. Actualisez son état avant de réessayer.',
        REVIEW_SELECTION: 'Sélection',
        REVIEW_ACTION: 'Action',
        REVIEW_SELECT_ROW: 'Sélectionner l’entretien de {{name}}',
        REVIEW_SELECTED_COUNT: '{{count}} entretiens sélectionnés',
        REVIEW_SELECT_READY: 'Sélectionner uniquement les entretiens prêts',
        REVIEW_CLEAR_SELECTION: 'Effacer la sélection',
        REVIEW_OPEN: 'Ouvrir la vérification',
        REVIEW_COMPLETE_MISSING: 'Compléter les informations manquantes',
        REVIEW_DEFAULTS_HELP: 'Périmètre : uniquement les {{count}} entretiens sélectionnés. Seules les valeurs vides des brouillons privés hors traitement sont complétées. Les valeurs existantes, collaborateurs, objectifs et textes extraits ne sont jamais remplacés.',
        REVIEW_LEAVE_UNCHANGED: 'Ne pas modifier',
        REVIEW_FILL_NOTIFICATIONS: 'Compléter uniquement les préférences de notification manquantes (conserver les préférences existantes)',
        REVIEW_AFFECTED_COUNT: '{{count}} brouillons sélectionnés recevront les valeurs manquantes renseignées.',
        REVIEW_DEFAULTS_BLOCKED: 'Si le préavis est renseigné, vérifiez sa valeur (1 à 12 mois) et actualisez les brouillons sans version courante.',
        REVIEW_CANCEL_DEFAULTS: 'Annuler et effacer les valeurs',
        REVIEW_APPLY_DEFAULTS: 'Enregistrer les informations manquantes',
        REVIEW_DEFAULTS_ERROR: 'Ces valeurs manquantes n’ont pas pu être enregistrées. Vérifiez ce brouillon avant de réessayer.',
        REVIEW_DEFAULTS_PARTIAL: '{{count}} brouillons n’ont pas pu être mis à jour. Les modifications réussies sont conservées ; vérifiez les erreurs avant de réessayer.',
        REVIEW_DEFAULTS_SUCCESS: 'Informations manquantes enregistrées sur {{count}} brouillons. Aucun entretien n’a été importé.',
        REVIEW_DEFAULTS_PROGRESS: 'Enregistrement : {{completed}} / {{total}} terminés, {{success}} enregistrés, {{failed}} en échec.',
        REVIEW_IMPORT_PROGRESS: 'Import : {{completed}} / {{total}} terminés, {{success}} importés, {{failed}} en échec.',
        REVIEW_JOB_QUEUED: 'En attente',
        REVIEW_JOB_RUNNING: 'En cours',
        REVIEW_JOB_SUCCESS: 'Terminé',
        REVIEW_JOB_FAILED: 'Échec ; vérifier avant de réessayer',
        REVIEW_CALENDAR_WARNINGS: '{{count}} entretiens importés présentent des avertissements de remise des invitations calendrier. Ce ne sont pas des échecs d’import ; ne les importez pas à nouveau.',
        REVIEW_NAVIGATION_WARNING: 'La file sélectionnée continue si vous naviguez dans l’application. Gardez cet onglet ouvert jusqu’à la fin ; sa fermeture ou son rechargement peut interrompre les tâches non envoyées.',
        REVIEW_SELECTION_BLOCKED: 'Aucun import tant qu’un entretien sélectionné n’est pas prêt, contient des erreurs bloquantes, est introuvable ou n’a pas de version courante. Corrigez ou actualisez ces lignes, désélectionnez-les ou utilisez « Sélectionner uniquement les entretiens prêts ».',
        REVIEW_FINAL_ACK: 'J’ai vérifié les {{count}} entretiens sélectionnés et leurs objectifs. Je comprends que l’import crée des entretiens historiques terminés, sans demande de signature, e-mails aux participants, notifications de planification ni invitations calendrier.',
        REVIEW_IMPORT_SELECTED: 'Importer les entretiens sélectionnés ({{count}})',
        REVIEW_IMPORT_ONE: 'Importer cet entretien',
        REVIEW_IMPORT_ONE_BLOCKED: 'Cet entretien doit être prêt et à jour, sans erreur bloquante. Ouvrez sa vérification pour compléter les contrôles manquants.',
        REVIEW_IMPORT_ONE_CONFIRM: 'En confirmant, vous attestez avoir vérifié cet entretien et ses objectifs. Seul cet entretien sera importé comme entretien historique terminé, sans demande de signature, e-mails aux participants, notifications de planification ni invitations calendrier. Les autres entretiens sélectionnés ne seront pas importés.',
        REVIEW_IMPORT_ERROR: 'Cet entretien n’a pas été importé. Vérifiez son état actuel avant de réessayer.',
        REVIEW_PARTIAL_FAILURE: '{{count}} entretiens n’ont pas pu être importés et restent sélectionnés pour vérification et nouvel essai. Les imports réussis ne seront pas répétés.',
        REVIEW_IMPORT_SUCCESS: '{{count}} entretiens sélectionnés importés.',
        REVIEW_REFRESH_REQUIRED: 'Ce brouillon n’a pas de version courante. Actualisez ou rouvrez sa vérification avant de l’enregistrer ou de l’importer.',
        REVIEW_STALE_ERROR: 'Le brouillon a changé ou n’est plus modifiable. Actualisez et vérifiez son état avant de réessayer. Votre demande n’a pas été appliquée.',
        REVIEW_MISSING_ERROR: 'Ce brouillon n’existe plus ou est indisponible. Actualisez la liste et vérifiez votre sélection.',
        IMPORT_BUTTON: 'Importer des entretiens',
        CREATE_TITLE: 'Importer des fichiers d’entretien',
        HISTORICAL_IMPORT_NOTICE: 'Les imports PDF et Excel créent des entretiens historiques silencieusement : aucune notification de planification ni invitation calendrier n’est envoyée. L’heure et le préavis en mois sont facultatifs ; laissez-les vides s’ils sont inconnus.',
        CREATE_HELP: 'Sélectionnez une campagne, ajoutez les valeurs par défaut, puis importez vos fichiers. La structure des classeurs Excel doit être vérifiée avant de créer les brouillons.',
        CAMPAIGN: 'Campagne',
        SELECT_CAMPAIGN: 'Sélectionner une campagne',
        DEFAULT_MANAGER: 'Manager par défaut',
        DEFAULT_DATE: 'Date par défaut',
        DEFAULT_TIME: 'Heure par défaut (facultative)',
        DEFAULT_TIME_HELP: 'Utilisée uniquement si l’entretien importé ne contient pas d’heure. Laissez vide si elle est inconnue ; aucune heure n’est supposée.',
        NOTICE_MONTHS: 'Préavis en mois (facultatif)',
        LOCATION: 'Lieu',
        LOCATION_ONSITE: 'Présentiel',
        LOCATION_REMOTE: 'À distance',
        // Historical imports can now represent interviews completed through a form.
        LOCATION_FORM: 'Formulaire',
        INTERVIEW_LINK: 'Lien visio',
        FILES: 'Fichiers PDF ou Excel',
        FILES_HELP: 'Sélectionnez des fichiers sources PDF texte, XLS ou XLSX. Les transferts sont mis en file d’attente, avec trois fichiers envoyés simultanément. Fichiers Excel : 25 Mio maximum par fichier. Le traitement peut continuer après avoir quitté cette page.',
        ACCEPTED_FILES_ONLY: 'Seuls les fichiers PDF, XLS et XLSX sont acceptés.',
        SPREADSHEET_SIZE_ERROR: 'Les fichiers Excel de plus de 25 Mio n’ont pas été ajoutés.',
        MAX_FILES: 'Certains fichiers n’ont pas pu être ajoutés.',
        SELECT_CAMPAIGN_AND_FILES: 'Sélectionnez une campagne et au moins un fichier PDF ou Excel.',
        UPLOAD_ERROR: 'Erreur lors de l’upload du fichier.',
        UPLOAD_MISSING_PATH: 'Le chemin du document uploadé est introuvable.',
        BATCH_CREATED: 'Lot d’import créé. Le traitement est en cours.',
        BATCH_CREATE_ERROR: 'Erreur lors de la création du lot d’import.',
        LOAD_CAMPAIGNS_ERROR: 'Erreur lors du chargement des campagnes.',
        CREATE_BATCH: 'Créer le lot d’import',
        FILES_START_HELP: 'Cliquez sur « {{action}} » pour commencer l’envoi des fichiers sélectionnés.',
        PROGRESS_TITLE: 'Progression',
        PROGRESS_IDLE: 'Aucun traitement en cours.',
        PROGRESS_RUNNING: 'Extraction et analyse en cours. Vous pouvez attendre sur cette page.',
        PROGRESS_DONE: 'Traitement terminé.',
        PROGRESS_SUMMARY: '{{processed}}/{{total}} entretiens traités · {{ready}} prêts · {{review}} à vérifier',
        VALIDATE_READY: 'Valider les prêts ({{count}})',
        VALIDATE_READY_SUCCESS: 'Les brouillons prêts ont été validés.',
        VALIDATE_READY_ERROR: 'Erreur lors de la validation des brouillons prêts.',
        BATCH_SELECTOR: 'Lot d’import',
        BATCH_CREATED_AT: 'Créé le {{date}}',
        NO_BATCH: 'Aucun lot d’import pour cette sélection.',
        DRAFTS_TITLE: 'Brouillons importés',
        DRAFTS_COUNT_SUFFIX: 'brouillons',
        REFRESH: 'Rafraîchir',
        NO_DRAFTS: 'Aucun brouillon importé.',
        NO_DRAFTS_HELP: 'Créez un lot d’import pour commencer à vérifier les entretiens extraits.',
        EMPTY_SELECT_TITLE: 'Commencez par une campagne',
        EMPTY_SELECT_HELP: 'Sélectionnez une campagne ci-dessus ou ouvrez la fenêtre d’import pour ajouter des fichiers PDF ou Excel d’entretien.',
        VIEW_PDF: 'Voir PDF',
        REVIEW_EDIT: 'Vérifier / modifier',
        RETRY: 'Réessayer',
        RETRY_STARTED: 'Réessai lancé.',
        RETRY_VALIDATION: 'Réessayer la validation',
        RETRY_ERROR: 'Erreur lors du réessai.',
        VALIDATE: 'Valider',
        VALIDATE_SUCCESS: 'Brouillon validé avec succès.',
        VALIDATE_ERROR: 'Erreur lors de la validation du brouillon.',
        DRAFT_NEEDS_REVIEW: 'Ce brouillon doit encore être vérifié avant validation.',
        DELETE_TITLE: 'Supprimer le brouillon importé',
        DELETE_BATCH_TITLE: "Supprimer le lot d'import",
        DELETE_BATCH_CONFIRM: "Supprimer ce lot d'import et tous ses brouillons restants ? Les entretiens déjà importés et leurs objectifs restent inchangés. Les sources nécessaires à leurs comptes rendus sont conservées en interne.",
        DELETE_BATCH_SUCCESS: "Lot d'import et brouillons restants supprimés. Les entretiens importés restent inchangés.",
        DELETE_BATCH_BUSY: "Ce lot est en cours de traitement. Attendez la fin de l'extraction ou de l'import, puis réessayez.",
        DELETE_BATCH_ERROR: "Impossible de supprimer le lot d'import. Actualisez et réessayez.",
        DELETE_CONFIRM: 'Voulez-vous vraiment supprimer ce brouillon importé ?',
        DELETE_SUCCESS: 'Brouillon supprimé avec succès.',
        DELETE_ERROR: 'Erreur lors de la suppression du brouillon.',
        FILE_STATUS: {
          PENDING: 'Prêt à envoyer',
          QUEUED: 'En file d’envoi',
          UPLOADING: 'Upload en cours',
          UPLOADED: 'Uploadé',
          FAILED: 'Échec',
        },
        COUNTS: {
          SOURCES: 'Fichiers sources',
          MAPPING: 'Structures à vérifier',
          TOTAL: 'Entretiens',
          PROCESSED: 'Traités',
          READY: 'Prêts',
          FAILED: 'Échecs',
          VALIDATED: 'Validés',
        },
        BULK_AUTOMATION: {
          TITLE: 'Traiter ce lot',
          HELP: 'Vérifiez les fichiers sources, puis traitez les entretiens ensemble. Aucun entretien n’est importé automatiquement.',
          VISIBLE_COUNT: '{{visible}} entretiens visibles sur {{total}}',
          FILTERS: 'Filtrer les entretiens du lot actif',
          FILTER_all: 'Tous',
          FILTER_ready: 'Prêts',
          FILTER_needsReview: 'À vérifier',
          FILTER_failed: 'En échec',
          FILTER_missingEmployee: 'Collaborateur manquant',
          FILTER_missingManager: 'Manager manquant',
          FILTER_objectives: 'Objectifs à vérifier',
          FILTER_missingPlanning: 'Planification incomplète',
          FILTER_converted: 'Importés',
          SEARCH: 'Rechercher un collaborateur ou un manager',
          SCOPE_SELECTED: 'Périmètre : {{count}} entretiens sélectionnés dans ce lot, y compris les sélections masquées.',
          SCOPE_VISIBLE: 'Périmètre : uniquement {{count}} entretiens visibles dans ce lot.',
          SELECTED_COUNT: '{{count}} sélectionnés, dont {{hidden}} masqués par les filtres',
          SELECT_VISIBLE: 'Sélectionner tous les visibles éligibles ({{count}})',
          SELECT_ALL: 'Sélectionner les visibles',
          CLEAR_SELECTION: 'Effacer {{count}} sélections ({{hidden}} masquées)',
          IMPORT_READY_COUNT: 'Importer tous les prêts visibles ({{count}})',
          ACCEPT_COUNT: 'Accepter la règle des objectifs ({{count}})',
          RETRY_FAILED_COUNT: 'Relancer les échecs ({{count}})',
          RETRY_ALL_COUNT: 'Tout relancer parmi les éligibles ({{count}})',
          REMATCH_COUNT: 'Réassocier les utilisateurs manquants ({{count}})',
          FILL_PLANNING: 'Sélectionner les planifications incomplètes et les compléter',
          WAIT_STABLE: 'Les actions groupées seront disponibles après le chargement et le traitement du lot actif. Vérifiez les fichiers sources séparément.',
          NO_MATCH: 'Aucun entretien ne correspond à ces filtres. Les sélections masquées sont conservées.',
          EXCEPTIONS: 'Corriger les utilisateurs manquants par groupes ({{count}})',
          GROUP_HELP: 'Seules les affectations vides sont complétées. Les collaborateurs sont regroupés uniquement avec le même matricule ou courriel et la même identité d’origine ; sinon ils restent séparés. Les groupes de noms de managers nécessitent votre affectation explicite. Vérifiez individuellement les cas ambigus. Aucun compte n’est créé.',
          GROUP_employee: 'Collaborateur dans la source',
          GROUP_manager: 'Manager dans la source',
          GROUP_COUNT: '{{count}} affectations manquantes dans ce périmètre',
          GROUP_RECORDS: 'Vérifier individuellement les entretiens concernés',
          CHOOSE_EXISTING: 'Choisir un utilisateur existant',
          ASSIGN_COUNT: 'Affecter aux {{count}} enregistrements incomplets',
          ACTION_acceptObjectives: 'Accepter la règle des objectifs',
          ACTION_importReady: 'Importer tous les entretiens prêts visibles',
          ACTION_retryFailed: 'Relancer les entretiens en échec',
          ACTION_retryAll: 'Relancer tous les entretiens éligibles',
          ACTION_rematch: 'Réassocier les utilisateurs manquants',
          ACTION_assignEmployee: 'Affecter les collaborateurs manquants',
          ACTION_assignManager: 'Affecter les managers manquants',
          SNAPSHOT_HELP: 'Cette confirmation concerne uniquement le nombre affiché et les versions enregistrées actuelles. Un changement de lot, de filtres, de sélection ou de partage nécessite une nouvelle confirmation.',
          POLICY_HELP: 'Acceptez ensemble, une seule fois pour cette sélection, les objectifs sources et les formulations d’objectifs déduites par l’IA disponibles. Les choix et exclusions humains existants sont conservés. Cette action utilise l’analyse en cache, sans nouvel appel IA, et n’importe aucun entretien.',
          POLICY_PRIVATE: 'Les mentions d’origine source ou IA restent privées dans cette vérification. Elles ne sont pas ajoutées au compte rendu public de l’entretien.',
          POLICY_FACTS: 'Les dates d’origine, les formulations sources et les résultats connus sont conservés. Les résultats manquants restent inconnus ; aucun niveau d’atteinte ni pourcentage n’est inventé. Les contradictions de phase ou d’année restent visibles comme avertissements non bloquants après confirmation. Les consignes actuelles confirmées déterminent le classement par période ; les périodes non résolues et les bilans historiques restent dans le compte rendu, pas dans le menu Objectifs. Les contrôles d’intégrité de la source et d’acceptation restent obligatoires.',
          ASSESSED_YEAR: 'Année évaluée par défaut (facultatif)',
          PLANNED_YEAR: 'Année planifiée par défaut (facultatif)',
          YEAR_HELP: 'Les années à quatre chiffres complètent uniquement une année de classification inconnue lorsque la phase évaluée ou planifiée est connue. Les années et échéances explicites de la source ne changent jamais ; la date de rendez-vous n’est pas utilisée.',
          IMPORT_HELP: 'Importez uniquement les entretiens prêts visibles à l’ouverture de cette fenêtre. Les sélections masquées, les dossiers incomplets et les entretiens déjà importés sont exclus. Il s’agit de la validation finale, distincte de l’acceptation des objectifs.',
          MAIL_HELP: 'Les imports historiques n’envoient aucune notification de planification ni invitation calendrier, quelle que soit la préférence de notification précédemment enregistrée.',
          RETRY_HELP: 'Les brouillons prêts, à vérifier et en échec avec cache sont revérifiés sans IA. Seuls les véritables échecs sans analyse en cache relancent l’extraction et peuvent consommer des crédits IA. Les affectations, la planification et les modifications humaines sont conservées. Les traitements en cours, les fichiers sources et les entretiens convertis sont exclus ; reprenez un entretien converti en échec avec son action Importer existante.',
          REMATCH_HELP: 'Réessayez l’association des collaborateurs et managers manquants aux utilisateurs existants, sans IA. Les affectations existantes ne sont jamais remplacées. Les identités ambiguës ou introuvables restent à corriger manuellement.',
          ASSIGN_HELP: 'Affectez {{name}} à {{count}} affectations vides. Les affectations existantes ne changent pas. Confirmez que ces identités d’origine correspondent à cet utilisateur.',
          AI_CREDITS_ACK: 'J’autorise la relance de l’analyse pour {{count}} entretiens en échec sans cache exploitable et comprends qu’elle peut consommer des crédits IA.',
          CONFIRM_ACK: 'Je confirme cette action pour ces {{count}} entretiens.',
          PROGRESS: '{{completed}} / {{total}} traités : {{success}} réussis, {{failed}} en échec, {{skipped}} ignorés ou non résolus',
          SKIPPED: 'Ignoré ou correction encore nécessaire',
          MATCH_UNRESOLVED: 'Certains utilisateurs ne peuvent pas être associés de façon unique. Choisissez un utilisateur existant ou vérifiez cet entretien.',
          POLICY_UNRESOLVED: 'La règle a été appliquée mais certains objectifs nécessitent encore une vérification individuelle. Cet entretien n’a pas été approuvé pour l’import.',
          COMPLETE: 'Action groupée terminée. Vérifiez les statuts actualisés avant d’importer.',
          PARTIAL: '{{count}} entretiens ont été ignorés ou n’ont pas pu être traités. Les autres ont été traités ; les sélections sont conservées pour correction.',
          ERROR: 'Cet entretien n’a pas pu être traité. Actualisez et vérifiez ses détails avant de réessayer.',
          ERROR_INTERVIEW_IMPORT_CONFLICT: 'Cet entretien a changé ou est en cours de traitement. Actualisez avant de réessayer.',
          ERROR_INTERVIEW_IMPORT_NOT_ELIGIBLE: 'Cet entretien n’est plus éligible à cette action.',
          ERROR_INTERVIEW_IMPORT_ANALYSIS_REQUIRED: 'L’analyse en cache est indisponible. Une relance d’analyse distincte et explicitement confirmée est nécessaire.',
        },
        OBJECTIVE_BADGE: {
          SELECTED_ONE: '1 retenu',
          SELECTED: '{{count}} retenus',
          SELECTED_DETAIL_ONE: '1 retenu pour l’import',
          SELECTED_DETAIL: '{{count}} retenus pour l’import',
          SUGGESTIONS_REVIEW_ONE: '1 suggestion à vérifier',
          SUGGESTIONS_REVIEW: '{{count}} suggestions à vérifier',
          SUGGESTIONS_AVAILABLE_ONE: '+1 suggestion disponible',
          SUGGESTIONS_AVAILABLE: '+{{count}} suggestions disponibles',
          SUGGESTIONS_HELP: 'Ces suggestions ne sont pas incluses dans la liste retenue pour l’import.',
          REVIEW: 'À vérifier',
          VERIFIED: 'Vérifiés',
          VERIFIED_ONE: 'Vérifié',
          WITHOUT: 'Sans objectif',
          CONFIRMED: 'Confirmé',
          NONE: 'Aucun objectif détecté',
          ANALYZE: 'À analyser',
          SOURCE_REVIEW: 'Source à vérifier',
        },
        TABLE: {
          STATUS: 'Statut',
          FILE: 'Fichier',
          COLLABORATOR: 'Collaborateur',
          MANAGER: 'Manager',
          DATE: 'Date',
          CONFIDENCE: 'Confiance',
          OBJECTIVES: 'Objectifs',
          ERRORS: 'Alertes',
          ACTIONS: 'Actions',
        },
        STATUS: {
          AWAITING_MAPPING: 'À vérifier',
          MAPPED: 'Brouillons d’entretien générés',
          UPLOADED: 'Uploadé',
          PROCESSING: 'Traitement en cours',
          QUEUED: 'En attente d’analyse',
          ANALYSING: 'Analyse IA',
          PREPARING: 'Préparation des brouillons',
          COMPLETED: 'Terminé',
          COMPLETED_WITH_ERRORS: 'Terminé avec erreurs',
          EXTRACTING_TEXT: 'Extraction texte',
          ANALYZING: 'Analyse IA',
          NEEDS_REVIEW: 'À revoir',
          READY: 'Prêt',
          VALIDATING: 'Validation',
          VALIDATED: 'Validé',
          VALIDATED_WITH_WARNINGS: 'Validé avec alertes',
          FAILED: 'Échec',
          FAILED_VALIDATION: 'Échec validation',
          DELETED: 'Supprimé',
          UNKNOWN: 'Inconnu',
        },
        WARNING: {
          MISSING_CAMPAIGN: 'La campagne est obligatoire.',
          INTERVIEW_SPREADSHEET_FONT: 'Le PDF individuel n’a pas pu être généré. Vos réponses sources sont conservées. Relancez la préparation une fois le problème de rendu corrigé.',
          INTERVIEW_MAPPING_INPUT_LIMIT: 'Le classeur complet dépasse la limite d’analyse IA. L’analyse a été arrêtée sans raccourcir la source. Répartissez le contenu dans des classeurs plus petits puis réessayez.',
          INTERVIEW_IMPORT_AI_INPUT_LIMIT: 'L’entretien complet dépasse la limite d’analyse IA. Aucun texte partiel n’a été envoyé. Utilisez un document source plus petit puis réessayez.',
          INTERVIEW_IMPORT_AI_CONTEXT_UNAVAILABLE: 'Les questions et le contexte source complets ne sont pas disponibles pour cet ancien brouillon. Revérifiez la préparation du classeur avant de réessayer ; aucune analyse partielle n’a été effectuée.',
          MISSING_INTERVIEW_TYPE: 'Le type d’entretien de la campagne est obligatoire.',
          MISSING_EMPLOYEE: 'Le collaborateur doit être sélectionné.',
          MISSING_MANAGER: 'Le manager doit être sélectionné.',
          MISSING_INTERVIEW_DATE: 'La date de l’entretien est obligatoire.',
          MISSING_INTERVIEW_TIME: 'L’heure de l’entretien est obligatoire.',
          MISSING_NOTICE_MONTHS: 'Le préavis en mois est obligatoire.',
          INVALID_INTERVIEW_TIME: 'Renseignez une heure d’entretien valide ou laissez le champ vide si elle est inconnue.',
          INVALID_NOTICE_MONTHS: 'Renseignez un nombre entier positif de mois de préavis ou laissez le champ vide si cette valeur est inconnue.',
          MISSING_DOCUMENT: 'Le document PDF uploadé est obligatoire.',
          MISSING_EXTRACTED_TEXT: 'Le texte extrait de l’entretien est obligatoire.',
          MISSING_DOC_HTML: 'Le HTML généré de l’entretien est obligatoire.',
          MISSING_WORKFLOW: 'Le workflow généré est obligatoire.',
          OBJECTIVES_NOT_REVIEWED: 'Les objectifs doivent être vérifiés avant validation.',
          EXCEL_INSTRUCTION_ANALYSIS_STALE: 'L’analyse de l’entretien est absente ou ne correspond plus aux consignes actuelles du classeur. Relancez l’analyse du brouillon avant l’import.',
          SPREADSHEET_ARTIFACT: 'Le document individuel de l’entretien est absent ou ne correspond plus au texte source actuel. Il doit être régénéré avant l’import.',
          OBJECTIVE_CLASSIFICATION_STALE: 'Le classement des objectifs ne peut plus être vérifié par rapport à la sélection et à la source actuelles. Vérifiez les objectifs puis enregistrez le brouillon pour le recalculer avant confirmation.',
          OBJECTIVE_ACCEPTANCE_REQUIRED: 'Le classement actuel des objectifs n’a pas été accepté. Vérifiez les objectifs sélectionnés, résolvez les blocages, puis confirmez la liste et enregistrez le brouillon.',
          OBJECTIVE_SOURCE_STALE: 'Un objectif sélectionné ne peut plus être vérifié par rapport à sa source. Vérifiez son association à la source avant confirmation ; son titre seul ne prouve pas la correspondance.',
          OBJECTIVE_PHASE_CONFLICT: 'Avertissement non bloquant : le texte source et son interprétation divergent entre bilan et objectif à venir. Vérifiez la période appliquée ; les consignes actuelles confirmées déterminent son classement. Cet avertissement n’empêche pas l’import de l’entretien après confirmation et le texte original est conservé.',
          OBJECTIVE_YEAR_CONFLICT: 'Avertissement non bloquant : les années sources divergent entre elles ou avec les consignes actuelles confirmées. Vérifiez l’année appliquée sans réécrire le texte source ni les échéances. Cet avertissement n’empêche pas l’import de l’entretien après confirmation.',
          OBJECTIVE_PERIOD_MULTIPLE_YEARS: 'Plusieurs années figurent dans la source. Vérifiez l’année de classement appliquée. Une année non résolue reste uniquement dans le compte rendu, sans création dans le menu Objectifs ; cet avertissement ne bloque pas l’import de l’entretien après confirmation.',
          OBJECTIVE_PERIOD_UNKNOWN: 'La période de l’objectif n’est pas entièrement établie. Si sa phase ou son année reste inconnue, il est conservé uniquement dans le compte rendu, pas dans le menu Objectifs. L’import de l’entretien reste possible après confirmation.',
          OBJECTIVE_PLANNING_AMBIGUOUS: 'La source ne distingue pas clairement un objectif à venir d’un contexte historique. Vérifiez la période appliquée ; une phase ou une année non résolue reste uniquement dans le compte rendu. Cet avertissement ne bloque pas l’import de l’entretien après confirmation.',
          OBJECTIVE_HISTORY_ONLY: 'Certains objectifs évalués ou dont la période reste indéterminée sont conservés uniquement dans le compte rendu de l’entretien, sans création dans le menu Objectifs. Cela n’empêche pas l’import de l’entretien après confirmation.',
          INTERVIEW_INTERPRETATION_STALE: 'L’interprétation du classeur est absente ou ne correspond plus à la source. Vérifiez la préparation du classeur avant de réessayer.',
          AMBIGUOUS_INTERVIEW_DATE: 'La date d’entretien extraite est ambiguë. Vérifiez la date avant validation.',
          SHORT_TEXT: 'Le PDF est peut-être scanné ou illisible.',
          EMPLOYEE_MATCH: 'La correspondance du collaborateur doit être vérifiée.',
          MANAGER_MATCH: 'La correspondance du manager doit être vérifiée.',
          PROCESSING_ERROR: 'L’analyse de la source ou la préparation du brouillon a échoué.',
          INSUFFICIENT_AI_CREDITS: 'Crédits IA insuffisants pour analyser ce fichier.',
          OBJECTIVE_IMPORT_FAILED: 'L’import des objectifs a échoué.',
          CONVERSION_FAILED: 'La validation de l’import a échoué.',
          FAILED: 'L’analyse ou la préparation du brouillon a échoué.',
          DIAGNOSTIC_CODE: 'Code de diagnostic : {{code}}.',
          FAILED_VALIDATION: 'La validation a échoué.',
          AI_WARNING: 'L’analyse IA signale un point à vérifier. Contrôlez l’aperçu et la présence de toutes les réponses attendues avant l’import. Cet avertissement seul ne signifie pas que l’analyse a échoué.',
          INTERVIEW_OBJECTIVE_GUIDANCE_EVIDENCE: 'L’analyse guidée des objectifs n’a pas pu vérifier ses justificatifs sources. Il s’agit d’un échec d’analyse du brouillon, pas de l’import final.',
          INTERVIEW_INTERPRETATION_DELIVERY_UNAVAILABLE: 'Aucun document d’entretien exploitable n’a pu être préparé à partir du contenu source retenu. Vérifiez la source et son interprétation ; cette préparation n’a effectué aucun import final.',
        },
        OBJECTIVE_EVIDENCE_REASON: {
          evidence_list_invalid: 'La proposition n’a pas fourni une liste valide de citations sources.',
          citation_shape_invalid: 'Une citation source présente une structure invalide.',
          citation_ref_invalid: 'Une référence de cellule source est invalide.',
          citation_part_invalid: 'La citation utilise une partie de la source non prise en charge.',
          citation_quote_invalid: 'Un passage cité est vide ou dépasse la taille prise en charge.',
          source_ref_unavailable: 'La cellule citée n’est pas disponible dans la source validée de cet entretien.',
          source_part_unavailable: 'L’en-tête, la question ou la valeur citée n’est pas disponible à cette référence.',
          quote_not_in_source: 'Le passage cité n’a pas été retrouvé dans le texte source référencé.',
          duplicate_citation: 'La proposition répète une citation source.',
          source_value_required: 'Une réponse source est nécessaire ; un titre ou une date seuls ne suffisent pas à établir un objectif.',
          fact_shape_invalid: 'Un KPI, une échéance ou une année proposés présentent une structure invalide.',
          fact_part_invalid: 'Le fait proposé s’appuie sur une partie de la source non prise en charge.',
          fact_value_unsupported: 'Le KPI, l’échéance ou l’année proposés ne sont pas étayés par le passage cité.',
          fact_value_ambiguous: 'La citation ne permet pas d’identifier sans ambiguïté la valeur de ce fait.',
          year_not_in_source: 'L’année présentée comme issue de la source n’apparaît pas dans le justificatif cité.',
        },
        SPREADSHEET: {
          DUPLICATE_MATCHING: {
            TITLE: 'Associer les réponses aux entretiens en doublon',
            HELP: 'Plusieurs entretiens concernent le même collaborateur. Vérifiez l’entretien associé à chaque bloc de réponses et modifiez les choix si nécessaire. Les associations déjà enregistrées sont conservées.',
            ORDER_SUGGESTION: 'Associations proposées : à vérifier. Lorsque les nombres correspondent, les blocs de réponses sont proposés dans le même ordre que les entretiens du collaborateur. Cet ordre n’est pas une preuve : vérifiez les managers et les réponses. Les cas non concordants restent sans choix automatique.',
            CONFIRM: 'J’ai vérifié ces associations et corrigé les choix si nécessaire.',
            CONFIRM_HELP: 'Vérifiez les associations puis cochez la confirmation avant de les enregistrer.',
            GROUP: 'Groupe de doublons {{number}}',
            SELECT_LABEL: 'Associer ce bloc de réponses à',
            PLACEHOLDER: 'Choisir un entretien',
            CHOICE: 'Manager : {{manager}} | Collaborateur : {{employee}} | Feuille principale {{sheet}}, ligne {{row}}',
            CONFLICT: 'Dans ce groupe de doublons, deux blocs de la même feuille ne peuvent pas être associés au même entretien.',
            INCOMPLETE: 'Choisissez un entretien pour chaque bloc, sans associer deux blocs de la même feuille au même entretien.',
            SAVE_HELP: 'Enregistrez ces associations pour actualiser l’aperçu, puis poursuivez la vérification habituelle avant de préparer les brouillons.',
            SAVE: 'Enregistrer les associations et voir l’aperçu',
            LOAD: 'Charger les blocs de réponses en doublon',
          },
          SIMPLE_TITLE: 'Vérifier l’import Excel',
          SIMPLE_HELP: 'Vérifiez les entretiens détectés, puis préparez leurs brouillons privés. Sans consignes, la vérification des questions est facultative.',
          SIMPLE_COUNT: 'entretiens détectés',
          SIMPLE_COUNT_UNCONFIRMED: 'entretiens proposés à vérifier',
          SIMPLE_IDENTITIES: 'identités distinctes dans le fichier',
          SIMPLE_NOT_CREATED: 'Cette étape prépare uniquement des brouillons privés. Aucun entretien réel n’est créé avant l’import final depuis la page principale.',
          PRIMARY_LISTS: 'Listes principales d’entretiens',
          SUPPORTING_COUNT: '{{count}} feuille(s) complémentaires ajoutent des détails, pas des entretiens supplémentaires.',
          PRIMARY_CHOICE_TITLE: 'Quelle feuille contient la liste des entretiens ?',
          PRIMARY_CHOICE_HELP: 'Choisissez la feuille qui définit les entretiens, et non une liste d’objectifs ou de formations. Le fichier sera réanalysé selon votre choix, sans modifier les autres réglages ici.',
          PRIMARY_CHOICE_PLACEHOLDER: 'Choisir une feuille de ce fichier',
          PRIMARY_CHOICE_ACTION: 'Analyser avec cette liste d’entretiens',
          LEGACY_ROLE_UPGRADE: 'Cette ancienne analyse ne distingue pas les entretiens principaux des détails complémentaires. Choisissez la liste principale et relancez l’analyse avant la préparation des brouillons privés.',
          SUPPORTING_CORRECTION_HELP: 'Certains détails ne peuvent pas être rattachés à un entretien. Précisez dans les consignes la feuille des entretiens et l’identifiant qui les relie, puis relancez l’analyse. Aucune attribution ne sera devinée.',
          ROLE: 'Rôle de la feuille',
          ROLES: { primary: 'Entretiens principaux', supporting: 'Détails complémentaires', unresolved: 'Non déterminé' },
          SHEET_TITLE_REF: 'Titre',
          PREPARE_SUCCESS: 'Brouillons privés préparés. Relisez-les et corrigez-les avant l’import final.',
          SIMPLE_ISSUE_TITLE: 'Un point est à vérifier avant de continuer',
          SIMPLE_ISSUE_FIELD: 'Certaines informations se contredisent. Précisez leur lecture dans les consignes, puis relancez l’analyse.',
          SIMPLE_ISSUE_IDENTITY: 'Certains entretiens ne peuvent pas être attribués avec certitude. Précisez l’identifiant du collaborateur et le regroupement des entretiens dans les consignes, puis relancez l’analyse.',
          SIMPLE_ISSUE_MAPPING: 'La lecture du fichier doit être vérifiée. Précisez vos consignes si nécessaire, puis relancez l’analyse.',
          SIMPLE_CORRECT: 'Voir le point à corriger',
          SIMPLE_RETRY: 'Relancer l’analyse',
          SIMPLE_DIAGNOSTIC_DETAILS: 'Afficher les détails techniques',
          SIMPLE_HEADERS_TITLE: 'Vérifier les questions détectées',
          COMPACT_HEADERS_COUNT: '{{count}} textes · {{sheets}} feuilles',
          COMPACT_HEADERS_SHEETS: 'Feuilles concernées',
          COMPACT_HEADERS_DETAILS: 'Lire les {{count}} questions et libellés',
          COMPACT_HEADERS_HIDE_DETAILS: 'Afficher seulement les exemples',
          HEADERS_EXPAND_FIRST: 'Ouvrez la liste complète des questions avant de confirmer.',
          OPTIONAL_HEADER_REVIEW: 'Facultatif',
          OPTIONAL_HEADER_REVIEW_HELP: 'Ce contrôle facultatif concerne l’affichage des questions dans le compte rendu. L’IA reçoit le texte source complet même avant ce contrôle.',
          HEADER_CHECK: {
            TITLE: 'Vérifier les questions détectées',
            SUMMARY: '{{answers}} réponses concernant {{affected}} entretiens sur {{total}} nécessitent la confirmation de leurs libellés.',
            HELP: 'Vérifiez les questions communes une seule fois pour ce fichier, pas pour chaque collaborateur. Sans confirmation, les réponses associées seraient absentes des comptes rendus.',
            EXAMPLE: 'Exemple de réponse de l’entretien {{number}}',
            ALL_CHECKED: 'Les {{count}} entretiens ont été vérifiés. Les exemples sont illustratifs ; les compteurs portent sur tout le fichier.',
            REVIEW_ALL: 'Vérifier tous les libellés et titres communs ({{count}} feuilles)',
            CONFIRM: 'Je confirme que tous les libellés et titres de feuilles présentés ici sont communs et ne contiennent aucune réponse propre à un collaborateur. Cette confirmation porte sur la structure, pas sur les réponses.',
            CONFIRM_HELP: 'Ouvrez la liste complète des libellés, vérifiez-la, puis confirmez une seule fois pour le fichier. Les libellés techniques sans réponse sont disponibles uniquement dans les détails techniques.',
            PREPARE: 'Confirmer et préparer les brouillons',
            REQUIRED: 'Les libellés de certaines réponses restent à vérifier. Actualisez l’aperçu et résolvez les points signalés avant de préparer les brouillons.',
            REFRESH: 'Actualisez l’aperçu pour vérifier les libellés manquants dans tous les entretiens. Aucune confirmation supplémentaire ne sera demandée si aucune réponse n’est concernée.',
            UNRESOLVED: 'Certaines réponses renseignées n’ont pas de libellé de question exploitable. Corrigez les en-têtes du fichier ou précisez leur association dans les consignes avant de préparer les brouillons.',
            UNRESOLVED_COUNT: '{{count}} réponses renseignées n’ont pas de libellé de question exploitable. La confirmation des libellés ne suffit pas. Corrigez les en-têtes du fichier ou précisez leur association dans les consignes.',
            CHANGED: 'Le résultat actualisé n’a pas pu être confirmé comme inchangé. Aucun brouillon n’a été préparé automatiquement. Actualisez et vérifiez le dernier résultat avant de continuer.',
          },
          HEADER_NOTICE_TITLE: 'Les questions et titres de colonnes sont à vérifier',
          HEADER_NOTICE_HELP: 'Certains libellés de questions ne sont pas confirmés. Leurs réponses peuvent être absentes du compte rendu final, même si elles figurent dans l’aperçu source. Vérifiez les libellés complets de chaque feuille ci-dessous, confirmez qu’ils ne contiennent aucune réponse individuelle, puis recalculez l’aperçu. Les réponses originales sont conservées.',
          HEADER_NOTICE_ACTION: 'Vérifier les questions et les titres',
          HEADER_NOTICE_REFRESH_TITLE: 'Une remarque concerne les titres du fichier',
          HEADER_NOTICE_REFRESH_HELP: 'L’analyse a signalé des titres non reconnus, mais leurs détails de vérification ne sont pas disponibles ici. Actualisez l’aperçu pour vérifier leur état actuel.',
          SIMPLE_HEADERS_HELP: 'Vérifiez que ces textes sont les questions ou les en-têtes du fichier, et non des réponses. Ce contrôle porte sur la structure des brouillons, pas sur ce que l’IA a le droit de lire.',
          SIMPLE_HEADERS_PROGRESS: '{{done}} feuilles vérifiées sur {{total}}',
          SIMPLE_HEADERS_CONTENT: 'Questions et titres détectés complets',
          SIMPLE_HEADERS_ACK: 'Ces textes sont des questions ou des titres, pas des réponses individuelles.',
          SIMPLE_HEADERS_CONFIRM: 'Confirmer et continuer',
          NOT_A_HEADING: 'Corriger cette détection',
          WRONG_LABEL_ORIGIN_HELP: 'Choisissez l’emplacement à corriger. Aucune donnée source ne sera supprimée.',
          WRONG_LABEL_HEADER_ROW: 'Ligne d’en-tête affichée dans cette vérification : {{row}}.',
          WRONG_LABEL_HEADER_HELP: 'Vérifiez la ligne d’en-tête sélectionnée à l’aide des exemples sources ci-dessous, s’ils sont disponibles. Les réponses individuelles doivent rester dans le contenu des entretiens, pas dans les intitulés communs. Aucune cellule, valeur ou ligne n’a été supprimée. Corrigez les réglages, puis vérifiez à nouveau.',
          WRONG_LABEL_TITLE_HELP: 'Il s’agit du titre d’une feuille, pas d’une cellule ni d’une référence A1. Vérifiez le périmètre et la structure adaptés à cette feuille. Si son titre contient une réponse individuelle ou des informations personnelles, corrigez le fichier source puis relancez l’analyse. Cette action ne renomme pas la feuille et ne supprime aucun contenu.',
          SIMPLE_HEADERS_DONE: 'Questions vérifiées.',
          SIMPLE_HEADERS_NEXT: 'Vérifier la feuille suivante',
          SIMPLE_CHECKED: 'vérifié',
          SIMPLE_HEADERS_REOPEN: 'Revoir',
          SIMPLE_HEADERS_ALL_DONE: 'Questions vérifiées.',
          SIMPLE_HEADERS_FIRST: 'Continuez pour préparer les brouillons. Sans consignes, la vérification des questions est facultative.',
          SIMPLE_REFRESH_FIRST: 'Revérifiez la détection après un changement de réglages.',
          SIMPLE_EXAMPLES_TITLE: 'Exemples d’entretiens détectés',
          SIMPLE_EXAMPLES_HELP: '{{shown}} exemples sur {{total}} entretiens. Seuls les 3 premiers sont présentés ici ; tous les brouillons privés restent disponibles pour correction avant l’import.',
          SIMPLE_SELECT_EXAMPLE: 'Choisir un exemple d’entretien',
          SIMPLE_EXAMPLE_NUMBER: 'Exemple {{number}}',
          SIMPLE_IDENTITY_MISSING: 'Collaborateur à identifier',
          SIMPLE_TO_COMPLETE: 'À compléter dans le brouillon',
          SIMPLE_VIEW_CONTENT: 'Lire le contenu extrait',
          SIMPLE_SAMPLE_LIMIT: 'Les exemples présentent au plus les 3 premiers entretiens, pas le classeur complet. Les nombres incluent tous les entretiens détectés.',
          SIMPLE_REPEAT_WARNING: '{{repeatedEmployeeCount}} identités du fichier apparaissent dans plusieurs entretiens. Vérifiez qu’il s’agit bien d’entretiens distincts, et non de lignes d’objectifs ou de formations.',
          SIMPLE_NOTES: '{{count}} remarques à lire',
          SIMPLE_CONTENT_SCOPE: 'Contenu des brouillons : {{included}} feuilles retenues, {{ignored}} hors entretiens',
          SIMPLE_INCLUDED: 'Utilisée',
          SIMPLE_EXCLUDED: 'Non reprise dans les brouillons',
          SIMPLE_SHEET: 'Feuille',
          SIMPLE_ADVANCED: 'Réglages avancés',
          SIMPLE_ADVANCED_TITLE: 'Corriger les réglages de détection',
          SIMPLE_ADVANCED_HELP: 'Ces réglages servent uniquement à corriger la détection. Travaillez sur une feuille, puis actualisez l’aperçu.',
          SIMPLE_CLOSE_SETTINGS: 'Revenir à la vérification',
          SIMPLE_PREVIEW_NEEDED: 'Continuez avec la structure détectée pour préparer les brouillons privés. Aucun entretien ne sera importé.',
          SIMPLE_REVIEW_HEADERS: 'Vérifier les questions',
          SIMPLE_CHECKING: 'Vérification et préparation...',
          SIMPLE_REFRESH: 'Préparer les brouillons',
          SIMPLE_CREATE: 'Créer les {{count}} brouillons',
          SIMPLE_FINAL_ACK: 'J’ai vérifié le contenu proposé et les remarques pour ces {{count}} brouillons.',
          SIMPLE_CREATING: 'Création des brouillons...',
          TITLE: 'Vérifier l’import Excel',
          SOURCES_TITLE: 'Fichiers Excel',
          DELETE_SOURCE_TITLE: 'Supprimer le fichier source Excel',
          DELETE_SOURCE_CONFIRM: 'Supprimer ce fichier source et sa structure non confirmée ? Aucun brouillon d’entretien n’a été généré à partir de cette source.',
          AWAITING_HELP: 'Vérifiez la structure de chaque classeur avant de générer ses brouillons d’entretien. Les fichiers sources ne sont pas des entretiens.',
          SOURCE_HELP: 'La source n’est pas téléchargeable. Vérifiez la structure et les exemples du serveur pour créer les PDF individuels.',
          NO_INTERVIEWS_YET: 'Aucun brouillon d’entretien pour le moment. Terminez la vérification de la structure du classeur ci-dessus.',
          GENERATED_COUNT: '{{count}} brouillon(s) d’entretien généré(s). Vérifiez-les ci-dessous.',
          REVIEW_LAYOUT: 'Vérifier la structure',
          HELP: 'Choisissez comment chaque feuille devient des entretiens, associez les champs d’identité et de date, puis générez un aperçu. Aucun entretien n’est créé sans confirmation explicite.',
          SHEET_BOUNDS: '{{rows}} lignes / {{columns}} colonnes',
          IDENTITY_SUMMARY: '{{recordCount}} entretiens proposés / {{distinctEmployeeCount}} collaborateurs identifiés',
          IDENTITY_DETAILS: '{{identifiedRecordCount}} entretiens proposés disposent d’un identifiant de collaborateur. Ces nombres proviennent des identités associées dans la source, pas de correspondances vérifiées avec les collaborateurs.',
          REPEATED_EMPLOYEES_WARNING: '{{repeatedEmployeeCount}} collaborateurs ont plusieurs entretiens proposés (jusqu’à {{maxRecordsPerEmployee}} par collaborateur). Plusieurs entretiens par collaborateur peuvent être légitimes pour des dates ou périodes différentes, mais les objectifs et l’historique des formations ne doivent pas être comptés comme des entretiens distincts. Vérifiez les correspondances des champs et le regroupement avant de confirmer.',
          CONFLICTING_FIELD_HELP: 'Des correspondances attribuent des valeurs différentes au même champ dans un seul entretien. Corrigez la correspondance de champ incorrecte, puis demandez un nouvel aperçu. Ne découpez pas un entretien en entretiens distincts pour les objectifs ou l’historique des formations uniquement pour supprimer le conflit.',
          CONFLICTING_FIELD_LOCATION: 'feuille "{{sheet}}", cellule {{cell}}',
          CONFLICTING_FIELD_BINDINGS: '{{field}} : correspondances en conflit provenant de {{first}} et de {{second}}.',
          MISSING_INTERVIEW_IDENTITY_HELP: 'Certains entretiens proposés n’ont pas d’identité de collaborateur. Associez un identifiant de collaborateur (matricule, e-mail ou nom) et regroupez les lignes de détail avec leur entretien. Les objectifs et l’historique des formations ne doivent pas devenir des entretiens distincts. Ne devinez pas les identités ; demandez un nouvel aperçu après correction de la structure.',
          AMBIGUOUS_INTERVIEW_SEGMENTATION_HELP: 'Les identités ou les limites des entretiens sont ambiguës. Résolvez les homonymes et les identités contradictoires avec un matricule ou un e-mail du fichier avant d’utiliser les dates. Pour un même collaborateur identifié, rattachez les détails d’un seul entretien ou associez la date réelle ou la période évaluée d’entretiens réellement distincts. Les dates des objectifs et des formations ne sont pas des dates d’entretien. Aucune fusion n’est automatique ; corrigez la structure et demandez un nouvel aperçu.',
          IDENTITY_RECORD_SOURCES: 'Entretien proposé {{record}} : {{sources}}.',
          INVALID_JOIN_MODE_HELP: 'Les listes principales jointes doivent utiliser le mode par lignes ou regroupé avec une clé complète et ordonnée. Les feuilles complémentaires doivent être regroupées. Les formulaires restent indépendants. Vérifiez ces réglages sans supprimer de détails sources.',
          INVALID_SHEET_ROLE_HELP: 'Chaque feuille incluse doit avoir un rôle explicite : entretiens principaux ou détails complémentaires. Les feuilles ignorées ne doivent pas avoir de rôle.',
          ROLE_REQUIRED_HELP: 'Choisissez les feuilles qui définissent les entretiens et celles qui contiennent des détails complémentaires avant de continuer.',
          PRIMARY_SHEET_REQUIRED_HELP: 'Choisissez une liste principale d’entretiens. Les détails complémentaires ne peuvent pas créer d’entretiens.',
          INVALID_PRIMARY_SHEET_COUNT_HELP: 'Chaque groupe de jointure doit contenir une seule liste principale. Chaque formulaire indépendant peut être une source principale.',
          INVALID_SUPPORTING_SHEET_HELP: 'Les feuilles complémentaires doivent être regroupées et jointes à une seule liste principale au moyen de clés complètes et ordonnées.',
          UNMATCHED_SUPPORTING_KEY_HELP: 'Certaines lignes complémentaires ne correspondent à aucun entretien principal. Corrigez les plages sources ou les clés complètes indiquées ; ne supprimez pas les lignes et ne créez pas d’entretiens supplémentaires.',
          SUPPORTING_IDENTITY_MISMATCH_HELP: 'Les détails complémentaires identifient un autre collaborateur que l’entretien principal. Corrigez le rattachement ou les références de clé sans écraser les identités.',
          DUPLICATE_PRIMARY_KEY_HELP: 'Plusieurs lignes principales partagent une clé de recherche. Vérifiez l’identifiant complet de l’entretien et sa période, tout en conservant les entretiens réellement distincts.',
          NONCONTIGUOUS_GROUP_KEY_HELP: 'Le même identifiant de collaborateur réapparaît dans des blocs de réponses séparés. Vérifiez d’abord la liste principale d’entretiens, puis associez les entretiens en doublon si cela vous est proposé. Ne fusionnez pas des entretiens distincts et ne supprimez pas de lignes de réponses.',
          PRIMARY_SELECTION_MISMATCH_HELP: 'Les feuilles principales détectées ne correspondent pas à votre choix. Relancez l’analyse avec la liste choisie ou vérifiez les rôles des feuilles.',
          INCOMPATIBLE_JOIN_KEYS_SHEETS: 'Les feuilles {{sheets}} et {{lastSheet}} n’utilisent pas le même nombre de colonnes de clé de jointure.',
          INCOMPATIBLE_JOIN_KEYS_FALLBACK: 'Certaines feuilles jointes n’utilisent pas le même nombre de colonnes de clé de jointure.',
          INCOMPATIBLE_JOIN_KEYS_HELP: 'Vérifiez les colonnes de clé de jointure dans la structure. Choisissez les mêmes éléments d’identification, dans le même ordre, pour ces feuilles. Les lettres des colonnes peuvent être différentes.',
          ORPHAN_CONTINUATION_FALLBACK: 'Une ligne contient des données mais aucune clé de regroupement : son entretien ne peut pas être déterminé. Vérifiez les références des colonnes de clé, la première ligne de données, le paramètre de continuation et les séparateurs vides dans la structure, puis demandez un nouvel aperçu. Ne devinez pas le collaborateur et ne propagez pas une clé au-delà d’un séparateur vide.',
          ORPHAN_CONTINUATION_LOCATION: 'Feuille "{{sheet}}", ligne {{row}}.',
          ORPHAN_CONTINUATION_ROW: 'Ligne {{row}}.',
          ORPHAN_CONTINUATION_CONTEXT: 'Cellules de clé de regroupement : {{keys}}. Lignes de données sélectionnées : {{start}}-{{end}}.',
          ORPHAN_CONTINUATION_DISABLED: 'Cette ligne contient des données mais aucune clé de regroupement. Les lignes de continuation sont désactivées ; la clé complète précédente se trouve à la ligne {{row}}, sans séparateur vide entre les deux. Envisagez d’activer les lignes de continuation uniquement si cette ligne appartient à cet entretien précédent, puis demandez un nouvel aperçu. Rien n’est activé automatiquement.',
          ORPHAN_CONTINUATION_NO_KEY: 'Cette ligne contient des données mais aucune clé de regroupement, et aucune clé complète précédente n’est disponible dans la plage de données sélectionnée. Vérifiez les références des colonnes de clé et la première ligne de données dans la structure source. Activer la continuation ne suffit pas à identifier l’entretien ; ne devinez jamais le collaborateur.',
          ORPHAN_CONTINUATION_SEPARATOR: 'Cette ligne contient des données mais aucune clé de regroupement. La ligne vide de séparation {{row}} a effacé le rattachement à l’entretien précédent. Vérifiez la structure, les références de clé de regroupement et les limites de lignes. Ne propagez pas une clé au-delà du séparateur ; activer la continuation ne suffit pas à résoudre cette ligne.',
          SHEET_SAMPLES: 'Voir des exemples de cellules',
          SHEET_SAMPLES_HELP: 'Ces exemples limités aident à identifier les colonnes et les coordonnées du formulaire. Ils ne représentent pas toute la feuille : des valeurs et des lignes peuvent être omises ou raccourcies.',
          HEADER_REVIEW_TITLE: 'Vérifier les libellés partagés de la ligne {{row}}',
          HEADER_REVIEW_HELP: 'Ces cellules non reconnues seraient répétées dans chaque entretien de cette feuille. Vérifiez leur texte complet. Si une cellule contient une réponse ou des informations personnelles, corrigez la ligne d’en-tête au lieu de la valider.',
          HEADER_REVIEW_ACK: 'Je confirme que ces cellules contiennent uniquement des questions ou des libellés communs, sans information propre à un collaborateur. Recalculez ensuite l’aperçu.',
          HEADER_REVIEW_TOO_LARGE: 'Les questions complètes ne peuvent pas être vérifiées en toute sécurité. Précisez leur emplacement dans les consignes puis relancez l’analyse, ou corrigez le fichier source. Aucun libellé n’a été approuvé.',
          PREPARE_BLOCKED: {
            BUSY: 'Patientez pendant l’opération en cours.',
            ANALYSIS: 'Cliquez sur « Analyser avec ces consignes » pour relancer l’analyse du fichier avant de préparer les brouillons.',
            HEADERS: 'Les questions détectées ne peuvent pas être utilisées de façon sûre. Vérifiez le fichier source puis relancez l’analyse.',
            PREVIEW: 'Cliquez sur « Revérifier le fichier » avant de préparer les brouillons. Cette vérification n’utilise pas l’IA.',
            EMPTY: 'Aucun entretien détecté. Vérifiez le fichier source ou précisez la liste des entretiens dans les consignes, puis relancez l’analyse.',
            INTERPRETATION: 'Cochez la confirmation de l’interprétation ci-dessus avant de préparer les brouillons privés.',
          },
          HIDDEN_SHEET: 'Cette feuille est masquée dans le classeur. Vérifiez si elle doit être ignorée.',
          MERGES: 'Cellules fusionnées',
          MODE: 'Mode de lecture',
          REASON: 'Explication de la structure',
          MODES: { ignore: 'Ignorer la feuille', rows: 'Un entretien par ligne', grouped: 'Regrouper les lignes par clé', form: 'Un formulaire par feuille', blocks: 'Formulaires répétés à hauteur fixe' },
          MODE_HELP: {
            ignore: 'Cette feuille est explicitement exclue de l’import.',
            rows: 'Chaque ligne de données crée un entretien.',
            grouped: 'Les lignes aux clés identiques forment un entretien. Les jointures entre feuilles doivent être configurées explicitement.',
            form: 'Cette feuille contient un seul formulaire d’entretien.',
            blocks: 'Chaque bloc de hauteur fixe contient un entretien. Les références indiquent les cellules du premier bloc, puis se décalent de la hauteur du bloc.',
          },
          HEADER_ROW: 'Ligne d’en-tête (facultative)',
          START_ROW: 'Première ligne de données (facultative)',
          END_ROW: 'Dernière ligne de données (facultative)',
          BLOCK_ROWS: 'Lignes par bloc',
          ROWS_HELP: 'Les lignes commencent à 1. Les bornes de début et de fin sont incluses. Laissez les bornes facultatives vides pour utiliser les valeurs du serveur.',
          DATE_FORMAT: 'Ordre de la date',
          DATE_FORMATS: { dmy: 'Jour / Mois / Année', mdy: 'Mois / Jour / Année', ymd: 'Année / Mois / Jour' },
          JOIN_GROUP: 'Groupe de jointure entre feuilles (facultatif)',
          KEY_COLUMNS: 'Colonnes clés séparées par des virgules',
          KEY_COLUMNS_EXAMPLE: 'A, C',
          CONTINUATION_ROWS: 'Rattacher les lignes sans clé à l’entretien précédent',
          JOIN_HELP: 'Chaque groupe joint nécessite une seule liste principale. Les feuilles complémentaires ajoutent des détails uniquement aux entretiens correspondants. Utilisez tous les éléments de la clé dans le même ordre ; les lettres des colonnes peuvent différer. Les formulaires restent indépendants.',
          FIELDS: 'Correspondances des champs',
          TARGET: 'Champ de l’entretien',
          REFERENCE: 'Référence source',
          COLUMN_REF_HELP: 'Utilisez les lettres des colonnes, par exemple A ou BC, sans numéro de ligne.',
          CELL_REF_HELP: 'Utilisez la position absolue des cellules du premier formulaire, par exemple B4 ou $B$4. Les blocs suivants sont décalés du nombre de lignes configuré.',
          ADD_FIELD: 'Ajouter une correspondance',
          REMOVE_FIELD_TITLE: 'Supprimer la correspondance',
          REMOVE_FIELD_CONFIRM: 'Supprimer cette correspondance de champ ? Un nouvel aperçu sera nécessaire.',
          TARGETS: {
            employeeName: 'Nom complet du collaborateur', employeeFirstName: 'Prénom du collaborateur', employeeLastName: 'Nom du collaborateur',
            employeeEmail: 'E-mail du collaborateur', employeeNumber: 'Matricule', managerName: 'Nom complet du manager',
            managerFirstName: 'Prénom du manager', managerLastName: 'Nom du manager', managerEmail: 'E-mail du manager',
            interviewDate: 'Date de l’entretien', evaluatedPeriod: 'Période évaluée',
          },
          INVALID_MAPPING: 'Choisissez des rôles explicites et au moins une source principale. Chaque feuille complémentaire doit rejoindre une seule liste principale. Vérifiez les bornes, les références, les clés complètes et la hauteur des blocs.',
          REVIEW_ERROR: 'La vérification de la structure n’a pas pu aboutir',
          PREVIEW_TITLE: 'Aperçu des entretiens',
          PREVIEW_REQUIRED: 'Générez un nouvel aperçu. Toute modification de structure efface l’aperçu et sa confirmation.',
          PREVIEW_COUNT: '{{total}} entretien(s) au total / {{shown}} exemple(s) affiché(s)',
          SAMPLES_HELP: 'Le serveur fournit uniquement les textes des 3 premiers entretiens, pas l’ensemble. Les nombres incluent tous les entretiens détectés ; la préparation privée n’importe aucun entretien réel.',
          IGNORED_SHEETS: 'Feuilles ignorées',
          SOURCE_ROWS: '{{sheet}} : lignes {{start}} à {{end}} incluses',
          TRUNCATED: 'Seul cet exemple à l’écran est abrégé. Le contenu source original reste complet.',
          ACKNOWLEDGEMENT: 'J’ai vérifié la structure, les alertes et les exemples et je confirme la génération des {{count}} brouillons d’entretien.',
          PREVIEW_ACTION: 'Revérifier le fichier',
          CONFIRM_ACTION: 'Générer les brouillons',
          PREVIEW_SUCCESS: 'Vérifications actualisées. Relisez les intitulés ou corrigez les points restants avant de continuer.',
          PREVIEW_ERROR: 'Impossible de générer l’aperçu. Vérifiez les détails puis réessayez.',
          CONFIRM_SUCCESS: 'Les brouillons d’entretien sont générés. Ils peuvent être vérifiés et validés.',
          CONFIRM_ERROR: 'Impossible de générer les brouillons. Votre structure reste modifiable. Générez un nouvel aperçu avant de confirmer à nouveau.',
          STALE_PREVIEW: 'L’aperçu ou l’état de la source a changé. Générez un nouvel aperçu ou fermez puis actualisez la liste des sources.',
          DUPLICATE_WORKBOOK_TITLE: 'Fichier déjà préparé',
          DUPLICATE_WORKBOOK: 'Ce fichier a déjà été préparé dans cette campagne. Fermez cette fenêtre et reprenez le lot d’import existant pour consulter ses brouillons ou les entretiens déjà importés. Préparer à nouveau cette copie créerait des doublons.',
        },
        MODAL: {
          TITLE: 'Vérifier le brouillon d’entretien',
          REVIEW_HELP: 'Complétez les informations, relisez les objectifs et consultez les réponses originales sans perdre vos modifications.',
          REVIEW_NAVIGATION: 'Sections de vérification de l’entretien',
          CORRECTIONS_TITLE: 'Corrections',
          CORRECTIONS_HELP: 'Vérifiez les personnes et les informations pratiques ci-dessous. Vous pouvez enregistrer votre progression même si tout n’est pas encore complet.',
          PEOPLE_HELP: 'Associez chaque personne à un compte existant. Un nom extrait ne suffit pas à identifier un compte.',
          ACCOUNT_SELECTED: 'Compte sélectionné',
          ACCOUNT_REQUIRED: 'Compte à sélectionner',
          PLANNING_HELP: 'Conservez les informations de l’entretien d’origine. L’heure et le préavis en mois sont facultatifs et restent inconnus si les champs sont vides.',
          OBJECTIVES_HELP: 'Relisez chaque objectif et ses détails, puis confirmez explicitement votre vérification.',
          OBJECTIVES_REVIEW_HELP: 'Cette confirmation est enregistrée avec le brouillon privé. Modifier un objectif la réinitialise.',
          OBJECTIVE_SELECTION: {
            TITLE: 'Objectifs à importer',
            HELP: 'Choisissez les objectifs à garder, complétez votre liste, puis confirmez-la. Rien n’est importé à cette étape.',
            CREATE: 'Ajouter manuellement',
            SELECTED_COUNT: 'Sélection : {{count}}',
            SELECTED_LABEL: 'dans la liste d’import',
            CANDIDATES_LABEL: 'suggestions à ajouter',
            CANDIDATES_TITLE: 'Suggestions d’objectifs',
            CANDIDATES_HELP: 'Ajoutez les suggestions utiles à votre liste ci-dessus. Les suggestions laissées ici ne seront pas importées.',
            SOURCE_BADGE: 'Texte du fichier',
            AI_BADGE: 'Suggestion IA',
            AI_ADDED_BADGE: 'Interprétation IA',
            MANUAL_BADGE: 'Ajout manuel',
            EDITABLE_BADGE: 'Valeurs du brouillon',
            ADD_TO_LIST: 'Ajouter à la liste',
            REMOVE: 'Retirer de la liste',
            SOURCE_ADD_HELP: 'Ajoute le titre et le commentaire originaux. Les autres champs restent à vérifier.',
            AI_ADD_HELP: 'Ajoute uniquement l’intitulé proposé, à relire. Aucun statut, progression ou commentaire IA n’est copié.',
            READ_SOURCE_COMMENT: 'Lire le commentaire original',
            READ_AI_COMMENT: 'Lire la proposition IA (non vérifiée)',
            EMPTY_TITLE: 'Votre liste d’import est vide',
            EMPTY_WITH_CANDIDATES: 'Des suggestions sont disponibles ci-dessous. Ajoutez celles que vous souhaitez garder ou créez un objectif manuellement.',
            EMPTY_WITHOUT_CANDIDATES: 'Vous pouvez créer un objectif manuellement ou confirmer un import sans objectif. Une liste vide ne prouve pas que l’entretien ne contient aucun souhait ou projet.',
            CONFIRM_LIST: 'Je confirme les {{count}} objectifs de cette liste',
            CONFIRM_EMPTY: 'Je confirme un import sans objectif',
            REVIEW_HELP: 'Cette confirmation concerne uniquement votre liste. Elle n’ajoute aucune suggestion et ne déclenche pas l’import final.',
            TITLE_REQUIRED: 'Saisissez un intitulé pour cet objectif.',
            COMMENT_PLACEHOLDER: 'Commentaire facultatif à vérifier ou à compléter.',
            COMPARE_SOURCE: 'Comparer avec le texte original',
            USE_SOURCE_COMMENT: 'Reprendre ce commentaire original',
            AI_DETAILS: 'Consulter les informations proposées par l’IA',
            AI_DETAILS_HELP: 'Informations non vérifiées, conservées séparément. Le commentaire IA ne remplace jamais votre commentaire.',
            READ_INTERVIEW: 'Consulter le texte original de l’entretien',
            REFERENCES_TITLE: 'Consulter le fichier, les références et les propositions d’origine',
            PARTIAL_SOURCE: 'Certaines lignes du fichier n’ont pas d’intitulé. Les objectifs identifiés restent disponibles.',
            PARTIAL_RESTORE_HELP: 'La source contient des lignes incomplètes. Ajoutez les objectifs identifiés individuellement pour ne pas remplacer votre liste par une source partielle.',
            SOURCE_NOT_INCLUDED: 'La feuille des objectifs n’est pas incluse dans la source vérifiée. Cela ne signifie pas qu’il n’existe aucun objectif ; votre liste reste inchangée.',
            INCOMPLETE_TITLE: 'Lignes du fichier à clarifier',
            UNLABELLED_FIELD: 'Valeur du fichier',
            DEFAULTS_HELP: 'Les suggestions étayées peuvent déjà être sélectionnées dans ce brouillon privé. Retirez celles que vous ne souhaitez pas garder : elles reviennent dans les suggestions et peuvent être ajoutées à nouveau. Enregistrez votre choix, puis confirmez explicitement votre vérification.',
            SELECT_SUPPORTED: 'Sélectionner les suggestions étayées',
            ORIGINAL_PASSAGE: 'Passage original de l’entretien',
            CONCRETE_TARGETS: 'Cibles concrètes dans la source',
            NO_TARGETS: 'Aucune cible concrète indiquée dans ce passage.',
            EVIDENCE_HELP: 'Il s’agit des mots d’origine, pas d’une preuve de réalisation. Vos valeurs modifiables restent distinctes ; aucun statut, année ou pourcentage n’est déduit.',
            EVIDENCE_UNAVAILABLE: 'Passage source original indisponible ou sans correspondance unique. Vérifiez cette idée manuellement ; aucune citation ni aucun résultat n’est supposé.',
            USE_SOURCE_PASSAGE: 'Reprendre ce passage original comme commentaire',
          },
          OBJECTIVE_GUIDANCE: {
            OPTIONAL_UNAVAILABLE: 'Les suggestions supplémentaires de l’IA sont indisponibles. Les objectifs issus des colonnes vérifiées restent disponibles et peuvent être vérifiés puis confirmés.',
            SOURCE_COLUMNS: 'Colonnes confirmées : {{extractedCount}} objectifs extraits sur {{expectedCount}} cellules de titre renseignées. Points à vérifier : {{exceptionCount}}. Les titres originaux et les champs associés sont copiés sans sélection par l’IA.',
            TITLE: 'Propositions d’objectifs guidées par vos consignes',
            HELP: 'Vérifiez ce que l’analyse propose de créer et ce qu’elle écarte. Exclure un objectif de la création ne supprime pas son historique du compte rendu.',
            PROPOSAL_BADGE: 'Proposition IA guidée',
            NOT_CURRENT: 'L’analyse guidée est incomplète ou ne correspond plus à ce brouillon. Vos choix sont conservés, mais ne peuvent pas être confirmés tant que l’analyse et la source ne sont pas à jour.',
            SELECTION_ISSUES: 'Certains choix ne correspondent plus à une proposition admissible. Corrigez la sélection puis enregistrez-la avant de la confirmer. Vos choix précédents n’ont pas été supprimés.',
            YEAR_CONFLICT: 'Avertissement non bloquant : l’année de référence sélectionnée diffère de l’année source ou des consignes actuelles confirmées. Le classement par période confirmé s’applique, sans modifier le texte source ni les échéances. Cet avertissement n’empêche pas l’import de l’entretien après confirmation.',
            REVIEW_REQUIRED: 'Vérifiez puis enregistrez la sélection d’objectifs guidée avant de confirmer l’import.',
            DECISIONS: 'Vérifier les décisions de l’analyse ({{count}})',
            NO_DECISIONS: 'Aucun objectif candidat n’a été identifié dans les passages autorisés. Vérifiez la source avant de confirmer une liste vide.',
            DECISION_INCLUDE: 'Proposition admissible',
            DECISION_EXCLUDE: 'Exclu de la création',
            DECISION_REVIEW: 'À vérifier ; non sélectionné',
            REASON: 'Explication de l’IA',
            REASONS: {
              unrelated_field_evidence: 'Les passages cités ne permettent pas d’établir sans ambiguïté un objectif unique et ses mesures associées.',
              ambiguous_source_year: 'Les références d’année sources ne permettent pas d’établir clairement l’année de l’objectif.',
              source_year_requires_evidence: 'Le contexte d’année source doit être vérifié avant de pouvoir utiliser une année fournie par les consignes.',
              missing_year: 'Aucune année d’objectif étayée ni année de contexte autorisée n’est disponible.',
              model_exclude: 'L’analyse propose d’exclure cet élément de la création d’objectifs.',
              model_review: 'L’analyse demande une vérification individuelle avant de pouvoir sélectionner cet élément.',
              category_excluded: 'Cette catégorie ne fait pas partie des objectifs à sélectionner.',
              source_ineligible: 'Ce passage ne permet pas de créer un objectif selon la règle actuelle.',
              assessed_history: 'Cet élément concerne un bilan ou un historique, pas un nouvel objectif à créer.',
              unknown_phase: 'La source ne permet pas d’identifier clairement un objectif nouveau ou prévu.',
              target_year_excluded: 'L’année source ne correspond pas à l’année d’objectifs demandée.',
              incomplete_coverage: 'L’analyse n’a pas traité tous les passages sources requis.',
              other: 'Une vérification supplémentaire de la source ou de la sélection est nécessaire.',
            },
            NO_KPI: 'Aucun KPI étayé fourni ; aucune cible inventée',
            YEAR_SOURCE: 'Année étayée par la source',
            YEAR_INSTRUCTION_CONTEXT: 'Année fournie par vos consignes, absente de la source',
            YEAR_UNKNOWN: 'Année non établie',
            MANUAL_HELP: 'Dans ce mode, seules les propositions admissibles et étayées par la source peuvent être ajoutées. Vous pouvez modifier ou retirer les propositions sélectionnées ; les choix non étayés restent visibles pour correction.',
            DEFAULTS_HELP: 'Seules les propositions admissibles sont présélectionnées. Elles ne sont ni approuvées ni importées automatiquement. Vérifiez les titres, passages sources, KPI et années avant de confirmer votre liste.',
            CANDIDATE_HELP: 'Le titre est proposé par l’IA à partir de la source ; ce n’est pas forcément le titre exact du classeur. Les passages justificatifs et les valeurs de KPI fournies restent consultables.',
            PART_LABEL: 'En-tête de colonne source',
            PART_QUESTION: 'Question source',
            PART_YEAR: 'Référence d’année source',
          },
          OBJECTIVE_CLASSIFICATION: {
            ISSUE_AT_INDEX: 'Objectif enregistré {{index}} : {{message}}',
            PHASE_LABEL: 'Période de l’objectif',
            PHASE_ASSESSED: 'Bilan des objectifs précédents',
            PHASE_PLANNED: 'Objectifs définis',
            PHASE_UNKNOWN: 'Période à préciser',
            YEAR_LABEL: 'Année de classement (si absente de la source)',
            YEAR_UNKNOWN: 'Année non renseignée',
            YEAR_INVALID: 'Saisissez une année entière entre 1900 et 3000, ou laissez le champ vide.',
            SOURCE_DEADLINE: 'Échéance originale',
            SOURCE_YEAR: 'Formulation originale de l’année',
            SOURCE_HELP: 'Les consignes actuelles confirmées déterminent le classement par période lorsqu’elles s’appliquent. La formulation originale des années, le texte source et les échéances sont conservés. Modifier la date de l’entretien dans l’application ne décale pas ces objectifs.',
            REPORT_ONLY_UNKNOWN: 'Compte rendu uniquement : tant que la phase ou l’année de classement est inconnue, cet élément reste dans le compte rendu de l’entretien sans création dans le menu Objectifs, y compris pour un objectif à venir sans année. Cela n’empêche pas l’import de l’entretien après confirmation.',
            REPORT_ONLY_HISTORY: 'Compte rendu uniquement : cet élément évalué ou historique reste dans le compte rendu de l’entretien sans création d’un nouvel objectif dans le menu Objectifs. Cela n’empêche pas l’import de l’entretien après confirmation.',
            RESULT_ATTAINED: 'Atteint',
            RESULT_PARTIAL: 'Partiellement atteint',
            RESULT_NOT_ATTAINED: 'Non atteint',
            RESULT_UNKNOWN: 'Résultat non renseigné',
            BATCH_ACCEPTED: 'Cette liste a été acceptée selon les règles du lot. Cela ne signifie pas que chaque élément a été vérifié manuellement.',
            BATCH_REVIEW: 'Acceptés par règle du lot',
          },
          OBJECTIVE_PROVENANCE: {
            SOURCE_TITLE: 'Objectifs de la source originale',
            SOURCE_HELP: 'Formulation exacte de la source, conservée en lecture seule pour comparaison. Les valeurs retenues pour l’import figurent dans votre liste principale.',
            SOURCE_COMMENT: 'Commentaire original de l’objectif',
            NOT_PROVIDED: 'Non renseigné',
            DEADLINE: 'Échéance source',
            IMPORTANCE: 'Importance source',
            EVIDENCE: 'Références source (privées)',
            ASSESSMENT_TITLE: 'Notes d’évaluation originales',
            ASSESSMENT_HELP: 'Ces notes peuvent concerner plusieurs objectifs. Elles ne sont pas automatiquement rattachées à un seul objectif.',
            STALE: 'La source a changé. Les éléments antérieurs servent uniquement de référence ; la restauration et l’application des suggestions IA sont désactivées.',
            UNAVAILABLE: 'Les objectifs source vérifiés sont indisponibles. Les valeurs actuelles du brouillon restent inchangées.',
            RESTORE: 'Restaurer les objectifs source',
            RESTORE_HELP: 'Remplacer explicitement la liste enregistrée par les valeurs source. Les brouillons existants ne sont jamais réinitialisés automatiquement.',
            RESTORE_DIRTY: 'Enregistrez vos modifications et rouvrez ce brouillon avant de restaurer les objectifs source. Les modifications non enregistrées ne seront pas perdues.',
            RESTORE_CONFIRM: 'Remplacer tous les objectifs enregistrés par les valeurs de la source originale ? Les objectifs personnalisés et les modifications seront supprimés, le statut et la progression réinitialisés, et la vérification des objectifs effacée. Les personnes, la planification et les choix de notification restent inchangés. Seul le brouillon privé sera enregistré.',
            RESTORE_SUCCESS: 'Les objectifs source ont été restaurés dans le brouillon privé. Vérifiez-les avant l’import.',
            RESTORE_ERROR: 'Impossible de restaurer les objectifs source. Les valeurs actuelles ont été conservées.',
            AI_TITLE: 'Propositions IA (non vérifiées)',
            AI_HELP: 'Il s’agit de suggestions, pas du texte source original. Rien n’est appliqué automatiquement. L’action explicite copie uniquement le statut et la progression, jamais le commentaire IA.',
            AI_COMMENT: 'Commentaire IA (non vérifié)',
            APPLY_TARGET: 'Objectif source correspondant :',
            APPLY: 'Appliquer le statut / la progression proposés',
            NO_COMPLETION: 'Aucun statut ni progression exploitable n’est proposé.',
            UNMATCHED: 'Aucun objectif source unique ne correspond. Vérifiez et modifiez le brouillon manuellement ; aucun objectif ne sera créé ou modifié automatiquement.',
            EFFECTIVE_TITLE: 'Objectifs modifiables du brouillon',
          },
          REVIEW_CHECKED: 'Vérifié',
          REVIEW_PENDING: 'À vérifier',
          OBJECTIVE_NUMBER: 'Objectif {{number}}',
          UNTITLED_OBJECTIVE: 'Objectif sans titre',
          CONTENT_HELP: 'Consultez ici les réponses de l’entretien. Les détails techniques et la modification directe du texte restent dans les options avancées.',
          AI_CONTENT_HELP: 'Vérifiez le contenu de l’entretien structuré par l’IA à partir de cet enregistrement Excel. Les objectifs sont vérifiés séparément ; les cellules sources restent accessibles dans les détails techniques.',
          SOURCE_REFERENCE_HELP: 'Les cellules originales du classeur sont conservées pour vérification. Elles ne constituent pas le contenu analysé de l’entretien affiché dans le compte rendu.',
          SAVE_HELP: 'Enregistre uniquement ce brouillon privé. L’import final de l’entretien reste une action distincte.',
          LOADING: 'Chargement de la dernière version du brouillon...',
          NOT_FOUND: 'Ce brouillon n’existe plus ou est indisponible. Fermez et actualisez la liste.',
          READ_ONLY: 'Les entretiens en cours de traitement ou importés sont en lecture seule.',
          STALE_ERROR: 'Une version courante du brouillon est nécessaire. Fermez puis rouvrez cette vérification avant d’enregistrer. Les modifications non enregistrées ne sont pas appliquées automatiquement.',
          CONTENT_TITLE: 'Contenu de l’entretien',
          SOURCE_NOT_CURRENT: 'Le texte extrait a été modifié ou ne peut pas être vérifié par rapport à la source. Le texte ci-dessus est le contenu courant ; la source originale ci-dessous ne l’est pas.',
          ORIGINAL_SOURCE: 'Source originale',
          ORIGINAL_SOURCE_HELP: 'Référence uniquement. Ces réponses originales ne remplacent pas le texte modifié courant.',
          ORIGINAL_ROW: 'Valeurs de la ligne originale (aucune question ni aucun répondant déduit)',
          TECHNICAL_DETAILS: 'Détails techniques et provenance',
          CORRECT_PEOPLE: 'Corriger le collaborateur et le manager',
          CORRECT_PLANNING: 'Corriger les informations de l’entretien historique',
          LOCATION_MISSING: 'Non renseigné',
          EDIT_EXTRACTED_TEXT: 'Avancé : modifier le texte extrait',
          EDIT_TEXT_HELP: 'Il s’agit de l’unique source modifiable du contenu. L’enregistrement met à jour le document et le workflow du brouillon privé, pas un vrai entretien. Après modification du texte, les réponses structurées originales servent uniquement de référence.',
          SAVE_PRIVATE: 'Enregistrer le brouillon privé',
          DELETE_OBJECTIVE_TITLE: 'Retirer l’objectif de ce brouillon',
          DELETE_OBJECTIVE_CONFIRM: 'Retirer cet objectif du brouillon privé ? La modification sera appliquée uniquement lors de l’enregistrement du brouillon.',
          LOAD_ERROR: 'Impossible de charger le brouillon.',
          COLLABORATOR: 'Collaborateur',
          MANAGER: 'Manager',
          EXTRACTED: 'Extrait',
          DATE: 'Date et heure',
          DATE_ONLY: 'Date',
          TIME_ONLY: 'Heure (facultative)',
          LOCATION: 'Lieu',
          LOCATION_ONSITE: 'Présentiel',
          LOCATION_REMOTE: 'À distance',
          LOCATION_FORM: 'Formulaire',
          INTERVIEW_LINK: 'Lien visio',
          NOTICE_MONTHS: 'Préavis en mois (facultatif)',
          RAW_TEXT: 'Texte extrait',
          VALIDATION_ERRORS_TITLE: 'Points à corriger',
          VALIDATION_ERRORS_HELP: 'Ces éléments doivent être corrigés avant l’import de cet entretien.',
          OBJECTIVE_WARNINGS_TITLE: 'Avertissements non bloquants sur les objectifs',
          OBJECTIVE_WARNINGS_HELP: 'Relisez ces avertissements et confirmez explicitement votre liste d’objectifs. Ces avertissements seuls n’empêchent pas l’import après confirmation ; les contrôles d’intégrité de la source et d’acceptation restent obligatoires. Les consignes actuelles confirmées déterminent la période, sans modifier le texte source original ni les échéances. Les avertissements concernent la liste enregistrée ; enregistrez vos modifications pour les actualiser.',
          CLOSE_SAVED_REVIEW: 'Vérification terminée, fermer',
          OBJECTIVES: 'Objectifs',
          ADD_OBJECTIVE: 'Ajouter un objectif',
          OBJECTIVE_TITLE: 'Titre',
          SCOPE_INDIVIDUAL: 'Individuel',
          SCOPE_COLLECTIVE: 'Collectif',
          KPI: 'KPI',
          TARGET_YEAR: 'Année de référence',
          STATUS: 'Statut',
          PROGRESS: 'Progression',
          COMMENT: 'Commentaire',
          NO_OBJECTIVES: 'Aucun objectif extrait.',
          OBJECTIVES_REVIEWED: 'J’ai relu les objectifs à inclure lors de l’import explicite de cet entretien',
          INVALID_FORM: 'Complétez les champs obligatoires.',
          SAVE_SUCCESS: 'Brouillon mis à jour.',
          SAVE_WITH_VALIDATION_ERRORS: 'Brouillon privé enregistré. Corrigez les points indiqués avant l’import.',
          SAVE_WITH_OBJECTIVE_WARNINGS: 'Brouillon privé enregistré avec succès. Les avertissements non bloquants sur les objectifs restent visibles pour vérification. Confirmez et enregistrez votre liste si nécessaire, puis fermez cette vérification. L’import final de l’entretien reste une action distincte.',
          SPREADSHEET_FONT_ERROR: 'Le PDF individuel n’a pas pu être généré. Vos réponses sources sont conservées. Relancez la préparation une fois le problème de rendu corrigé.',
          NOT_ANALYZED: 'Non analysé',
          SAVE_ERROR: 'Erreur lors de la mise à jour du brouillon.',
        },
      },
      ASSISTANT: {
        PLACEHOLDER: "Posez une question à l'assistant...",
        CLEAR_SELECTION: 'Effacer la sélection',
      },
      WORKFLOW_TAB: 'Entretien',
      CARD_TABS: {
        PREVIOUS: 'Section d\'entretien précédente',
        NEXT: 'Section d\'entretien suivante',
      },
      DOCUMENTS: {
        TAB_TITLE: 'Documents',
        VIEW_ERROR: 'Impossible d\'ouvrir le document. Veuillez réessayer.',
        UPLOAD: 'Uploader un document',
        UPLOAD_SUCCESS: 'Document uploadé avec succès',
        UPLOAD_ERROR: 'Erreur lors de l\'upload du document',
        SAVE_ERROR: 'Erreur lors de l\'enregistrement du document',
        LOAD_ERROR: 'Impossible de charger les documents',
        DELETE_TITLE: 'Supprimer le document',
        DELETE_CONFIRM: 'Voulez-vous vraiment supprimer « {{name}} » ?',
        DELETE_SUCCESS: 'Document supprimé avec succès',
        DELETE_ERROR: 'Erreur lors de la suppression du document',
      },
      HISTORY: {
        TAB_TITLE: 'Résumé & Évolution',
        SUBTITLE: 'Synthèse globale et évolution du collaborateur sur la base de ses entretiens terminés.',
        BADGE_INTERVIEWS: 'entretien(s) source(s)',
        SUMMARY_TITLE: 'Résumé global',
        EVOLUTION_TITLE: 'Évolution',
        AXES_PROGRESSION_TITLE: 'Axes de progression',
        PAST_INTERVIEWS_TITLE: 'Entretiens passés',
        COMPUTED_AT: 'Analyse enregistrée le',
        LOADING: 'Chargement du résumé…',
        NEVER_COMPUTED: 'Aucun résumé enregistré disponible.',
        LIST_LOADING: 'Chargement des entretiens passés...',
        LIST_ERROR: 'Impossible de charger les entretiens passés. Rouvrez cet onglet pour réessayer.',
        RELOAD_LIST: 'Recharger les entretiens passés',
        UNAVAILABLE: 'Analyse indisponible.',
        ERROR_CAPACITY: 'Le volume d’informations contenu dans cet historique d’entretiens est trop important pour permettre une analyse par l’IA. Vous pouvez toujours consulter chaque entretien individuellement.',
        ERROR_TIMEOUT: 'L’analyse n’a pas pu être terminée dans le délai imparti. Vous pouvez réessayer plus tard. Tout résumé enregistré reste accessible.',
        ERROR_BUSY: 'Le service d’analyse est momentanément occupé. Vous pouvez réessayer plus tard. Les entretiens passés restent accessibles.',
        ERROR_SOURCES_CHANGED: 'Les entretiens sources ont changé pendant l’analyse. Relancez l’analyse pour prendre en compte ces modifications.',
        ERROR_SUPPORT: 'L’analyse n’a pas pu aboutir. Contactez votre administrateur. Les entretiens passés et tout résumé enregistré restent accessibles.',
        BTN_REFRESH: 'Rafraîchir',
        REFRESHING: 'Calcul en cours…',
        REFRESH_SUCCESS: 'Résumé recalculé avec succès',
        REFRESH_ERROR: 'Erreur lors du calcul du résumé',
        NO_CREDITS: 'Crédits IA insuffisants pour recalculer le résumé.',
        NO_INTERVIEWS: 'Aucun entretien terminé pour ce collaborateur.',
        BTN_VIEW: 'Visualiser',
        COL_DATE: 'Date',
        COL_TEMPLATE: 'Type / Modèle',
        LOAD_ERROR: 'Impossible de charger le résumé de l\'historique',
      },
      MY_INTERVIEWS: {
        SEARCH_PERSON_LABEL: 'Personne',
        SEARCH_PERSON_PLACEHOLDER: 'Rechercher un collaborateur ou un responsable',
        FILTER_STATUS: 'Statut',
        // Le filtre affiche le nom mais conserve l'UUID de campagne comme valeur stable.
        FILTER_CAMPAIGN: 'Campagne',
        FILTER_CAMPAIGN_ALL: 'Toutes les campagnes',
        FILTER_TAKEOVER: 'Prise en main',
        FILTER_TAKEOVER_ALL: 'Tous',
        FILTER_TAKEOVER_TAKEN: 'Pris en main',
        FILTER_TAKEOVER_NOT_TAKEN: 'Non pris en main',
        DELETE_SUCCESS: 'Entretien supprimé avec succès',
        DELETE_ERROR: "Erreur lors de la suppression de l'entretien",
        FETCH_ERROR: 'Impossible de récupérer la dernière version de cet entretien',
        RESCHEDULE_TITLE: "Reprogrammer l'entretien",
        RESCHEDULE_SUBTITLE: "Choisissez une nouvelle date et heure pour l'entretien avec {{ name }}.",
        RESCHEDULE_DATE_LABEL: 'Nouvelle date',
        RESCHEDULE_TIME_LABEL: 'Nouvelle heure',
        RESCHEDULE_SAVE: 'Enregistrer les modifications',
        RESCHEDULE_SUCCESS: 'Entretien reprogrammé avec succès',
        RESCHEDULE_ERROR: "Erreur lors de la reprogrammation de l'entretien",
        RESCHEDULE_TOOLTIP: "Reprogrammer l'entretien",
        EXTRACT_OBJECTIVES_TOOLTIP: 'Extraire les objectifs vers le module Objectifs',
        EXTRACTION_TITLE: 'Extraire les objectifs de l’entretien',
        EXTRACTION_SUBTITLE: '{{ interviewType }} · {{ employeeName }}',
        EXTRACTION_LOADING: 'Chargement des objectifs de l’entretien…',
        // La synchronisation finale affiche la provenance et exige une année de référence validée côté serveur.
        EXTRACTION_EMPTY: 'Aucun objectif exploitable n’a été trouvé dans cet entretien.',
        // Expliquer l'année globale sans laisser penser que les années existantes seront remplacées.
        EXTRACTION_REFERENCE_YEAR: 'Année de référence actuelle',
        EXTRACTION_REFERENCE_YEAR_HELP: 'Utilisée uniquement pour les objectifs sans année cible : cette année si le manager peut évaluer, ou l’année suivante s’il ne peut pas évaluer.',
        EXTRACTION_IMPORT_SELECTED: 'Ajouter les objectifs sélectionnés',
        EXTRACTION_CANCEL: 'Annuler',
        EXTRACTION_SCOPE_LABEL: 'Portée',
        EXTRACTION_SOURCE_FIELD: 'Champ source',
        EXTRACTION_ALREADY_IMPORTED: 'Déjà importé',
        EXTRACTION_EXISTS: 'Existe déjà dans Objectifs',
        EXTRACTION_SELECT_ALL: 'Tout sélectionner',
        EXTRACTION_CLEAR_SELECTION: 'Tout désélectionner',
        EXTRACTION_IMPORT_SUCCESS: '{{ count }} objectif(s) ajouté(s) avec succès',
        EXTRACTION_IMPORT_EMPTY: 'Aucun objectif sélectionné à ajouter',
        EXTRACTION_IMPORT_ERROR: 'Erreur lors de l’ajout des objectifs',
        EXTRACTION_ASSIGNED_TO: 'Collaborateur concerné',
        EXTRACTION_UPDATED_FROM_INTERVIEW: 'Modifications détectées',
        EXTRACTION_UPDATE: 'Mettre à jour',
        EXTRACTION_SYNC_SELECTED: 'Ajouter / mettre à jour la sélection',
        EXTRACTION_SYNC_SUCCESS: '{{ total }} objectif(s) synchronisé(s) avec succès ({{ imported }} ajoutés, {{ updated }} mis à jour)',
        EXTRACTION_LOAD_ERROR: 'Impossible de charger les objectifs disponibles pour la synchronisation.',
        EXTRACTION_NOTHING_CHANGED: 'Aucun objectif ne nécessitait de synchronisation.',
        EXTRACTION_SELECTED_SUMMARY: '{{ imported }} à créer · {{ updated }} à mettre à jour',
        EXTRACTION_SELECT_OBJECTIVE_ARIA: "Sélectionner l'objectif {{ objective }}",
        EXTRACTION_TARGET_YEAR: 'Année de référence finale',
        EXTRACTION_TARGET_YEAR_PLACEHOLDER: 'Sélectionner une année',
        EXTRACTION_INVALID_YEAR: 'Une année de référence valide est obligatoire.',
        EXTRACTION_OUT_OF_RANGE_YEAR: "L'année enregistrée est hors de la plage standard et reste disponible.",
        EXTRACTION_BLOCKED: 'Indisponible',
        EXTRACTION_BLOCKED_REASON: "La source de cet objectif n'est plus affectée au collaborateur de l'entretien ou n'est plus disponible.",
        EXTRACTION_IMPORTED_HISTORY: 'Les objectifs évalués, sans année précise ou sans classement accepté restent dans l’historique de l’entretien. Ils ne sont pas créés comme objectifs actifs.',
        EXTRACTION_SOURCE_IMPORTED: 'Objectif importé',
        EXTRACTION_SOURCE_CREATED: "Objectif de l'entretien",
        EXTRACTION_DONE: 'Objectifs extraits',
        EXTRACTION_DONE_TOOLTIP: 'Au moins un objectif de cet entretien a déjà été extrait vers le module Objectifs',
        SKILL_EXTRACTION_TOOLTIP: 'Extraire les compétences vers le profil du collaborateur',
        SKILL_EXTRACTION_TITLE: 'Extraire les compétences de l’entretien',
        SKILL_EXTRACTION_SUBTITLE: '{{ interviewType }} · {{ employeeName }}',
        SKILL_EXTRACTION_LOADING: 'Chargement des compétences évaluées…',
        SKILL_EXTRACTION_EMPTY: 'Aucune compétence exploitable n’a été trouvée dans cet entretien.',
        SKILL_EXTRACTION_COUNT: '{{ count }} compétence(s)',
        SKILL_EXTRACTION_UPDATE_EXPLANATION: 'La valeur proposée est l’évaluation du responsable. La modifier mettra à jour cette évaluation dans l’entretien terminé et la compétence dans le profil du collaborateur.',
        SKILL_EXTRACTION_SELECT_ALL: 'Tout sélectionner',
        SKILL_EXTRACTION_CLEAR_SELECTION: 'Tout désélectionner',
        SKILL_EXTRACTION_SELECT_ARIA: 'Sélectionner la compétence {{ skill }}',
        SKILL_EXTRACTION_NO_DOMAIN: 'Domaine non renseigné',
        SKILL_EXTRACTION_SOURCE_STANDARD: 'Catalogue partagé',
        SKILL_EXTRACTION_SOURCE_CUSTOM: 'Catalogue entreprise',
        SKILL_EXTRACTION_SOURCE_INTERVIEW: 'Créée dans l’entretien',
        SKILL_EXTRACTION_CURRENT_PROFILE: 'Évaluation attribuée dans le profil',
        SKILL_EXTRACTION_MANAGER_EVALUATION: 'Évaluation du responsable',
        SKILL_EXTRACTION_COLLABORATOR_EVALUATION: 'Évaluation du collaborateur',
        SKILL_EXTRACTION_INFORMATION_ONLY: 'Pour information uniquement',
        SKILL_EXTRACTION_PROPOSED_EVALUATION: 'Évaluation du responsable proposée',
        SKILL_EXTRACTION_CHOOSE_EVALUATION: 'Choisir une évaluation',
        SKILL_EXTRACTION_NOT_EVALUATED: 'Non évalué',
        SKILL_EXTRACTION_ACTION_CREATE: 'Ajouter',
        SKILL_EXTRACTION_ACTION_UPDATE: 'Mettre à jour',
        SKILL_EXTRACTION_ACTION_CREATE_AND_ADD: 'Créer et ajouter',
        SKILL_EXTRACTION_ACTION_NONE: 'À jour',
        SKILL_EXTRACTION_ACTION_BLOCKED: 'Bloqué',
        SKILL_EXTRACTION_BLOCKED_REASON: 'Motif :',
        SKILL_EXTRACTION_BLOCKED_GENERIC: 'Cette compétence ne peut pas être importée.',
        SKILL_EXTRACTION_BLOCKED_MISSING_MANAGER_EVALUATION: 'Évaluation du responsable manquante',
        SKILL_EXTRACTION_BLOCKED_INVALID_MANAGER_EVALUATION: 'Évaluation du responsable invalide',
        SKILL_EXTRACTION_BLOCKED_SKILL_SOURCE_NOT_ALLOWED: 'Source de compétence non autorisée',
        SKILL_EXTRACTION_BLOCKED_CATALOG_SKILL_NOT_FOUND: 'Compétence introuvable dans le catalogue',
        SKILL_EXTRACTION_BLOCKED_CUSTOM_SKILL_CREATION_DISABLED: 'Création de compétences personnalisées désactivée',
        SKILL_EXTRACTION_BLOCKED_MISSING_SKILL_LABEL: 'Libellé de compétence manquant',
        SKILL_EXTRACTION_BLOCKED_DUPLICATE_USER_COMPETENCE_ROWS: 'Plusieurs compétences de profil correspondent',
        SKILL_EXTRACTION_BLOCKED_DUPLICATE_INTERVIEW_SKILL_TARGET: 'Cette compétence apparaît plusieurs fois dans l’entretien',
        SKILL_EXTRACTION_IMPORT_ONE: 'Importer cette compétence',
        SKILL_EXTRACTION_IMPORT_SELECTED: 'Importer la sélection',
        SKILL_EXTRACTION_CANCEL: 'Annuler',
        SKILL_EXTRACTION_LOAD_ERROR: 'Impossible de charger les compétences disponibles pour l’import.',
        SKILL_EXTRACTION_IMPORT_EMPTY: 'Aucune compétence valide sélectionnée.',
        SKILL_EXTRACTION_IMPORT_SUCCESS: '{{ count }} compétence(s) importée(s) avec succès.',
        SKILL_EXTRACTION_IMPORT_ERROR: 'Erreur lors de l’import des compétences.',
        SKILL_EXTRACTION_NOTHING_CHANGED: 'Aucune compétence n’a été modifiée.',
        PREPARE_SIGNATURE_TOOLTIP: 'Préparer pour la signature',
        FINAL_DECISION_TOOLTIP: 'Accepter ou refuser',
        VIEW_DOCUMENT_TOOLTIP: 'Voir le document',
        TAKE_CONTROL: 'Prendre la main',
        TAKE_CONTROL_TOOLTIP: "Prendre la main de l'entretien",
        TAKE_CONTROL_SUCCESS: "Vous avez pris la main de l'entretien",
        TAKE_CONTROL_ERROR: 'Erreur lors de la prise de main',
        IMPORTED_PDF_NOT_FOUND: 'Le PDF importé est introuvable pour cet entretien.',
        IMPORTED_PDF_OPEN_ERROR: 'Impossible d’ouvrir le PDF importé.',
        PREPARATION_SIMULATOR_TOOLTIP: 'Préparer cet entretien avec l’IA',
        PREPARATION_SIMULATOR_TITLE: 'Simulateur de préparation',
        PREPARATION_SIMULATOR_SUBTITLE: '{{ interviewType }} · {{ employeeName }}',
        PREPARATION_SIMULATOR_INTRO_TITLE: 'Préparez vos arguments avant l’échange',
        PREPARATION_SIMULATOR_INTRO_TEXT: 'Le simulateur peut jouer le rôle du responsable d’entretien, vous challenger et vous aider à formuler une demande claire.',
        PREPARATION_SIMULATOR_PRIVACY: 'Uniquement les informations visibles par vous',
        PREPARATION_SIMULATOR_LOADING: 'Chargement du contexte de préparation…',
        PREPARATION_SIMULATOR_THINKING: 'Le simulateur prépare sa réponse…',
        PREPARATION_SIMULATOR_INPUT_PLACEHOLDER: 'Expliquez votre objectif, votre état d’esprit ou la demande que vous voulez préparer...',
        PREPARATION_SIMULATOR_COMPOSER_HINT: 'Entrée pour envoyer, Maj + Entrée pour revenir à la ligne',
        PREPARATION_SIMULATOR_STARTERS_LABEL: 'Exemples pour démarrer',
        PREPARATION_SIMULATOR_STARTER_MINDSET: 'Je veux parler de mon état d’esprit',
        PREPARATION_SIMULATOR_STARTER_SALARY: 'Je veux préparer une demande d’augmentation',
        PREPARATION_SIMULATOR_STARTER_ARGUMENTS: 'Aide-moi à construire mes arguments',
        PREPARATION_SIMULATOR_SEND: 'Envoyer',
        PREPARATION_SIMULATOR_YOU: 'Vous',
        PREPARATION_SIMULATOR_AI: 'Simulateur',
        PREPARATION_SIMULATOR_LOAD_ERROR: 'Impossible de démarrer le simulateur de préparation',
        PREPARATION_SIMULATOR_SEND_ERROR: 'Erreur lors de l’envoi du message au simulateur',
        PREPARATION_SIMULATOR_CREDIT_ERROR: 'Crédits IA insuffisants pour envoyer ce message au simulateur.',
        PREPARATION_SIMULATOR_SETTING_TITLE: 'Simulateur de préparation aux entretiens',
        PREPARATION_SIMULATOR_SETTING_DESCRIPTION: 'Autorise les collaborateurs à préparer leurs entretiens avec le chatbot lorsque le module IA est actif.',
        PREPARATION_SIMULATOR_SETTING_ENABLED: 'Activé',
      },
      MEETING_TEMPLATE: {
        DEFAULT_TITLE: 'Modèle de document',
        NAME_PLACEHOLDER: 'Nom du modèle',
        ADDITIONAL_MANAGERS_LABEL: 'Managers supplémentaires',
        ADDITIONAL_MANAGERS_HELP: "Maximum 2 (en plus du responsable principal)",
        WAITING_VALIDATION:
          "Ce document est en attente de remplissage par {{ employee }}. Dès que le document est validé par l'autre partie, il sera disponible pour vos modifications et validation.",
        FIELD_LABEL: 'Libellé du champ',
        FIELD_LABEL_PLACEHOLDER: 'Saisissez un libellé (optionnel)',
        QUESTION_TITLE: 'Intitulé de question',
        QUESTION_TITLE_PLACEHOLDER: "Saisissez l'intitulé de la question",
        // Translate the field picker, including the static 9-box component name.
        ADD_QUESTION: 'Ajouter une question',
        QUESTION_TYPE_PLACEHOLDER: 'Type de question',
        DRAG_TO_REORDER: 'Glissez pour réordonner',
        HELP_TEXT: 'Aide',
        HELP_TEXT_PLACEHOLDER: "Saisissez un texte d'aide (optionnel)",
        CARD_TYPE_LABEL: 'Type de carte',
        CARD_TITLE_LABEL: 'Titre',
        CARD_SECTION_LABEL: 'Section',
        CARD_SECTION_PLACEHOLDER: 'Nom de section facultatif',
        CARD_HEADER_THEME_LABEL: "Thème de l'en-tête",
        CARD_HEADER_THEME_HELP: "Choisissez les couleurs de fond et de texte de l'en-tête de cette carte.",
        CARD_HEADER_THEME_DEFAULT: 'Par défaut',
        CARD_HEADER_THEME_SAND: 'Sable',
        CARD_HEADER_THEME_AMBER: 'Ambre',
        CARD_HEADER_THEME_SAGE: 'Sauge',
        CARD_HEADER_THEME_TEAL: 'Turquoise',
        CARD_HEADER_THEME_SKY: 'Ciel',
        CARD_HEADER_THEME_BLUE: 'Bleu',
        CARD_HEADER_THEME_INDIGO: 'Indigo',
        CARD_HEADER_THEME_VIOLET: 'Violet',
        CARD_HEADER_THEME_ROSE: 'Rose',
        CARD_HEADER_THEME_SLATE: 'Ardoise',
        CARD_HEADER_THEME_ENTERPRISE_PRIMARY: "Primaire de l'entreprise",
        CARD_HEADER_THEME_ENTERPRISE_SECONDARY: "Secondaire de l'entreprise",
        CARD_HEADER_THEME_ENTERPRISE_TERTIARY: "Tertiaire de l'entreprise",
        CARD_HEADER_THEME_CURRENT_CUSTOM: 'Thème actuel',
        TYPE_DYNAMIC: 'Type dynamique',
        TYPE_FEEDBACK: 'Type demande de feedback',
        SEARCH_INTERVIEW_TYPE: "Rechercher un type d'entretien",
        SEARCH_DOC_TEMPLATE: 'Rechercher un modèle de document',
        WARNING_TITLE: 'Attention : modifications manuelles',
        MANUAL_EDITS_WARNING:
          "Vous avez effectué des modifications manuelles dans le document final. Si vous retournez aux cartes et les modifiez, toutes vos modifications manuelles dans l'éditeur seront perdues. Voulez-vous continuer ?",
        CONTINUE_AND_LOSE_EDITS: 'Continuer et perdre les modifications',
        SAVE_SUCCESS: 'Document sauvegardé avec succès',
        SAVE_ERROR: 'Erreur lors de la sauvegarde du document',
        TEMPLATE_SAVE_SUCCESS: 'Modèle sauvegardé avec succès',
        CUSTOM_REPORT: {
          TITLE: 'Rapport IA personnalisé',
          DESCRIPTION: "Configurez un document supplémentaire basé sur l'entretien terminé, distinct du résumé standard et de l'assistant de préparation.",
          INSTRUCTIONS_LABEL: 'Instructions et contenu attendu',
          INSTRUCTIONS_PLACEHOLDER: "Décrivez l'objectif, les rubriques et le format. Par exemple : préparer un argumentaire de négociation salariale à partir des réalisations et des éléments factuels de l'entretien.",
          MANAGER_LABEL: 'Mettre ce rapport à disposition des managers',
          EMPLOYEE_LABEL: 'Mettre ce rapport à disposition du collaborateur',
          ENABLED_LABEL: 'Activer la génération automatique du rapport pour ce modèle',
          GENERATION_HELP: "Activez cette option pour créer automatiquement un rapport à la fin des futurs entretiens. Si vous la désactivez, vos instructions et vos choix d'accès sont conservés. Vous pouvez toujours tester le rapport avant de l'activer.",
          ACCESS_HELP: "Les rapports générés sont toujours accessibles aux administrateurs de votre entreprise ; les cases à cocher contrôlent uniquement l'accès supplémentaire des managers et des collaborateurs.",
          VISIBILITY_HELP: "Les rapports enregistrés sont accessibles dans Entretiens et Mes tâches / Mes entretiens selon les droits enregistrés avec chaque entretien.",
          VIEW_SAVED: 'Rapport personnalisé',
          LOADING_SAVED: 'Chargement du rapport...',
          SAVED_UNAVAILABLE: "Ce rapport personnalisé ne vous est plus accessible. Actualisez la liste des entretiens.",
          SAVED_ERROR: 'Impossible de charger le rapport personnalisé. Veuillez réessayer.',
          SNAPSHOT_HELP: "Ces paramètres s'appliquent aux nouveaux entretiens créés à partir de ce modèle. Les entretiens existants conservent leurs paramètres enregistrés.",
          GLOBAL_HELP: 'Ce modèle est partagé. Dupliquez-le pour personnaliser les paramètres du rapport pour votre entreprise.',
          SAVE_SETTINGS: 'Enregistrer les paramètres',
          SAVING: 'Enregistrement...',
          SAVE_SUCCESS: 'Les paramètres du rapport personnalisé ont été enregistrés.',
          SAVE_ERROR: "Impossible d'enregistrer les paramètres du rapport personnalisé. Vos modifications ont été conservées.",
          PREVIEW: 'Tester le rapport',
          PREVIEW_TITLE: 'Aperçu du rapport personnalisé',
          PREVIEW_HELP: "Générez un test privé à partir des instructions enregistrées et d'un entretien terminé, sans n8n. Cet aperçu n'est ni enregistré ni partagé et ne remplace pas le résumé de l'entretien. Un aperçu généré avec succès utilise des crédits IA.",
          SAVE_FIRST: "Enregistrez ce modèle et les instructions du rapport avant de le tester. Les changements de visibilité ou de génération automatique ne bloquent pas le test.",
          SELECT_INTERVIEW: 'Entretien terminé',
          SELECT_PLACEHOLDER: 'Sélectionner un entretien terminé',
          SEARCH_LABEL: "Rechercher par collaborateur ou type d'entretien",
          SEARCH: 'Rechercher',
          LOADING_INTERVIEWS: 'Chargement des entretiens terminés...',
          NO_INTERVIEWS: 'Aucun entretien terminé ne correspond à cette recherche.',
          LIST_ERROR: 'Impossible de charger les entretiens terminés. Relancez la recherche pour réessayer.',
          PREVIOUS_PAGE: 'Précédent',
          NEXT_PAGE: 'Suivant',
          PAGE: 'Page {{page}}',
          GENERATE: "Générer l'aperçu",
          GENERATING: "Génération de l'aperçu du rapport...",
          CLOSE_PREVIEW: "Annuler l'aperçu",
          PREVIEW_ERROR: "Impossible de générer l'aperçu. Veuillez réessayer.",
          QUOTA_ERROR: "Le solde de crédits IA est insuffisant pour générer un aperçu.",
          INSTRUCTIONS_ERROR: "Ce modèle ne contient plus d'instructions enregistrées pour le rapport. Rechargez le modèle et enregistrez des instructions avant de tester.",
          SOURCE_ERROR: "Cet entretien ne contient aucun contenu exploitable pour l'aperçu ou n'est plus disponible.",
          STATUS_ERROR: "Cet entretien n'est plus terminé. Sélectionnez un autre entretien terminé.",
          TOO_LARGE_ERROR: "Les instructions ou le contenu de l'entretien sont trop longs pour cet aperçu.",
          LIMIT_ERROR: "Trop de demandes d'aperçu. Veuillez patienter avant de réessayer.",
          TIMEOUT_ERROR: 'Le service IA a mis trop de temps à répondre. Veuillez réessayer.',
        },
        // Keep all interview modal backdrop labels and feedback scoped to the template editor.
        MODAL_BACKGROUND: {
          TITLE: "Image d'arrière-plan de la modale",
          HELP: "Cette image s'affichera derrière la modale pour les futurs entretiens créés à partir de ce modèle.",
          UPLOAD: 'Importer une image',
          SELECT: 'Sélectionner une image',
          DECODING: "Validation de l'image...",
          CHANGE: "Remplacer l'image",
          REMOVE: "Supprimer l'image",
          PREVIEW_ALT: "Aperçu de l'image d'arrière-plan de la modale d'entretien",
          ACCEPTED_FORMATS: 'Formats PNG, JPEG ou WebP, 5 Mo maximum.',
          INVALID_TYPE: 'Sélectionnez une image PNG, JPEG ou WebP.',
          OVERSIZE_FILE: "L'image ne doit pas dépasser 5 Mo.",
          INVALID_FILE: "Le navigateur n'a pas pu décoder cette image. Sélectionnez un fichier image valide.",
          REMOVE_CONFIRMATION_TITLE: "Supprimer l'image d'arrière-plan",
          REMOVE_CONFIRMATION_MESSAGE: "Voulez-vous supprimer l'image d'arrière-plan de ce modèle lors du prochain enregistrement ?",
          UPLOAD_SAVE_FAILURE: "Impossible d'enregistrer l'image d'arrière-plan. Aucune modification d'image n'a été appliquée.",
          NO_IMAGE: "Aucune image d'arrière-plan configurée",
          REMOVAL_PENDING: "La suppression sera appliquée lors de l'enregistrement",
        },
        SKILL_SEARCH_LABEL: 'Rechercher une compétence',
        SKILL_SEARCH_PLACEHOLDER: 'Commencez à taper pour rechercher des compétences...',
        SKILL_LOADING: 'Chargement des compétences...',
        SKILL_START_SEARCH: 'Commencez à saisir pour afficher les compétences disponibles.',
        SKILL_NO_RESULTS: 'Aucune compétence ne correspond à votre recherche.',
        // Translate custom creation failures in the same admin search panel.
        SKILL_CREATE_ERROR: 'Impossible de créer la compétence personnalisée.',
        SKILL_SELECTED_LABEL: 'Compétences sélectionnées',
        SKILL_DOMAIN_LABEL: 'Domaine',
        SKILL_EMPTY_SELECTION: 'Aucune compétence sélectionnée pour le moment',
        SKILL_LEVEL_ARIA: 'Sélection du niveau de compétence',
        SKILL_LEVEL_BEGINNER: 'Débutant',
        SKILL_LEVEL_INTERMEDIATE: 'Intermédiaire',
        SKILL_LEVEL_ADVANCED: 'Avancé',
        SKILL_LEVEL_EXPERT: 'Expert',
        SKILL_MANAGER_CAN_ADD: 'Autoriser le manager à ajouter des compétences à évaluer',
        SKILL_MANAGER_CAN_ADD_HELP:
          'Si activé, le manager pourra sélectionner des compétences supplémentaires au-delà de celles listées ci-dessus.',
        SKILL_COLLAB_CAN_ADD: 'Autoriser le collaborateur à ajouter des compétences à évaluer',
        SKILL_COLLAB_CAN_ADD_HELP:
          'Si activé, le collaborateur pourra sélectionner des compétences supplémentaires au-delà de celles listées ci-dessus.',
        SKILL_AUTOLOAD_COLLAB: 'Charger automatiquement les compétences du collaborateur',
        SKILL_AUTOLOAD_COLLAB_HELP: "À l'entretien, importe automatiquement les compétences actuelles de ce collaborateur (fusionnées avec la liste définie).",
        SKILL_AUTOLOAD_SOURCES: 'Sources de chargement automatique',
        SKILL_AUTOLOAD_PROFILE: 'Compétences du profil collaborateur',
        SKILL_AUTOLOAD_JOB_DESCRIPTION: 'Compétences de la fiche de poste affectée',
        SKILL_COLLAB_CAN_EVALUATE: 'Autoriser le collaborateur à évaluer les compétences',
        SHOW_EVALUATION: "Afficher les options d'évaluation",
        SHOW_EVALUATION_HELP: "Si activé, les options d'évaluation seront affichées pour ce champ.",
        COMMENT_MANDATORY: 'Commentaire obligatoire',
        COMMENT_MANDATORY_HELP: 'Si activé, un commentaire est requis pour chaque élément de ce champ.',
        // Les onglets configurent les définitions et imports par collaborateur sans exposer un catalogue global.
        OBJECTIVE_COLLAB_CAN_ADD: 'Autoriser le collaborateur à ajouter des objectifs',
        OBJECTIVE_AUTOLOAD_COLLAB: 'Charger automatiquement les objectifs du collaborateur',
        OBJECTIVE_AUTOLOAD_COLLAB_HELP: "Maintient à jour, pendant l'entretien, les objectifs du collaborateur cible correspondant aux années configurées.",
        OBJECTIVE_MANAGER_CAN_EVALUATE: 'Autoriser le manager à évaluer les objectifs',
        OBJECTIVE_COLLAB_CAN_EVALUATE: 'Autoriser le collaborateur à évaluer les objectifs',
        OBJECTIVE_TARGET_YEAR_LABEL: 'Année de référence par défaut (Vous pouvez la modifier pour chaque objectif)',
        OBJECTIVE_TARGET_YEAR_PLACEHOLDER: "Ex: 2026",
        OBJECTIVE_TABS_ARIA: 'Mode de configuration des objectifs',
        OBJECTIVE_CREATE_TAB: 'Créer',
        OBJECTIVE_CREATE_DESCRIPTION: "Définissez les objectifs fournis par ce modèle. L'année de référence sélectionnée est appliquée par défaut à chaque nouvel objectif.",
        OBJECTIVE_IMPORT_TAB: 'Importer',
        OBJECTIVE_IMPORT_DESCRIPTION: "Configurez les objectifs existants qui seront résolus séparément pour chaque collaborateur cible lors de la planification de son entretien.",
        OBJECTIVE_IMPORT_YEARS_LABEL: 'Années à importer',
        OBJECTIVE_IMPORT_YEARS_PLACEHOLDER: 'Sélectionner une ou plusieurs années',
        OBJECTIVE_IMPORT_ALL_YEARS: 'Toutes les années',
        OBJECTIVE_IMPORT_SELECTED_COUNT: '{{count}} année(s) sélectionnée(s)',
        OBJECTIVE_IMPORT_NO_YEARS: "Aucune année d'objectif n'est actuellement disponible pour cette entreprise.",
        OBJECTIVE_IMPORT_YEAR_REQUIRED: 'Sélectionnez au moins une année ou Toutes les années.',
        OBJECTIVE_IMPORT_REMOVE_YEAR_ARIA: "Retirer l'année d'import",
        OBJECTIVE_TEXT_OPTIONS: "Options d'évaluation des objectifs",
        OBJECTIVE_PERCENTAGE_HINT: "Pourcentages par option :",
        ADD_CUSTOM_INTRO_CARD: "Ajouter une carte d'introduction personnalisée",
        ADD_CUSTOM_INTRO_CARD_DESC:
          'Activez une introduction riche en texte qui apparaîtra au début du document généré.',
        CUSTOM_INTRO_CONTENT_LABEL: "Contenu de l'introduction",
        INTRODUCTION_CARD_TITLE: 'Introduction',
        OBJECTIVE_ADD_LABEL: 'Ajouter un objectif',
        OBJECTIVE_ADD_BTN: 'Ajouter',
        OBJECTIVE_PLACEHOLDER: 'Saisissez un objectif puis appuyez sur Entrée',
        OBJECTIVE_SELECTED_LABEL: 'Objectifs définis',
        OBJECTIVE_EMPTY_SELECTION: 'Aucun objectif défini pour le moment',
        OBJECTIVE_SCOPE_LABEL: 'Périmètre',
        OBJECTIVE_SCOPE_INDIVIDUAL: 'Individuel',
        OBJECTIVE_SCOPE_COLLECTIVE: 'Collectif',
        OBJECTIVE_SCOPE_ARIA: "Sélection du périmètre de l'objectif",
        OBJECTIVE_EDIT_LABEL: "Modifier l'objectif",
        OBJECTIVE_SAVE_LABEL: 'Enregistrer',
        OBJECTIVE_CANCEL_EDIT: 'Annuler',
        FORMATION_FIELD_LABEL: 'Formation',
        FORMATION_MANAGER_CAN_ADD: 'Autoriser le manager à ajouter des formations',
        FORMATION_COLLAB_CAN_ADD: 'Autoriser le collaborateur à demander des formations',
        FORMATION_COMMENT_MANDATORY: 'Commentaire obligatoire',
        FORMATION_ADMIN_DATES_HINT: 'Le manager renseigne les dates si elles sont laissées vides ici.',
        FORMATION_ADD_FROM_CATALOG: 'Ajouter une formation du catalogue',
        FORMATION_SEARCH_CATALOG: 'Rechercher une formation...',
        FORMATION_NO_RESULTS: 'Aucune formation trouvée',
        FORMATION_PRESELECTED: 'Formations pré-sélectionnées',
        FORMATION_ASSIGNED: 'Proposer',
        FORMATION_REQUESTED: 'Demander',
        FORMATION_PRESELECTED_BADGE: 'Pré-sélectionnée',
        FORMATION_START_DATE: 'Début',
        FORMATION_END_DATE: 'Fin',
        FORMATION_ALREADY_ASSIGNED: 'Déjà assignée',
        FORMATION_STATUS_FINISHED: 'Terminée',
        FORMATION_STATUS_EXPIRED: 'Expirée',
        FORMATION_STATUS_IN_PROGRESS: 'En cours',
        FORMATION_STATUS_NOT_STARTED: 'Non commencée',
        FORMATION_STARTED_ON: 'Démarrée le',
        FORMATION_FINISHED_ON: 'Terminée le',
        FORMATION_EXPIRED_ON: 'Échéance dépassée le',
        FORMATION_ALREADY_ASSIGNED_HINT: 'Formations déjà assignées au collaborateur',
        FORMATION_COMMENT_PLACEHOLDER: 'Ajouter un commentaire...',
        FORMATION_COMMENT_MANDATORY_PLACEHOLDER: 'Commentaire obligatoire...',
        FORMATION_MANAGER_LIST: 'Formations assignées par le manager',
        FORMATION_COLLAB_LIST: 'Formations demandées par le collaborateur',
        FORMATION_NO_ENTRIES: 'Aucune formation',
        FORMATION_REMOVE: 'Retirer',
        TRANSLATION_ENABLE: 'Activer la multilingue',
        TRANSLATION_SOURCE_LANG: 'Langue source',
        TRANSLATION_TARGET_LANG: 'Langue cible',
        TRANSLATION_PREVIEW_LANG: 'Langue',
        TRANSLATION_BTN: 'Traduire',
        TRANSLATION_BTN_LOADING: 'Traduction…',
        TRANSLATION_SUCCESS: 'Traduction générée avec succès',
        TRANSLATION_ERROR: 'Erreur lors de la traduction',
        TRANSLATION_NO_CREDIT: 'Crédits IA insuffisants pour traduire',
        TRANSLATION_NO_STRINGS: 'Aucun texte à traduire dans ce modèle',
        VIEWER_LANG_SWITCHER: 'Langue d\'affichage',
        PREVIEW: 'Prévisualiser',
        PREVIEW_NO_CARDS: 'Ajoutez une carte avant d’ouvrir la prévisualisation',
        PREVIEW_NOTICE: 'Prévisualisation temporaire du modèle. Les réponses sont supprimées à la fermeture.',
        PREVIEW_ROLE_LABEL: 'Rôle de prévisualisation',
        PREVIEW_FEEDBACK_NOTICE: 'Les actions de feedback ne sont pas disponibles dans la prévisualisation du modèle.',
        // Libellés du contenu de feedback croisé simulé, sans création ni envoi réel.
        PREVIEW_FEEDBACK_FORMAT: 'Format de la rencontre',
        PREVIEW_FEEDBACK_IN_PERSON: 'Présentiel',
        PREVIEW_FEEDBACK_VIDEO: 'Visioconférence',
        // Cross-feedback forms are asynchronous and distinct from meeting formats.
        PREVIEW_FEEDBACK_FORM: 'Formulaire',
        PREVIEW_FEEDBACK_CONTRIBUTOR: 'Contributeur exemple',
        PREVIEW_COLLABORATOR: 'Collaborateur exemple',
        PREVIEW_MANAGER: 'Manager exemple',
        PREVIEW_OBJECTIVE: 'Objectif de développement exemple',
        PREVIEW_SKILL: 'Compétence exemple',
        PREVIEW_DOMAIN: 'Domaine exemple',
        PREVIEW_FORMATION: 'Formation exemple',
        PREVIEW_USER: 'Utilisateur exemple',
        PREVIEW_SELECT_COLLABORATOR: 'Choisir un collaborateur',
        // Nommer explicitement le destinataire rend l'option d'administration non ambiguë.
        CROSS_FEEDBACK_ALLOW_SUMMARY_SHARING: 'Autoriser les managers à partager la synthèse des feedbacks avec le collaborateur',
        CROSS_FEEDBACK_ALLOW_SUMMARY_SHARING_HELP: 'Si désactivé, le manager ne peut pas partager le compte rendu avec le collaborateur évalué.',
      },
      // Keep translated labels separate from the persisted A1-C3 technical answer code.
      NINE_BOX: {
        FIELD_TYPE: 'Matrice 9 cases',
        INSTRUCTION: 'Sélectionnez la case qui représente le mieux la performance et le potentiel du collaborateur.',
        GRID_ARIA: 'Matrice à neuf cases de performance et de potentiel',
        PERFORMANCE: 'Performance',
        POTENTIAL: 'Potentiel',
        LOW: 'Faible',
        HIGH: 'Élevé',
        NO_SELECTION: 'Aucune case sélectionnée',
        CELLS: {
          A3: {
            TITLE: 'Énigmatique',
            DESCRIPTION: 'Mauvaise performance, potentiel élevé',
          },
          A2: {
            TITLE: 'Future Star',
            DESCRIPTION: 'Bon/moyen rendement avec potentiel élevé',
          },
          A1: {
            TITLE: 'Future Leader',
            DESCRIPTION: 'Performance supérieure, prêt pour une promotion',
          },
          B3: {
            TITLE: 'Inconsistant',
            DESCRIPTION: 'Peu de performance avec potentiel moyen',
          },
          B2: {
            TITLE: 'Performance moyenne, potentiel moyen',
            DESCRIPTION: 'Ou en poste depuis moins de 3 à 6 mois (équipe de gestion)',
          },
          B1: {
            TITLE: 'Performer',
            DESCRIPTION: 'Haute performance, potentiel modéré',
          },
          C3: {
            TITLE: 'Sous performe',
            DESCRIPTION: 'Performance médiocre, possibilités limitées (recrutez)',
          },
          C2: {
            TITLE: 'Bon/moyen rendement',
            DESCRIPTION: 'Potentiel limité',
          },
          C1: {
            TITLE: 'Employé de confiance',
            DESCRIPTION: 'Haute performance, faible potentiel',
          },
        },
      },
      FIELD_VISIBILITY: 'Visibilité du champ',
      FIELD_LABEL: 'Libellé du champ',
      FIELD_LABEL_PLACEHOLDER: 'Saisissez un libellé',
      VISIBLE_FOR_ADMIN: 'Visible pour admin',
      VISIBLE_FOR_MANAGER: 'Visible pour responsable',
      VISIBLE_FOR_COLLABORATOR: 'Visible pour collaborateur',
      ADVANCED_PARAMETERS: 'Paramètres avancés',
      FIELD_EDITABLE_BY: 'Champ éditable par',
      // Décrire séparément chaque rôle rend les quatre combinaisons facultatif/obligatoire explicites.
      FIELD_RESPONSE_RULES: 'Réponse attendue par rôle',
      FIELD_RESPONSE_RULES_HELP: 'Choisissez séparément si le manager et le collaborateur doivent répondre à ce champ.',
      FIELD_ROLE_MANAGER: 'Réponse du manager',
      FIELD_ROLE_COLLABORATOR: 'Réponse du collaborateur',
      EDITABLE_OPTIONAL: 'Optionnel',
      EDITABLE_MANDATORY: 'Obligatoire',
      EDITABLE_HIDDEN: 'Non visible',
      MANAGER_OPTIONAL_ANSWER: 'Question facultative',
      MANAGER_REQUIRED_ANSWER: 'Question obligatoire',
      MANAGER_READONLY: 'Question en lecture seule',
      COLLAB_OPTIONAL_ANSWER: 'Réponse facultative',
      COLLAB_REQUIRED_ANSWER: 'Réponse obligatoire',
      COLLAB_READONLY: 'En lecture seule',
      FIELD_ANSWER_MODE: 'Mode de réponse',
      ANSWER_SINGLE_COLLAB: 'Réponse unique (Collaborateur)',
      ANSWER_SINGLE_MANAGER: 'Réponse unique (Manager)',
      ANSWER_MULTIPLE: 'Réponses multiples (Manager + Collaborateur)',
      WORKFLOW_PARAMETERS: "Paramètres de l'entretien",
      WORKFLOW_PARAMS_TITLE: 'Paramètres généraux',
      WORKFLOW_PARAMS_DESC: "Configurez les paramètres globaux de l'entretien",
      COLLAB_CAN_VIEW_WORKFLOW: "Le collaborateur peut consulter l'ensemble de l'entretien",
      COLLAB_CAN_VIEW_WORKFLOW_DESC: 'Si activé, le collaborateur pourra voir toutes les sections du formulaire',
      VISIBLE_BY_COLLABORATOR: 'Visible par le collaborateur',
      VISIBLE_BY_COLLABORATOR_DESC: "Si activé, l'entretien sera visible par le collaborateur",
      MANAGER_CAN_VIEW_BEFORE_VALIDATION: "Le manager peut voir l'entretien avant validation du collaborateur",
      MANAGER_CAN_VIEW_BEFORE_VALIDATION_DESC:
        'Si activé, le manager aura accès au contenu avant que le collaborateur ne valide',
      ALLOW_MANAGER_AI_ASSISTANCE: "Autoriser le manager à choisir l'assistance IA",
      ALLOW_MANAGER_AI_ASSISTANCE_DESC:
        "Si activé, le manager pourra activer ou désactiver l'assistance IA lors de la complétion de l'entretien, sinon l'assistance IA sera désactivée par défaut sans possibilité de l'activer.",
      IA_GUIDELINE_TITLE: 'Instructions IA par défaut',
      IA_GUIDELINE_DESC: "Définissez les instructions par défaut pour l'assistant IA lors de la génération de contenu pour ce modèle d'entretien.",
      IA_GUIDELINE_PLACEHOLDER: 'Ex : Utiliser un ton professionnel et bienveillant. Se concentrer sur les objectifs de développement du collaborateur...',
      PREPARATION_QUESTIONS_TITLE: 'Questions de préparation',
      PREPARATION_QUESTIONS_DESC: 'Définissez les questions auxquelles le manager doit répondre avant d’utiliser l’assistant IA. Ces réponses guideront l’IA dans ses suggestions.',
      PREPARATION_QUESTIONS_SUGGESTIONS_TITLE: 'Suggestions',
      PREPARATION_QUESTIONS_SUGGESTION_1: 'Quel est le message principal que vous souhaitez que votre collaborateur retienne à l’issue de cet entretien ?',
      PREPARATION_QUESTIONS_SUGGESTION_2: 'Dans quel état d’esprit abordez-vous cet entretien (ex : confiant, incertain, tendu…) ?',
      PREPARATION_QUESTIONS_SUGGESTION_3: 'Quelles réactions de votre collaborateur anticipez-vous, et comment souhaitez-vous y répondre en tant que manager ?',
      PREPARATION_QUESTIONS_SUGGESTION_4: 'Quel est, selon vous, le niveau de priorité à retenir ce collaborateur dans l’entreprise ? (Échelle de 1 à 5, où 5 = collaborateur clé à retenir absolument)',
      PREPARATION_QUESTION_PLACEHOLDER: 'Saisissez la question...',
      ADD_PREPARATION_QUESTION_PLACEHOLDER: 'Ajouter une nouvelle question de préparation...',
      PREPARATION_QUESTIONS_SECTION_TITLE: 'Questions de préparation',
      PREPARATION_QUESTIONS_SECTION_DESC: 'Veuillez répondre aux questions suivantes pour aider l\'assistant IA à mieux vous accompagner.',
      PREPARATION_ANSWER_PLACEHOLDER: 'Saisissez votre réponse...',
      AI_ASSISTANT_TITLE: 'Assistant IA',
      AI_ASSISTANT_TAB: 'Assistant IA',
      AI_ASSISTANT_DISCLAIMER: "La version finale de l'entretien est sous la responsabilité du manager.",
      AI_ASSISTANT_CHOICE_MADE: 'Votre choix',
      AI_ASSISTANT_CHOICE_YES: 'Assistance IA activée',
      AI_ASSISTANT_CHOICE_NO: 'Assistance IA désactivée',
      AI_ASSISTANT_CHANGE_CHOICE: "Vous pouvez modifier votre choix en cliquant sur l'une des options ci-dessous.",
      
      AI_CHAT: {
        CARD_LABEL: 'Section',
        QUESTION_LABEL: 'Question',
        PROGRESS: 'Progression',
        CANCEL_AI_ASSISTANCE: 'Annuler l’assistance IA',
        CONTINUE_INTERVIEW: 'Continuer l’entretien',
        SIDEBAR_INPUT_PLACEHOLDER: 'Saisissez votre message...',
        SEND_TO_AI: 'Envoyer à l’IA',
        CANCEL_CONFIRMATION_TITLE: "Annuler l'assistance IA",
        CANCEL_CONFIRMATION_MESSAGE: "Êtes-vous sûr de vouloir annuler l'assistance IA ? Vos réponses aux questions de préparation seront perdues.",
        INPUT_PLACEHOLDER: 'Saisissez votre réponse...',
        COMPLETION_MESSAGE: 'Merci pour vos réponses ! Vous pouvez maintenant continuer avec l\'entretien.',
      },
      AI_TEXT: {
        CONTEXTUALISER: 'Reformuler',
        VERIFIER: 'Vérifier',
        CONTEXTUALISER_TITLE: 'Reformuler le texte',
        VERIFIER_TITLE: 'Vérifier le texte',
        SELECTED_TEXT: 'Texte sélectionné',
        INSTRUCTION_LABEL: 'Instructions / Contexte',
        INSTRUCTION_HINT: 'Ajoutez des consignes ou du contexte pour guider la réponse IA.',
        INSTRUCTION_PLACEHOLDER: 'Ajoutez des instructions pour l’IA...',
        GENERATE: 'Générer',
        RESULT_LABEL: 'Résultat',
        RESULT_PLACEHOLDER: 'Le texte généré apparaîtra ici...',
        CANCEL: 'Annuler',
        INSERT: 'Insérer',
        ERROR_NO_CONVERSATION: 'Impossible de contacter l’IA. Veuillez réessayer.',
        ERROR_GENERATING: 'Erreur lors de la génération du texte',
      },
      // Traductions de la dictée vocale et de tous ses messages utilisateur/toaster.
      VOICE_DICTATION: {
        OPEN: 'Saisir du texte par la voix',
        TITLE: 'Dictée vocale',
        START: 'Commencer l’enregistrement',
        STOP: 'Arrêter l’enregistrement',
        READY: 'Prêt à enregistrer',
        RECORDING: 'Enregistrement en cours…',
        RECORDING_HINT: 'Parlez normalement. La transcription s’affiche en temps réel et reste modifiable.',
        UNSUPPORTED_HINT: 'La transcription vocale native n’est pas disponible dans ce navigateur.',
        TRANSCRIPTION_LABEL: 'Transcription',
        TRANSCRIPTION_PLACEHOLDER: 'La transcription en temps réel apparaîtra ici…',
        INSTRUCTION_LABEL: 'Instructions pour l’IA',
        INSTRUCTION_PLACEHOLDER: 'Indiquez comment l’IA doit reformuler ce texte…',
        REFORMULATE_WITH_AI: 'Reformuler avec l’IA',
        ACCEPT: 'Accepter',
        EMPTY_TRANSCRIPTION: 'Ajoutez ou dictez un texte avant de le reformuler.',
        UNSUPPORTED: 'La transcription vocale native n’est pas prise en charge par ce navigateur.',
        HTTPS_REQUIRED: 'La transcription vocale nécessite une connexion HTTPS sécurisée.',
        PERMISSION_DENIED: 'L’accès au microphone a été refusé. Autorisez-le dans les paramètres du navigateur.',
        MICROPHONE_UNAVAILABLE: 'Aucun microphone disponible n’a pu être utilisé.',
        RECOGNITION_ERROR: 'La transcription vocale a été interrompue. Veuillez réessayer.',
        START_ERROR: 'Impossible de démarrer l’enregistrement vocal.',
        REFORMULATION_ERROR: 'Erreur lors de la reformulation du texte avec l’IA.',
      },
      ALLOW_CONCURRENT_EDITING: 'Autoriser l’édition simultanée par le manager et le collaborateur',
      ALLOW_CONCURRENT_EDITING_DESC: 'Si activé, le manager et le collaborateur peuvent remplir l\'entretien en même temps sans attendre que l\'autre valide',
      EDITABLE_BY_MANAGER: 'Modifiable par le responsable d\'entretien',
      COLLAB_CAN_REFUSE: 'Le collaborateur peut refuser de remplir l\'entretien',
      COLLAB_CAN_REFUSE_DESC: 'Si activé, le collaborateur pourra refuser de compléter le formulaire',
      MANAGER_CAN_REFUSE: "Le manager peut refuser de remplir l'entretien",
      MANAGER_CAN_REFUSE_DESC: 'Si activé, le manager pourra refuser de compléter le formulaire',
      CROSS_FEEDBACK_AUTO_CANCEL: 'Annuler automatiquement les feedbacks croisés non terminés après la fin de l\'entretien',
      CROSS_FEEDBACK_AUTO_CANCEL_DESC: "Si activé, les feedbacks croisés non terminés sont automatiquement annulés à la fin de l'entretien. Les feedbacks croisés peuvent être demandés après la date de l'entretien, quelle que soit cette option.",
      REFUSE_CONSEQUENCES: "Détailler les conséquences d'un refus",
      REFUSE_CONSEQUENCES_PLACEHOLDER:
        "Si vous n'êtes pas d'accord avec les conclusions de l'entretien, vous pouvez le refuser. Un entretien avec le service RH sera alors organisé.",
      REFUSE_INTERVIEW: "Refuser l'entretien",
      REFUSE_INFO: 'Vous pouvez refuser cet entretien. Veuillez prendre connaissance des informations suivantes :',
      CONSEQUENCES: 'Conséquences',
      REFUSE_PROCEED: 'Continuer',
      REFUSE_REASON_PROMPT: 'Veuillez indiquer la raison de votre refus (optionnel).',
      REFUSE_REASON_LABEL: 'Raison du refus',
      REFUSE_REASON_PLACEHOLDER: 'Expliquez pourquoi vous refusez cet entretien...',
      REFUSE_CONFIRM: 'Confirmer le refus',
      REFUSE_SUCCESS: 'Entretien refusé avec succès',
      REFUSE_ERROR: "Erreur lors du refus de l'entretien",
      REFUSED: 'Refusé',
      REFUSED_BY_EMPLOYEE: 'Refusé par le collaborateur',
      REFUSED_BY_MANAGER: 'Entretien refusé par le contributeur',
      REFUSED_BY_COLLAB: 'CR refusé par le collaborateur',
      PENDING_COLLAB_VALIDATION: 'En attente de validation du collaborateur',
      PENDING_COLLAB_VALIDATION_TOOLTIP: 'En attente de validation de {{name}}',
      COLLABORATOR_VALIDATED_TOOLTIP: '{{name}} a validé',
      MANAGER_VALIDATED_TOOLTIP: '{{name}} a validé',
      PENDING_MANAGER_VALIDATION: 'En attente de validation du responsable entretien',
      PENDING_MANAGER_VALIDATION_TOOLTIP: 'En attente de validation de {{name}}',
      CANCEL_VALIDATION: {
        BUTTON_TITLE: "Annuler la validation",
        TITLE: 'Annuler la validation',
        WARNING: "Attention : cette action est irréversible et nécessitera une nouvelle validation.",
        MESSAGE: "Choisissez quelle validation vous souhaitez annuler :",
        RESET_MANAGER: "Annuler la validation du responsable",
        RESET_COLLAB: "Annuler la validation du responsable et du collaborateur",
        RESET_COLLAB_ONLY: "Annuler la validation du collaborateur",
        CONFIRM_TITLE: "Confirmer l'annulation de validation",
        CONFIRM_MANAGER_MESSAGE: "Voulez-vous vraiment annuler la validation du responsable ?",
        CONFIRM_COLLAB_MESSAGE: "Voulez-vous vraiment annuler la validation du responsable et du collaborateur ?",
        CONFIRM_COLLAB_ONLY_MESSAGE: "Voulez-vous vraiment annuler la validation du collaborateur ?",
        CONFIRM_ACTION: 'Confirmer',
        SUCCESS_MANAGER: "L'entretien a été réinitialisé avant la validation du responsable",
        SUCCESS_COLLAB: "L'entretien a été réinitialisé avant la validation du collaborateur",
        ERROR: "Erreur lors de l'annulation de la validation",
      },
      PURGE_CROSS_FEEDBACK: {
        BUTTON_TITLE: 'Détruire les entretiens feedbacks croisés',
        BUTTON_TOOLTIP: 'Supprimer définitivement les feedbacks croisés terminés avant une date',
        TITLE: 'Détruire les feedbacks croisés',
        WARNING: "<strong>Action sensible et irréversible.</strong> Tous les <strong>feedbacks croisés terminés</strong> réalisés avant la date choisie seront définitivement supprimés. Cette action ne peut pas être annulée.",
        DATE_LABEL: 'Supprimer les feedbacks croisés terminés avant le :',
        DATE_HINT: 'Seuls les feedbacks croisés (entretiens liés à un parent) dont le statut est « Terminé » et dont la date d\'entretien est antérieure à cette date seront supprimés.',
        CONFIRM_LABEL: 'Pour confirmer, saisissez le mot DELETE :',
        CONFIRM_PLACEHOLDER: 'DELETE',
        CONFIRM_BUTTON: 'Supprimer définitivement',
        SUCCESS: '{{count}} feedback(s) croisé(s) supprimé(s) avec succès',
        ERROR: 'Erreur lors de la suppression des feedbacks croisés',
      },
      PRIORITY_MODAL: {
        TITLE: 'Explication de la priorité',
        PRIORITY_LEVEL_LABEL: 'Niveau de priorité',
        EXPLANATION_LABEL: 'Explication',
        TOOLTIP: "Voir l'explication de la priorité",
        NO_EXPLANATION: 'Aucune explication disponible pour le moment.',
        PRIORITY: {
          NORMAL: 'Normal',
          IMPORTANT: 'Important',
          URGENT: 'Urgent',
        },
      },
      TO_FILL_BY_YOU: 'À renseigner par vous',
      YOUR_SIGNATURE_REQUIRED: 'Votre signature requise',
      PENDING_COLLAB_SIGNATURE: 'En attente de signature du collaborateur',
      TO_SIGN_BY_YOU: 'À signer par vous',
      SIGNED_BY_YOU: 'Signé par vous',
      LATE: 'En retard',
      STATS: {
        IN_PROGRESS: 'Entretiens en cours',
        IN_PROGRESS_SHORT: 'en cours',
        LATE: 'Entretiens en retard',
        LATE_SHORT: 'en retard',
        CURRENT_FILTER_HINT: 'Selon les filtres affichés',
        LATE_HINT: 'Planifiés ou en validation après la date prévue',
        CAMPAIGNS_HINT: 'Total des campagnes affichées',
      },
      STATUS_DRAFT: 'Brouillon',
      STATUS_PLANNED: 'Planifié',
      STATUS_STARTED: 'Démarré',
      STATUS_COMPLETED: 'Terminé',
      STATUS_CANCELLED: 'Annulé',
      STATUS_REVISION: 'CR refusé / En révision',
      FILL_DOCUMENT: 'Remplir le document',
      REFUSED_NO_REASON: 'Aucune raison fournie',
      VIEW_REFUSAL_REASON: 'Voir la raison du refus',
      REFUSAL_REASON_TITLE: 'Raison du refus',
      CARD_VISIBLE_FOR_COLLABORATOR: 'Carte visible pour le collaborateur',
      CARD_VISIBLE_ONLY_FOR_MANAGER: "Carte visible uniquement si le collaborateur est manager",
      PARAGRAPH_EDITOR: {
        TOOLBAR: 'Mise en forme du paragraphe',
        PLACEHOLDER: 'Saisir le contenu du paragraphe...',
        UNDO: 'Annuler',
        REDO: 'Rétablir',
        BOLD: 'Gras',
        ITALIC: 'Italique',
        UNDERLINE: 'Souligné',
        STRIKE: 'Barré',
        BULLET_LIST: 'Liste à puces',
        ORDERED_LIST: 'Liste numérotée',
        LINK: 'Ajouter un lien',
        CLEAR: 'Effacer la mise en forme',
        APPLY: 'Appliquer',
        REMOVE: 'Retirer',
        CANCEL: 'Annuler',
        LINK_ERROR: 'Utilisez un lien relatif, HTTPS, une ancre ou une adresse e-mail.',
        HINT: 'Sélectionnez du texte pour le mettre en forme. Le contenu collé est nettoyé automatiquement.',
        EDIT: 'Modifier',
        DONE: 'Terminer',
      },
      TARGET: {
        CAN_READ: "Permettre à la cible de lire le contenu de l'entretien",
        MUST_VALIDATE: "La cible doit valider l'entretien avant le manager",
      },
      FILL_WORKFLOW: {
        TITLE: "Remplir le document d'entretien",
        COLLABORATOR: 'Collaborateur',
        MANAGER: 'Manager',
        SAVE_AND_VALIDATE: 'Sauvegarder et valider',
        NO_WORKFLOW: 'Aucun entretien disponible',
        VIEW_ANSWER: 'Voir la réponse',
        EDITOR_PLACEHOLDER: 'Cliquez pour commencer à écrire...',
        PREVIEW_SAVE_AND_PREVIEW: 'Enregistrer et prévisualiser',
        PREVIEW_FINALIZE_COLLAB: 'Finaliser et envoyer',
        PREVIEW_FINALIZE_MANAGER: 'Finaliser et envoyer pour signature',
        PREVIEW_PREVIEW_ONLY: 'Prévisualiser',
        PREVIEW_AND_VALIDATE: 'Prévisualiser et valider',
        PREVIEW_RUN_AI_AUDIT: 'Vérifier',
        AI_AUDIT_IN_PROGRESS: 'Audit IA en cours...',
        FINAL_ACCEPT: 'Accepter',
        FINAL_REFUSE: 'Refuser',
        FINAL_ACCEPT_SUCCESS: 'Entretien accepté définitivement',
        FINAL_ACCEPT_ERROR: "Erreur lors de l'acceptation définitive de l'entretien",
        FINAL_REFUSE_SUCCESS: 'Entretien refusé - En attente de révision par le manager',
        FINAL_REFUSE_ERROR: "Erreur lors du refus de l'entretien",
        REVISE_AND_RESUBMIT: 'Réviser et renvoyer',
        REVISE_SUCCESS: 'Entretien renvoyé au collaborateur pour validation',
        REVISE_ERROR: "Erreur lors de l'envoi de l'entretien révisé",
        FINAL_DECISION_ACCEPTED: 'Entretien accepté par {{name}} le {{date}}.',
        FINAL_DECISION_REFUSED: 'Entretien refusé par le contributeur le {{date}}.',
        MARK_COMPLETED: 'Marquer comme terminé',
        UNMARK_COMPLETED: 'Marquer comme non terminé',
        COMPLETED: 'Terminé',
        DRH_REQUEST: 'Demander un entretien RH',
        DRH_REQUEST_SUCCESS: "Votre demande d'entretien RH a été envoyée.",
        DRH_REQUEST_ERROR: "Erreur lors de l'envoi de la demande d'entretien RH.",
      },
      PREVIEW: {
        OPEN: 'Prévisualiser le document',
        TITLE: "Compte rendu de l'entretien",
        DESCRIPTION:
          "Voici une vue consolidée des questions et des réponses. Cette mise en page est utilisée pour l'export PDF.",
        EXPORT_PDF: 'Exporter en PDF',
        EXPORTING: 'Export en cours...',
        DEFAULT_TITLE: 'Entretien',
        UNLABELED_FIELD: 'Champ sans libellé',
        UNLABELED_OBJECTIVE: 'Objectif sans libellé',
        UNLABELED_SKILL: 'Compétence sans libellé',
        COLLAB_ANSWER: 'Réponse du collaborateur',
        MANAGER_ANSWER: "Réponse du responsable d'entretien",
        OBJECTIVE_INDEX: 'Objectif {{number}}',
        NO_ANSWER: 'Aucune réponse renseignée',
        PLACEHOLDER_COLLAB: 'Réponse du collaborateur visible après sa validation.',
        PLACEHOLDER_MANAGER: "Réponse du responsable d'entretien visible après sa validation.",
        ERROR_BUILD: 'Erreur lors de la construction de la prévisualisation.',
        ERROR_EXPORT: "Erreur lors de l'export du PDF.",
      },
      VALIDATION: {
        // L'année des objectifs créés par le manager bloque la finalisation, mais pas le brouillon.
        VALIDATION_ERROR: 'Validation requise',
        MANDATORY_FIELDS_MISSING: 'Veuillez remplir tous les champs obligatoires avant de prévisualiser :',
        MANDATORY_CONTENT_MISSING: 'Contenu obligatoire manquant',
        CLICK_MISSING_FIELD: 'Cliquez sur un champ manquant pour y accéder directement.',
        FIELD_REQUIRED: 'Ce champ est obligatoire',
        COMMENT_REQUIRED: 'Commentaire obligatoire',
        OBJECTIVE_YEAR_LABEL: 'Année de référence',
        OBJECTIVE_YEAR_PLACEHOLDER: 'Sélectionner une année',
        OBJECTIVE_YEAR_REQUIRED: 'année obligatoire',
        OBJECTIVE_YEAR_LOCKED_HELP: "Sélectionnez une année de référence pour déverrouiller les autres contrôles de l'objectif.",
      },
      PDF_HEADER: {
        EMPLOYEE: 'Collaborateur',
        MANAGER: "Responsable d'entretien",
        CONTRIBUTOR: 'Contributeur',
        DATE: "Date de l'entretien",
      },
      SELECT_DOCS: 'Sélectionner des documents',
      NO_DOC_AVAILABLE: 'Aucun document disponible',
      NO_OBJECTIVES_ADDED: 'Aucun objectif ajouté',
      NO_SKILLS_SELECTED: 'Aucune compétence sélectionnée',
      NO_USERS_SELECTED: 'Aucun utilisateur sélectionné',
      NO_FORMATIONS_SELECTED: 'Aucune formation sélectionnée',
      NO_FORMATIONS_FOUND: 'Aucune formation trouvée',
      SELECTED_SKILLS: 'Compétences sélectionnées',
      SELECTED_FORMATIONS: 'Formations sélectionnées',
      SEARCH_FORMATIONS: 'Rechercher des formations',
      SEARCH_SKILLS: 'Rechercher des compétences',
      FORMATION_DEFAULT_NAME: 'Formation',
      SELECT_SIRH_ELEMENT: 'Sélectionner un élément SIRH',
      SKILLS_INFO: 'Recherchez et ajoutez des compétences pertinentes pour cet entretien',
      SKILLS_SEARCH_PLACEHOLDER: 'Rechercher une compétence...',
      COMMENT_PLACEHOLDER: 'Ajouter un commentaire...',
      COMMENT_MANDATORY_PLACEHOLDER: 'Commentaire obligatoire...',
      ADD_SKILL: 'Ajouter la compétence',
      INVALID_SKILL: 'Compétence invalide',
      SKILL_ALREADY_EXISTS: 'Cette compétence a déjà été ajoutée',
      DATA_SAVED_SUCCESS: 'Données sauvegardées avec succès',
      ERROR_LOADING: 'Erreur lors du chargement des données',
      ERROR_SAVING_DATA: 'Erreur lors de la sauvegarde des données',
        ERROR_SUBMIT: "Erreur lors de la soumission de l'entretien",
        ERROR_VALIDATE: "Erreur lors de la validation de l'entretien",
        MANAGER_VALIDATION_WAITING_FOR_COLLABORATOR: 'Le collaborateur doit valider son entretien avant que vous puissiez le valider.',
      SUCCESS_SUBMITTED: 'Entretien soumis avec succès',
      SUCCESS_VALIDATED: 'Entretien validé avec succès',
      EVALUATE_SKILLS: 'Évaluer les compétences',
      EVALUATE_YOUR_SKILLS: 'Évaluez vos compétences',
      ADD_MORE_SKILLS: 'Ajouter des compétences',
      SELECT_LEVEL: 'Sélectionner un niveau',
      SELECT_MIN: 'Sélectionnez au moins {{min}} élément(s)',
      SELECT_MAX: 'Sélectionnez au maximum {{max}} élément(s)',
      SELECT_BETWEEN: 'Sélectionnez entre {{min}} et {{max}} élément(s)',
      ENTER_SCORE: 'Entrer une note',
      SKILL_SOURCE_ADMIN: "Sélectionné par l'admin",
      SKILL_SOURCE_COLLABORATOR: 'Ajouté par le collaborateur',
      SKILL_SOURCE_MANAGER: 'Ajouté par le manager',
      CANNOT_DELETE_ADMIN_SKILL: "Vous ne pouvez pas supprimer une compétence sélectionnée par l'administrateur",
      SKILL_REMOVED: 'Compétence supprimée',
      SKILL_ADDED: 'Compétence ajoutée avec succès',
      // Description controls are shared by manager and collaborator interview views.
      SKILL_DESCRIPTION_SHOW: 'Afficher la description de la compétence',
      SKILL_DESCRIPTION_HIDE: 'Masquer la description de la compétence',
      SKILL_DESCRIPTION_UNAVAILABLE: 'Aucune description disponible pour cette compétence.',
      COLLABORATOR_EVALUATION: 'Évaluation du collaborateur',
      COLLABORATOR_COMMENT: 'Commentaire du collaborateur',
      OBJECTIVE_EVALUATION: 'Évaluation',
      NO_SKILLS_ADDED_BY_COLLAB: 'Aucune compétence ajoutée par le collaborateur',
      NO_OBJECTIVES_ADDED_BY_COLLAB: 'Aucun objectif ajouté par le collaborateur',
      OBJECTIVE_SCOPE_INDIVIDUAL: 'Individuel',
      OBJECTIVE_SCOPE_COLLECTIVE: 'Collectif',
      OBJECTIVE_ACHIEVEMENT_STATUS: "Statut d'atteinte",
      OBJECTIVE_KPI_METRIC: 'Indicateur KPI',
      OBJECTIVE_KPI_METRIC_PLACEHOLDER: 'Saisissez l\'indicateur de performance...',
      // Separate the labels from their explanations so Official and Non-official remain visibly bold.
      OBJECTIVE_OFFICIAL: 'Officiel',
      OBJECTIVE_NON_OFFICIAL: 'Non officiel',
      OBJECTIVE_OFFICIAL_SWITCH_ARIA: "Définir si l’objectif du collaborateur est officiel",
      OBJECTIVE_NON_OFFICIAL_HELP: "L’objectif reste uniquement informatif et n’est pas ajouté aux objectifs du collaborateur.",
      OBJECTIVE_OFFICIAL_HELP: "L’objectif est ajouté à la liste des objectifs du collaborateur. Vous pouvez modifier son titre et ses KPI avant validation.",
      ACHIEVEMENT_NOT_ACHIEVED: 'Non atteint',
      ACHIEVEMENT_PARTIALLY_ACHIEVED: 'Partiellement atteint',
      ACHIEVEMENT_ACHIEVED: 'Atteint',
      ACHIEVEMENT_EXCEEDED: 'Dépassé',
      EVALUATION_LEVELS: {
        NOT_ACHIEVED: 'Non atteint',
        PARTIALLY_ACHIEVED: 'Partiellement atteint',
        ACHIEVED: 'Atteint',
        EXCEEDED: 'Dépassé',
      },
      MIN_SELECTIONS_LABEL: 'Sélections minimales',
      MIN_SELECTIONS_HELP: 'Nombre minimum de sélections requises (défaut: 1)',
      MAX_SELECTIONS_LABEL: 'Sélections maximales',
      MAX_SELECTIONS_HELP: 'Nombre maximum de sélections autorisées (0 = illimité)',
      MAX_SELECTIONS_REACHED: 'Limite de {{max}} sélection(s) atteinte',
      UNLIMITED: 'Illimité',
      RATING_ALLOW_COMMENT: 'Autoriser un commentaire',
      SKILLS_EVALUATION_FORMAT: "Format d'évaluation des compétences",
      SKILLS_EVALUATION_FORMAT_DESC:
        'Choisissez le format d\'évaluation qui sera utilisé pour tous les champs de type "Compétence"',
      SKILLS_FORMAT_STARS: 'Étoiles (notation par étoiles)',
      SKILLS_FORMAT_TEXT: 'Texte (options textuelles)',
      SKILLS_TEXT_OPTIONS: "Options d'évaluation textuelle",
      SKILLS_AUTOSYNC: {
        TITLE: 'Synchronisation des compétences',
        LABEL: 'Synchroniser automatiquement les compétences après validation',
        DESC:
          "Lorsqu'un entretien est validé, le niveau de chaque compétence évaluée (notation 1 à 5) met à jour le référentiel des compétences du collaborateur. Si désactivé, aucune compétence n'est modifiée.",
        ENABLED: 'Activé',
        DISABLED: 'Désactivé',
        SAVED: 'Option de synchronisation mise à jour',
        LOAD_ERROR: 'Échec du chargement de l\'option de synchronisation',
        SAVE_ERROR: 'Échec de l\'enregistrement de l\'option de synchronisation',
        DOMAIN_FILTER_LABEL: 'Filtrer par domaine',
        ALL_DOMAINS: 'Tous les domaines',
        DOMAIN_SEARCH_PLACEHOLDER: 'Rechercher et sélectionner des domaines...',
        ALLOWED_DOMAINS_HINT: "Sélectionnez les domaines autorisés pour ce champ. Si aucun n'est sélectionné, tous les domaines sont disponibles. Le manager et le collaborateur ne pourront ajouter que des compétences des domaines sélectionnés.",
      },
      AVAILABLE_OPTIONS: 'Options disponibles',
      NEW_OPTION_PLACEHOLDER: 'Nouvelle option...',
      SELECTED_COUNT: '{{count}} / {{max}} sélection(s)',
      DOCUMENT_HEADER_CONFIG: 'Informations administratives',
      DOCUMENT_HEADER_CONFIG_DESC: 'Sélectionnez les informations administratives à afficher dans le document généré.',
      CUSTOM_VALUE: 'Valeur personnalisée',
      FROM_DATABASE: 'Rempli automatiquement',
      USE_DATABASE: 'Rempli automatiquement',
      USE_CUSTOM_VALUE: 'Valeur personnalisée',
      CUSTOM_VALUE_LABEL: 'Valeur personnalisée',
      CUSTOM_VALUE_HELP: 'Cette valeur sera affichée pour tous les entretiens utilisant ce modèle',
      AUTO_FILLED_INFO:
        "Rempli automatiquement lors de la création de l'entretien. Si les données sont manquantes, le champ apparaîtra vide.",
      HEADER_FIELD_EMPLOYEE_NAME: 'Nom du collaborateur',
      HEADER_FIELD_EMPLOYEE_NAME_DESC: 'Nom complet du collaborateur (prénom et nom)',
      HEADER_FIELD_EMPLOYEE_NAME_PLACEHOLDER: 'Ex: Jean Dupont',
      HEADER_FIELD_EMPLOYEE_FUNCTION: 'Fonction',
      HEADER_FIELD_EMPLOYEE_FUNCTION_DESC: 'Fonction ou poste occupé par le collaborateur',
      HEADER_FIELD_EMPLOYEE_FUNCTION_PLACEHOLDER: 'Ex: Développeur Full Stack',
      HEADER_FIELD_EMPLOYEE_TITLE: 'Titre',
      HEADER_FIELD_EMPLOYEE_TITLE_DESC: 'Titre professionnel du collaborateur',
      HEADER_FIELD_EMPLOYEE_TITLE_PLACEHOLDER: 'Ex: Ingénieur Senior',
      HEADER_FIELD_EMPLOYEE_SITE: 'Site',
      HEADER_FIELD_EMPLOYEE_SITE_DESC: 'Site de travail ou localisation du collaborateur',
      HEADER_FIELD_EMPLOYEE_SITE_PLACEHOLDER: 'Ex: Paris - La Défense',
      HEADER_FIELD_EMPLOYEE_TEAM: 'Team',
      HEADER_FIELD_EMPLOYEE_TEAM_DESC: 'Team or squad of the employee',
      HEADER_FIELD_EMPLOYEE_TEAM_PLACEHOLDER: 'E.g.: Customer Support',
      HEADER_FIELD_SENIORITY: 'Ancienneté',
      HEADER_FIELD_SENIORITY_DESC: "Ancienneté du collaborateur dans l'entreprise (si données disponibles)",
      HEADER_FIELD_SENIORITY_PLACEHOLDER: 'Ex: 5 ans',
      HEADER_FIELD_SALARY_COEFFICIENT: 'Coefficient (nombre entre 350 et 900)',
      HEADER_FIELD_SALARY_COEFFICIENT_DESC: 'Coefficient salarial selon la convention collective',
      HEADER_FIELD_SALARY_COEFFICIENT_PLACEHOLDER: 'Ex: 450',
      HEADER_FIELD_MANAGER_NAME: 'Nom du manager',
      HEADER_FIELD_MANAGER_NAME_DESC: "Nom complet du manager responsable de l'entretien",
      HEADER_FIELD_MANAGER_NAME_PLACEHOLDER: 'Ex: Marie Martin',
      HEADER_FIELD_INTERVIEW_DATE: "Date de l'entretien",
      CAMPAIGNS: {
        TITLE: "Campagnes d'entretiens",
        DESCRIPTION: 'Créez et gérez des campagnes pour planifier des entretiens en masse',
        CREATE_CAMPAIGN: 'Créer une campagne',
        EDIT_CAMPAIGN: 'Modifier la campagne',
        // Keep campaign mutation fallbacks translated when the failure is unrelated to payroll authorization.
        CREATE_ERROR: 'Impossible de créer la campagne',
        UPDATE_ERROR: 'Impossible de mettre à jour la campagne',
        CREATE_FIRST_CAMPAIGN: 'Créez votre première campagne',
        CAMPAIGN_NAME: 'Nom de la campagne',
        CAMPAIGN_NAME_PLACEHOLDER: 'Ex: Entretiens annuels 2025',
        CAMPAIGN_DESCRIPTION: 'Description',
        CAMPAIGN_DESCRIPTION_PLACEHOLDER: "Décrivez l'objectif de cette campagne...",
        INTERVIEW_TYPE: "Type d'entretien",
        SELECT_INTERVIEW_TYPE: "Sélectionnez un type d'entretien",
        DOCUMENT_TEMPLATE: 'Modèle de document',
        SELECT_DOCUMENT_TEMPLATE: 'Sélectionnez un modèle (optionnel)',
        NO_TEMPLATES_AVAILABLE: "Aucun modèle disponible pour ce type d'entretien",
        STATUS: 'Statut',
        STATUS_ACTIVE: 'Actif',
        STATUS_INACTIVE: 'Inactif',
        STATUS_COMPLETED: 'Terminé',
        CREATED_BY: 'Créé par',
        CREATED_AT: 'Créé le',
        INTERVIEWS_COUNT: 'Entretiens créés',
        DRAFTS: {
          TITLE: "Brouillons d'entretiens",
          DESCRIPTION: 'Vous avez actuellement {{ count }} brouillon(s) prêts à être convertis.',
          ADD_BUTTON: 'Nouveau brouillon',
          LAUNCH_ALL: 'Envoyer tous les entretiens',
          LOAD_ERROR: 'Impossible de charger les brouillons de campagne',
          EMPTY_TITLE: 'Aucun brouillon pour le moment',
          EMPTY_DESCRIPTION: 'Une fois vos brouillons créés, ils apparaîtront ici.',
          CONVERT_BUTTON: 'Transformer le brouillon en entretien',
          CONVERT_SUCCESS: '{{ count }} entretien(s) créé(s) depuis le brouillon',
          CONVERT_ERROR: 'Impossible de convertir ce brouillon',
          LAUNCH_SUCCESS: '{{ total }} entretien(s) créé(s) depuis les brouillons',
          LAUNCH_ERROR: 'Impossible de lancer les brouillons de la campagne',
          LAUNCH_CONFIRM_TITLE: 'Lancer la campagne ?',
          LAUNCH_CONFIRM_MESSAGE: 'Le lancement enverra immédiatement les emails et la campagne sera définitivement verrouillée. Voulez-vous continuer ?',
          LAUNCH_CONFIRM_ACTION: 'Lancer maintenant',
          TABLE: {
            COLLABORATOR: 'Collaborateur',
            CONTRIBUTOR: 'Contributeur',
            CREATED_AT: 'Date de création',
            INTERVIEW_DATE: "Date de l'entretien",
            LOCATION: 'Lieu',
            INTERVIEW_TYPE: "Type d'entretien",
            CREATED_BY: 'Créé par',
            ACTIONS: 'Actions',
          },
          // Batch actions have distinct labels because they do not launch the entire campaign.
          BULK: {
            SELECTED: '{{ count }} brouillon(s) sélectionné(s)',
            SELECT_ALL: 'Sélectionner tous les brouillons de cette campagne',
            SELECT_DRAFT: 'Sélectionner le brouillon de {{ target }}',
            EDIT_ACTION: 'Modifier la sélection',
            CONVERT_ACTION: 'Transformer la sélection',
            DELETE_ACTION: 'Supprimer la sélection',
            EDIT_TITLE: 'Modifier les brouillons sélectionnés',
            EDIT_HELP: 'Cochez uniquement les champs à modifier pour les {{ count }} brouillon(s) sélectionné(s). Les autres valeurs restent inchangées.',
            NON_ATOMIC: 'Les brouillons sont traités un par un. Si une opération échoue, les modifications déjà réussies sont conservées.',
            TIME: "Heure de l'entretien",
            LINK_HELP: 'Un lien vide efface les liens existants. Le lieu Présentiel efface également les liens visioconférence.',
            SAVE: 'Enregistrer les modifications',
            INVALID_FORM: 'Sélectionnez au moins un champ et renseignez une valeur valide (préavis de 1 à 12 mois et lien http(s)).',
            BUSY_DRAFT: 'Attendez la fin de l’opération en cours avant de traiter toute la sélection.',
            DELETE_TITLE: 'Supprimer les brouillons sélectionnés',
            DELETE_CONFIRM: 'Supprimer uniquement les brouillons sélectionnés ? Cette action ne touche pas les autres brouillons.',
            CONVERT_TITLE: 'Transformer les brouillons sélectionnés',
            CONVERT_CONFIRM: 'Transformer uniquement les brouillons sélectionnés en entretiens ? Des invitations calendrier et des emails peuvent être envoyés.',
            UPDATE_SUCCESS: '{{ count }} brouillon(s) mis à jour.',
            UPDATE_PARTIAL: '{{ success }} brouillon(s) mis à jour, {{ failed }} échec(s). Les échecs restent sélectionnés.',
            UPDATE_ERROR: 'Aucun brouillon sélectionné n’a pu être mis à jour.',
            DELETE_SUCCESS: '{{ count }} brouillon(s) supprimé(s).',
            DELETE_PARTIAL: '{{ success }} brouillon(s) supprimé(s), {{ failed }} échec(s). Les échecs restent sélectionnés.',
            DELETE_ERROR: 'Aucun brouillon sélectionné n’a pu être supprimé.',
            CONVERT_SUCCESS: '{{ count }} entretien(s) créé(s) depuis la sélection.',
            CONVERT_PARTIAL: '{{ count }} entretien(s) créé(s), {{ failed }} brouillon(s) en échec. Les échecs restent sélectionnés.',
            CONVERT_ERROR: 'Aucun brouillon sélectionné n’a pu être transformé en entretien.',
            CALENDAR_WARNING: '{{ count }} brouillon(s) converti(s) avec des invitations calendrier non remises à tous les participants.',
            UNEXPECTED_ERROR: 'Le traitement de la sélection a été interrompu. Actualisez les brouillons avant de réessayer.',
          },
          IMPORT: {
            // The draft-only wording distinguishes this action from creating or launching a campaign.
            BUTTON: 'Importer des brouillons',
            TITLE: 'Importer des brouillons',
            HELP: 'Crée automatiquement des brouillons à partir d’un Excel contenant les correspondances salariés / responsables.',
            EYEBROW: 'Importer avec l’IA',
            FILE: 'Fichier Excel',
            FILE_HELP: 'Un fichier XLSX, 10 Mo maximum. Aucun entretien n’est envoyé par cet import.',
            INSTRUCTIONS: 'Instructions d’import pour l’IA',
            INSTRUCTIONS_HELP: 'Indiquez les feuilles à utiliser et les règles d’interprétation utiles.',
            ANALYZE: 'Analyser',
            ANALYZING: 'Analyse en cours…',
            QUESTIONS: 'Précisions nécessaires',
            ANSWER: 'Votre réponse',
            CONTINUE: 'Continuer l’analyse',
            REVIEW: 'Vérifier les brouillons',
            INHERITED: 'Le type et le modèle sont ceux de la campagne.',
            DEFAULTS: 'Préavis : 1 mois. Présentiel. Document visible par le collaborateur.',
            SOURCE: 'Source Excel',
            EXCLUDED: 'Données exclues selon les instructions',
            APPLY_FIELD: 'Appliquer : {{ field }}',
            APPLY: 'Appliquer aux lignes non ignorées et non créées',
            SELECT_ALL: 'Sélectionner les {{ count }} lignes prêtes',
            SELECT_ROW: 'Sélectionner la ligne {{ row }}',
            IGNORE: 'Ignorer',
            RESTORE: 'Réintégrer',
            CREATE_ONE: 'Créer ce brouillon',
            CREATE_SELECTED: 'Créer les brouillons',
            COUNTS: '{{ ready }} prête(s), {{ blocked }} à compléter, {{ ignored }} ignorée(s), {{ created }} créée(s)',
            PROGRESS: 'Création {{ current }} sur {{ total }}',
            RESULT: '{{ success }} brouillon(s) créé(s), {{ failed }} échec(s), {{ unknown }} résultat(s) à vérifier',
            NO_ROWS: 'Aucun entretien trouvé dans le périmètre demandé.',
            UNRESOLVED: 'Sélectionnez le collaborateur et le responsable.',
            MATCH_UNAVAILABLE: 'Le rapprochement automatique est indisponible. Sélectionnez les personnes manuellement.',
            INVALID_SCHEDULE: 'Renseignez une date valide et une heure au format HH:mm.',
            INVALID_FILE: 'Sélectionnez un fichier XLSX valide.',
            UNSAFE_FILE: 'Ce classeur ne peut pas être lu en sécurité. Utilisez un XLSX simple sans contenu externe.',
            LIMIT_EXCEEDED: 'Le fichier ou le résultat dépasse les limites de cet import. Réduisez le périmètre demandé.',
            AI_ERROR: 'L’analyse n’a pas abouti. Aucun brouillon n’a été créé par l’analyse.',
            ACCESS_ERROR: 'Votre session ou vos droits ne permettent pas cette opération.',
            CAMPAIGN_CHANGED: 'La campagne est introuvable ou ses paramètres ont changé. Rouvrez l’import.',
            LOG_ERROR: 'La journalisation IA est indisponible. L’analyse ne peut pas être validée.',
            UNKNOWN_RESULT: 'Le résultat d’une création est incertain. Vérifiez les brouillons de la campagne avant tout nouvel import.',
            UNSAVED_WARNING: 'Les lignes non créées seront perdues en fermant cette fenêtre. Les brouillons déjà créés seront conservés.',
            CLOSE: 'Fermer',
            CANCEL: 'Annuler',
            STATUS: {
              READY: 'Prêt',
              BLOCKED: 'À compléter',
              IGNORED: 'Ignoré',
              CREATING: 'Création en cours',
              CREATED: 'Créé',
              FAILED: 'Échec',
              UNKNOWN: 'À vérifier',
            },
          },
          TARGET_UNKNOWN: 'Cible inconnue',
          TARGET_SINGLE: 'Collaborateur spécifique',
          TARGET_ALL: 'Toute l\'organisation',
          TARGET_SITE: '{{ total }} site(s) sélectionné(s)',
          TARGET_SERVICE: '{{ total }} service(s) sélectionné(s)',
          TARGET_TEAM: '{{ total }} équipe(s) sélectionnée(s)',
          TARGET_ADMIN_PAIE: 'Administrateur(s) paie',
          TARGET_MANAGER_PAIE: 'Manager(s) paie',
          TARGET_BADGE_ALL: 'Tous',
          SHOW_TARGETS: 'Voir les cibles',
          HIDE_TARGETS: 'Masquer les cibles',
          SHOW_COLLABORATORS: 'Voir collaborateur(s)',
          TARGET_DETAILS: {
            ALL: 'Tous les collaborateurs de l’entreprise',
            ADMIN_PAIE: 'Administrateurs paie',
            MANAGER_PAIE: 'Managers paie',
            SITE: 'Site',
            SERVICE: 'Service',
            TEAM: 'Équipe',
            NO_SELECTION: 'Aucune cible spécifique sélectionnée',
            COUNT_LABEL: '{{ total }} personne(s)',
            UNKNOWN: 'Inconnu (#{{ id }})'
          },
          CREATE_SUCCESS: 'Brouillon créé avec succès',
          DELETE_SUCCESS: 'Brouillon supprimé avec succès',
          DELETE_ERROR: 'Impossible de supprimer ce brouillon',
          DELETE_CONFIRM_TITLE: 'Supprimer le brouillon',
          DELETE_CONFIRM_MESSAGE: 'Êtes-vous sûr de vouloir supprimer le brouillon pour {{ target }} ?',
          MODAL: {
            TITLE: 'Créer un brouillon',
            EDIT_TITLE: 'Modifier le brouillon',
            MISSING_CAMPAIGN: 'Contexte campagne manquant. Merci de rouvrir la page.',
            TARGET_TYPE: 'Type de cible',
            TARGET_SINGLE: 'Collaborateur unique',
            TARGET_SITE: 'Site(s)',
            TARGET_SERVICE: 'Service(s)',
            TARGET_TEAM: 'Équipe(s)',
            TARGET_ADMIN_PAIE: 'Administrateur(s) paie',
            TARGET_MANAGER_PAIE: 'Manager(s) paie',
            TARGET_ALL: 'Toute l’entreprise',
            TARGET_SELECT: 'Sélectionner les cibles',
            TARGET_CAN_READ: 'Les cibles peuvent lire le document',
            TARGET_MUST_VALIDATE: 'Validation obligatoire avant lancement',
            PLACEHOLDER_SINGLE: 'Rechercher un collaborateur',
            PLACEHOLDER_SITE: 'Sélectionner un ou plusieurs sites',
            PLACEHOLDER_SERVICE: 'Sélectionner un ou plusieurs services',
            PLACEHOLDER_TEAM: 'Sélectionner une ou plusieurs équipes',
            PLACEHOLDER_ADMIN_PAIE: 'Tous les administrateurs paie seront inclus',
            PLACEHOLDER_MANAGER_PAIE: 'Tous les managers paie seront inclus',
            PLACEHOLDER_ALL: 'Tous les collaborateurs seront inclus',
            COLLABORATOR: 'Collaborateur',
            COLLAB_CAN_READ: 'Le collaborateur peut lire et modifier le document',
            MANAGER: 'Responsable',
            INTERVIEW_TYPE: "Type d'entretien",
            DOC_TEMPLATE: "Modèle d'entretien",
            EDIT_DOC: 'Modifier le document',
            DATE: "Date de l'entretien",
            NOTICE_MONTHS: 'Préavis (mois)',
            LOCATION: 'Lieu',
            LOCATION_ONSITE: 'Présentiel',
            LOCATION_REMOTE: 'Distanciel',
            LOCATION_FORM: 'Formulaire',
            INTERVIEW_LINK: 'Lien visioconférence',
            MUST_SIGN: 'Signature électronique requise',
            SAVE: 'Enregistrer le brouillon',
            UPDATE: 'Mettre à jour le brouillon',
            SAVE_SUCCESS: 'Brouillon enregistré avec succès',
            SAVE_SUCCESS_MULTIPLE: '{{ count }} brouillons créés avec succès',
            SAVE_ERROR: 'Impossible de sauvegarder le brouillon',
            UPDATE_SUCCESS: 'Brouillon mis à jour avec succès',
            UPDATE_ERROR: 'Impossible de mettre à jour le brouillon',
            INVALID_FORM: 'Merci de compléter les champs obligatoires',
            TARGET_REQUIRED: 'Merci de sélectionner au moins une cible',
            DEFAULT_TEMPLATE_NAME: 'Document',
            PAYROLL_INFO_ADMIN: '{{ total }} administrateur(s) paie auront accès à cette campagne.',
            PAYROLL_INFO_MANAGER: '{{ total }} manager(s) paie auront accès à cette campagne.',
          },
          COLLABORATORS_MODAL: {
            TITLE: 'Collaborateurs ciblés',
            EMPTY: 'Aucun collaborateur trouvé pour cette sélection.',
            NO_ROLE: 'Aucun rôle indiqué',
            LOAD_ERROR: 'Impossible de charger les collaborateurs. Veuillez réessayer plus tard.',
          },
        },
        SEARCH_PLACEHOLDER: 'Rechercher une campagne...',
        NO_CAMPAIGNS: 'Aucune campagne créée pour le moment',
        NO_RESULTS: 'Aucune campagne ne correspond à votre recherche',
        LOCKED_EDIT_FORBIDDEN: 'La campagne a déjà été lancée et ne peut plus être modifiée.',
        EXPORT: {
          BUTTON: 'Exporter la campagne',
          SUCCESS: 'Campagne exportée avec succès',
          ERROR: 'Impossible d\'exporter cette campagne',
          EMPTY: 'Aucune donnée d\'entretien disponible pour l\'export',
          WARNING: '{{ count }} entretien(s) n\'ont pas pu être exporté(s) complètement',
          DEFAULT_SHEET_TITLE: 'Carte d\'entretien',
          SHEET_SUMMARY: '{{ count }} entretien(s) regroupé(s) dans cette carte',
          PERSON_BLOCK_TITLE: 'Entretien n°{{ index }}',
          CONTENT_TITLE: 'Contenu de la carte',
          HEADER: {
            INTERVIEW_TYPE: 'Type d\'entretien',
            STATUS: 'Statut',
            SENIORITY_VALUE: '{{ count }} {{ suffix }}',
          },
          COLUMNS: {
            QUESTION: 'Question',
            COLLABORATOR: 'Réponse du collaborateur',
            MANAGER: 'Réponse du responsable d\'entretien',
          },
        },
        TABS: {
          DRAFTS: 'Brouillons',
          INTERVIEWS: 'Entretiens',
        },
        ANALYZE_WITH_TOM: 'Analyser avec Tom',
        FILTERS_TITLE: 'Filtres d\'analyse',
        FILTER_CAMPAIGN: 'Campagne',
        FILTER_SERVICE: 'Service',
        FILTER_TEAM: 'Équipe',
        FILTER_MANAGER: 'Manager',
        FILTER_INTERVIEW_TYPE: 'Type d\'entretien',
        FILTER_SUMMARY: 'Filtres appliqués',
        START_ANALYSIS: 'Lancer l\'analyse',
        ANALYZING: 'Analyse en cours',
        ANALYSIS_RESULT: 'Résultats de l\'analyse',
        ANALYSIS_CAMPAIGN_NAME: 'Nom de la campagne',
        TOTAL_INTERVIEWS: 'Total des entretiens',
        APPLIED_FILTERS: 'Filtres appliqués',
        TOM_WELCOME_TITLE: 'Copilote de campagne',
        TOM_WELCOME_BODY: 'Je suis prêt à analyser {{campaign}}. Ajustez les filtres à gauche puis posez une question ou lancez une analyse globale.',
        TOM_ALL_CAMPAIGNS: 'Toutes les campagnes',
        TOM_ALL_CAMPAIGNS_FILTER_REQUIRED: 'Pour analyser toutes les campagnes, au moins un filtre supplémentaire est requis.',
        TOM_SINGLE_CAMPAIGN_FILTER_REQUIRED: 'Pour analyser une campagne, au moins un filtre supplémentaire est requis.',
        TOM_REQUIRED_FILTERS_NOTE: 'La sélection de campagne est obligatoire. Pour lancer Tom, choisissez au moins un de ces filtres : service, équipe ou manager. Le type d’entretien reste facultatif.',
        TOM_FILTERS_SUBTITLE: 'Les filtres sont appliqués avant l’appel IA, pas seulement dans l’affichage.',
        TOM_FILTER_CHANGE_CONFIRM_TITLE: 'Réinitialiser la conversation Tom ?',
        TOM_FILTER_CHANGE_CONFIRM: 'Modifier ces filtres réinitialisera la conversation en cours avec Tom. Voulez-vous continuer ?',
        TOM_FILTER_CHANGE_CONFIRM_ACTION: 'Réinitialiser la conversation',
        TOM_FILTER_CHANGE_CANCEL_ACTION: 'Garder les filtres actuels',
        TOM_DEFAULT_PROMPT: 'Analyse cette campagne avec les filtres actuels.',
        TOM_FILTERED_INTERVIEWS_COUNT: '{{count}} entretiens filtrés',
        TOM_SUGGESTED_PROMPTS: 'Prompts suggérés',
        TOM_PROMPT_SUMMARY: 'Résume les thèmes principaux de cette campagne.',
        TOM_PROMPT_MANAGERS: 'Quels managers doivent être traités en priorité ?',
        TOM_PROMPT_RISKS: 'Quels risques apparaissent entre les équipes ?',
        TOM_PROMPT_ACTIONS: 'Propose 3 actions pour les RH et les managers.',
        TOM_HIGHLIGHTS: 'Signaux clés',
        TOM_PATTERNS: 'Tendances',
        TOM_RISKS: 'Risques',
        TOM_RECOMMENDATIONS: 'Actions recommandées',
        TOM_COVERAGE: 'Couverture et limites',
        TOM_INPUT_PLACEHOLDER: 'Posez une question de suivi à Tom sur cette campagne...',
        TOM_INPUT_HINT: 'Tom répond uniquement à partir des données filtrées de la campagne.',
        TOM_RESPONDING: 'Tom analyse les entretiens filtrés...',
        TOM_SEND: 'Envoyer',
        TOM_CLEAR_FILTERS: 'Effacer',
        TOM_FILTERS_LOAD_ERROR: 'Impossible de charger les filtres d\'analyse',
        TOM_ERROR_MESSAGE: 'Tom n\'a pas pu terminer l\'analyse. Réessayez.',
        TOM_EMPTY_CAMPAIGN: 'Aucun entretien à analyser',
        SELECT_CAMPAIGN_TO_ANALYZE: 'Sélectionner une campagne à analyser',
        SELECT_CAMPAIGN_DESCRIPTION: 'Choisissez la campagne que vous souhaitez analyser avec Tom.',
        NO_CAMPAIGNS_WITH_INTERVIEWS: 'Aucune campagne avec des entretiens disponible pour l\'analyse',
      },
      CROSS_FEEDBACK: {
        TITLE: 'Feedback croisé',
        DEADLINE_LABEL: 'Date limite pour remplir le feedback croisé',
        DOCUMENT_NAME: 'Document',
        COLLABORATOR: 'Collaborateur',
        RESPONSABLE: 'Responsable',
        CONTRIBUTEUR: 'Contributeur',
        DATE: 'Date',
        STATUS: 'Statut',
        NOT_CREATED: 'Non créé',
        SELECT_COLLABORATOR: 'Sélectionner un collaborateur',
        SELECT_RESPONSABLE: 'Sélectionner un responsable',
        CREATE: 'Créer',
        CREATE_INTERVIEW: "Créer l'entretien",
        VIEW_INTERVIEW: "Voir l'entretien",
        REMOVE_INTERVIEW: "Supprimer l'entretien",
        CREATE_ALL: 'Créer tous les entretiens',
        SEND_ALL: 'Envoyer tous les entretiens',
        CREATE_NEW_INTERVIEW: 'Demander un feedback',
        SUGGEST_MANAGERS: 'Suggérer des contributeurs',
        INTERVIEW_TYPE: "Type d'entretien",
        DOCUMENT_TEMPLATE: 'Modèle de document',
        SELECT_MANAGERS: 'Sélectionner les contributeurs',
        SEARCH_MANAGER: 'Rechercher un contributeur',
        SEND_INTERVIEWS: 'Envoyer les demandes',
        ERROR_NO_CONFIG:
          'Configuration manquante pour les entretiens croisés. Veuillez contacter votre administrateur.',
        ERROR_NO_TEMPLATE: 'Aucun modèle de document configuré pour ce feedback croisé.',
        ERROR_NO_TYPE: "Aucun type d'entretien configuré pour ce feedback croisé.",
        ADD_INTERVIEW: 'Ajouter un entretien',
        NO_DOCUMENTS: 'Aucun document configuré pour cet entretien croisé',
        STATUS_PLANNED: 'Planifié',
        STATUS_SCHEDULED: 'Programmé',
        STATUS_IN_PROGRESS: 'En cours',
        STATUS_COLLAB_SUBMITTED: 'Soumis par le collaborateur',
        STATUS_MANAGER_VALIDATED: 'Validé par le manager',
        STATUS_CANCELED: 'Annulé',
        STATUS_REFUSED: 'Refusé',
        STATUS_REQUESTED: 'Demandé',
        STATUS_RECEIVED: 'Reçu',
        ERROR_MISSING_INFO: 'Veuillez renseigner le collaborateur, le responsable et la date',
        ERROR_CREATE: 'Erreur lors de la création du feedback croisé. Veuillez réessayer.',
        ERROR_CREATE_WITH_MANAGER:
          'Erreur lors de la création du feedback croisé pour {{manager}}. Veuillez réessayer.',
        SUCCESS_CREATED: 'Entretien créé avec succès',
        SUCCESS_CREATED_ALL: '{{count}} entretien(s) créé(s) avec succès',
        NO_INTERVIEWS_TO_CREATE: 'Aucun entretien à créer',
        NO_TYPES_CONFIGURED: "Aucun type d'entretien configuré pour cette carte",
        INTERVIEW_ADDED: 'Entretien ajouté avec succès',
        INTERVIEW_REMOVED: 'Entretien supprimé avec succès',
        CANNOT_REMOVE_CREATED: 'Impossible de supprimer un entretien déjà créé',
        DELETE_INTERVIEW: "Supprimer l'entretien",
        CONFIRM_DELETE: "Êtes-vous sûr de vouloir supprimer l'entretien croisé de {{manager}} ?",
        SUCCESS_DELETED: 'Entretien croisé supprimé avec succès',
        ERROR_DELETE: 'Erreur lors de la suppression du feedback croisé. Veuillez réessayer.',
        ERROR_DELETE_WITH_MANAGER:
          'Erreur lors de la suppression du feedback croisé de {{manager}}. Veuillez réessayer.',
        ERROR_NOT_FOUND: 'Feedback croisé non trouvé. Il a peut-être déjà été supprimé.',
        ERROR_CANNOT_DELETE:
          'Impossible de supprimer cet entretien. Seuls les entretiens planifiés ou programmés peuvent être supprimés.',
        SUGGEST_MANAGERS_TITLE: 'Suggérer des contributeurs',
        SUGGEST_MANAGERS_DESC:
          'Vous pouvez suggérer des contributeurs pour les entretiens croisés. La liste finale des contributeurs sera validée avec votre manager.',
        SAVE_SUGGESTIONS: 'Enregistrer les suggestions',
        SUGGESTIONS_SAVED: 'Suggestions enregistrées avec succès',
        COLLAB_SUGGESTIONS: 'Suggestions du collaborateur',
        SELECT_ALL: 'Sélectionner tous',
        SUGGESTION_SELECTED: '{{name}} ajouté à la sélection',
        SUGGESTION_DESELECTED: '{{name}} retiré de la sélection',
        ALREADY_SELECTED: '{{name}} est déjà sélectionné',
        ALL_SUGGESTIONS_SELECTED: '{{count}} suggestion(s) ajoutée(s) à la sélection',
        ALL_SUGGESTIONS_DESELECTED: '{{count}} suggestion(s) retirée(s) de la sélection',
        ALL_ALREADY_SELECTED: 'Toutes les suggestions sont déjà sélectionnées',
        ERROR_INVALID_DATE: 'Date limite invalide pour le feedback croisé.',
        ERROR_DATE_PAST: "La date ne peut pas être dans le passé",
        ERROR_DATE_EXCEEDS_PARENT: "La date ne peut pas dépasser la date de l'entretien parent",
        UPDATE_DATE: "Mettre à jour la date",
        UPDATE_DATE_SUCCESS: "Date du feedback croisé mise à jour avec succès",
        UPDATE_DATE_ERROR: "Erreur lors de la mise à jour de la date du feedback croisé. Veuillez réessayer.",
        RELAUNCH_INTERVIEW: 'Relancer le contributeur',
        RELAUNCH_SUCCESS: 'Relance envoyée à {{manager}} avec succès',
        RELAUNCH_SKIPPED: 'La relance n’a pas été envoyée : le compte du destinataire est inactif ou ses emails de rappel sont désactivés.',
        RELAUNCH_ERROR: 'Erreur lors de la relance du contributeur. Veuillez réessayer.',
        // Libellés du compte rendu IA anonyme des feedbacks croisés.
        SUMMARY_TITLE: 'Compte rendu des feedbacks croisés',
        SUMMARY_GENERATE: 'Générer le compte rendu IA',
        SUMMARY_GENERATED: 'Le compte rendu IA a été généré.',
        SUMMARY_GENERATE_ERROR: 'Impossible de générer le compte rendu IA.',
        SUMMARY_SAVED: 'Le compte rendu a été enregistré comme brouillon privé.',
        SUMMARY_SAVE_ERROR: 'Impossible d’enregistrer le compte rendu.',
        SUMMARY_SHARE: 'Partager avec le collaborateur',
        SUMMARY_SHARED: 'Le compte rendu a été partagé avec le collaborateur.',
        SUMMARY_SHARE_ERROR: 'Impossible de partager le compte rendu.',
        SUMMARY_SHARED_BADGE: 'Partagé',
        SUMMARY_PRIVATE_BADGE: 'Brouillon privé',
        SUMMARY_ANONYMOUS_NOTICE: 'Ce compte rendu est anonyme et ne doit pas identifier les contributeurs.',
      },
    },
    SUIVITEMPSPARAMETRE: {
      ENATTENTEINS: "En attente d'inscription",

      ACTIF: 'Actif',
      ENATTENTE: 'En attente',
      PARAMETRE: 'Paramétrage du suivi des temps',
      AUTOVALIDATION: "Ne nécessite pas la validation d'un tiers",
      TEXT1:
        'Si cette option est activée, les temps de travail déclarés par les collaborateurs seront automatiquement validés sans intervention d’un responsable',
      //Exiger une validation des temps
      EXIGERVALIDATION: 'Qui est autorisé à valider et déclarer les temps',
      TEXT2:
        "Activez cette option pour exiger une validation des temps de travail déclarés par un responsable : Responsable d’équipe, Responsable de service, Responsable de site ou Manager avant qu'ils ne soient enregistrés définitivement",
      //Responsable d'équipe
      RESPONSABLEEQUIPE: 'Responsable d équipe',
      //Responsable service
      RESPONSABLESERVICE: 'Responsable de service',
      //Responsable de site
      RESPONSABLESITE: 'Responsable de site',
      //Manager
      MANAGER: 'Manager',
      //Exiger une validation de pause
      EXIGERVALIDATIONPAUSE: 'Exiger une validation de pause',
      TEXT3:
        'Si activé, les pauses déclarées par les collaborateurs devront être validées manuellement. Sélectionnez le niveau de responsabilité pour cette validation : Responsable d’équipe, Responsable de service, Responsable de site ou Manager.',
      //Qui est autorisé à déclarer les temps de travail
      QUIESTAUTORISE: 'Qui est autorisé à déclarer les temps de travail',
      TEXT4:
        'Définissez les collaborateurs ou groupes de collaborateurs qui ont l’autorisation de déclarer leurs temps de travail. Cela peut inclure tous les employés ou un groupe spécifique selon les besoins de l’entreprise',
      //Affichage dans le dashboard
      DASHBOARDAFFICHAGE: 'Les collaborateurs peuvent déclarer leurs heures directement ',
      TEXT5:
        'Si activé, les collaborateurs peuvent déclarer leurs heures directement. Si désactivé, cette fonctionnalité ne sera pas disponible.',
      //Auto valider les déclarations si elles sont dans les plages horaires normales
      AUTOVALIDATIONHORAIRES: 'Auto valider les déclarations si elles sont dans les plages horaires normales',
      TEXT6:
        "Si activé, une déclaration de temps est automatiquement validée dès lors que les horaires déclarés sont contenus dans les horaires habituels du collaborateur (Liste des jours travaillés) et qu'il n'est pas en congé approuvé ce jour-là. Sinon, elle reste en attente de validation manuelle.",
      ACTIVER_POINTEUSE: 'Activer la pointeuse pour les contrats sélectionnés',
      POINTEUSE_CONTRACT_INFO:
        "Seuls les collaborateurs ayant l'un de ces contrats sur ce site auront accès à la pointeuse.",
      // Site-specific settings
      SITE_SETTINGS: 'Paramètres pointeuse et forfait jour',
      SITE_SETTINGS_INFO: 'Configurez quels sites peuvent afficher la pointeuse et quels types de contrat sont autorisés',
      SELECT_SITE: 'Sélectionner un site',
      SELECT_SITE_PLACEHOLDER: '-- Choisir un site --',
      SELECT_CONTRACT_TYPES: 'Types de contrat autorisés',
      SAVE_SITE_SETTINGS: 'Enregistrer',
      REMOVE_SITE_SETTINGS: 'Supprimer',
      CONFIGURED_SITES: 'Sites configurés',
      SELECT_SITE_ERROR: 'Veuillez sélectionner un site',
      SELECT_CONTRACT_ERROR: 'Veuillez sélectionner au moins un type de contrat',
      NOMBRE_JOURS_ANNUEL: 'Jours travaillés au forfait',
      NOMBRE_JOURS_ANNUEL_PLACEHOLDER: '260',
      NOMBRE_JOURS_ERROR: 'Veuillez entrer un nombre de jours valide (entre 1 et 366)',
      MAX_JOURS_CONSECUTIFS: 'Nombre de jours consécutifs travaillés à ne pas dépasser',
      MAX_JOURS_CONSECUTIFS_PLACEHOLDER: '6',
      MAX_JOURS_CONSECUTIFS_ERROR: 'Veuillez entrer un nombre de jours consécutifs valide (entre 1 et 365)',
      JRTT_DISCLAIMER: 'Le nombre des JRTT ne sont pas automatiques',
      // RTT Management
      RTT_MANAGEMENT: 'Gestion des RTT',
      RTT_MANAGEMENT_INFO: 'Gérez les jours travaillés, les congés payés et le nombre de RTT par site et par groupe',
      SELECT_YEAR: 'Sélectionner une année',
      SITE: 'Site',
      GROUPE: 'Groupe',
      JOURS_TRAVAILLES_FORFAIT: 'Jours travaillés au forfait',
      CONGES_PAYES: 'Congés payés',
      NOMBRE_RTT: 'Nombre de RTT',
      ACTIONS: 'Actions',
      NO_RTT_DATA: 'Aucune donnée RTT disponible pour cette année',
      RTT_MISSING_HOLIDAYS: 'Aucun jour férié trouvé pour ce site — vérifiez le code pays du site',
      // Rappel de renseignement des temps
      RAPPEL_TITLE: 'Rappel de renseignement des temps',
      RAPPEL_INFO: 'Configurez la fréquence à laquelle les collaborateurs reçoivent un rappel pour renseigner leurs temps',
      RAPPEL_FREQUENCE: 'Fréquence des rappels',
      RAPPEL_JAMAIS: 'Jamais',
      RAPPEL_QUOTIDIEN: 'Tous les jours',
      RAPPEL_HEBDO: 'Toutes les semaines',
      RAPPEL_MENSUEL: 'Tous les mois',
      RAPPEL_JOUR_SEMAINE: 'Jour de la semaine',
      RAPPEL_JOURS_AVANT: 'Nombre de jours avant le dernier jour ouvré du mois',
      RAPPEL_JOURS_AVANT_SUFFIX: 'jours avant le dernier jour ouvré',
      RAPPEL_HEURE: 'Heure d\'envoi',
      LUNDI: 'Lundi',
      MARDI: 'Mardi',
      MERCREDI: 'Mercredi',
      JEUDI: 'Jeudi',
      VENDREDI: 'Vendredi',
      SAMEDI: 'Samedi',
      DIMANCHE: 'Dimanche',
    },
    AUTH,
    REMUNERATION: {
      ...REMUNERATION_TRANSLATIONS,
      TITLE: 'Gestion des rémunérations',
      BTN_COLUMNS: 'Ordre des colonnes',
      BTN_TABS: 'Onglets',
      BTN_REPORTING: 'Reporting',
      BTN_EXPORT: 'Export',
      BTN_ADD_COLUMN: 'Ajouter une colonne',
      BTN_RESET_WIDTHS: 'Réinitialiser les largeurs',
      SETTINGS: {
        TITLE: 'Paramètres Rémunérations',
        DESCRIPTION: 'Gérez les paramètres du module Rémunérations',
        VISIBILITY_SETTINGS: "Paramètres d'affichage",
        VISIBLE_COLLABORATEUR: 'Afficher "Mes Rémunérations" aux collaborateurs',
        VISIBLE_COLLABORATEUR_DESC: 'Lorsque activé, les collaborateurs peuvent voir leurs rémunérations',
        VISIBLE_MANAGER: 'Afficher les rémunérations aux managers',
        VISIBLE_MANAGER_DESC: 'Lorsque activé, les managers peuvent voir les rémunérations de leurs équipes',
        HIDE_MONTHLY_VIEW_MANAGER: 'Masquer la vue mensuelle pour les managers paie',
        HIDE_MONTHLY_VIEW_MANAGER_DESC: 'Les managers paie ne verront que la vue annuelle',
        HIGHLIGHT_EDITABLE_COLUMNS: 'Mettre en surbrillance les colonnes à modifier',
        HIGHLIGHT_EDITABLE_COLUMNS_DESC: 'Afficher les valeurs des colonnes modifiables avec une couleur jaune',
        DEFAULT_YEAR_MANAGER: 'Année par défaut pour les managers',
        DEFAULT_YEAR_MANAGER_DESC: "Définir l'année affichée par défaut pour les managers paie",
        DEFAULT_YEAR_UPDATED: 'Année par défaut mise à jour avec succès',
        MANAGERS: 'Gestionnaires de Rémunération',
        ADMIN_PAIES: 'Administrateurs Paie',
        SELECT_USER_ADMIN: 'Sélectionner un utilisateur',
        CHOOSE_USER: 'Choisir un utilisateur',
        ADD_ADMIN: 'Ajouter Admin Paie',
        NO_ADMIN_PAIES: 'Aucun administrateur paie configuré',
        SELECT_COLLABORATOR: 'Sélectionner un collaborateur',
        CHOOSE_COLLABORATOR: 'Choisir un collaborateur',
        SELECT_MANAGER: 'Sélectionner un gestionnaire',
        CHOOSE_MANAGER: 'Choisir un gestionnaire',
        ADD_MANAGER: 'Ajouter Gestionnaire',
        NO_MANAGERS: 'Aucun gestionnaire configuré',
        COLLABORATOR: 'Collaborateur',
        MANAGER: 'Gestionnaire',
        LAST_UPDATE: 'Dernière mise à jour',
        SELECT_USER: 'Veuillez sélectionner un utilisateur',
        SELECT_COLLAB_MANAGER: 'Veuillez sélectionner un collaborateur et un gestionnaire',
        ADMIN_ADDED: 'Administrateur paie ajouté avec succès',
        ADMIN_REMOVED: 'Administrateur paie supprimé avec succès',
        MANAGER_ADDED: 'Gestionnaire ajouté avec succès',
        MANAGER_REMOVED: 'Gestionnaire retiré avec succès',
        CONFIRM_REMOVE_ADMIN: 'Supprimer cet administrateur paie ?',
        CONFIRM_REMOVE_ADMIN_DESC:
          'Êtes-vous sûr de vouloir retirer cet administrateur paie ? Cette action est irréversible.',
        CONFIRM_REMOVE_MANAGER: 'Retirer ce collaborateur ?',
        CONFIRM_REMOVE_MANAGER_DESC:
          'Êtes-vous sûr de vouloir retirer ce collaborateur de votre liste de collaborateurs managés pour le module Rémunération ?',
        CONFIRM_REMOVE_MANAGER_COLLAB:
          'Êtes-vous sûr de vouloir retirer {{name}} de votre liste de collaborateurs managés pour le module Rémunération ?',
        MANAGED_EMPLOYEES_MODULE: 'Liste des collaborateurs managés - Module Rémunération',
        NO_MANAGED_EMPLOYEES: 'Aucun collaborateur managé pour le module Rémunération',
        CONTRACT_VISIBILITY: 'Contrats visibles',
        CONTRACT_VISIBILITY_DESC:
          'Sélectionnez les types de contrats qui seront visibles dans la gestion des rémunérations',
        NO_CONTRACTS: 'Aucun contrat disponible',
        CONTRACTS_SELECTED: 'contrat(s) sélectionné(s)',
        EXCLUDED_USERS_TITLE: 'Collaborateurs exclus',
        EXCLUDED_USERS_DESC: 'Sélectionnez les collaborateurs qui ne doivent pas apparaître dans les tableaux de rémunération.',
        EXCLUDED_USERS_PLACEHOLDER: 'Rechercher par nom, équipe, site…',
        EXCLUDED_USERS_EMPTY: 'Aucun collaborateur ne correspond à vos filtres.',
        EXCLUDED_USERS_SELECTED: 'collaborateur(s) exclu(s)',
        EXCLUDED_USERS_UPDATED: 'Collaborateurs exclus mis à jour avec succès',
        EXCLUDED_USERS_SELECTED_LIST: 'Collaborateurs exclus',
        MANAGE_EXCLUDED_USERS: 'Gérer les collaborateurs exclus',
        EXCLUDED_USERS_SAVE_HINT: 'Fermez ce panneau puis cliquez sur « Enregistrer » pour appliquer les changements.',
        SUPER_MANAGER_PAIES: 'Super Manager Paies',
        SUPER_MANAGER_ADDED: 'Utilisateur ajouté comme super manager paies avec succès',
        SUPER_MANAGER_REMOVED: 'Utilisateur retiré des super managers paies avec succès',
      },
      LOADING: {
        DEFAULT: 'Chargement en cours...',
        FETCHING_DATA: 'Récupération des données...',
        PROCESSING_DATA: 'Traitement des données...',
      },
      FILTERS: {
        VIEW_TYPE: 'Type de vue',
        MONTHLY: 'Mensuelle',
        YEARLY: 'Annuelle',
        YEAR: 'Année',
        START_DATE: 'Date de début',
        END_DATE: 'Date de fin',
        ALL_SERVICES: 'Tous les services',
        SERVICES_SELECTED: 'service(s) sélectionné(s)',
        SELECT_SERVICES: 'Sélectionner des services',
        CLEAR_SELECTION: 'Effacer la sélection',
        SELECT_ALL: 'Tout sélectionner',
        SEARCH_PLACEHOLDER: 'Chercher',
        ALL_SITES: 'Tous les sites',
      },
      PAGINATION: {
        ROWS_PER_PAGE: 'Lignes par page',
        SHOWING: 'Affichage',
        TO: '-',
        OF: 'sur',
        RESULTS: 'résultat',
        RESULTS_PLURAL: 'résultats',
        FILTERED_ON: 'filtré sur',
      },
      TABLE: {
        MATRICULE: 'Matricule',
        LAST_NAME: 'Nom',
        FIRST_NAME: 'Prénom',
        SITE_COUNTRY_FLAG: 'Pays du site',
        EMPTY: 'Aucune donnée disponible pour le moment',
        COLUMN_FIXED_SALARY: 'Salaire fixe N-1 (2025) en €',
        COLUMN_FIXED_EVAL: '% évaluation salaire fixe',
        COLUMN_LOCAL_CURRENCY: 'Salaire fixe N-1 (2025) en devise locale',
        COLUMN_BONUS_EVAL: '% évaluation bonus',
        COLUMN_VARIABLE_PAY: 'Salaire variable',
        COLUMN_STOCK_VALUE: 'Valeur des actions',
        COLUMN_ALLOWANCE: 'Indemnités',
        COLUMN_PERFORMANCE_INDEX: 'Indice de performance',
        COLUMN_COMMISSION: 'Commission',
        COLUMN_PAY_FREQUENCY: 'Fréquence de paiement',
      },
      CORE_INFO: {
        TITLE: 'Information CORE du collaborateur',
        TOGGLE_LABEL: 'Afficher les détails',
      },
      SUMMARY: {
        COLUMN_NAME: 'Nom de la colonne',
        SUM: 'Somme',
        AVERAGE: 'Moyenne',
      },
      EDIT_MONTHLY_VALUE: 'Modifier la valeur mensuelle',
      EDIT_PERIOD_VALUES: 'Modifier les valeurs par période',
      VALUE: 'Valeur',
      ENTER_VALUE: 'Entrer une valeur',
      UNSAVED_CHANGES_TITLE: 'Modifications non sauvegardées',
      UNSAVED_CHANGES_MESSAGE:
        'Vous avez des modifications non sauvegardées. Si vous continuez, ces modifications seront perdues.',
      UNSAVED_CHANGES_HINT:
        'Cliquez sur "Enregistrer" en haut de la page pour sauvegarder vos modifications avant de changer de vue.',
      DISCARD_CHANGES: 'Abandonner les modifications',
      VALIDATION: {
        MUST_BE_NUMBER: 'La valeur doit être un nombre valide',
        MUST_BE_DATE: 'La valeur doit être une date au format AAAA-MM-JJ',
        INVALID_DATE: "La date saisie n'est pas valide",
      },
      COLUMN: 'Colonne',
      MONTH: 'Mois',
      START_DATE: 'Date de début',
      END_DATE: 'Date de fin',
      ADD_PERIOD: 'Ajouter une période',
      ADD_FIRST_PERIOD: 'Ajouter la première période',
      NO_PERIODS: 'Aucune période définie',
      PERIOD_OVERLAP_ERROR: 'Cette période chevauche une autre période',
      EXPORT: {
        FILENAME: 'Remunerations',
        SHEET_NAME: 'Rémunérations',
        SUMMARY: 'Résumé',
        SUCCESS: 'Le tableau a été exporté avec succès',
        ERROR: "Erreur lors de l'export du tableau",
      },
      SUMMARY_AVERAGE: {
        INCLUDE_ZEROS: 'Inclure les valeurs à zéro dans les moyennes',
        HELP: "Préférence de l'entreprise pour les tableaux de synthèse verts uniquement.",
        ADMIN_ONLY: "Seuls les administrateurs de l'entreprise peuvent modifier cette préférence.",
        LOADING: "Chargement de la préférence de l'entreprise...",
        SAVING: "Enregistrement de la préférence de l'entreprise...",
        SAVED: "La préférence de calcul des moyennes de l'entreprise a été enregistrée.",
        UNAVAILABLE: "Les moyennes sont indisponibles tant que la préférence enregistrée n'est pas confirmée. Actualisez la page.",
        LOAD_ERROR: "La préférence de calcul des moyennes de l'entreprise n'a pas pu être chargée. Actualisez la page.",
        SAVE_ERROR: "L'enregistrement de la préférence de calcul des moyennes de l'entreprise n'a pas pu être confirmé. Actualisez la page avant de réessayer.",
      },
      DELETE_COLUMN: {
        TITLE: 'Supprimer la colonne',
        BUTTON: 'Supprimer la colonne',
        DESCRIPTION: "Cette action supprime définitivement la colonne de tous les onglets de votre entreprise, ainsi que ses valeurs mensuelles et périodiques enregistrées, ses motifs et ses paramètres d'onglet. Une colonne encore utilisée ne peut pas être supprimée ; les documents enregistrés et les historiques d'entretien ne sont pas effacés.",
        IRREVERSIBLE: 'Cette action est irréversible.',
        CONCURRENCY_NOTICE: "Effectuez cette suppression uniquement lorsqu'aucun import ni aucune mise à jour des rémunérations n'est en cours.",
        NAME_CONFIRM_LABEL: 'Saisissez le nom affiché de la colonne pour confirmer :',
        CONFIRM: 'Supprimer',
        IN_PROGRESS: 'Suppression...',
        SUCCESS: 'La colonne et ses valeurs de rémunération enregistrées ont été supprimées.',
        ERROR: "La suppression n'a pas pu être confirmée. Actualisez la liste des colonnes avant de réessayer.",
        DEPENDENCIES: "Cette colonne est encore utilisée par des calculs, des références ou des documents. Retirez ces références avant de la supprimer.",
        SHARED: "La définition d'une colonne commune ne peut pas être supprimée pour une seule entreprise.",
        NOT_ALLOWED: "Seuls les administrateurs de paie peuvent supprimer définitivement une colonne propre à l'entreprise.",
        UNAVAILABLE: "Sélectionnez une colonne propre à l'entreprise et attendez la fin de l'opération en cours. Les droits d'administration de paie sont nécessaires.",
        UNSUPPORTED_SCHEMA: "Les données liées n'ont pas pu être vérifiées de manière fiable. La suppression a été interrompue ; contactez votre administrateur.",
        NOT_FOUND: "Cette colonne n'est plus disponible. Actualisez la liste des colonnes.",
        NAME_MISMATCH: 'Saisissez exactement le nom affiché de la colonne pour confirmer sa suppression.',
        UNCONFIRMED: "La suppression n'a pas pu être confirmée. Ne considérez pas les données comme effacées ; actualisez la liste avant de réessayer.",
      },
      REORGANIZE: {
        TITLE: 'Réorganisez vos colonnes',
        DESCRIPTION:
          'Glissez les catégories ou les colonnes pour modifier leur ordre. Les colonnes restent dans leur catégorie.',
        SCOPE_SUMMARY: 'Colonnes : cet onglet. Catégories : tous les onglets de votre entreprise.',
        HELP: 'Aide',
        COLUMN_COUNT: 'Colonnes : {{count}} (colonnes masquées incluses)',
        DRAG_CATEGORY: 'Glisser pour réordonner cette catégorie',
        DRAG_COLUMN: 'Glisser pour réordonner dans cette catégorie',
        EXPAND_CATEGORY: 'Développer {{name}}',
        COLLAPSE_CATEGORY: 'Réduire {{name}}',
        EDIT_CATEGORY: 'Renommer la catégorie : {{name}}',
        EDIT_COLUMN: 'Renommer la colonne : {{name}}',
        CATEGORY_NAME: 'Nom de la catégorie',
        COLUMN_NAME: 'Nom de la colonne',
        YEAR_SELECTED: 'Année sélectionnée',
        YEAR_PREVIOUS: 'Année précédente',
        YEAR_TWO_YEARS_BEFORE: 'Deux ans auparavant',
        YEAR_NEXT: 'Année suivante',
        YEAR_BEFORE_COUNT: '{{count}} ans auparavant',
        YEAR_AFTER_COUNT: '{{count}} ans après',
        YEAR_TEXT_BEFORE: "Texte avant l'année",
        YEAR_TEXT_BETWEEN: 'Texte entre les années',
        YEAR_TEXT_AFTER: "Texte après l'année",
        YEAR_PREVIEW: 'Aperçu :',
        YEAR_RULE_HELP: "L'année s'adapte à la période sélectionnée. Modifiez le texte autour, puis cliquez sur Enregistrer.",
        YEAR_PREVIEW_UNAVAILABLE: "L'aperçu sera disponible lorsque l'année sélectionnée sera chargée.",
        YEAR_LABEL_UNSUPPORTED: "L'année automatique de ce libellé n'a pas pu être reconnue. Son nom n'a pas été modifié.",
        YEAR_LABEL_INVALID: "Ces champs servent uniquement à renommer le texte. L'année automatique ne peut pas être modifiée ici.",
        SUPER_CATEGORY: 'Section',
        NO_SUPER_CATEGORY: 'Sans section',
        SUPER_CATEGORY_HELP: "Utilisez l'icône stylo pour renommer une section, une catégorie ou une colonne, puis cliquez sur Enregistrer.",
        EDIT_SUPER_CATEGORY: 'Renommer la section : {{name}}',
        SUPER_CATEGORY_NAME: 'Nom de la section',
        INVALID_SUPER_CATEGORY_NAME: 'Saisissez un nom de section.',
        SUPER_CATEGORY_NAME_EXISTS: 'Une autre section utilise déjà ce nom. Choisissez un autre nom.',
        SUPER_CATEGORY_SCOPE_REQUIRED: "Les informations des sections n'ont pas pu être chargées correctement. Fermez puis rouvrez cette fenêtre avant de réessayer.",
        SUPER_CATEGORY_SAVE_ERROR: "Certaines modifications n'ont pas pu être enregistrées. Gardez cette fenêtre ouverte et cliquez de nouveau sur Enregistrer pour terminer le renommage de la section. Les modifications déjà enregistrées sont conservées.",
        BTN_CONFIRM: 'Confirmer',
        SUCCESS: 'Colonnes réorganisées avec succès',
        SUCCESS2: 'Les colonnes ont été réorganisées avec succès',
        HIDDEN_COLUMN: 'Colonne cachée',
        SELECT_TAB: 'Sélectionnez un onglet avant de réorganiser ses colonnes.',
        DUPLICATE_CONFIGURATION: "Les configurations de catégories ou de colonnes en double doivent être vérifiées avant de réorganiser cet onglet.",
        SCOPE_HELP: "Les modifications des colonnes concernent uniquement cet onglet. Celles des catégories et des sections s'appliquent aussi aux autres onglets où elles apparaissent.",
        INVALID_ORDER: 'Indiquez un ordre entier valide.',
        SAVE_ERROR: "Toutes les modifications n'ont pas pu être enregistrées. Certaines peuvent déjà l'être ; vérifiez vos modifications avant de réessayer.",
      },
      COLUMN_MANAGEMENT: {
        TITLE: 'Gestion de colonne',
        REORGANIZE: 'Réorganiser les colonnes',
        ADD: 'Ajouter une colonne',
        PARAMETERIZE: 'Paramétrer les onglets',
        EDIT: 'Modifier une colonne',
      },
      PARAM_COLUMN: {
        TITLE: 'Paramétrer les onglets',
        DESCRIPTION: "Sélectionnez une colonne et définissez ses paramètres d'affichage pour l'onglet choisi.",
        SELECT_REQUIRED: 'Veuillez sélectionner une colonne et un onglet',
        SELECT_COLUMN: 'Sélectionner une colonne',
        SELECT_COLUMN_PLACEHOLDER: 'Choisir une colonne...',
        SELECT_ONGLET: 'Sélectionner un onglet',
        SELECT_ONGLET_PLACEHOLDER: 'Choisir un onglet...',
        SECTION_GENERAL: 'Informations générales',
        LABEL: 'Libellé',
        ORDER: 'Ordre',
        SECTION_VISIBILITY: 'Visibilité',
        HIDDEN_COLUMN: 'Colonne cachée',
        VISIBLE_BY_MANAGERS: 'Visible par les managers',
        EDITABLE_BY_MANAGERS: 'Modifiable par les managers',
        HISTORICAL_EDITING_DISABLED: 'Cette option de modification est désactivée pour les colonnes historiques.',
        VISIBLE_BY_COLLABORATORS: 'Visible par les collaborateurs',
        VISIBLE_IN_SUMMARY: 'Visible dans la carte synthèse du collaborateur',
        SECTION_CALCULATION: 'Calcul',
        AUTO_SUM: 'Somme automatique',
        LABEL_SUM: 'Label de la somme',
        AUTO_AVERAGE: 'Moyenne automatique',
        LABEL_AVERAGE: 'Label de la moyenne',
        BTN_SAVE: 'Enregistrer',
        SUCCESS: 'Paramètres enregistrés avec succès',
        ERROR: "Erreur lors de l'enregistrement des paramètres",
        COLUMN_AVAILABLE: "Colonne disponible dans l'onglet",
        DELETE_SUCCESS: 'Colonne retirée de l\'onglet avec succès',
        DELETE_ERROR: 'Erreur lors de la suppression de la colonne de l\'onglet',
        LOAD_REQUIRED: "Chargez les paramètres de la colonne et de l'onglet sélectionnés avant d'enregistrer.",
        DUPLICATE_CONFIGURATION: "Plusieurs configurations existent pour cette colonne et cet onglet. Elles doivent être vérifiées avant d'enregistrer.",
        INVALID_ORDER: "Indiquez un ordre entier entre -32768 et 32767. L'effacement d'un ordre existant n'est pas pris en charge ici.",
        INVALID_LABEL: 'Indiquez un libellé de colonne non vide.',
        INVALID_COLOR: "Indiquez une couleur hexadécimale valide. L'effacement d'une couleur existante n'est pas pris en charge ici.",
      },
      EDIT_COLUMN: {
        TITLE: 'Modifier une colonne',
        METADATA_BASELINE_REQUIRED: "Resélectionnez la colonne avant d'enregistrer afin de conserver ses paramètres existants.",
        DESCRIPTION: "Modifiez la définition de la colonne. Les réglages propres à un onglet se gèrent dans Paramétrer les onglets.",
        BASE_NAME: 'Nom par défaut',
        NAME_PLACEHOLDER: 'Ex. : bonus proposé',
        SEARCH: 'Rechercher par nom ou code de colonne',
        STANDARD_COLUMN: 'Standard',
        DEFINITION_SCOPE: 'Les modifications concernent cette colonne dans les différents onglets. Les personnalisations existantes de chaque onglet sont conservées.',
        RUBRIC_HELP: "Modifier ce code peut affecter les correspondances de paie et les calculs qui l'utilisent.",
        LOAD_ERROR: "Les paramètres des colonnes n'ont pas pu être chargés. Fermez puis rouvrez cette fenêtre pour réessayer.",
        BASE_VALUES_UNAVAILABLE: 'Les paramètres initiaux de cette colonne sont indisponibles ou incohérents. Resélectionnez la colonne avant de modifier ses valeurs.',
        SELECT_REQUIRED: 'Sélectionnez la colonne à modifier.',
        SHARED_READ_ONLY: 'Cette colonne standard ne peut pas être modifiée ici. Son affichage peut être personnalisé dans Paramétrer les onglets.',
        OWNERSHIP_UNKNOWN: "La possibilité de modifier cette colonne n'a pas pu être vérifiée. Rouvrez cette fenêtre après le chargement des paramètres.",
        SAVE_ERROR: "Les modifications n'ont pas pu être enregistrées. Votre saisie a été conservée.",
        CATEGORY_CREATED_RETRY: "La catégorie a été créée, mais la colonne n'a pas pu être enregistrée. Réessayez Enregistrer pour terminer sans créer une autre catégorie.",
        CREATION_UNCONFIRMED: "Le résultat de la création n'a pas pu être confirmé. Fermez puis rouvrez cette fenêtre et vérifiez si l'élément existe déjà avant de le créer à nouveau.",
        ATTACHMENT_RETRY: "La colonne a été créée, mais ses paramètres d'onglet n'ont pas pu être enregistrés. Réessayez pour terminer ; fermer cette fenêtre n'annulera pas la création de la colonne.",
        RETRY_ATTACHMENT: "Réessayer les paramètres d'onglet",
        SAVING: 'Enregistrement...',
        NO_CHANGES: 'Aucune modification à enregistrer.',
        SELECT_COLUMN: 'Sélectionner une colonne',
        SELECT_PLACEHOLDER: 'Choisir une colonne à modifier...',
        NEW_NAME: 'Nouveau nom',
        BTN_SAVE: 'Enregistrer',
      },
      ADD_COLUMN: {
        TITLE: 'Ajouter une colonne personnalisée',
        DESCRIPTION:
          "Ajoutez une nouvelle colonne au tableau, en l'intégrant à une catégorie existante ou en créant une nouvelle catégorie pour l'organiser.",
        SECTION_GENERAL: 'Informations générales',
        SECTION_CATEGORY: 'Catégorie',
        SECTION_VISIBILITY: 'Visibilité',
        SECTION_CALCULATION: 'Calcul',
        COLUMN_NAME: 'Nom de la nouvelle colonne',
        INSERT_YEAR_TOKEN: 'Insérer l\'année',
        INSERT_YEAR_TOKEN_HELP: 'Utilisez {{token}} dans le texte pour placer l\'année à l\'endroit souhaité.',
        DYNAMIC_YEAR_DISPLAY: 'Affichage dynamique',
        DYNAMIC_YEAR_DISPLAY_TOGGLE: 'Activer le libellé dynamique',
        DYNAMIC_YEAR_DISPLAY_HELP: 'Ajoute automatiquement une année au libellé.',
        DYNAMIC_YEAR_OFFSET_LABEL: 'Décalage d\'année par rapport à N',
        DYNAMIC_YEAR_OFFSET_HELP: '0 = même année, -1 = année précédente, +1 = année suivante.',
        DYNAMIC_YEAR_REFERENCE_PREVIEW: 'Référence',
        DYNAMIC_YEAR_DISABLED_INFO: 'Le libellé dynamique est désactivé. Le nom restera affiché tel que vous le saisissez.',
        LABEL_PREVIEW: 'Aperçu du libellé',
        LABEL_PREVIEW_CONTEXT_DYNAMIC: 'Vue {{displayedYear}} · {{reference}} · Libellé {{resolvedYear}}',
        LABEL_PREVIEW_CONTEXT_STATIC: 'Année actuellement affichée dans la vue : {{displayedYear}}',
        TYPE: 'Type',
        TYPE_TEXT: 'Texte',
        TYPE_NUMBER: 'Chiffre',
        TYPE_CURRENCY: 'Monnaie',
        TYPE_PERCENTAGE: 'Pourcentage',
        CURRENCY_SYMBOL: 'Symbole de la monnaie',
        CURRENCY_EURO: 'Euro',
        CURRENCY_DOLLAR: 'Dollar américain',
        CURRENCY_POUND: 'Livre sterling',
        CURRENCY_YEN: 'Yen japonais',
        CURRENCY_FRANC: 'Franc suisse',
        CURRENCY_RUPEE: 'Roupie indienne',
        CURRENCY_REAL: 'Real brésilien',
        CURRENCY_RUBLE: 'Rouble russe',
        CURRENCY_KRONA: 'Couronne (SEK/NOK/DKK)',
        CURRENCY_ZLOTY: 'Zloty polonais',
        PAYROLL_CODE: 'Rubrique de paie',
        CODE_COLUMN: 'Code de la colonne',
        CODE_COLUMN_HELP: 'Code unique généré automatiquement : minuscules, chiffres et underscores uniquement. Les espaces sont remplacés par des underscores.',
        CHECKING_CODE: 'Vérification de la disponibilité...',
        CODE_AVAILABLE: 'Code disponible',
        CODE_ALREADY_EXISTS: 'Le code "{{code}}" existe déjà pour la colonne "{{label}}"',
        HIDDEN_COLUMN: 'Colonne cachée',
        EXISTING_CATEGORY: 'Catégorie existante',
        SELECT_CATEGORY: 'Sélectionner une catégorie',
        ADD_NEW_CATEGORY: 'Ajouter une nouvelle catégorie',
        NEW_CATEGORY: 'Nouvelle catégorie',
        NEW_CATEGORY_PLACEHOLDER: 'Tapez le nom de la catégorie...',
        VISIBLE_BY_MANAGERS: 'Visible par les managers',
        EDITABLE_BY_MANAGERS: 'Modifiable par les managers',
        VISIBLE_BY_COLLABORATORS: 'Visible par les collaborateurs',
        VISIBLE_IN_SUMMARY: 'Visible dans la carte synthèse du collaborateur',
        AUTO_SUM: 'Somme automatique',
        AUTO_SUM_TOOLTIP: 'Calcule automatiquement la somme de cette colonne',
        AUTO_AVERAGE: 'Moyenne automatique',
        LABEL: 'Label',
        LABEL_SUM: 'Label de la somme',
        LABEL_SUM_PLACEHOLDER: 'Ex: Total salaires, Somme des bonus...',
        LABEL_AVERAGE: 'Label de la moyenne',
        LABEL_AVERAGE_PLACEHOLDER: 'Ex: Moyenne salaires, Moyenne des bonus...',
        CALCULATION_PERIOD: 'Période de calcul',
        CALCULATION_PERIOD_TOOLTIP: 'Définit si la colonne est calculée mensuellement ou sur toute la période',
        MENSUELLE: 'Mensuelle',
        PERIODIQUE: 'Périodique',
        USE_FORMULA_FRONT: 'Utiliser une formule de calcul',
        USE_FORMULA_FRONT_TOOLTIP: 'Cette colonne sera calculée automatiquement à partir d\'autres colonnes',
        FORMULA_BUILDER: 'Constructeur de formule',
        SELECT_COLUMN_A: 'Sélectionner la colonne A',
        SELECT_COLUMN_B: 'Sélectionner la colonne B',
        SELECT_COLUMN: 'Sélectionner une colonne',
        ADD_COLUMN_TO_FORMULA: 'Ajouter une colonne à la formule',
        ADD_COLUMN_BTN: 'Ajouter',
        ADVANCED_MODE: 'Mode avancé',
        TOGGLE_ADVANCED_MODE: 'Basculer vers le mode avancé pour des formules complexes',
        ADVANCED_MODE_HELP: 'Écrivez votre formule avec des parenthèses et des constantes. Ex: ((col1 + col2) / col3) * 100',
        ADVANCED_FORMULA_PLACEHOLDER: 'Ex: ((salaire_fixe + bonus) / (salaire_n_1 + bonus_n_1) - 1) * 100',
        CLICK_TO_INSERT: 'Cliquez pour insérer',
        OPERATORS: 'Opérateurs',
        FORMULA_PREVIEW: 'Aperçu de la formule',
        NO_FORMULA_COLUMNS: 'Aucune colonne numérique disponible pour créer une formule. Ajoutez d\'abord des colonnes numériques.',
        USE_FORMULA_COLUMN: 'Colonne historique',
        USE_FORMULA_COLUMN_TOOLTIP: 'Cette colonne affichera les données historiques d\'une autre colonne avec un décalage temporel',
        FORMULA_COLUMN_BUILDER: 'Configuration de la colonne historique',
        SOURCE_COLUMN: 'Colonne source',
        SELECT_SOURCE_COLUMN: 'Sélectionner la colonne source',
        DELTA_MONTH: 'Décalage (mois)',
        DELTA_MONTH_PLACEHOLDER: 'Ex: -12 pour N-1',
        DELTA_MONTH_HELP: 'Nombre de mois de décalage. Ex: -12 pour l\'année précédente, -1 pour le mois précédent',
        NO_SOURCE_COLUMNS: 'Aucune colonne source disponible. Ajoutez d\'abord des colonnes.',
        CALCULATED_COLUMN: 'Colonne calculée',
        CALCULATED_TOOLTIP: 'Cette colonne sera calculée automatiquement selon une formule',
        CALCULATED_FROM_HISTORY: "Calculée sur la base de l'historique",
        HISTORY_TOOLTIP: 'Utilise les données historiques pour calculer la valeur',
        SELECT_COLUMN_PLACEHOLDER: 'Choisir une colonne...',
        HISTORY_TYPE: "Type d'historique",
        HISTORY_TYPE_PLACEHOLDER: 'Choisir un type...',
        HISTORY_TYPE_SUM: 'Somme',
        HISTORY_TYPE_AVERAGE: 'Moyenne',
        HISTORY_TYPE_LAST: 'Dernière valeur',
        HISTORY_TYPE_FIRST: 'Première valeur',
        BTN_ADD: 'Ajouter une colonne',
        VALIDATION_ERROR: 'Veuillez remplir tous les champs obligatoires',
        API_NOT_READY: "API non disponible - La colonne sera ajoutée une fois l'API prête",
      },
      MES_REMUNERATIONS: {
        TITLE: 'Mon espace rémunération',
        YEAR_LABEL: 'Année affichée',
        NET_SALARY: 'Ton Salaire net cumulé',
        EVOLUTION: 'Evolution',
        EVOLUTION_SUBTITLE: "Par rapport à la même date l'an dernier",
        OTHER_BENEFITS: 'Autres avantages',
        COMPANY_INVESTMENT: "Investissement total de l'entreprise",
        BONUSES: 'Primes',
        EMPLOYER_CHARGES: 'Charges patronales',
        NO_DATA_FOR_YEAR: 'Aucune donnée disponible pour cette année',
        ERROR_LOADING_DATA: 'Erreur lors du chargement des données de rémunération',
        NO_BENEFITS_TITLE: 'Aucun avantage disponible',
        NO_BENEFITS_TEXT:
          "Aucune donnée d'avantages n'a été enregistrée pour l'année {{year}}. Les avantages seront affichés dès qu'ils seront disponibles.",
      },
      MESSAGES: {
        COLUMN_CREATED: 'Colonne créée avec succès',
        COLUMN_UPDATED: 'Colonne mise à jour avec succès',
        COLUMN_DELETED: 'Colonne supprimée avec succès',
        CATEGORY_CREATED: 'Catégorie créée avec succès',
        CATEGORY_UPDATED: 'Catégorie mise à jour avec succès',
        VALUE_CREATED: 'Valeur créée avec succès',
        VALUE_UPDATED: 'Valeur mise à jour avec succès',
        VALUE_DELETED: 'Valeur supprimée avec succès',
      },
      ADD_COMMENT: 'Ajouter un commentaire',
      DISTRIBUTION: 'Répartition',
      TEXT_EDITOR: {
        OPEN: 'Ouvrir l’éditeur de texte',
        TITLE: 'Modifier le texte',
        PLACEHOLDER: 'Saisissez le texte complet...',
        HINT: 'Ctrl+Entrée pour appliquer au tableau',
        APPLY: 'Appliquer',
        CHARACTERS: 'caractères',
      },
      COMMENT_MODAL: {
        TITLE: 'Ajouter un commentaire',
        MOTIF: 'Motif',
        MOTIF_PLACEHOLDER: 'Entrez le motif de cette modification...',
        YEARLY_VIEW_NOTE: "Le commentaire sera enregistré pour le mois de décembre de l'année sélectionnée",
      },
      DISTRIBUTION_MODAL: {
        TITLE: 'Répartition de la valeur',
        DESCRIPTION: "Choisissez comment répartir cette valeur sur l'année",
        DISTRIBUTION_TYPE: 'Type de répartition',
        DECEMBER_ONLY: 'Décembre uniquement',
        DECEMBER_ONLY_DESC: 'La valeur sera appliquée uniquement au mois de décembre',
        ALL_MONTHS: 'Tous les mois (même valeur)',
        ALL_MONTHS_DESC: "La même valeur sera appliquée à chaque mois de l'année",
        DIVIDED_EQUALLY: 'Répartition égale',
        DIVIDED_EQUALLY_DESC: 'La valeur sera divisée équitablement sur les 12 mois',
      },
    },
    USER: {
      DETAILS: {
        PERSO_INFO: 'Informations personnelles',
        presentation: 'Presentation',
        CHANGE_PASS: 'Changer le mot de passe',
        CONGE: 'Congés',
        NOM: 'Nom',
        PRENOM: 'Prénom',
        AVAIL: 'Disponibilités',
        PLANNING: 'Planning des déplacements',
        PLANNING_WORK_MODE: 'Modes de travail',
        succ: 'Profil modifié avec succès',
        allow: 'Types de fichiers autorisés',
        btn: 'Modifier',
        COLLAB: 'Collaborateur',
        ENTRE: 'Entreprise',
        EQUIPE: 'Equipe',
        SITE: 'Site',
        SERVICE: 'Service',
        RESERVATION: 'le nombre maximal de rendez-vous reservables pour ce mois-ci est atteint.',
        FORMATIONS: 'Formations',
        COMPETENCES: 'Compétences',
        EMAIL_PERSONNELLE: 'E-mail personnel',
        TELEPHONE: 'Téléphone Personnel',
      },
    },
    EuipeTransverse: {
      Gerer: {
        Nom: 'Nouvelle Équipe Transverse ',
        List: 'Liste des équipes transverses',
      },
      DELETE: {
        TITLE: ' Supprimer équipe transverse',
        DESC_1: 'suppression équipe transverse ...',
        DESC_2: 'Êtes-vous sûr de supprimer définitivement cette équipe transverse ?',
        BTN_DELETE: 'Supprimer',
        BTN_CANCEL: 'Annuler',
      },
    },
    COLLAB: {
      DETAILS: {
        TITLE: 'Liste des collaborateurs',
        NEW_COLLABORATOR: 'Nouveau collaborateur',
        PROPOSERCANDIDAT: 'Suggérer des candidat',
        ADDFROMDOC: 'Renseigner depuis un document',
        inscription: 'Inscription par lien',
        RUP: 'Télécharger RUP',
        RUP_TITRE: 'Registre Unique du Personnel',
        RUP_BUTTON: 'Télécharger',
        SEARCH: 'Rechercher',
        FIELD: 'dans tous les domaines',
        PRENOM: 'Prénom',
        NOM: 'Nom',
        Responsable: 'Responsable',
        Fonction: 'Fonction',
        Site: 'Site',
        Service: 'Service',
        Equipe: 'Equipe',
        ACTIONS: 'ACTIONS',
        IMG: 'Image',
        IMPORT_COLLABS_BTN: 'Importer',
        IMPORT_COLLABS_FROM_FILE_TITLE: 'Ajouter des collaborateurs depuis un fichier',
        IMPORT_COLLABS_FROM_FILE_DESC: 'Veuillez importer un fichier  .xls, ou xlsx suivant le format: ',
        IMPORT_COLLABS_FROM_FILE_DESC_FORMAT: 'email, prénom, nom, fonction, service',
        TAG_AS_AMBASSADOR: 'Marquer comme ambassadeur',
        MARKED_AS_AMBASSADOR: 'a été marqué comme ambassadeur',
        UNMARKED_AS_AMBASSADOR: "a n'est plus un ambassadeur",
        // Ces libellés décrivent uniquement le nouveau menu d’actions de l’écran de gestion des collaborateurs.
        ACTION_MENU: {
          DETAILS_DESCRIPTION: 'Ouvrir la fiche du collaborateur',
          TAGS_STATUS: 'Tags & statuts',
          HIGH_POTENTIAL: 'Haut potentiel',
          HIGH_POTENTIAL_DESCRIPTION: 'Identifier un talent à fort potentiel',
          PARTICULAR_FOLLOW_UP: 'Suivi particulier',
          PARTICULAR_FOLLOW_UP_DESCRIPTION: 'Suivi renforcé et attention particulière',
          AMBASSADOR: 'Ambassadeur',
          AMBASSADOR_DESCRIPTION: "Activer le statut d’ambassadeur",
          ACCOUNT_MANAGEMENT: 'Gestion du compte',
          ACTIVATE_ACCOUNT: 'Activer le compte',
          ACTIVATE_ACCOUNT_DESCRIPTION: 'Rendre le compte actif et accessible',
          TRANSFER_ALUMNI: 'Transférer en Alumni',
          TRANSFER_ALUMNI_DESCRIPTION: 'Déplacer vers la base alumni',
          DEACTIVATE_ACCOUNT: 'Désactiver le compte',
          DEACTIVATE_ACCOUNT_DESCRIPTION: 'Suspendre l’accès temporairement',
          UPCOMING_STARTER: 'Arrivée à venir',
          // La sortie prochaine complète l’indicateur d’arrivée déjà utilisé par la liste.
          UPCOMING_DEPARTURE: 'Départ à venir',
        },
        // La nouvelle modale conserve les mêmes actions métier et clarifie uniquement la saisie du commentaire.
        TAG_COMMENT_MODAL: {
          CLOSE: 'Fermer',
          POTENTIAL_TITLE: 'Identifier un haut potentiel',
          POTENTIAL_DESCRIPTION: 'Ajoutez un contexte utile pour expliquer les qualités ou le potentiel observé.',
          FOLLOW_UP_TITLE: 'Activer un suivi particulier',
          FOLLOW_UP_DESCRIPTION: 'Précisez le contexte nécessitant une attention ou un accompagnement renforcé.',
          COMMENT_LABEL: 'Commentaire',
          COMMENT_HINT: 'Facultatif · 500 caractères maximum',
          POTENTIAL_PLACEHOLDER: 'Ex. : forte capacité d’évolution, leadership observé, expertise clé…',
          FOLLOW_UP_PLACEHOLDER: 'Ex. : accompagnement recommandé, point de vigilance, suivi managérial…',
          CANCEL: 'Annuler',
          CONFIRM_POTENTIAL: 'Confirmer le haut potentiel',
          CONFIRM_FOLLOW_UP: 'Activer le suivi',
        },
        ACTIF: 'Actifs',
        ALUMNI: 'Alumni',
        DESACTIVER: 'Désactivés',
        EN_ATTENTE: "En attente d'inscription",
        SITE: 'Site',
        FILTRE: 'Filtre',
        ALL: 'Tout',
        TITREALUMNI: 'Transférer dans la liste des alumnis',
        SOUSTITREALUMNI: 'Transférer dans la liste des alumnis ...',
        BODYALUMNI:
          'Êtes vous sûre de vouloir désactiver le compte utilisateur et le transférer dans la liste des alumnis ?',
        BODYALUMNI2: 'confirmation de la date effective de sortie',
        TITREACTIF: 'Réactiver  compte',
        SOUSTITREACTIF: ' Réactivation  compte ...',
        BODYACTIF: 'Êtes vous sure de vouloir réactiver ce compte ?',
        CANCEL: 'Annuler',
        SAVE: 'sauvegarder',
        ENVOIEMAILBIENVENUE: "Paramétrer l'envoie d'email de Bienvenue",
        ENVOYERMAILBIENVENUEINSCRIT: 'Envoyer le mail de bienvenue automatiquement à chaque nouvel inscrit',
        PASENVOYERMAILBIENVENUEINSCRIT: 'Ne pas envoyer de mail de bienvenue automatiquement',
        ENTREPRISESTRUCTURE: 'Organigramme',
        ORGA: 'Organigramme',
        MONEQUIPE: 'Mon équipe',
        CONFIRMATIONEMAIL: "Confirmation l'envoi de mail de bienvenue",
        MSGCONFIRMATIONEMAIL:
          "Souhaitez-vous envoyer un mail aux collaborateurs déjà ajoutés et n'ayant pas reçu de mail de bienvenue ?",
        OUI: 'Oui',
        NON: 'Non',
        SENDEMAILSALLCOLLABS:
          "Les mails de bienvenue seront envoyés à tous les collaborateurs déjà ajoutés et n'ayant pas reçu de mail.",
        SENDEMAILSALLCOLLABS2:
          'Seuls les nouveaux collaborateurs ajoutés à partir de ce moment recevront le mail de bienvenue.',
        SUCCESSPARAMETRAGE: 'Paramétrage effectué avec succès',
        ERRPARAMETRAGE: 'Erreur lors du paramétrage',
        ListCollegues: {
          LIST: 'Liste des collègues',
          p1: "Si vous voulez pouvoir proposer des rendez-vous à vos collègues, vous devez accepter l'option permettant à vos collègues de réserver un rendez-vous avec vous",
          Profil: 'Profil',
          p2: "Vous devez accepter d'être visible par d'autres afin d'accéder à l'annuaire.",
          p3: "Votre entreprise doit activer l'option annuaire pour les collaborateurs",
          interet: "Centre d'interret:",
        },
      },

      EDIT: {
        Edit: 'Modifier',
        Create: 'Ajouter un ',
        customer: 'collaborateur',
        Nom: 'Nom',
        Name: 'Nom',
        Prenom: 'Prénom',
        FIrstName: 'Prénom',
        fonction: 'Fonction',
        fon: 'Fonction',
        Email: 'E-mail professionnel',
        mail: 'E-mail personnel',
        password: 'Mot de passe',
        m2p: 'Mot de passe',
        Equipe: 'Sélectionner Equipe',
        Role: 'Sélectionner Role',
        ADMIN: 'Administrateur',
        USER: 'Collaborateur',
        BTN_SAVE: 'Sauvegarder',
        BTN_SAVEBROUILLON: 'Sauvegarder en brouillon',
        BTN_SAVEINTERNE: 'Sauvegarder et publier en interne',
        BTN_SAVEPORTAIL: 'Sauvegarder et publier dans le portail',

        BTN_CANCEL: 'Annuler',
        ERR: 'Ce e-mail existe déjà. Veuillez utiliser une autre adresse e-mail',
        ERR1: 'Ce e-mail est invalide. Veuillez utiliser une autre adresse e-mail',
        dateentree: "Date d'entrée",
        dateSortie: 'Date de sortie',
        qualification: 'Qualification',
        dateAutorisationEmbauche: 'Date d’autorisation d’embauche',
        dateAutorisationLicenciement: 'Date d’autorisation de licenciement',
        dateAutorisationDemande: "Date de l'autorisation ou demande de l'autorisation",
        titreAutorisation: "Titre d'autorisation",
        numeroOrdreTitre: "Numéro d'ordre du titre",
        dateDelivranceTitre: 'Date de délivrance du titre',
        dateExpirationTitre: "Date d'expiration du titre",
        ERROR_DATE_EXPIRATION_AFTER_DELIVRANCE:
          "La date d'expiration du titre doit être postérieure à la date de délivrance.",
        departement_naissance: 'Département de naissance',
        date_entree_groupe: "Date d'entrée dans le groupe",
      },
      SELFSERVICE: {
        TITLE: 'Consulter Disponibilité',
      },
      RECONNAISSANCE: {
        // Libellés du parcours moderne d'envoi, d'historique et d'édition des reconnaissances.
        TITRE: 'Envoyer une Reconnaissance',
        EYEBROW: 'Célébrer un collègue',
        DESCRIPTION: 'Mettez en lumière une contribution qui mérite d’être partagée.',
        CLOSE: 'Fermer la fenêtre de reconnaissance',
        NAVIGATION: 'Navigation de la reconnaissance',
        COMPOSE_TAB: 'Envoyer',
        HISTORY_TAB: 'Mes reconnaissances',
        CHOIXIMAGE: 'Choisissez une image',
        IMAGE_WELCOME: 'Bienvenue',
        IMAGE_BRAVO: 'Bravo',
        IMAGE_COLLABORATION: 'Collaboration',
        IMAGE_ENGAGEMENT: 'Engagement',
        IMAGE_LEADERSHIP: 'Leadership',
        IMAGE_THANKS: 'Merci',
        IMAGE_GOAL: 'Objectif atteint',
        IMAGE_TEAMWORK: 'Esprit d’équipe',
        PUBLIC_NOTICE_TITLE: 'Publication visible par tous',
        PUBLIC_DASHBOARD_NOTICE:
          'Cette reconnaissance sera affichée sur le tableau de bord de l’entreprise et sera visible par tous les collaborateurs.',
        MSGTEXT: 'Message de reconnaissance',
        MESSAGE_PLACEHOLDER: 'Expliquez ce que vous avez apprécié dans sa contribution…',
        BTN_SEND: 'Envoyer',
        CANCEL: 'Annuler',
        SENDING: 'Envoi en cours…',
        ADDSUCCESS: 'Reconnaissance ajoutée avec succès',
        ADD_ERROR: 'La reconnaissance n’a pas pu être envoyée. Réessayez.',
        INVALID_FORM: 'Sélectionnez une carte et écrivez un message.',
        INVALID_MESSAGE: 'Le message ne peut pas être vide.',
        SELECTIMAGESUCCES: 'Image sélectionnée avec succès !',
        ERREURSELECTIMAGESUCCES: 'Veuillez sélectionner une image et ecrire un message',
        HISTORY_TITLE: 'Reconnaissances envoyées',
        HISTORY_DESCRIPTION: 'Retrouvez et corrigez les messages que vous avez publiés.',
        HISTORY_LOADING: 'Chargement de votre historique…',
        HISTORY_LOAD_ERROR: 'Impossible de charger votre historique pour le moment.',
        HISTORY_EMPTY_TITLE: 'Aucune reconnaissance envoyée',
        HISTORY_EMPTY: 'Votre prochain message de reconnaissance apparaîtra ici.',
        REFRESH_HISTORY: 'Actualiser l’historique',
        RETRY: 'Réessayer',
        SENT_AT: 'Envoyée le',
        EDIT: 'Modifier',
        EDIT_FOR: 'Modifier la reconnaissance envoyée à',
        EDIT_TITLE: 'Modifier le message',
        EDIT_CANCEL: 'Annuler',
        UPDATE: 'Enregistrer',
        UPDATE_SUCCESS: 'Reconnaissance mise à jour avec succès',
        UPDATE_ERROR: 'La reconnaissance n’a pas pu être mise à jour.',
        UNKNOWN_RECIPIENT: 'Ancien collaborateur',
        LOAD_MORE: 'Afficher plus',
      },
      RESERVER: {
        TITLE: ' Réserver rendez-vous',
        DESC_1: 'Réservation de rendez-vous ...',
        DESC_2: 'Êtes-vous sûr de vouloir réserver  ce rendez-vous ?',
        BTN_DELETE: 'Réserver',
        BTN_CANCEL: 'Annuler',
      },
      DELETE: {
        TITLE: 'Désactivation du compte',
        DESC_1: 'Êtes-vous sûr(e) de vouloir désactiver ce compte ?',
        DESC_2:
          'La désactivation sera effective à la date indiquée ci-dessous. L’utilisateur ne pourra plus se connecter après cette date.',
        BTN_NETOYER: 'Nettoyer',
        BTN_DELETE: 'Desactiver',
        BTN_CANCEL: 'Annuler',
      },
      btnSave: 'Sauvegarder',
      collaborateursManages: 'Collaborateurs managés',
      listeCollaborateursManages: 'Liste des collaborateurs managés',
      aucunCollaborateurManage: 'Aucun collaborateur managé trouvé',
      ajouterCollaborateur: 'Ajouter un collaborateur',
      aucunCollaborateurSansManager: 'Aucun collaborateur sans manager trouvé',
      ajouter: 'Ajouter',
      photo: 'Photo',
      nom: 'Nom',
      prenom: 'Prénom',
      fonction: 'Fonction',
      equipe: 'Équipe',
      service: 'Service',
      site: 'Site',
      actions: 'Actions',
      CONFIRMATION_RETIRER_MANAGER:
        'Êtes-vous sûr de vouloir retirer ce collaborateur de votre liste de personnes managées?',
    },

    ONBOARDINGTEXT: {
      SUIVREONB: "Suivi de l'onboarding et de l'offboarding",
      ADDBUDDYONB: 'Ajouter buddy',
      ADDFORMATIONONB: 'Ajouter règle de formation',
      ADDACCEUILONB: "Ajouter règle d'accueil",
      ADDTACHEONB: 'Ajouter règle tâche',
      ADDENQUETEONB: 'Ajouter règle enquete',
      ADDDEBRIEFONB: 'Ajouter règle de debriefing',
      ADDRDVONB: 'Ajouter rendez-vous',
      ADDVIDEOONB: 'Ajouter vidéo',
      ACTIVERONB: 'Activer onboarding',
      DESACTIVERONB: 'Désactiver onboarding',
      ACTIFOFFBOARDING: 'Activer offboarding',
      DESACTIFOFFBOARDING: 'Désactiver offboarding',
      ADDDOCONB: 'Ajouter un document',
      TELECHARDERDOCONB: 'Télécharger',
      VOIRDOCONB: 'Voir le document',
      PLUSONB: 'Plus',
      MOINSONB: 'Moins',
      TELECHARGEDOC: 'Télécharger le document',
      TOUTONB: 'Tout',
      FAITONB: 'Fait',
      AFAIREONB: 'À faire',
      INDEXERONB: 'Indexer',
      SURVEY_ONBOARDING_TARGET_HELP:
        'Seules les enquêtes avec un ciblage de type onboarding seront listées ci-dessous',
    },
    APIEXTERNE: {
      description: "Génerer une clé d'API externe pour ton entreprise",
      descriptionsupprimer: "Supprimer le  clé d'API externe pour ton entreprise",
      button: 'Génerer clé',
      buttonsupprimer: 'Supprimer clé',
    },
    ANNUAIRE: {
      TITLE: 'Annuaire',
      p0: "Pour prendre en compte les changements il est nécessaire de rafraichir l'application",
      p100: 'Pour prendre en compte les changements il est nécessaire de cliquer sur button sauvegarder apres remplir les champs ci dessous',
      button: "Rafraichir l'application",
      p: "Activer l'annuaire pour les collaborateurs",
      p1: 'Activer les communautés pour les collaborateurs',
      p2: 'Activer les événements pour les collaborateurs',
      p3: 'Activer les questions et réponses pour les collaborateurs',
      p4: 'Activer les  boîtes à idées pour les collaborateurs',
      ponboarding: "Activer l'onboarding pour les collaborateurs",
      Annuaire: "Apparaître dans l'annuaire",
      Accept: 'Accepter de recevoir des propositions de rendez-vous de collègues',
      abn: 'Votre abonnement est',
      parametre_msg1:
        'Gérez vos modules ici en les activant ou désactivant selon votre abonnement pour adapter la plateforme à vos besoins',
    },
    MYACTVITY: {
      status: {
        att: 'Attente de votre confirmation',
        att1: 'Attente de confirmation de ',
        att2: 'Attente de confirmation des deux collaborateurs ',
        rdvConfirme: 'Le rendez-vous est confirmé',
        rdvDecline: 'Vous avez décliné le rdv',
        rdvDecline1: ' a décliné le rdv',
        annule: 'Annulé',
        terminer: 'Terminer',
      },
      DETAILS: {
        detail: 'Détails du rendez-vous',
        restoDetail: 'Détails du restaurant',
        Lieu: 'Lieu',
        ACTIVITY_DETAILS: ' Details du Rendez-vous',
        COFFE: 'Café',
        LUNCH: 'Déjeuner',
        RESTAURANT: 'Restaurant',
        BACK: 'Retour',
        BACLOSE: 'Fermer',
        CANCEL: 'Annuler',
        SELECT: 'Sélectionner',
        ACCEPT: 'Accepter',
        REFUSE: 'Refuser',
        TERMINER: 'Terminer et Noter',
        ACTIVITY_TYPE: 'type de rendez-vous',
        MADE_BY: 'Organisé par',
        ACTIVITY_STATUS: 'Status du rdv',
        MEETING_IS_WITH: 'Collaborateur',
        MY_STATUS: 'Mon status',
        MY_COMMENT: 'Mon commentaire',
        MY_COMMENT2: 'commentaire de collaborateur',
        RESTAURANT_NAME: 'Nom du restaurant',
        JOIN: 'Rejoindre',
        LEAVE: 'Abandonner',
        SEND: 'Envoyer',
        WELCOME: 'discutez avec ',
        ACCEPTED: 'Accepté',
        REFUSED: 'Refusé',
        CANCELED: 'Annulé',
        CREATED: 'Creé',
        ATTENTE: 'Attente de confirmation',
        FINISHED: 'Terminé',
        RATING: ' Ma note',
        RAITING2: 'collaborateur Note',
        FILE: 'importez votre fichier',
        RATE_COMMENT: 'Note',
        DEATAILLS: 'Detailles',
        note: 'Ma note',
        newMess: 'Communiquer avec votre collaborateur',
        avecQui: 'Avec qui?',
        Avis: 'Avis',
        ser: 'Service: ',
        Avis1: 'Avis:',
        Nom: 'Nom: ',
        Adresse: 'Adresse: ',
        Horraires: 'Horraires: '
      },
      MENU: {
        TLF: 'Téléphone',
        Cuisine: 'Cuisine',
        Services: 'Services',
        Livraison: 'Livraison',
        Self: 'Self service',
        tearace: 'terrasse',
        vegetariens: 'Convient au vegetariens',
        bio: 'Produits bio',
        Halal: 'Plats Halal',
        gluten: 'Plats sans gluten',
        diabetiques: 'Plats pour diabetiques',
        vegans: 'Convient aux vegans',
      },
      note: {
        head: "Est-ce que votre rendez-vous s'est bien passé ?",
        body: 'Laissez une note',
        comnt: 'Laissez un commentaire',
      },
      LIST: {
        TITLE: 'Gérer les rendez-vous de vos équipes',
        BTN_ADD: 'Nouvelle activité',
        SEARCH: ' Rechercher ',
        FIELD: ' dans tous les domaines',
        start_date: 'Date de début',
        status_global: ' Statut globale',
        user_1: 'Collaborateur 1',
        status_1: 'Statut 1',
        user_2: 'Collaborateur 2',
        status_2: 'Statut 2',
        TASK_STATUS_IN_PROGRESS: 'en cours',
        ACTIONS: 'Actions',
      },
      EDIT: {
        TITLEADD: 'un rendez-vous',

        TITLEMODIF: 'le rendez-vous',
        CREATE: 'Ajouter',
        UPDATE: 'Modifier',
        TITLE: 'Rendez-vous',
        Date: 'Date de début',
        Restaurant: 'Entrez le nom du restaurant',
        USER_1: 'Sélectionnez le convive 1',
        User1: 'Convive 1',
        USER_2: 'Sélectionnez le convive 2',
        User2: 'Convive 2',
        Description: 'Déscription',
        type: 'Type de rendez-vous',
        caffee: 'Café',
        meal: 'Repas',
        BTN_SAVE: 'Sauvegarder',
        BTN_CANCEL: 'Annuler',
        ERRERRDV: 'Un rendez vous existe pour les users dans cette date',
      },
      DELETE: {
        TITLE: ' Supprimer Rendez-vous',
        DESC_1: 'suppression Rendez-vous ...',
        DESC_2: 'Êtes-vous sûr de supprimer définitivement ce rendez-vous ?',
        DESC_3: 'Êtes-vous sûr de vouloir supprimer le document intitulé ',

        BTN_DELETE: 'Supprimer',
        BTN_CANCEL: 'Annuler',
      },

      ACTIVITY: {
        TITLE: 'Liste des notes et commentaires',
        SEARCH: ' Rechercher ',
        FIELD: ' dans tous les domaines',
        start_date: 'date de début',
        Disponible: 'Liste des personnes disponibles',
      },
      RATING: {
        TITLE: "Est-ce que votre rendez-vous s'est bien passé ?",
        COMMENT: 'Laissez un commentaire',
        NOTE: 'Laissez une note',
        no: 'Note',
        BTN_SAVE: 'Sauvegarder',
        BTN_CANCEL: 'Annuler',
        BTN_SAVESEND: 'Sauvegarder et envoyer',
      },
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: "Nombre d'enregistrements sélectionnés: ",
        ALL: 'All',
        SUSPENDED: 'Suspended',
        ACTIVE: 'Active',
        FILTER: 'Filter',
        BY_STATUS: 'by Status',
        BY_TYPE: 'by Type',
        BUSINESS: 'Business',
        INDIVIDUAL: 'Individual',
        SEARCH: 'Search',
        IN_ALL_FIELDS: 'in all fields',
      },
      ECOMMERCE: 'éCommerce',
      CUSTOMERS: {
        CUSTOMERS: 'Les clients',
        CUSTOMERS_LIST: 'Liste des clients',
        NEW_CUSTOMER: 'Nouveau client',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'Suppression du client',
          DESCRIPTION: 'Êtes-vous sûr de supprimer définitivement ce client?',
          WAIT_DESCRIPTION: 'Le client est en train de supprimer ...',
          MESSAGE: 'Le client a été supprimé',
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'Supprimer les clients',
          DESCRIPTION: 'Êtes-vous sûr de supprimer définitivement les clients sélectionnés?',
          WAIT_DESCRIPTION: 'suppression clients ...',
          MESSAGE: 'Les clients sélectionnés ont été supprimés',
        },
        UPDATE_STATUS: {
          TITLE: 'Le statut a été mis à jour pour les clients sélectionnés',
          MESSAGE: 'Le statut des clients sélectionnés a été mis à jour avec succès',
        },
        EDIT: {
          UPDATE_MESSAGE: 'Le client a été mis à jour',
          ADD_MESSAGE: 'Le client a été créé',
        },
      },
    },
    SITE: {
      LIST: {
        TITLE: 'Liste des sites',
        BTN_ADD: 'Nouveau site',
        SEARCH: 'Rechercher ',
        FIELD: 'dans tous les domaines',
        NAME: 'Nom',
        ADDRESS: 'Adresse',
        VILLE: 'Ville',
        PAYS: 'Pays',
        ACTIONS: 'Actions',
      },
      EDIT: {
        res: 'Responsable',
        ressite: 'Responsable du site',

        Edit: 'Modifier',
        Create: 'Créer un nouveau site',
        SITE: ' le site',
        Nom: 'Nom du site',
        Name: 'Nom',
        Address: 'Adresse',
        add: 'Addresse',
        ville: 'Ville',
        city: 'Ville',
        pays: 'Pays',
        country: 'Pays',
        BTN_SAVE: 'Sauvegarder',
        BTN_CANCEL: 'Annuler',
        AMBASSADEUR: 'Ambassadeur du site',
        DOCUMENTS: 'Documents',
        DOCUMENTS_DROP: 'Glisser-déposer ou sélectionner',
        DOCUMENTS_FORMATS: 'Renseignez le titre et ajoutez le document de l’accord avant de l’ajouter à la liste.',
        DOCUMENTS_TITLE: 'Titre de l’accord',
        DOCUMENTS_FILE: 'Document de l’accord',
        DOCUMENTS_TYPE: 'Type de document',
        DOCUMENTS_TYPE_PLACEHOLDER: 'Sélectionner le type de document',
        DOCUMENTS_IMPORTED: 'Document déjà importé',
        DOCUMENTS_ADD: 'Ajouter l’accord',
        DOCUMENTS_PRIORITY_HIGH: 'Priorité la plus élevée',
        DOCUMENTS_PRIORITY_LOW: 'Priorité la plus basse',
        DOCUMENTS_EMPTY: 'Aucun document ajouté pour le moment.',
        DOCUMENTS_DELETE_TITLE: 'Supprimer l’accord',
        DOCUMENTS_DELETE_CONFIRM: 'Voulez-vous vraiment supprimer cet accord ?',
        DOCUMENTS_DELETE_SUCCESS: 'Accord supprimé avec succès',
        DOCUMENTS_DELETE_ERROR: 'Erreur lors de la suppression de l’accord',
        DELETE_ALL_DOCUMENTS: 'Supprimer tous les documents',
        DELETE_ALL_DOCUMENTS_TITLE: 'Supprimer tous les documents',
        DELETE_ALL_DOCUMENTS_CONFIRM: 'Êtes-vous sûr de vouloir supprimer tous les documents de ce site ?',
        DELETE_ALL_DOCUMENTS_SUCCESS: 'Tous les documents ont été supprimés avec succès',
        DELETE_ALL_DOCUMENTS_ERROR: 'Erreur lors de la suppression des documents',
        DOCUMENTS_EXTRACTING_TEXT: 'Extraction du texte...',
        DOCUMENTS_PROCESSING_CHUNKS: 'Traitement du document...',
        DOCUMENTS_FINALIZING: 'Finalisation...',
        DOCUMENTS_PLEASE_WAIT: 'Cela peut prendre quelques instants pour les grands documents.',
        DOCUMENTS_STATUS_EXTRACTING: 'Extraction du texte',
        DOCUMENTS_STATUS_PREPARING: 'Préparation pour Julie',
        DOCUMENTS_STATUS_IMPORTED: 'Importé avec succès',
        DOCUMENTS_UPLOAD_SUCCESS: 'Accord importé avec succès',
        DOCUMENTS_UPLOAD_ERROR: 'Erreur lors de l’import de l’accord',
      },
      DELETE: {
        TITLE: '  Supprimer Site',
        DESC_1: ' suppression Site ...',
        DESC_2: 'Êtes-vous sûr de supprimer définitivement ce Site?',
        BTN_DELETE: 'Supprimer',
        BTN_CANCEL: 'Annuler',
      },
    },
    INDICATOR: {
      DELETE: {
        TITLE: '  Supprimer Indicateur',
        DESC_1: ' suppression indicateur ...',
        DESC_2: 'Êtes-vous sûr de supprimer définitivement cet indicateur pour ce site?',
        BTN_DELETE: 'Supprimer',
        BTN_CANCEL: 'Annuler',
      },
    },
    GROUP: {
      LIST: {
        TITLE: 'Liste des équipes',
        BTN_ADD: 'Nouvelle équipe',
        SEARCH: 'Rechercher ',
        FIELD: 'dans tous les domaines',
        NAME: "Nom de l'équipe",
        MSG1: 'ATTENTION, vous ne pouvez pas le supprimer,',
        MSG2: 'Des salariés sont attachés à cette équipe!',
        NBR: 'N° MEMBRES',
        SERVICE: ' nom du Service ',
        ACTIONS: 'Actions',
        USERS: 'Utilisateurs',
        AFFECTER: 'Affecter',
        MODIFIEREQUIPE: 'Modifier',
        SUPPRIMEREQUIPE: 'Supprimer',
        HISTORIQUE: 'Historique',
      },
      EDIT: {
        Edit: 'Modifier',
        Create: 'Créer une nouvelle équipe',
        GROUP: 'équipe',
        GROUPREQUIS: " Nom de l'équipe",
        Service: 'Sélectionnez le Service',
        BTN_SAVE: 'Sauvegarder',
        BTN_CANCEL: 'Annuler',
        NOMGROUP: 'Nom de l équipe',
        GROUPedit: "l'équipe",
        RESPONSABLE_EQUIPE: "Responsable de l'équipe",
        AMBASSADEUR_EQUIPE: "Ambassadeur de l'équipe",
      },
      EDITTRANSVERSE: {
        Edit: 'Modifier',
        Create: 'Créer une équipe transverse',
        GROUP: 'Équipe Transverse',
        GROUPREQUIS: " Nom de l'équipe ",
        Service: 'Sélectionnez le Service',
        BTN_SAVE: 'Sauvegarder',
        BTN_CANCEL: 'Annuler',
      },
      DELETE: {
        TITLE: '  Supprimer Equipe',
        DESC_1: 'Suppression équipe ...',
        DESC_2: 'Êtes-vous sûr de supprimer définitivement cette equipe?',
        BTN_DELETE: 'Supprimer',
        BTN_CANCEL: 'Annuler',
      },
    },
    SERVICE: {
      LIST: {
        TITLE: 'Liste des services',
        BTN_ADD: 'Nouveau service',
        SEARCH: 'Rechercher ',
        FIELD: 'dans tous les domaines',
        NAME: 'Nom du service',
        SITE: 'nom du site',
        ACTIONS: 'Actions',
      },
      EDIT: {
        Edit: 'Modifier',
        Create: 'Créer un nouveau service',
        SERVICE: ' le service',
        NAME: 'Nom du service',
        SITE: 'Sélectionnez le Site',
        si: 'Site',
        BTN_SAVE: 'Sauvegarder',
        BTN_CANCEL: 'Annuler',
        RESP_SERVICE: 'Responsable de service',
        AMBASSADEUR_SERVICE: 'Ambassadeur de service',
      },
      DELETE: {
        TITLE: '  Supprimer service',
        DESC_1: 'suppresion Service...',
        DESC_2: 'Êtes-vous sûr de supprimer définitivement ce service?',
        BTN_DELETE: 'Supprimer',
        BTN_CANCEL: 'Annuler',
      },
    },
    USER_PROFILE,
    DASHBOARD: {
      MYACTIVITY: 'Taux implication Global',
      RDVFINICHED: 'Rendez-vous terminés',
      RDVREFUSED: 'Rendez-vous refusés',
      NOTEMOY: 'Note moyenne',
      RDVACCEPTED: 'Rendez-vous acceptés',
    },
    DASHBOARD1: {
      MESRDV: 'Mes rendez-vous',
      MESRDVonboarding: 'Tes rendez-vous',

      ABSCENCERDV: 'Pas de rendez-vous pour le moment',
      VOIR: 'Voir tout',
      EQUIPE: 'Ton équipe',
      ABSEQUIPE: 'Pas de membres dans ton équipe pour le moment.',
      BUDDY: 'Ton buddy',
      ABSBUDDY: 'Aucun buddy',
      INFORMATIONSCONTACT: 'Informations de contact',
      ABSINFORMATIONSCONTACT: 'Pas encore existant',
      ACCEUILPREMIERJOUR: "La personne qui t'accueillera",
      ABSACCEUILPREMIERJOUR: "La personne qui t'accueillera n'est pas encore attribuée.",
      INCONNU: 'Inconnu',
      Compte: 'Compte à rebours',
      Jours: 'jours',
      Heures: 'heures',
      Minutes: 'minutes',

      Precedent: 'Précédent',
      Suivant: 'Suivant',
      CONGRAT: 'Envoyer les félicitations',
      ANNIVERSAIRE: "Aujourd'hui, c'est l'anniversaire de",
      CARTEDEJOUR: 'Tes cartes du jour',
      ABSCENCERECRUE: 'Pas de nouveaux arrivants',
      DEMANDECAFE: 'Offrez lui un café',
      RECONNAISSANCE: 'Reconnaissance',
      // Accroche du bandeau éditorial de la carte de reconnaissance.
      RECONNAISSANCE_SUBTITLE: 'Valorisez les réussites et les attentions du quotidien',
      RECONNAISSANCE_TAGLINE: 'Des petits mots, un grand impact',
      // Interactions accessibles du flux social de reconnaissance.
      RECOGNITION_TO: 'à',
      RECOGNITION_LIKE: 'Aimer cette reconnaissance',
      RECOGNITION_UNLIKE: 'Retirer mon like de cette reconnaissance',
      RECOGNITION_SHOW_LIKERS: 'Voir les {{count}} personnes qui aiment cette reconnaissance',
      RECOGNITION_LIKED_BY: 'Aimé par',
      RECOGNITION_LIKES_LOADING: 'Chargement des personnes…',
      RECOGNITION_LIKES_ERROR: 'Impossible de charger la liste.',
      RECOGNITION_OTHER: 'Reconnaissance',
      RECOGNITION_UNKNOWN_USER: 'Ancien collaborateur',
      RECOGNITION_TODAY: "Aujourd’hui",
      RECOGNITION_YESTERDAY: 'Hier',
      RECOGNITION_DAYS_AGO: 'Il y a {{count}} jours',
      RDVPROCHAIN: 'Vos prochains Rendez-vous',
      WITH: 'Avec',
      Restaurant: 'Restaurant',
      GROWTITLE: 'Fais grandir ta carrière',
      GROWMSG1: 'Partage des moments de convivialité avec tes collègues et élargis ton réseau !',
      GROWMSG2: "Bravo 👏 ton réseau s'étoffe, continue d'accroitre ta visibilité !",
      GROWMSG3: "Bravo 👏 tu as bien développé ton réseau, continue à l'entretenir ! ",
      POTENTIELTITLE: 'Le potentiel de ton profil',
      POTENTIELMSG1: 'Renseigne ton profil pour briser plus facilement la glace.',
      POTENTIELMSG2: 'Bravo 👏 ton profil est au maximum de son potentiel!',
      POTENTIELMSG3: 'Vous êtes à la  position ',
      POTENTIELMSG4: '  des top miameurs!',
      POTENTIELMSG5: 'Merci de faire des rendez-vous pour augmenter votre position!',
      PROCHAINRDV: 'Prochains rendez-vous',
      ABSRESTAURANT: 'Lieu à définir',
      ABSRDV: 'Pas de rendez-vous planifiés',
      ABSRDV2: "Vous n 'avez pas de rendez-vous planifiés pour le moment",
      ABSNOTIF: "Vous n'avez pas de notifications pour le moment",

      ABSEQUIPEMOIS: 'Pas de top  équipes pour ce  mois',
      ABSMIAMEURSSEMAINE: 'Pas de top miameurs cette semaine',
      ABSRDV3: 'Pas de top services pour ce mois',
      ABSEVENT: "Pas d'événement planifiés",
      ABSEVENT2: "Vous n'avez pas  d'événements planifiés pour le moment",
      ABSIDEA: "Pas d'idée planifiés",
      ABSIDEA2: "Vous n 'avez pas  d'idée planifiés pour le moment",

      TOPSERVICES: 'Top services du mois',
      ABSSERVICE: 'Classement bientôt disponible',
      RDV: 'Rendez-vous',
      TOP_MIAM_SEMAINE: 'Top miameurs de la semaine',
      JOURSFERIES: 'Jours fériés',
      TOP_MOIS_EQUIPE: 'Top Équipes du mois',
      EVENNEMENT: 'Evenements',
      IDEA: 'Idée collaborateur',
      PARTICIPATION: 'Participation des collaborateurs      ',
      BAROMETRE0: 'Prochaine action:',
      BAROMETRE: 'Lancer le Barométre',
      GO: "J'y vais",
      COLLABS: 'Collaborateurs',
      ACTIVE: 'Actifs',
      GENRE: 'Genre',
      SORTIE: 'Sorties',
      ENTREE: 'Entrées',
      ALERT: 'Alertes',
      QUESTION: 'Questions en attente',
      IDEAOUVERTES: "Nombre d'idées ouvertes",
      DETAILS: 'Plus de détails',
      SELECT: 'Selectionner site ici',
      PARTICIPATIONSER: 'Participation par service',
      ABSSERVICEdash: 'pas des services pour ce site',
      EVOLUTIONQVCT: 'Evolution de la QVCT',
      BAROMETREDASH: 'Barométre QVCT',
      BAROMETRERELATION: 'Relations',
      BAROMETRECONTENU: 'Contenu',
      BAROMETRESANTE: 'Santé',
      BAROMETREEGALITE: 'Egalité',
      BAROMETREMANAGEMENT: 'Management',
      BAROMETRECOMPETENCES: 'Compétences',
      RendezvousDASH: 'Rendez-vous',
      EvenementsDASH: 'Evenements',
      NewsletterDASH: 'Newsletter',
      FormationDASH: 'Formation',
      ideeDASH: 'Boite  à idée',
      SAVEDASH: 'Sauvegarder',
      BIENVENUERECRU: 'Bienvenue aux nouvelles recrues ',
      BIENVENUERECRU1: 'Nous souhaitons la bienvenue à ',
      BIENVENUERECRU2: 'qui intègre notre entreprise dans le service ',
      BIENVENUERECRU3: 'Voir plus',
      BIENVENUERECRU4: 'Offrez lui un café',
      PARRAINEPERSONNE: 'Les personnes que tu parraines',
      ABSPARRAINEPERSONNE: 'aucune personne à parrainer',
      PERSONNESMANAGEES: 'Les personnes que tu manages',
      ABSPERSONNESMANAGEES: 'Aucune personne à manager',
      ANNIF: 'Anniversaires à venir',
      ABSANNIF: "Vous n'avez pas d'anniversaires à venir pour le moment",
      FERIER: 'Jours fériés à venir',
      ABSFERIER: 'Pas de jours fériés à venir',
      TEMPSTRAVAILLE: 'Temps travaillé',
      PAUSEDEPEPUIS: 'En pause depuis',
      COMMENCER: 'Commencer ma journée',
      REPREND: 'Je reprends',
      PAUSE: 'Je fais une pause',
      TERMINERJOURNE: 'Terminer ma journée',
      BIENVENUE: 'Bienvenue',
      BIENVENUEEQUIPE: 'Nous sommes ravis de te compter dans notre équipe!',
      COMPLETEPROFIL: 'Complète ton profil',
      VOICI: 'Voici tes actions à réaliser :',
      VOIRVIDEO: "Voir la video d'accueil",
      SUIVREFORMATION: 'Suivre les formations demandées',
      COMMENCERONB: 'Commencer',
    },
    PARAMETRENOTIFICATION: {
      PARAMETRENOTIF: 'Paramétrage des préférences de notifications',
      NOTIFEMAIL: 'Recevoir les notifications par email',
      NOTIFSLACK: 'Recevoir les notifications par slack',
      NOTIFTEAMS: 'Recevoir les notifications par teams',
    },
    INDICATEUR: {
      BLOCK: "bloquer la valeur de l' indicateur",
      TITLE:
        'Pour prendre en compte les changements il est nécessaire de cliquer sur button save apres remplir les champs ci dessous',
      CONFLITS: 'taux de conflit',
      GESTIONCONFLIS: 'taux de gestion de conflits',
      SATISFACTION: 'taux de satisfaction',
      ENGAGEMENT: 'taux d engagement',
      AUTONOMIE: "taux d'autonomie",
      VARIETETACHE: 'taux de variété de tâches',
      PRODUCTIVITE: 'taux de productivité',
      ERREUR: 'taux d erreur',
      SANTE: "taux d'absentéisme santé",
      STRESS: 'taux de stress professionnel',
      BIENETRE: 'indice de bien_etre',
      BURNOUT: 'taux de burnout',
      MOBILITE: 'taux de mobilité professionnelle',
      PROMOTION: 'taux de promotion interne',
      SCORE: 'score global',
    },
    DASHBOARD2: {
      RDVACC: 'RDVS Acceptés',
      RDVRED: 'RDVS Refusés',
      RSVCAN: 'RDVS Annulés',
    },
    WIZARDS: {
      Bienvenue: 'Bienvenue',
      ADD: 'Adresse',
      ADDSIEGE: 'Adresse du siège social',
      ACCOUNTTYPE: 'Type de compte',
      Organization: 'Organisation',
      Service: 'Service',
      Siege: 'Siège',
      Team: 'Équipe',
      Ended: 'Terminé',
      CYTOA: 'Choisissez votre type de compte',
      IFYOUNEED: "Si vous avez besoin de plus d'informations vous pouvez consulter",
      help: "L'aide en ligne",
      Société: 'Société',
      Équipe: 'Équipe',
      GRP: "Groupe d'amis",
      ENTER: 'Entrez les détails de votre société',
      NOMSOS: 'Nom de votre société',
      SILNOMSOS: "S'il vous plait tapez votre nom de société.",
      Country: 'Pays',
      Ville: 'Ville',
      ENTERCITY: "S'il vous plait tapez votre ville.",
      ENTEREQ: 'Taper les détails de votre équipe',
      ENTERNOMEQ: 'Nom de votre équipe',
      SILENTERNOMEQ: "S'il vous plait tapez votre nom de l'équipe.",
      ENTERGRP: "Taper les détails de votre groupe d'amis",
      ENTERADD: "S'il vous plait tapez votre adresse",
      taille: 'Quelle est la taille de votre entreprise: ',
      ENterGRPNAME: 'Nom de votre groupe',
      SILENTERNOMSos: "S'il vous plait tapez votre nom de société.",
      ServiceDetails:
        "Pour fournir un service intelligent et personnalisé pour chaque collaborateur nous avons besoin de connaitre la position de chacun dans l'entreprise.",
      nomService: 'à quel service êtes vous rattaché(e)',
      SILService: "S'il vous plait tapez votre service.",
      DETAILSDESER: 'Les détails de votre service',
      NOMSERVICE: 'Nom de service',
      TAPEREQ:
        "Pour fournir un service intelligent et personnalisé pour chaque collaborateur nous avons besoin de connaitre la position de chacun dans l'entreprise.",
      NomEQ: ' à quelle équipe êtes vous rattaché(e) ?',
      SILEQ: "S'il vous plait tapez votre équipe.",
      DetailsEQ: 'Les détails de votre équipe',
      REVIEW: 'Vérifiez vos détails et soumettez',
      FELICITATION: 'Félicitations vous êtes prêt à démarrer',
      REQ1: 'Maintenant ajoutez des salariés à:votre entreprise',
      REQ2: 'Membres à votre equipe',
      REQ3: 'Membres à votre groupe',
      Previous: 'Précédent',
      Next: 'Étape suivante',
      Equipe_Trans: 'Équipe transverse qui mène le suivi',
      SITE_Talend: 'Site des collaborateurs bénéficiaires',
      Submit: 'Soumettre',
    },
    DISPO: {
      EMI: {
        title: 'Comment puis-je vous aider ?',
        send: 'Envoyer',
        historique: 'Mon historique',
        poser: 'Poser la question',
        p: "Attention les réponses de l'assistant sont à but informatif et ne peuvent pas se substituer aux conseils d'un expert. WeMiam ne porte aucune responsabilité vis à vis de l'application ou non des conseils et des indications fournies par l'IA qui alimente cet assistant. Si vous avez besoin de réponses plus pointues ou d'assistance, nos experts sont disponibles pour vous aider.",
        contacter: 'Contacter un Expert',
        question: 'Mes questions',
        placeholderquestion:
          'Il est important de préciser votre demande afin que nous puissions vous offrir une réponse adéquate. Veuillez nous donner plus de détails sur ce que vous souhaitez afin que nous puissions comprendre vos besoins et vous aider de la meilleure manière possible.',
      },
      demander: 'Demander à ',
      btn: 'Je suis disponible',
      btnDej: 'Déjeuner',
      btnAfter: 'Après le travail',
      alert: 'Vous êtes déjà enregistré(e) pour cet évènement. ',
      att: 'Attention',
    },
    STRATEGIE: {
      GERER: {
        list: 'Liste des stratégies',
        new: 'Nouvelle stratégie',
        icons: 'Icônes',
        NAME: 'NOM',
        DESCRIPTION: 'DESCRIPTION',
      },
      EDIT: {
        DETAILSSTRATEGIE: 'Détails de la stratégie',
        EDIT: 'Modifier la stratégie',
        event_id: 'Evénement',
        nom: "Nom d'événement",
        HEURE: 'Heure de generation',
        jour_mois: 'Jour de mois',
        jour_semaine: 'Jour de semaine',
        type_frequence: 'Fréquence de génération',
        equipe_cible1: 'Équipe qui bénéficie du Service',
        equipe_cible2: 'Équipe qui met à disposition son calendrier',
        site_cible: ' Site concernée',
        service_cible: 'Service concerné',
        equipetrans_cible: 'Equipe transverse concerné',
        delai: 'Délai de prevenance',
        delai_minimum: "Délai minimum entre deux reservations d'un même membre",
        nbre_mois: 'Nombre de reservations autorisées par mois',
        jours: 'Tous les jours',
        mois: 'Tous les mois',
        semaines: 'Toutes les semaines',
        datedemarrage: 'Date de démarrage',
        type: "Type d'evenement",
        dej: 'Dejeuner',
        petitdej: 'Petit déjeuner',
        after: 'Après le travail',
        diner: 'Dîner',
      },
      DELETE: {
        TITLE: '  Supprimer stratégie',
        DESC_1: 'Suppression stratégie ...',
        DESC_2: 'Êtes-vous sûr de vouloir supprimer définitivement cette stratégie?',
        BTN_DELETE: 'Supprimer',
        BTN_CANCEL: 'Annuler',
      },
      ACTIVATE: {
        TITLE: 'Activer stratégie',
        TITLE1: 'Désactiver stratégie',
        DESC_1: 'Êtes-vous sûr de vouloir activer temporairement cette stratégie?',
        DESC_2: 'Êtes-vous sûr de vouloir désactiver temporairement cette stratégie?',
        BTN_ACTIVATE: 'Activer',
        BTN_DESACTIVATE: 'Désactiver',
        BTN_CANCEL: 'Annuler',
      },
      WIZARDS: {
        taille: 'Quelle est la taille de votre entreprise: ',
        Param: 'Paramétrer votre stratégie',
        ACCOUNTTYPE: 'Type de stratégie',
        Organization: 'Détails',
        Service: 'Date de lancement',
        Detailssp: 'Détails spécifiques',
        Ended: 'Terminé',
        CYTOA: 'Choisissez votre stratégie',
        IFYOUNEED: "Si vous avez besoin de plus d'informations vous pouvez consulter",
        help: "L'aide en ligne",
        ENTER: 'Personnalisez votre stratégie',
        Société: 'Société',
        FREQUENCY: 'Fréquence',
        TYPEEVENT: "Type d'événement",
        JOUR: 'Jour de génération',
        HOUR: "Heure de l'activité",
        site: 'Collaborateurs ciblès',
        plus: 'À quelle date cette stratégie doit-elle démarrer ?',
        demarrage: 'Date de démarrage',
        Previous: 'Précédent',
        Next: 'Étape suivante',
        Submit: 'Soumettre',
        FELICITATION: 'Félicitation, votre stratégie est prête!',
        name: 'Nom de la stratégie',
        duree_min: 'Durée minimum entre deux activités avec le même collaborateur (en mois)',
        duree_min1: 'Durée minimale',
        duree_max: 'Durée maximum entre deux activités avec le même collaborateur (en mois)',
        duree_max1: 'Durée maximale',
        delaiPrev: 'Délai de prévenance minimum (En jours)',
        delaiPrev1: 'Délai de prévenance',
        nbrAct: 'Nombre maximum des rendez-vous',
        nbrAct1: 'Nombre des rendez-vous',
        typeAct: "Type d'activités",
        pas: 'Pas de paramètre spécifique pour cette stratégie',
        delaiMin: "Délai minimum entre deux reservations d'un même membre",
        nbrAu: 'Nombre de reservations autorisées par mois',
        list1: 'Périmètre des collaborateurs qui bénéficient du self service',
        list2: 'Équipe bénéficiant du self service',
        list3: 'Équipe transverse proposant son calendrier',
      },
      DETAILS: {
        nettoyage: 'Nettoyer les rendez-vous',
        reginerer: 'Génèrer les rendez-vous',
        Refresh: 'Rafraîchir',
        generer: 'Génèrer',
        strategieCible: 'Stratégie',
        Collaborateur: 'Collaborateur',
        Status: 'Statut',
        ListRDV: 'Liste des rendez vous',
        ListUSER: 'Liste des utilisateurs bénéficiaires',
        ListUSER1: 'Liste des utilisateurs ouvrant leur calendrier',
        DESC_1: 'Annuler tous les rendez-vous qui ne sont pas terminés quel que soit leur statut',
        DESC_2: 'Régénérer les rendez-vous et envoi des invitations aux collaborateurs',
        DESC_3: 'Êtes-vous sûr de vouloir lancer maintenant',
        minute: "Le régénération des rendez-vous peut prendre jusqu'à une minute",
        BTN_NETOYER: 'Nettoyer',
      },
    },
    TEMPS: {
      CONTRAT_HEURES: 'Heures contractuelles',
    },
    ALERTES: {
      LOADING_ALERTS: 'Chargement des alertes...',
      PLEASE_WAIT: 'Veuillez patienter',
      NO_ALERTS: 'Aucune alerte',
      SENDER: 'Envoyé par',
      MESSAGE: 'Message',
      DATE: 'Date',
    },

    CONTROLEDESAISIE: {
      SessionExpired: 'Votre session est expirée.Veuillez vous reconnecter',
      noSelection: 'Aucune Selection',
      nofound: 'Aucune donnée trouvée',
      FetchFails: "Impossible d'obtenir des données",
      dateDebutBeforeNow: 'La date de début doit être supérieure à la date du jour',
      dateFinAfterDateDebut: 'La date de fin doit être supérieure à la date de debut',
      dateFinBeforeNow: 'La date de fin doit être supérieure à la date du jour',
      dateFinEssai1AfterDateDebut:
        "La date de fin de première période d'essai doit être postérieure à la date de début du contrat",
      dateFinEssai2AfterDateFinEssai1:
        "La date de fin de deuxième période d'essai doit être postérieure à la date de fin de première période d'essai",
      dateInFuture: 'La date ne doit pas être dans le futur.',
      startBeforeEnd: 'La date de début doit être antérieure à la date de fin.',
      sameDate: 'La date de début et de fin ne peuvent pas être identiques.',
      VALID: ' a été saisi correctement',
      required: ' est requis',
      min: ' doit avoir au moins 3 symboles',
      min2: ' doit avoir au moins 2 symboles',
      max: ' devrait avoir un maximum de 500 symboles',
      email: ' format est incorrect',
      min0: ' devrait avoir un nombre superieur a 0',
      max100: ' devrait avoir un nombre inferieur a 100',

      datemin: ' devrait avoir un nombre superieur a 1',
      datemax: ' devrait avoir un nombre inferieur a 32',
      notemin: ' devrait avoir un note superieur ou egal a 0',
      notemax: ' devrait avoir un note inferieur a 6',
      notmatch: ' ne correspondait pas',
      semaineMin: ' devrait avoir un nombre de jours superieur a 1',
      semaineMax: ' devrait avoir un nombre de jours inferieur a 60',
      semaineMin1: 'devrait avoir un nombre de semaines superieur a 1',
      semaineMax1: ' devrait avoir un nombre de semaines inferieur a 5',
      monthMin: 'devrait avoir un nombre de mois inferieur a 1',
      logicDate: 'la date de fin doit être supérieure à la date de début',
      minvalue: 'devrait avoir un nombre superieur ou egal a 0',
      maxvalue: 'devrait avoir un nombre inferieur ou egal a 100',
    },
    GERER: {
      Title: 'Votre organisation ',
      IMAGE: 'Photo',
      nom: 'Nom',
      pays: 'Pays',
      ville: 'Ville',
      USE_LOGO_IN_SIDEBAR: "Utiliser le logo de l'entreprise dans la barre latérale",
      USE_LOGO_IN_SIDEBAR_TOOLTIP:
        "Activez pour afficher le logo de votre entreprise dans le menu latéral. Désactivez pour conserver le logo EmyeHR.",
      BRANDING_COLORS_TITLE: "Couleurs de l'entreprise",
      BRANDING_COLORS_HELP: "Choisissez jusqu'à trois couleurs pour les thèmes des cartes d'entretien.",
      BRAND_PRIMARY_COLOR: 'Couleur primaire',
      BRAND_SECONDARY_COLOR: 'Couleur secondaire',
      BRAND_TERTIARY_COLOR: 'Couleur tertiaire',
      BRAND_COLOR_CLEAR: 'Réinitialiser',
      BRAND_COLOR_INVALID: 'Saisissez une couleur hexadécimale au format #RRGGBB.',
      BRAND_SETTINGS_INVALID: "Les paramètres d'identité visuelle de l'entreprise sont invalides.",
      BRAND_TYPOGRAPHY_TITLE: 'Typographie',
      BRAND_TYPOGRAPHY_HELP: "Choisissez la police utilisée dans la fenêtre de remplissage d'entretien.",
      BRAND_TYPOGRAPHY_DEFAULT: 'Aucune / police actuelle',
      update: 'mettre à jour',
    },
    motdepasse: {
      titre1: 'Changer le mot de passe ',
      titre2: 'Modifier le mot de passe de votre compte',
      btnSave: 'Mettre à jour',
      btnCancel: 'Annuler',
      err1: "Configurez les mots de passe des utilisateurs pour qu'ils expirent périodiquement. Les utilisateurs devront être avertis que leurs mots de passe vont expirer,",
      err2: ' ou ils pourraient être bloqués par inadvertance hors du système !',
      succes: 'Le mot de passe a été changé avec succès',
      verify: 'Vérifiez votre mot de passe actuel',
      currentpwd: 'Mot de passe actuel',
      newpass: 'Nouveau mot de passe',
      verifypass: 'vérifier le mot de passe',
      passwordconfirm: 'Password confirmation',
      passwordRequirements: 'Exigences du mot de passe:',
      minLength: 'Au moins 8 caractères',
      hasUpperCase: 'Au moins une lettre majuscule',
      hasLowerCase: 'Au moins une lettre minuscule',
      hasNumeric: 'Au moins un chiffre',
      hasSpecialChar: 'Au moins un caractère spécial',
    },
    disponibilite: {
      dispo: 'Disponibilités',
      new: 'Nouvelle disponibilité',
      Search: 'Chercher une date',
      all: 'dans tous les domaines',
      jour: 'Jour',
      EVENT: 'Evenement',
    },
    deleteDispo: {
      title: 'Supprimer la disponibilité',
      msg1: 'suppression disponibilité...',
      msg2: 'Êtes-vous sûr de supprimer définitivement cette disponibilité ?',
      btnCancel: 'Annuler',
      btnDelete: 'Supprimer',
    },
    createDisponibilite: {
      title: 'Créer disponibilité',
      new: 'Nouvelle disponibilité',
      date: 'Date',
      créneaux: 'Créneaux',
    },
    status: {
      created: 'créé',
      accepted: 'accepté',
      refused: 'refusé',
      finished: 'achevé',
      canceled: 'annulé',
      notified: 'notifié',
    },
    acceptMyAct: {
      title: 'Activité acceptée',
      info: 'Êtes-vous sûr de vouloir accepter cette activité ?',
      btnCancel: 'Annuler',
      btnAccept: 'Accepter',
    },
    EditMyAct: {
      Edit: 'Éditer',
      Create: 'Créer',
      comment: 'commenter/noter',
      labelComment: 'Commenter',
      valid1: 'Le commentaire a été saisi correctement',
      valid2: 'Le commentaire doit comporter au moins 3 symboles',
      valid3: 'Le commentaire doit avoir un maximum de 10000 symboles',
      btnCancel: 'Annuler',
      btnSave: 'sauvegarder',
    },
    refuseMyAct: {
      title: "Refus d'activité",
      info: 'Êtes-vous sûr de vouloir refuser cette activité ?',
      btnCancel: 'Annuler',
      btnAccept: 'Refuser',
    },
    cancelAct: {
      title: "Annulation de l'activité",
      info: "Êtes-vous sûr d'annuler cette activité ?",
      btnCancel: 'Annuler',
      btnAccept: 'sauvegarder',
    },
    dialogInsc: {
      insc: 'Inscription par lien',
      btn: 'Copier',
    },
    jour: {
      importe: "N'import",
      dimanche: 'Dimanche',
      lundi: 'Lundi',
      mardi: 'Mardi',
      mercredi: 'Mercredi',
      jeudi: 'Jeudi',
      vendredi: 'Vendredi',
      samedi: 'Samedi',
    },
    typeDispo: {
      petitDej: 'Petit déjeuner',
      dej: 'Déjeuner     ',
      afterwork: 'Après le travail',
      diner: 'Diner     ',
    },
    editDispo: {
      Edit: 'Edit',
      Create: 'Créer',
      dispo: 'disponibilité',
      err1: 'Verifier votre donnée ,',
      err2: 'Ouups! disponibilité déjà existe!',
      selectDay: 'Sélectionnez le jour',
      day: 'Jour',
      selectType: 'Sélectionner le genre',
      type: 'Type',
      Cancel: 'Annuler',
      Save: 'Sauvegarder',
    },
    ListeDesJeux: {
      ListJeux: 'liste des jeux',
      jeuxAssoc: 'Jeux associés',
      pasAssoc: 'Jeux non associés',
      joueurs: 'joueurs',
    },
    gameOne: {
      ListJeux: 'liste des jeux ',
      gereAssoc: 'gérer les stratégies associés',
      rein: 'réinisitialiser les stats',
      ListJeuxM: 'retour',
      gereAssocM: 'gérer',
      reinM: 'relancer',
      desc: 'description complète de jeux ',
      points: 'points',
      numFois: 'nombre de fois joué ',
      temp: 'temp de jeux moyen',
      collab: 'les collaborateurs les plus actifs',
      date: 'date de dernière participation',
      numDePart: 'nombre de participation',
      serviceActif: 'les services les plus actifs',
      taux: 'taux de participation',
      derparticipation: 'date de dernière participation',
    },
    popupstart: {
      liste: 'liste des Stratégies',
      assoc: 'associer',
      dissoc: 'dissocier',
      activer: 'activer',
      des: 'désactiver',
      garde: "garde les résultats secret jusqu'a la fin de jeux",
    },
    assocStrat: {
      assoc: 'associer à une stratégie',
      dateD: 'date de début',
      dateF: 'date de fin',
      validate: 'valider',
      annuler: 'annuler',
    },
    sondage: {
      title: 'Liste des sondages',
      icon: 'ICÔNES',
      nom: 'NOM',
      description: 'DESCRIPTION',
      action: 'ACTIONS',
    },
    jeux: {
      play: 'jouer',
      played: 'terminé',
      title: 'Titre du jeu :',
      quit: 'quitter',
      actif: 'inactif',
      timer: 'se termine dans',
      timerDays: 'jours',
    },
    reset: {
      resettitle: 'êtes-vous sûr de vouloir supprimer les statistiques de ce jeu ?',
      resetdesc:
        "AVERTISSEMENT : cela supprimera les statistiques du jeu, y compris le score, le temps joué, le nombre de fois joué pour tous les joueurs appartenant à l'entreprise",
      confirm: 'confirmer',
    },
    wsregister: {
      wsr: "L'INTERFACE DU JEUX EST TEMPORAIREMENT INDISPONIBLE  !",
      wsolution:
        "il semble que l'interface du jeu ne soit pas accessible pour le moment, veuillez patienter jusqu'à ce que le problème soit résolu ou vous pouvez essayer de résoudre ce problème en vous reconnectant à notre site Web. Merci pour votre compréhension",
      annuler: 'annuler',
      déconnecter: 'déconnecter',
    },
    HAUTPOTENTIEL: {
      head: 'Marquer "Haut Potentiel"',
      body: 'Date du fin de tag',
      comnt: 'Laissez un commentaire',
    },
    DETAG: {
      TITLE: ' Supprimer tag collaborateur',

      DESC_2: 'Êtes-vous sûr de supprimer définitivement tag de ce collaborateur ?',
      BTN_DELETE: 'Supprimer',
      BTN_CANCEL: 'Annuler',
    },
    SUIVIPAR: {
      head: 'Marquer "Suivi particulier"',
      body: 'Date du fin de tag',
      comnt: 'Laissez un commentaire',
    },
    DETAGSUIVIPAR: {
      TITLE: ' Supprimer tag collaborateur',

      DESC_2: 'Êtes-vous sûr de supprimer définitivement tag de ce collaborateur ?',
      BTN_DELETE: 'Supprimer',
      BTN_CANCEL: 'Annuler',
    },
    presentation: {
      PERSO_INFO: 'Informations personnelles',
      presentation: 'Presentation',
      CHANGE_PASS: 'Changer le mot de passe',
      parag: 'Presentation',
      date: "Date d'anniversaire",
      hobies: 'Occupations sélectionnés',
      AVAIL: 'Disponibilités',
      succ: 'Profil modifié avec succès',
      allow: 'Types de fichiers autorisés',
      btn: 'Mise à jour',
      COLLAB: 'Collaborateur',
      ENTRE: 'Entreprise',
      EQUIPE: 'Equipe',
      SITE: 'Site',
      SERVICE: 'Service',
      msg: 'To validate your profile click on the update button',
    },
    toastr: {
      evnt: 'Vous êtes enregistré(e) pour cet évènement.',
      link: 'Le lien a ete copier correctement.',
      key: 'La clé a ete copier correctement.',
      gnrl: 'Votre donnée enregistrée avec succès',
      pres_err: 'Veillez selectionner une video de taille moin de 10M!',
      pres_err1: 'Veillez selectionner une video!',
      pres_success: 'Votre donnée enregistrée avec succès',
      idea: "Aucune idée n'est en cours de validation",
      eventinscrit: "Vous êtes inscrit pour l'événement",
      eventA_venir: "N'oubliez pas l'événement",
      prevus: 'prévus',
      eventinscritdate: 'prévu pour la date du',
      titreevent: 'Evénement',
      absabonnementevent: 'Les évènements sont disponible dans une offre supérieure',
      absabonnementidea: 'Les idées des  collaborateurs sont disponible dans une offre supérieure',
      suc: 'Opération réussie',
      err: 'Une erreur est survenue',
    },
    Notification: {
      newnotification: 'Nouvelle Notification',
      rendezvosmeeting: 'Rendez-vous ',
    },
    ANNONCE: {
      NVLANN: 'Nouvelle annonce',
      ANN: 'Annonce',
      LISTANNONCE: 'Liste des annonces',
      MODIFANNONCE: 'Modifier annonce',
      SUPPRIMERANNONCE: 'Supprimer annonce',
      MODAL_CREATE_TITLE: 'Créer une annonce',
      MODAL_EDIT_TITLE: 'Modifier une annonce',
      FIELD_TITLE: "Titre de l'annonce",
      FIELD_DESCRIPTION: 'Description',
      FIELD_START_DATE: "Date de début de l'annonce",
      FIELD_END_DATE: "Date de fin de l'annonce",
      FIELD_TARGET: "Cible de l'annonce",
      PRIORITY_LABEL: 'Niveau de priorité',
      PRIORITY_BASE: 'Priorité standard',
      PRIORITY_BASE_HINT: 'Visibilité par défaut pour tous les collaborateurs',
      PRIORITY_MEDIUM: 'Priorité moyenne',
      PRIORITY_MEDIUM_HINT: 'Mise en avant dans les listes et notifications',
      PRIORITY_HIGH: 'Priorité haute',
      PRIORITY_HIGH_HINT: 'Marquée urgente pour une visibilité immédiate',
      TARGET_MANAGERS: 'Managers',
      TARGET_MANAGERS_PAIE: 'Managers paie',
      TARGET_ADMINS_PAIE: 'Admins paie',
      SELECT_MANAGERS: 'Sélectionner les managers',
      SELECT_MANAGERS_PAIE: 'Sélectionner les managers paie',
      SELECT_ADMINS_PAIE: 'Sélectionner les admins paie',
      SEARCH_USER: 'Rechercher un utilisateur…',
      NO_USER_FOUND: 'Aucun utilisateur ne correspond à votre recherche',
    },
        EDIT_COURRIER_MODAL: {
      EDITOR_NOT_INITIALIZED: "L'éditeur de texte n'est pas initialisé",
      EDITOR_PLACEHOLDER: "Éditez le contenu du courrier...",

      SEND_SUCCESS: "Courrier envoyé avec succès !",
      SEND_ERROR: "Erreur lors de l'envoi du courrier",

      SAVE_SUCCESS: "Courrier modifié avec succès !",
      CONTENT_SAVE_SUCCESS: "Contenu sauvegardé avec succès !",
      CONTENT_SAVE_ERROR: "Erreur lors de la sauvegarde du contenu",

      PDF_GENERATION_ERROR: "Erreur : Impossible de générer le PDF",
      PDF_UPLOAD_ERROR: "Erreur lors de l'upload du PDF",
      PDF_PREVIEW_ERROR: "Erreur lors de la génération de l'aperçu PDF",
      PDF_BLOB_NULL: "La génération du PDF a échoué : résultat vide",
      PDF_CONVERT_ERROR: "Erreur lors de la conversion du PDF en image",

      UNAUTHORIZED_ERROR: "Erreur : Non autorisé (session expirée ?)",
      COURRIER_NOT_FOUND_ERROR: "Erreur : Courrier non trouvé",
      SERVER_ERROR: "Erreur : Problème serveur",

      HEADER_LOAD_PREVIEW_ERROR: "Impossible de charger l'aperçu de l'en-tête",
      HEADER_PROCESSING_WARNING: "Impossible de traiter l'en-tête/pied de page, on continue sans",
      HEADER_S3_ERROR: "Impossible de récupérer l'en-tête depuis le serveur",

      CAMPAIGN_DATA_LOAD_WARNING: "Impossible de charger les données de campagne, on continue sans",

      SIGNATURE_LOAD_WARNING: "Impossible de charger l'image de signature, on ignore",
      SIGNATURE_S3_ERROR: "Erreur lors de la récupération de la signature depuis le serveur",

      CANVAS_CONTEXT_ERROR: "Impossible d'obtenir le contexte du canvas."
      
    },
    COURRIERS_LIST: {
      LOAD_ERROR: "Erreur lors du chargement des courriers",
      PREVIEW_ERROR: "Erreur lors de la prévisualisation du courrier",

      HEADER_NO_NAME: "En-tête sans nom",
      HEADER_LOAD_WARNING: "Impossible de charger les en-têtes, on continue sans",
      HEADER_PROCESSING_WARNING: "Impossible de traiter l'en-tête/pied de page, on continue sans",
      HEADER_S3_ERROR: "Impossible de récupérer l'en-tête depuis le serveur",

      CAMPAIGN_DATA_LOAD_WARNING: "Impossible de charger les données de campagne, on continue sans",

      SIGNATURE_LOAD_WARNING: "Impossible de charger l'image de signature, on ignore",
      SIGNATURE_S3_ERROR: "Impossible de récupérer la signature depuis le serveur",

      PDF_CONVERT_ERROR: "Erreur lors de la conversion du PDF en image",
      CANVAS_CONTEXT_ERROR: "Impossible d'obtenir le contexte du canvas.",

      S3_PDF_LOAD_FALLBACK: "Impossible de charger le PDF depuis le serveur, affichage de la version HTML"
    },
    CAMPAIGN_COURRIER: {
      SETTING_TITLE: 'Module Courrier',
      SETTING_ENABLED: 'Activé',
      TITLE: 'Campagne Courrier',
      LIST: 'Liste des campagnes',
      CREATE: 'Créer une campagne',
      EDIT_CAMPAIGN: 'Modifier la campagne',
      DELETE: 'Supprimer la campagne',
      MODAL_CREATE_TITLE: 'Créer une campagne courrier',
      MODAL_EDIT_TITLE: 'Modifier la campagne courrier',
      FIELD_TITLE: 'Titre de la campagne',
      FIELD_DESCRIPTION: 'Description',
      FIELD_START_DATE: 'Date de début',
      FIELD_END_DATE: 'Date de fin',
      FIELD_TARGET: 'Cible de la campagne',
      PRIORITY_LABEL: 'Niveau de priorité',
      PRIORITY_BASE: 'Priorité standard',
      PRIORITY_MEDIUM: 'Priorité moyenne', 
      PRIORITY_HIGH: 'Priorité haute',
      DESCRIPTION: "Description",
      NBR_COLLABS: "Nb collabs ciblés",
      NBR_COURRIERS: "Nb courriers envoyés",
      CREATED_BY: "Créé par",
      UPDATED_AT: "Mise à jour",
      EDIT_REMETTANT: "Modifier le remettant",
      SELECT_REMETTANT: "Sélectionner un remettant",
      REMETTANT_UPDATED: "Remettant mis à jour avec succès",
      REMETTANT_UPDATE_ERROR: "Erreur lors de la mise à jour du remettant",
      CONFIGURATION: 'Configuration',
      MODIFICATION_VISUALIZATION: 'Modification et visualisation',
      COURIER_MANAGEMENT: 'Gestion des courriers',
      CAMPAIGN_SETTINGS: 'Paramètres de la campagne',
      CAMPAIGN_NAME: 'Nom de la campagne',
      CAMPAIGN_NAME_PLACEHOLDER: 'Ex: Campagne Augmentation 2024',
      CAMPAIGN_NAME_REQUIRED: 'Le nom est requis.',
      DESCRIPTION_PLACEHOLDER: 'Description de la campagne...',
      HEADER_PAPER: 'Papier en-tête',
      SELECT_HEADER: 'Sélectionner un en-tête',
      HEADER_REQUIRED: "L'en-tête est requis.",
      WHO_DELIVERS_MAIL: 'Qui remet le courrier ?',
      SELECT_MANAGER: 'Sélectionner un responsable',
      FIELD_REQUIRED: 'Champ requis.',
      DESIGNATED_COLLABORATOR: 'Collaborateur désigné',
      SEARCH_COLLABORATOR: 'Rechercher un collaborateur...',
      COURIER_CONTENT: 'Contenu du courrier',
      COLLABORATOR_DATA: 'Données Collaborateur',
      SEARCH: 'Rechercher',
      YEAR: 'Année',
      REDUCE: 'Réduire',
      SHOW_MORE: 'Afficher plus',
      NO_DATA_FOUND: 'Aucune donnée trouvée pour "{{searchText}}"',
      CONTENT_REQUIRED: 'Le contenu est requis.',
      PREVIEW_RENDER: 'Aperçu du rendu',
      GENERATE_PDF_PREVIEW: 'Générer l\'aperçu PDF',
      NO_HEADER_LOADED: '(Aucun en-tête chargé)',
      GENERATING_PDF_PREVIEW: 'Génération de l\'aperçu PDF...',
      GENERATING_COURRIERS: 'Génération des courriers en cours...',
      GENERATING_COURRIER_FOR: 'Génération du courrier',
      COURRIERS_GENERATED_SUCCESS: '{{count}} courrier(s) généré(s) avec succès',
      COURRIERS_GENERATED_WITH_DUPLICATES: '{{generated}} courrier(s) généré(s), {{duplicates}} déjà existant(s)',
      ALL_COURRIERS_ALREADY_EXIST: '{{count}} courrier(s) existent déjà pour ces collaborateurs',
      COURRIERS_GENERATION_ERRORS: '{{count}} erreur(s) lors de la génération',
      CREATE_CAMPAIGN_CONTINUE: 'Créer campagne et continuer',
      CREATING: 'Création...',
      COURIER_LIST: 'Liste des courriers',
      ADD_COLLABORATOR: 'Ajouter un collaborateur',
      SEARCH_COLLABORATOR_NAME: 'Rechercher par nom de collaborateur...',
      SEARCH_BY_REMETTANT_NAME: 'Rechercher par nom du remettant...',
      NAME_FIRSTNAME: 'Nom et prénom',
      STATUS: 'Statut',
      DELIVERED_BY: 'Remis par',
      DELIVERY_FILTER: 'Remise',
      CONSULTATION_FILTER: 'Consultation',
      ALL_DELIVERY_STATUSES: 'Tous les statuts de remise',
      ALL_CONSULTATION_STATUSES: 'Tous les statuts de consultation',
      DELIVERED: 'Remis',
      CONSULTED: 'Consulté',
      ACTIONS: 'Actions',
      PREVIEW: 'Prévisualiser',
      EDIT: 'Modifier',
      SEND: 'Enregistrer et Envoyer',
      NO_LETTER_ADDED: 'Aucun courrier ajouté pour le moment.',
      PREVIOUS: 'Précédent',
      NEXT: 'Suivant',
      CANCEL: 'Annuler',
      EXIT: 'Quitter',
      ADD_LETTER: 'Ajouter un courrier',
      SEARCH_BY_COLLABORATOR_NAME: 'Rechercher par nom de collaborateur...',
      EDIT_LETTER: 'Modifier le courrier - {{prenom}} {{nom}}',
      LETTER_CONTENT: 'Contenu du courrier',
      SAVE: 'Enregistrer',
      SELECT_TARGET: 'Sélectionner la cible',
      TARGET: 'Cible',
      SINGLE_COLLABORATOR: 'Collaborateur unique',
      SITES: 'Site(s)',
      SERVICES: 'Service(s)',
      TEAMS: 'Équipe(s)',
      PAYROLL_MANAGERS: 'Manager paies',
      PAYROLL_ADMINS: 'Admins paies',
      SELECT: 'Sélectionner',
      COLLABORATOR: 'Collaborateur',
      CONFIRM: 'Confirmer',
      MANAGE_LETTERS: 'Gestion des courriers',
      NO_LETTER_ADDED_YET: 'Aucun courrier ajouté pour le moment.',
      FORMULA_CALCULATION_TEST: 'Test de Calcul des Formules',
      LAUNCH_ALL_TESTS: 'Lancer tous les tests',
      CALCULATION_IN_PROGRESS: 'Calcul en cours...',
      RESET: 'Réinitialiser',
      CALCULATION_RESULTS: 'Résultats des calculs',
      VARIABLE: 'Variable',
      CODE: 'Code',
      TYPE: 'Type',
      FORMULA: 'Formule',
      RESULT: 'Résultat',
      SUCCESS_STATUS: 'Succès',
      ERROR_MSG: 'Erreur',
      MISSING: 'Manquant',
      ERROR_STATUS: 'Erreur',
      SUCCESS: 'Succès',
      MISSING_COUNT: 'Manquants',
      ERRORS: 'Erreurs',
      TOTAL: 'Total',
      NO_TEST_EXECUTED: 'Aucun test exécuté',
      CLICK_LAUNCH_TESTS: 'Cliquez sur "Lancer tous les tests" pour commencer le calcul des formules.',
      MANAGE_COURIER: 'Gérer les courriers',
      SENT: 'Envoyé',
      DRAFT: 'Brouillon',
      DELETED: 'Supprimé',
      DELETE_LETTER: "Supprimer le courrier",
      DELETE_LETTER_CONFIRM: "Êtes-vous sûr de vouloir supprimer ce courrier ?",
      DELETE_LETTER_IMPOSSIBLE: "Impossible de supprimer ce courrier. Il est peut-être déjà utilisé.",
      DELETE_LETTER_IRREVERSIBLE: "Cette action est irréversible.",
      DELETING_LETTER: "Suppression du courrier...",
      COURRIER_DELETED_SUCCESS: "Courrier supprimé avec succès",
      COURRIER_DELETE_ERROR: "Erreur lors de la suppression du courrier",
      FORMULA_HELP_TITLE: 'Formules Mathématiques',
      FORMULA_HELP_TEXT: 'Vous pouvez insérer des formules mathématiques qui seront calculées automatiquement. Les formules doivent commencer par le signe "=".',
      FORMULA_EXAMPLES_TITLE: 'Exemple de formule : ={{a}}+{{b}}',
      RETURN_TO_DRAFT: "Retour au brouillon",
      RETURN_TO_DRAFT_CONFIRM: "Êtes-vous sûr de vouloir retourner ce courrier au brouillon ?",
      RETURNING_TO_DRAFT: "Retour au brouillon en cours...",
      COURRIER_RETURNED_SUCCESS: "Courrier retourné au brouillon avec succès",
      COURRIER_RETURN_ERROR: "Erreur lors du retour du courrier au brouillon",
      EDIT_TEMPLATE: "Modifier le template",
      TEMPLATE_MODIFICATION_WARNING: "Attention : La modification de ce template n'affectera pas les courriers déjà générés. Seuls les nouveaux courriers utiliseront ce template mis à jour.",
      SIGNATURES: 'Signatures',
      SIGNATURE: 'Signature',
      SIGNATURE_UPLOAD: 'Télécharger la signature',
      SIGNATURE_POSITION: 'Position de la signature',
      SIGNATURE_PREVIEW: 'Aperçu de la signature',
      NO_SIGNATURES: 'Aucune signature ajoutée',
      ADD_SIGNATURES: 'Ajouter une signature',
      SIGNATURE_IMAGE_SPECS: 'L\'image doit être de 800x800 pixels et ne pas dépasser 200Ko',
      SIGNATURE_FORMAT_INFO: 'Format recommandé : PNG ou JPG, 800x800px, max 200Ko',
      SIGNATURE_SIZE: 'Taille de la signature',
      REMETTANT_FETCH_WARNING: "Impossible de récupérer le remettant, on continue sans",

      STEP1_REQUIRED_FIELDS: "Veuillez remplir tous les champs obligatoires avant de continuer.",
      COMPLETE_PREVIOUS_STEPS: "Veuillez compléter les étapes précédentes avant de continuer.",
      FORMS_INVALID: "Veuillez vérifier les formulaires.",

      HEADER_NO_NAME: "En-tête sans nom",
      HEADER_LOAD_ERROR: "Impossible de charger la liste des en-têtes",
      HEADER_FILE_NOT_FOUND: "Fichier introuvable pour cet en-tête.",
      HEADER_PREVIEW_ERROR: "Impossible de visualiser le document.",
      HEADER_LOAD_PREVIEW_ERROR: "Impossible de charger l'aperçu de l'en-tête",
      HEADER_PROCESSING_WARNING: "Impossible de traiter l'en-tête/pied de page, on continue sans",

      COLLABORATORS_LOAD_ERROR: "Impossible de charger les collaborateurs",
      COLLABORATORS_FETCH_ERROR: "Erreur lors de la récupération des collaborateurs",
      NO_COLLABORATORS_FOUND: "Aucun collaborateur trouvé pour cette cible",

      VARIABLES_LOAD_ERROR: "Impossible de charger la liste des variables depuis les données de paies.",
      PAIES_DATA_LOAD_WARNING: "Impossible de charger les données de paie, on continue sans",

      CAMPAIGN_ALREADY_CREATED: "La campagne est déjà créée. Vous ne pouvez plus modifier le template.",
      CAMPAIGN_AUTO_CREATED: "Campagne créée automatiquement avec succès",
      CAMPAIGN_AUTO_CREATE_ERROR: "Erreur lors de la création automatique",
      CAMPAIGN_CREATED: "Campagne créée avec succès",
      CAMPAIGN_CREATE_ERROR: "Erreur lors de la création",
      CAMPAIGN_DATA_LOAD_WARNING: "Impossible de charger les données de campagne, on continue sans",
      CAMPAIGN_SIGNATURES_LOAD_WARNING: "Impossible de charger les signatures de la campagne, on continue sans",

      EDITOR_INIT_ERROR: "Impossible d'initialiser l'éditeur de texte",
      EDITOR_NOT_INITIALIZED: "L'éditeur de texte n'est pas initialisé",

      PDF_PREVIEW_GENERATED: "Aperçu PDF généré !",
      PDF_PREVIEW_ERROR: "Erreur lors de la génération de l'aperçu PDF",
      PDF_PREVIEW_FALLBACK: "Impossible de générer le PDF, affichage en HTML",
      PDF_BLOB_NULL: "La génération du PDF a échoué : résultat vide",
      PDF_BLOB_EMPTY: "Le PDF généré est vide",
      PDF_COURRIER_PREVIEW_SUCCESS: "Aperçu PDF généré pour {{prenom}} {{nom}} !",

      CANVAS_CONTEXT_ERROR: "Impossible d'obtenir le contexte du canvas.",

      SIGNATURE_BUILD_ERROR: "Erreur lors de la construction de l'élément signature",
      SIGNATURE_LOAD_ERROR: "Erreur lors du chargement de l'image de signature",
      SIGNATURE_S3_ERROR: "Impossible de récupérer la signature depuis le serveur",
      SIGNATURE_UPLOAD_ERROR: "Erreur lors de l'upload de la signature",
      SIGNATURE_SIZE_EXCEEDED: "L'image ne doit pas dépasser 200 Ko",
      SIGNATURE_DIMENSIONS_EXCEEDED: "Les dimensions de l'image ne doivent pas dépasser 800x800px",
      SIGNATURE_REMOVED: "Signature supprimée avec succès",

      COURRIER_UPDATED: "Courrier modifié avec succès !",
      COURRIER_GENERATION_COLLAB_ERROR: "Erreur pour le collaborateur {{id}}",
      COURRIERS_LOAD_ERROR: "Erreur lors du chargement des courriers pour cette campagne",
      COURRIERS_GENERATED: "{{count}} courrier(s) généré(s) avec succès",
      COURRIERS_ALREADY_EXIST: "{{count}} courrier(s) existent déjà pour ces collaborateurs",

      RETURN_TO_DRAFT_SUCCESS: "Courrier retourné au brouillon avec succès",
      RETURN_TO_DRAFT_ERROR: "Erreur lors du retour du courrier au brouillon",

      AI_TEST_SELECT_COLLABORATOR: "Veuillez sélectionner un collaborateur",
      AI_TEST_EMPTY_TEMPLATE: "Le contenu du courrier est vide",
      AI_TEST_SUCCESS: "Aperçu généré avec succès",
      AI_TEST_ERROR: "Erreur lors de la génération",
      AI_GENERATION_ERROR: "Erreur lors de la génération IA",
      AI_GENERATION_FALLBACK_WARNING: "La génération IA a échoué, utilisation du template brut",

      SELECT_HEADER_FIRST: "Veuillez sélectionner un en-tête d'abord.",

      UNKNOWN_NOM: "Nom inconnu",
      UNKNOWN_PRENOM: "Prénom inconnu",

      DELIVERED_DIRECTLY: "Remis directement",

      DELETE_CANCELLED: "Suppression annulée",
      READING_DATE: "Date de lecture",
      DELIVERY_DATE: "Date de remise",
      NOT_CONSULTED: "Non consulté",
      NOT_DELIVERED: "Non remis",
      INVALID_DATE: "Date invalide",
      MARK_AS_DELIVERED: "Marquer comme remis",
      MARK_AS_DELIVERED_SUCCESS: "Courrier marqué comme remis avec succès",
      MARK_AS_DELIVERED_ERROR: "Erreur lors du marquage du courrier comme remis",
      READY: 'Prêt',
      SAVE_READY: 'Enregistrer prêt à l\'envoi',
      MARK_AS_READY: 'Marquer comme prêt',
      COURRIER_MARKED_READY: 'Courrier marqué comme prêt avec succès',
      COURRIER_READY_ERROR: 'Erreur lors du marquage du courrier comme prêt',
      IMAGE_FORMAT_NOT_SUPPORTED: 'Format d\'image non supporté. Formats supportés: PNG, JPEG, JPG',
      SIGNATURE_FORMAT_ERROR: 'Format d\'image de signature non supporté',
      HEADER_FORMAT_ERROR: 'Format d\'image d\'en-tête non supporté',
      MUST_SAVE_BEFORE_STEP3: 'Veuillez d\'abord enregistrer la campagne.',

      DOWNLOAD_PDF: 'Télécharger le PDF',
      DOWNLOAD_PDF_TITLE: 'Télécharger le PDF du courrier',
      PDF_DOWNLOAD_SUCCESS: 'PDF téléchargé avec succès',
      PDF_DOWNLOAD_ERROR: 'Erreur lors du téléchargement du PDF',
      // Translate the optional response configuration and administrator campaign results.
      RESPONSE_REQUIRED: 'Réponse du collaborateur',
      RESPONSE_REQUIRED_HELP: 'Demander un choix au collaborateur pour cette campagne',
      RESPONSE_QUESTION: 'Question',
      RESPONSE_QUESTION_PLACEHOLDER: 'Ex : Acceptez-vous cette proposition ?',
      RESPONSE_OPTIONS: 'Choix proposés',
      ADD_RESPONSE_OPTION: 'Ajouter un choix',
      RESPONSE_CONFIGURATION_INVALID: 'Saisissez une question et au moins deux choix différents.',
      RESULTS: 'Résultats',
      TARGETED: 'Collaborateurs ciblés',
      RESPONDENTS: 'Répondants',
      NON_RESPONDENTS: 'Sans réponse',
      RESPONSE_RATE: 'Taux de réponse',
      ANSWER: 'Réponse',
      RESPONSE_DATE: 'Date de réponse',
      NO_RESPONSE: 'Sans réponse',
      NO_RESPONSE_QUESTION: 'Cette campagne ne demande aucune réponse.',
      RESULTS_LOAD_ERROR: 'Erreur lors du chargement des résultats.',
      // Traductions de la configuration multi-questions et de la réponse libre.
      QUESTION: 'Question',
      ADD_QUESTION: 'Ajouter une question',
      OPTION_PLACEHOLDER: 'Choix',
      ALLOW_FREE_TEXT: 'Autoriser une réponse libre',
      QUESTION_CONFIGURATION_INVALID: 'Question incomplète : libellé requis, deux choix différents ou réponse libre autorisée.',
      FREE_TEXT_ANSWERS: 'Réponses libres'



    },
    MES_COURRIERS: {
      TITLE: "Mes Courriers",
      SEARCH_BY_COLLABORATOR_NAME: "Rechercher par nom de collaborateur",
      NAME_FIRSTNAME: "Nom & Prénom",
      CONSULTATION_DATE: "Date de consultation",
      ACTIONS: "Actions",
      PREVIEW: "Aperçu",
      NOT_CONSULTED: "Non consulté",
      NO_LETTER_FOUND: "Aucun courrier trouvé", 
      LOADING_PREVIEW: "Chargement de l'aperçu...",
      CLOSE: "Fermer",
      MY_LETTERS: "Mes Courriers",
      TEAM_LETTERS: "Courriers de mon équipe",
      MY_LETTERS_NO_LETTER_FOUND: "Aucun courrier trouvé",
      TEAM_LETTERS_NO_LETTER_FOUND: "Aucun courrier trouvé pour l'équipe",
      CAMPAIGN: 'Campagne',
      SEARCH_BY_CAMPAIGN: 'Rechercher par campagne',
      DELIVERY_DATE: "Date de remise",
      NOT_DELIVERED: "Non remis",
      INVALID_DATE: "Date invalide",
      DECLARE_AS_DELIVERED: "Déclarer comme remis",
      MARK_AS_DELIVERED_SUCCESS: "Courrier marqué comme remis avec succès",
      MARK_AS_DELIVERED_ERROR: "Erreur lors du marquage du courrier comme remis",
      // Translate the collaborator confirmation and immutable recorded response state.
      RESPONSE_CONFIRM: "Confirmer définitivement la réponse « {{option}} » ?",
      FREE_TEXT_PLACEHOLDER: "Ou saisissez votre réponse libre…",
      SUBMIT_RESPONSES: "Envoyer mes réponses",
      RESPONSES_INCOMPLETE: "Répondez à toutes les questions avant d’envoyer.",
      RESPONSES_CONFIRM: "Vos réponses seront enregistrées définitivement et ne pourront plus être modifiées.",
      RESPONSE_CONFIRM_TITLE: "Confirmer votre réponse",
      RESPONSE_CONFIRM_OK: "Confirmer",
      RESPONSE_CONFIRM_CANCEL: "Annuler",
      RESPONSE_SUCCESS: "Votre réponse a bien été enregistrée.",
      RESPONSE_ERROR: "Impossible d'enregistrer votre réponse.",
      YOUR_RESPONSE: "Votre réponse",
      REMETTANT_FETCH_WARNING: "Impossible de récupérer le remettant, on continue sans",
      PDF_DELETE_ERROR: "Erreur lors de la suppression du PDF",
      
    },
    AI_COURRIER: {
      VERIFICATION_AGENT: {
          LABEL: "Agent de contrôle",
          TOOLTIP: "Vérifie et corrige automatiquement certaines erreurs. Les résultats peuvent ne pas être toujours exacts.",
          DESCRIPTION: "L’agent de contrôle corrige automatiquement certaines erreurs pour vous aider, mais les résultats peuvent ne pas être toujours exacts.",
          STATUS_ENABLED: "Agent de contrôle activé",
          STATUS_DISABLED: "Agent de contrôle désactivé",
          CREDIT_WARNING_TITLE: "Consommation de crédits supplémentaires",
          CREDIT_WARNING_DESC: "L'agent de contrôle effectue une vérification supplémentaire du contenu généré. Cela consomme plus de crédits IA par courrier généré."
      },
      AI_INSTRUCTIONS: {
        TITLE: "Instructions IA personnalisées",
        DESCRIPTION: "Définissez les conditions pour inclure ou exclure des sections du courrier (ex: promotion, dépassement différé, etc.)",
        DEFAULT: "Choisissez ‘Monsieur’ si le genre du collaborateur est M, et ‘Madame’ si c’est F.",
        PLACEHOLDER: "Ex: Si bonus_2025 > 10000, inclure le paragraphe promotion.\nSi la somme des colonnes X + Y + Z dépasse 50000, c'est un cas de dépassement du différé.",
        SEARCH_VARIABLE: "Rechercher une variable à insérer...",
      },
      AI_TEST: {
        BUTTON: "Tester avec IA",
        BUTTON_TITLE: "Tester le courrier avec un collaborateur",
        PANEL_TITLE: "Test IA avec collaborateur",
        SELECT_COLLABORATOR: "Sélectionner un collaborateur pour tester",
        SEARCH_PLACEHOLDER: "Rechercher un collaborateur...",
        GENERATE: "Générer l'aperçu IA",
        GENERATING: "Génération en cours...",
        RESULT_TITLE: "Résultat de la génération IA",
        SUCCESS: "Aperçu généré avec succès",
        ERROR: "Erreur lors de la génération IA",
        EMPTY_TEMPLATE: "Le contenu du courrier est vide",
      },
      DEFAULT_TEMPLATE: `<p style="text-align: right;">Paris le XX/XX/XXXX</p>
<p style="text-align: right;">&nbsp;</p>
<p style="text-align: right;">A l'attention de [Monsieur/Madame] {{nom}}</p>
<p>&nbsp;</p>
<p><strong>Objet : Rémunération 2026</strong></p>
<p>&nbsp;</p>
<p>[Monsieur/Madame],</p>
<p>&nbsp;</p>
<p>J'ai le plaisir de vous annoncer que votre rémunération variable attribuée au titre de 2025 s'élève à =({{bonus_n_euro}}+{{portion_differee_2026}}+{{portion_differee_2027}}+{{portion_differee_2028}}) euros, se décomposant comme suit conformément à la politique de rémunération de XXXX en vigueur :</p>
<p>&nbsp;</p>
<ul>
<li>{{bonus_n_euro}} euros bruts versés en mars 2026 au titre du bonus,</li>
<li>=({{portion_differee_2026}}+{{portion_differee_2027}}+{{portion_differee_2028}}) euros bruts total sous forme de rémunération variable différée et à acquérir par tiers sur les 3 prochaines années sous conditions (2027,2028,2029)<sup>1</sup></li>
</ul>
<p>&nbsp;</p>
<p>J'ai également le plaisir de vous annoncer que vous êtes promu au poste de {{nouvelle_fonction_promo}}. Votre rémunération de base annuelle (temps plein) est portée à {{salaire_fixe_n_propose_euro}} euros bruts à compter du 1<sup>er</sup> janvier 2026, soit une augmentation de ={{salaire_fixe_n_propose_euro}}-{{salaire_fixe_n_1_euro}} euros.</p>
<p>&nbsp;</p>
<p>Je vous remercie de votre contribution aux résultats de l'entreprise et je vous prie d'agréer,</p>
<p>[Monsieur/Madame], l'expression de mes salutations distinguées.</p>
<p>&nbsp;</p>
<p style="text-align: right;"><strong>XXXX</strong></p>
<p style="text-align: right;">Directeur Général Délégué</p>`,
    },
    CONGE: {
      conge: 'Congés',
      new: 'Nouveaux congés',
      dateDebut: ' Date debut',
      dateFin: ' Date fin',
      EDIT: {
        NEW: 'Nouveaux congés',
        date_début: 'Date de début',
        debut_ms: 'Debut',
        date_fin: 'Date de fin',
        fin_ms: 'Fin',
      },
      DELETE: {
        TITLE: ' Supprimer congés',

        DESC_2: 'Êtes-vous sûr de vouloir supprimer définitivement ce congé?',
      },
    },
    PRESENTAION: {
      info: 'Informations sur ',
      VIDEO: 'Vidéo',
      Presentation: 'Présentation',
      HOBIES: 'Passe-temps',
      NOTAVAILBLE: ' indisponible',
    },
    Planning: {
      LIST: {
        TITLE: 'Planning',
        SITE: 'Site ',
        DT_BEBUT: 'Date de début',
        DT_FIN: 'Date de fin',
        BTN: 'Nouveau déplacement',
      },
      EDIT: {
        TITLE: 'Créer planning',
        TITLE1: 'Modifier planning',
        SITE: 'Select Site',
        DT_BEBUT: 'Date de début',
        DT_FIN: 'Date de fin',
      },
      DELETE: {
        TITLE: 'Supprimer le planning',
        CONTENT: ' Suppression déplacement ...',
        CONTENT2: 'Êtes-vous sûr de supprimer définitivement ce déplacement ?',
      },
    },
    TopBar: {
      ESPACE1: 'Espace administrateur',
      ESPACE2: 'Espace salarié',
    },
    CRON: {
      EVERY_MINUTE: 'Toutes les minutes',
      HOURLY_AT_MINUTE: 'Toutes les heures à la minute {{minute}}',
      DAILY_AT_TIME: 'Tous les jours à {{hour}}:{{minute}}',
      WEEKLY_ON_DAY_AT_TIME: 'Tous les {{day}} à {{hour}}:{{minute}}',
      MONTHLY_ON_DAY_AT_TIME: 'Tous les mois le {{day}} à {{hour}}:{{minute}}',
      CUSTOM_SCHEDULE: 'Planification',
      SUNDAY: 'Dimanche',
      MONDAY: 'Lundi',
      TUESDAY: 'Mardi',
      WEDNESDAY: 'Mercredi',
      THURSDAY: 'Jeudi',
      FRIDAY: 'Vendredi',
      SATURDAY: 'Samedi',
    },
    NOTIFICATIONS: {
      TITLE: 'Notifications et planifications',
      TABS: {
        NEW: 'Nouvelles',
        ALL: 'Toutes',
        PLANS: 'Planifications',
      },
      NO_NEW_ALERTS: 'Aucune nouvelle alerte',
      NO_ALERTS: 'Aucune notification',
      NO_PLANS: 'Aucune planification active',
      PLANS: {
        TITLE: 'Planification Emye',
        QUERY: 'Requête',
        SCHEDULE: 'Programmation',
        PERIOD: 'Période',
        STATUS: 'Statut de la dernière exécution',
        STATUS_SUCCESS: 'Succès',
        STATUS_ERROR: 'Échec',
        STATUS_PENDING: 'En attente',
        DELETE: 'Supprimer',
        DELETE_CONFIRM_TITLE: 'Supprimer la planification',
        DELETE_CONFIRM_MESSAGE:
          'Êtes-vous sûr de vouloir supprimer cette planification? Cette action est irréversible.',
        DELETE_SUCCESS: 'Planification supprimée avec succès',
        DELETE_ERROR: 'Erreur lors de la suppression de la planification',
        LOAD_ERROR: 'Erreur lors du chargement des planifications',
        LAST_RUN: 'Dernière exécution',
        STATUS_FAILED: 'Échec',
        STATUS_RUNNING: 'En cours',
      },
    },
    COMMON: {
      YES: 'Oui',
      NO: 'Non',
      SUCCESS: 'Succès',
      ERROR: 'Erreur',
    },
    SKILLS: {
      TITLE: 'Gestion des compétences',
      ADD_SKILL: 'Ajouter une compétence',
      EDIT_SKILL: 'Modifier la compétence',
      DELETE_TITLE: 'Supprimer la compétence',
      DELETE_CONFIRM: 'Êtes-vous sûr de vouloir supprimer cette compétence ?',
      TRANSLATE: 'Traduire',
      CREATED_FOR_ALL_LANGUAGES: "La compétence sera créée pour toutes les langues de l'entreprise.",
      CUSTOM_SKILLS: 'Compétences personnalisées',
      SHARED_SKILLS: 'Compètences ESCO',
      SHARED_SKILLS_INFO: 'Ces compétences sont partagées et ne peuvent pas être modifiées.',
      SKILL_LABEL: 'Nom de la compétence',
      SKILL_LABEL_PLACEHOLDER: 'Entrez le nom de la compétence',
      DESCRIPTION: 'Description',
      DESCRIPTION_PLACEHOLDER: 'Entrez une description (optionnel)',
      ACTIONS: 'Actions',
      RELATED_USERS: 'Utilisateurs liés',
      MANAGE_USERS: {
        TITLE: 'Gérer les utilisateurs',
        SEARCH: 'Rechercher des utilisateurs...',
        NO_USERS: 'Aucun utilisateur trouvé',
        ALREADY_LINKED: 'Lié',
        SAVE: 'Enregistrer',
        SAVED: 'Utilisateurs mis à jour avec succès',
        LOAD_ERROR: 'Échec du chargement des utilisateurs',
        SAVE_ERROR: "Échec de l'enregistrement des utilisateurs",
        INVALID_SKILL: 'Compétence invalide',
        RATING_REQUIRED: 'Veuillez sélectionner un niveau (1 à 5 étoiles) pour chaque utilisateur',
      },
      SEARCH_PLACEHOLDER: 'Rechercher une compétence...',
      SEARCH_SKILLS: 'Rechercher des compétences',
      NO_CUSTOM_SKILLS: 'Aucune compétence personnalisée',
      NO_SHARED_SKILLS: 'Aucune compétence ESCO trouvée',
      LABEL_REQUIRED: 'Le nom de la compétence est requis',
      DOMAIN_REQUIRED: 'Le domaine est requis',
      TOAST_CREATED: 'Compétence créée avec succès',
      TOAST_DOMAIN_CREATED: 'Domaine créé avec succès',
      TOAST_DOMAIN_UPDATED: 'Domaine mis à jour avec succès',
      TOAST_DOMAIN_DELETED: 'Domaine supprimé avec succès',
      MANAGE_DOMAINS: 'Domaines personnalisés',
      MANAGE_DOMAINS_CREATE_TITLE: 'Créer un nouveau domaine',
      MANAGE_DOMAINS_CREATE_DESC: 'Lancez l’assistant pour définir un domaine avec ses traductions.',
      MANAGE_DOMAINS_CREATE_CTA: 'Créer un domaine',
      MANAGE_DOMAINS_LIST_TITLE: 'Gérer les domaines existants',
      MANAGE_DOMAINS_LIST_DESC: 'Consultez, recherchez et maintenez les domaines déjà configurés.',
      MANAGE_DOMAINS_LIST_CTA: 'Ouvrir le gestionnaire',
      MANAGE_DOMAINS_LIST_HEADER: 'Domaines personnalisés',
      MANAGE_DOMAINS_LIST_HINT: '{{count}} domaine(s) disponible(s)',
      COMPETENCE_CUSTOM_ACTIF: {
        OPEN: 'Paramètres source des compétences',
        TITLE: 'Source des compétences',
        LABEL: 'Utiliser les compétences depuis :',
        STANDARD_ONLY: 'Utiliser uniquement les compétences standards',
        CUSTOM_ONLY: 'Utiliser uniquement les compétences personnalisées',
        BOTH: 'Utiliser les deux',
        LOAD_ERROR: 'Échec du chargement de la configuration des compétences',
        SAVE_ERROR: "Échec de l'enregistrement de la configuration des compétences",
        SAVED: 'Configuration des compétences mise à jour',
      },
      DOMAIN_LINKED_SKILLS_TITLE: 'Compétences liées',
      NO_DESCRIPTION: 'Aucune description fournie',
      NO_CUSTOM_DOMAINS: 'Aucun domaine personnalisé',
      TOAST_UPDATED: 'Compétence mise à jour avec succès',
      TOAST_DELETED: 'Compétence supprimée avec succès',
      TOAST_ERROR: 'Une erreur est survenue',
      SKILL_TYPE: 'Type',
      STATUS: 'Statut',
      REUSE_LEVEL: 'Niveau de réutilisation',
      DEFINITION: 'Définition',
      SCOPE_NOTE: 'Note de portée',
      SKILL_URI: 'URI de la compétence',
      SYNONYMS: 'Synonymes',
      DOMAIN_FILTER: 'Domaine',
      ALL_DOMAINS: 'Tous les domaines',
      DOMAIN: 'Domaine',
      DOMAIN_SELECT: 'Sélectionner un domaine',
      DOMAIN_CREATE_TOGGLE: 'Créer un nouveau domaine',
      DOMAIN_UPDATE_TOGGLE: 'Mettre à jour le domaine',
      DOMAIN_LABEL: 'Libellé du domaine',
      DOMAIN_LABEL_PLACEHOLDER: 'Entrez le libellé du domaine',
      DOMAIN_LABEL_REQUIRED: 'Le libellé du domaine est requis',
      DOMAIN_CREATE: 'Créer',
      DOMAIN_UPDATE: 'Mettre à jour',
      DOMAIN_NEW: 'Nouveau domaine',
      DOMAIN_DELETE_TITLE: 'Supprimer le domaine',
      DOMAIN_DELETE_CONFIRM: 'Êtes-vous sûr de vouloir supprimer ce domaine ?',
      PARENT_URI: 'URI parent',
      PARENT_URI_PLACEHOLDER: "Entrez l'URI parent (optionnel)",
      PARENT_LABEL: 'Libellé parent',
      PARENT_LABEL_PLACEHOLDER: 'Entrez le libellé parent (optionnel)',
      INVALID_URL: 'Veuillez entrer une URL valide',
      LANGUAGE_NOTE: 'La langue de la compétence sera automatiquement définie selon votre langue utilisateur.',
      // L'assistant d'import conserve tout son texte visible dans le namespace bilingue SKILLS.IMPORT.
      IMPORT: {
        BUTTON: 'Importer avec l’IA',
        TITLE: 'Import adaptatif des compétences',
        SUBTITLE: 'Analysez des fichiers de formats variables, vérifiez chaque proposition puis appliquez uniquement les lignes confirmées.',
        STEPS: {
          STEP_1: 'Fichiers et instructions',
          STEP_2: 'Domaines',
          STEP_3: 'Compétences',
          STEP_4: 'Associations et évaluations',
        },
        FILES: {
          KICKER: 'Lot source',
          TITLE: 'Déposez vos fichiers',
          DESCRIPTION: 'Ajoutez jusqu’à 20 fichiers PDF, XLS ou XLSX. Leur structure peut varier : aucun modèle fixe n’est imposé.',
          DROP_TITLE: 'Déposer les fichiers ici ou appuyer pour parcourir',
          DROP_HINT: 'PDF 10 Mo maximum, Excel 25 Mo maximum, 50 Mo par lot',
          REMOVE: 'Retirer le fichier',
          KB: 'Ko',
          MB: 'Mo',
          STATUS_READY: 'Prêt à analyser',
          STATUS_ANALYZING: 'Analyse en cours',
          STATUS_ANALYZED: 'Analysé',
          STATUS_FAILED: 'Analyse échouée',
          STATUS_IGNORED: 'Ignoré explicitement',
          STATUS_DUPLICATE: 'Doublon binaire, analyse réutilisée',
        },
        INSTRUCTIONS: {
          LABEL: 'Instructions pour l’IA',
          PLACEHOLDER: 'Exemple : importe uniquement les compétences de l’onglet 2026 et ignore les évaluations.',
          HELP: 'Précisez les onglets, périodes, types de notes, exclusions ou règles d’identité utiles.',
        },
        QUESTIONS: {
          TITLE: 'Précisions nécessaires',
          UNRESOLVED: 'question(s) obligatoire(s) non résolue(s)',
          ANSWER: 'Votre réponse',
          // Model-ranked suggestions remain optional; the last choice always accepts an explicit human answer.
          RECOMMENDED: 'Recommandé',
          OTHER: 'Autre : saisir ma propre réponse',
          ACTION_REQUIRED: 'Action requise',
          WAITING: 'Traitement en cours',
          REVIEWED: 'Réponses enregistrées localement',
          REQUIRED: '(obligatoire)',
          ANSWERS_REQUIRED: 'Répondez aux questions obligatoires ci-dessous pour poursuivre la revue du catalogue.',
          PROCESSING: 'Patientez pendant le traitement. Vous pourrez répondre aux questions dès sa fin.',
          ANSWERS_LOCAL: 'Vos réponses restent locales et seront envoyées uniquement avec l’analyse des rattachements.',
        },
        PROCESSING: {
          TITLE: 'Import en cours de traitement',
          EXECUTING: 'Application des données validées en cours…',
          ASSOCIATIONS: 'Analyse des rattachements en cours…',
          HELP: 'Veuillez patienter sans fermer cette page. Les actions sont temporairement bloquées pendant le traitement.',
        },
        SCOPE: {
          TITLE: 'Périmètre détecté',
          COMPLETE: 'Couverture complète',
          INCOMPLETE: 'Couverture à vérifier',
          UNPROCESSED_TITLE: 'Onglets non traités',
          CONFIRM_PARTIAL: 'J’ai pris connaissance des onglets non traités et je souhaite poursuivre uniquement avec les données vérifiées des autres onglets.',
          NO_CANDIDATES_REASON: 'Aucune donnée exploitable n’a été extraite de cet onglet.',
        },
        SCALE: {
          TITLE: 'Correspondance des niveaux',
          HELP: 'Confirmez explicitement la conversion de chaque échelle vers les niveaux entiers de 1 à 5.',
        },
        PERIODS: {
          LABEL: 'Période source',
        },
        REVIEW: {
          KICKER: 'Revue contrôlée',
          DOMAINS_DESCRIPTION: 'Traitez chaque domaine avant de poursuivre vers les compétences dépendantes.',
          SKILLS_DESCRIPTION: 'Vérifiez le parent réel, les doublons inter-domaines et les impacts multilingues.',
          ASSESSMENTS_DESCRIPTION: 'Associez uniquement des collaborateurs existants et conservez séparément autoévaluation et note assignée.',
          STATUS_FILTER: 'Filtrer par état',
          ALL_STATUSES: 'Tous les états',
          LOADING: 'Préparation de la revue…',
          EMPTY_STEP: 'Aucune ligne n’a été proposée pour cette étape. L’étape reste visible et peut être validée.',
          SELECT_ROW: 'Sélectionner cette ligne',
          RAW: 'Valeur source',
          EXISTING: 'Valeur existante',
          EFFECTIVE: 'Valeur appliquée',
          DESCRIPTION: 'Description effective',
          PARENT: 'Domaine source',
          SELECT_PARENT: 'Sélectionner un domaine appliqué ou réutilisé',
          SHARED_READ_ONLY: 'Catalogue partagé en lecture seule',
          CREATE_TRANSLATION_NOTICE: 'La création peut recopier le texte source dans les langues de l’entreprise. Aucun texte traduit automatiquement n’est promis.',
          EMPLOYEE: 'Collaborateur existant',
          SELECT_EMPLOYEE: 'Sélectionner un collaborateur',
          SEARCH_EMPLOYEE: 'Rechercher par nom, e-mail ou matricule…',
          NO_EMPLOYEES_FOUND: 'Aucun collaborateur correspondant',
          CLEAR_EMPLOYEE: 'Effacer la sélection',
          SKILL: 'Compétence appliquée ou réutilisée',
          SELECT_SKILL: 'Sélectionner une compétence',
          SELF_SCORE: 'Autoévaluation',
          ASSIGNED_SCORE: 'Note manager/admin',
          OLD_VALUE: 'Valeur actuelle',
          RAW_VALUE: 'Valeur brute',
          // Extraction omissions are visible even after automatic navigation to review.
          EXTRACTION_NOTICES: 'Points à vérifier et éléments non retenus ({{count}})',
          PARTIAL_MAPPING_NOTICE: 'Conversion de note ou ligne de correspondance n°{{index}} ignorée : sa validité n’a pas pu être établie. Les autres données sont conservées.',
          PARTIAL_LINE_NOTICE: 'Proposition de rattachement n°{{index}} ignorée : elle n’est pas vérifiable. Ce numéro désigne sa position dans la sortie de l’IA, et non une ligne du fichier Excel.',
          PARTIAL_ASSOCIATIONS_CONFIRM: 'Je confirme poursuivre uniquement avec les rattachements et les notes validés. Aucune note écartée ne sera appliquée.',
          PARTIAL_MORE_NOTICE: 'Nombre d’anomalies supplémentaires non détaillées dans cette liste : {{count}}.',
          MORE_NOTICES: 'Afficher les {{count}} autres explications',
          PROPOSED_VALUE: 'Niveau confirmé (1 à 5)',
          UNSPECIFIED: 'Non renseigné, conserver l’existant',
          CONFIRM_UNSCORED_ASSOCIATION: 'Créer ou conserver cette association sans importer de note. Les notes existantes sont conservées.',
          LINK_SUBSTEP: 'Association',
          ASSIGNED_SUBSTEP: 'Note assignée',
          SELF_SUBSTEP: 'Autoévaluation',
          NO_PROVENANCE: 'Provenance indisponible',
          SHEET_NAME: 'Nom de l’onglet : {{sheet}}',
          UNRESOLVED_COUNT: '{{count}} ligne(s) à traiter',
          REASONS: {
            EXACT_DOMAIN_MATCH: 'Domaine existant correspondant',
            NEW_DOMAIN: 'Nouveau domaine proposé',
            EXACT_SHARED_SKILL_MATCH: 'Compétence partagée correspondante',
            EXACT_CUSTOM_SKILL_MATCH: 'Compétence personnalisée correspondante',
            NEW_SKILL: 'Nouvelle compétence proposée',
            CROSS_DOMAIN_DUPLICATE: 'Même libellé déjà présent dans un autre domaine',
            EXACT_EMPLOYEE_MATCH: 'Collaborateur identifié avec certitude',
            NAME_MATCH_REQUIRES_CONFIRMATION: 'Correspondance par nom à confirmer',
            EMPLOYEE_REQUIRED: 'Collaborateur existant requis',
            SCALE_MAPPING_REQUIRED: 'Correspondance d’échelle requise',
            UNSCORED_ASSOCIATION_REQUIRES_CONFIRMATION: 'Confirmez explicitement l’association sans note ou renseignez au moins une évaluation',
            DUPLICATE_ACQUIRED_SKILL_URI: 'Plusieurs associations acquises existent pour cette URI',
            DOMAIN_SOURCE_REQUIRED: 'Le domaine source doit être clarifié ou réassigné',
            SKILL_SOURCE_REQUIRED: 'La compétence source doit être clarifiée ou réassignée',
            ASSOCIATION_DOMAIN_MISMATCH: 'Le domaine de l’association existante ne correspond pas au domaine proposé',
            PARENT_DOMAIN_IGNORED: 'Le domaine parent a été ignoré ou n’est pas appliqué',
            SKILL_PARENT_IGNORED: 'La compétence parente a été ignorée ou n’est pas appliquée',
            EVALUATIONS_UNAVAILABLE_CATALOGUE_ONLY: 'Évaluation ignorée selon la confirmation de périmètre catalogue uniquement',
          },
        },
        STATUS: {
          REVIEW: 'À revoir',
          BLOCKED: 'Bloquée',
          READY: 'Prête',
          RUNNING: 'En cours',
          VERIFIED: 'Appliquée et vérifiée',
          FAILED: 'Échec',
          PARTIAL: 'Partiellement appliquée',
          UNCERTAIN: 'Résultat incertain',
          IGNORED: 'Ignorée',
          REUSED: 'Réutilisée sans modification',
        },
        ACTIONS: {
          CLOSE: 'Fermer l’assistant',
          START_PAID_ANALYSIS: 'Confirmer 200 crédits et analyser',
          START_CATALOGUE_ANALYSIS: 'Confirmer 200 crédits et analyser le catalogue',
          ANALYZING: 'Analyse en cours…',
          PERSIST_CATALOGUE_AND_ANALYZE_ASSOCIATIONS: 'Créer/valider le catalogue et analyser les rattachements',
          ANALYZE_ASSOCIATIONS: 'Analyser les rattachements',
          PREVIOUS: 'Précédent',
          NEXT: 'Suivant',
          FINISH: 'Terminer',
          CREATE: 'Insérer',
          UPDATE: 'Mettre à jour',
          REUSE: 'Réutiliser sans modification',
          IGNORE: 'Ignorer',
          REVIEW_RETRY: 'Revoir avant nouvelle tentative',
          SELECT_READY: 'Sélectionner les valides',
          IGNORE_SELECTED: 'Ignorer la sélection',
          APPLY_SELECTED: 'Appliquer la sélection',
          APPLY_VALID: 'Appliquer les valides',
        },
        BILLING: {
          FORMATION_LIMITATION: 'Les écritures d’évaluations nécessitent les modules Formation et Compétence actifs. Confirmez un import limité au catalogue pour continuer.',
          CONFIRMATIONS: 'Confirmation du périmètre',
          CONFIRM_CATALOGUE_ONLY: 'Je confirme poursuivre uniquement avec les domaines et compétences, sans écrire d’évaluation.',
          NEW_LOT: 'Créer un nouveau lot',
          NEW_LOT_CONFIRM: 'Abandonner ce brouillon et préparer un nouveau lot ?',
        },
        TRANSLATIONS_WARNING: 'Attention : l’API existante remplacera toutes les variantes linguistiques par ce libellé « {{label}} » et cette description « {{description}} ». Je confirme ce payload exact.',
        ERRORS: {
          NEW_LOT_REQUIRED: 'Le lot en cours ne peut plus être modifié. Créez explicitement un nouveau lot.',
          MAX_FILES: 'Le lot ne peut pas contenir plus de 20 fichiers.',
          FILE_TYPE: 'Format non pris en charge. Utilisez uniquement PDF, XLS ou XLSX.',
          FILE_SIZE: 'Le fichier dépasse la limite autorisée ou est vide.',
          LOT_SIZE: 'Le lot dépasse la limite cumulée de 50 Mo.',
          DUPLICATE_FILE: 'Ce fichier est déjà présent dans le lot.',
          FILE_HASH_RECONCILIATION_FAILED: 'Les empreintes du lot accepté ne correspondent pas aux fichiers locaux. Aucun fichier n’a été envoyé à l’analyse.',
          INVALID_START_RESULT: 'La réponse d’admission du serveur est invalide.',
          FILES_REQUIRED: 'Ajoutez au moins un fichier avant de lancer l’analyse.',
          INSTRUCTIONS_TOO_LONG: 'Les instructions dépassent 8 000 caractères.',
          CATALOGUE_ONLY_CONFIRMATION_REQUIRED: 'Confirmez le périmètre catalogue uniquement avant de lancer l’analyse.',
          SETTINGS_UNAVAILABLE: 'Le contexte entreprise ne peut pas être vérifié. Le lancement de l’analyse reste bloqué.',
          INVALID_CONTEXT: 'Le contexte de l’import est invalide.',
          INVALID_MANIFEST: 'Le manifeste du lot est invalide.',
          INVALID_FILE_LOT: 'Le lot de fichiers envoyé est invalide.',
          SOURCE_LIMIT_EXCEEDED: 'Une source dépasse une limite de l’import.',
          CONTEXT_LIMIT_EXCEEDED: 'Le contexte de l’import dépasse la taille autorisée.',
          UNSUPPORTED_SOURCE_TYPE: 'Seuls les fichiers PDF, XLS et XLSX sont acceptés.',
          INVALID_SOURCE_SIGNATURE: 'Le contenu d’un fichier ne correspond pas à son extension.',
          UNSAFE_PDF_SOURCE: 'Le PDF contient du contenu actif, chiffré ou non pris en charge.',
          PDF_PAGE_LIMIT_EXCEEDED: 'Le PDF dépasse le nombre de pages autorisé.',
          UNREADABLE_SOURCE: 'Une source ne peut pas être lue en sécurité.',
          CANDIDATE_LIMIT_EXCEEDED: 'Le lot dépasse la limite cumulative de 10 000 propositions.',
          INVALID_CATALOGUE_RESULT: 'La réponse catalogue est invalide. Aucun rattachement n’a été analysé.',
          INVALID_CATALOGUE_LOCAL_ID: 'Le catalogue contient des références locales invalides ou dupliquées.',
          INVALID_ASSOCIATIONS_RESULT: 'La réponse des rattachements est invalide.',
          UNKNOWN_LOCAL_ID: 'Un rattachement référence un domaine ou une compétence inconnu du catalogue validé.',
          ASSOCIATION_LOCAL_ID_MISMATCH: 'Un rattachement ne correspond pas exactement au domaine et à la compétence validés.',
          CATALOGUE_NOT_PERSISTED: 'Toutes les lignes du catalogue doivent être validées avant l’analyse des rattachements.',
          WORKBOOK_PROFILE_LIMIT_EXCEEDED: 'La structure du classeur est trop volumineuse pour une analyse.',
          ADMIN_REQUIRED: 'Cette action est réservée aux administrateurs de l’entreprise.',
          UNAUTHORIZED: 'Une session d’entreprise authentifiée est requise.',
          INSUFFICIENT_AI_CREDITS: 'Les crédits IA de l’entreprise sont insuffisants.',
          RECEIPT_OR_MANIFEST_CONFLICT: 'Le workflow ne correspond pas à ce lot de fichiers.',
          ANALYSIS_BUSY: 'Le service d’analyse est occupé. Réessayez plus tard.',
          AI_PROVIDER_TIMEOUT: 'Le fournisseur IA a dépassé le délai autorisé.',
          AI_PROVIDER_UNAVAILABLE: 'Le fournisseur IA est temporairement indisponible.',
          AI_PROVIDER_OUTPUT_FAILED: 'Le fournisseur IA a renvoyé un résultat invalide.',
          AI_AGENT_LIMIT_EXCEEDED: 'L’analyse automatique a atteint ses limites. Le lot est conservé. Vous pouvez réessayer dans ce même import sans nouvelle facturation.',
          AI_AGENT_INCOMPLETE: 'L’analyse automatique n’est pas complète. Aucune donnée métier n’a été écrite par cette analyse.',
          ACCOUNTING_UNAVAILABLE: 'La comptabilisation des crédits IA est temporairement indisponible.',
          AI_CONFIGURATION_UNAVAILABLE: 'La configuration de l’analyse IA est indisponible.',
          PDF_CAPABILITY_UNAVAILABLE: 'L’analyse native des PDF est indisponible.',
          REQUEST_CANCELLED: 'La demande d’import a été annulée.',
          INTERNAL_ERROR: 'La demande d’import n’a pas pu être terminée.',
          ANALYSIS_FAILED: 'Aucun fichier n’a pu être analysé. Vous pouvez ignorer les fichiers concernés ou réessayer dans le même workflow.',
          REVIEW_CONTEXT_FAILED: 'Le catalogue ou les collaborateurs existants n’ont pas pu être chargés pour la revue.',
          EXECUTION_PAUSED: 'La file est suspendue après une erreur globale d’authentification, de droits ou de limitation.',
          REVIEW_REQUIRED: 'Complétez et confirmez les valeurs requises.',
          REUSE_TARGET_REQUIRED: 'La réutilisation exige une correspondance existante.',
          SHARED_SKILL_READ_ONLY: 'Une compétence partagée ne peut être ni créée ni modifiée.',
          SHARED_DOMAIN_READ_ONLY: 'Un domaine partagé ne peut pas être créé ou modifié.',
          TRANSLATION_OVERWRITE_CONSENT_REQUIRED: 'Confirmez l’écrasement multilingue pour ce payload exact.',
          DOMAIN_CHANGED_REVIEW_REQUIRED: 'Le domaine existant a changé. Relisez les valeurs avant de confirmer à nouveau.',
          SKILL_CHANGED_REVIEW_REQUIRED: 'La compétence existante a changé. Relisez les valeurs et confirmez à nouveau.',
          PARENT_DOMAIN_UNRESOLVED: 'Le domaine parent doit être appliqué ou réutilisé avant cette compétence.',
          SKILL_DEPENDENCY_UNRESOLVED: 'La compétence dépendante doit être appliquée ou réutilisée avant cette association.',
          EMPLOYEE_REQUIRED: 'Sélectionnez un collaborateur existant.',
          EMPLOYEE_PROFILE_LOADING: 'Chargement séquentiel des compétences du collaborateur…',
          EMPLOYEE_PROFILE_READ_FAILED: 'Les compétences du collaborateur n’ont pas pu être relues.',
          DUPLICATE_ACQUIRED_SKILL_URI: 'Plusieurs associations acquises utilisent la même URI ; traitement automatique bloqué.',
          ASSOCIATION_DOMAIN_MISMATCH: 'Le domaine relu de l’association existante ne correspond pas au domaine proposé.',
          DOMAIN_READBACK_UNCERTAIN: 'Le domaine n’a pas pu être confirmé après écriture.',
          SKILL_READBACK_UNCERTAIN: 'La compétence n’a pas pu être confirmée après écriture.',
          ASSOCIATION_CREATE_UNCERTAIN: 'La création de l’association peut avoir réussi, mais sa relecture est impossible.',
          ASSIGNED_SCORE_READBACK_FAILED: 'La note assignée n’a pas été confirmée par relecture.',
          SELF_SCORE_READBACK_FAILED: 'L’autoévaluation n’a pas été confirmée par relecture.',
          DOMAIN_TARGET_REQUIRED: 'Le domaine cible est introuvable.',
          CUSTOM_DOMAIN_TARGET_REQUIRED: 'Le domaine personnalisé cible est introuvable ou est en lecture seule.',
          CUSTOM_SKILL_TARGET_REQUIRED: 'La compétence personnalisée cible est introuvable.',
          EXECUTION_FAILED: 'L’exécution a échoué sans résultat vérifiable.',
          HTTP_0: 'Connexion interrompue. Vérifiez l’état affiché avant toute nouvelle tentative.',
          HTTP_400: 'La demande d’import est invalide.',
          HTTP_401: 'La session a expiré.',
          HTTP_403: 'Droits ou crédits insuffisants pour cette opération.',
          HTTP_409: 'Le workflow ou le manifeste ne correspond plus au lot payé.',
          HTTP_410: 'Ce workflow d’import n’est plus disponible.',
          HTTP_413: 'Les limites de traitement sont dépassées.',
          HTTP_415: 'Le type de fichier est incompatible.',
          HTTP_422: 'La source est illisible ou invalide.',
          HTTP_429: 'Trop de demandes. La file a été suspendue.',
          HTTP_502: 'Le fournisseur IA a renvoyé une sortie invalide.',
          HTTP_503: 'La facturation ou la configuration IA est indisponible.',
          HTTP_504: 'L’analyse IA a dépassé le délai autorisé.',
          SOURCE_READ_FAILED: 'Le fichier source n’est plus accessible. Sélectionnez à nouveau le fichier original pour réessayer.',
        },
        CONFIRM_CLOSE: {
          MESSAGE: 'Les écritures déjà vérifiées resteront acquises. Les fichiers, réponses et corrections en mémoire seront perdus. Fermer ?',
        },
        SUMMARY: {
          TITLE: 'Résumé du workflow',
          CATALOGUE_PHASE: 'Catalogue : {{domains}} domaine(s) et {{skills}} compétence(s) revus.',
          ASSOCIATIONS_PHASE: 'Rattachements : {{associations}} proposition(s) revue(s).',
        },
        ACCESSIBILITY: {
          STEPS: 'Progression de l’import des compétences',
          PROGRESS: '{{completed}} opération(s) terminée(s) sur {{total}}',
        },
      },
      PAGINATION: {
        OF: 'sur',
        RESULTS: 'résultats',
        ROWS_PER_PAGE: 'Lignes par page',
      },
    },
    // Report IA keeps all user-visible copy in the established bilingual catalog.
    REPORT_AI: {
      // Pending labels describe transient actions, never persisted report content.
      PENDING: { SAVE: 'Enregistrement en cours...', SOURCES: 'Chargement des lignes sources...' },
      HOME: { EYEBROW: 'Analyse RH assistée', TITLE: 'Vos décisions, mises en perspective', SUBTITLE: 'Créez et pilotez des tableaux de bord RH avec Emye, sans perdre le contrôle des données ni des versions.', CREATE: 'Créer un report', SEARCH: 'Rechercher un report', SORT: 'Trier les reports', UPDATED: 'Dernière modification', UPDATED_AT: 'Mise à jour', CREATED: 'Date de création', NAME: 'Nom', DIRECTION: 'Inverser le tri', SEARCH_ACTION: 'Rechercher', LOADING: 'Chargement des reports...', RETRY: 'Réessayer', NO_DESCRIPTION: 'Aucune description', PREVIEW_UNAVAILABLE: 'Aperçu disponible après le prochain enregistrement', VERSION: 'Version', OPEN: 'Ouvrir', DUPLICATE: 'Dupliquer', DELETE: 'Supprimer', EMPTY_TITLE: 'Aucun report pour le moment', EMPTY_TEXT: 'Décrivez votre besoin à Emye pour créer votre premier tableau de bord.', PREVIOUS: 'Précédent', NEXT: 'Suivant' },
      CREATE: { BACK: 'Retour aux reports', STEP: 'Nouveau report', TITLE: 'Que souhaitez-vous comprendre ?', NAME: 'Nom du report', DESCRIPTION: 'Description', PROMPT: 'Votre demande', PLACEHOLDER: 'Exemple : analyse les effectifs, les contrats et les absences approuvées par département...', SUGGESTION_1: 'Analyse les effectifs et les mouvements par département', SUGGESTION_2: 'Compare les absences approuvées et les contrats par site', GENERATE: 'Générer le report', CONTINUE: 'Continuer', NOT_SAVED: 'Non enregistré' },
      // Workspace labels support the grouped toolbar without changing any underlying operation.
      WORKSPACE: { BACK: 'Reports', UNTITLED: 'Report sans titre', UNSAVED: 'Modifications non enregistrées', SAVE: 'Enregistrer', REFRESH: 'Actualiser', REFRESHING: 'Actualisation...', RETRY: 'Réessayer', LOADING: 'Chargement du report...', EMPTY_TITLE: 'Cet onglet est vide', EMPTY_TEXT: 'Demandez à Emye d’ajouter un indicateur, un tableau ou un graphique.', NO_DATA: 'Aucune donnée', DEFAULT_TAB: 'Vue d’ensemble', ADD_TAB: 'Ajouter un onglet', RENAME_TAB: 'Renommer l’onglet', DELETE_TAB: 'Supprimer l’onglet', TAB_NAME: 'Nom de l’onglet', RENAME_REPORT: 'Renommer', EDIT_REPORT_TITLE: 'Modifier le titre du report', REPORT_NAME: 'Titre du report', COMPONENT_TITLE: 'Titre du composant', TITLE_TOO_LONG: 'Le titre ne peut pas dépasser {{max}} caractères.', MORE_ACTIONS: 'Plus d’actions' },
      // Layout labels describe dedicated handles, keyboard mode, and every refusal without changing existing STT chat keys.
      LAYOUT: { MOVE_HANDLE: 'Déplacer {{title}}', RESIZE_HANDLE: 'Redimensionner {{title}} depuis le coin inférieur droit', MOVE_HELP: 'Appuyez sur Entrée ou Espace pour commencer, utilisez les flèches pour déplacer sur la grille, puis Entrée pour appliquer ou Échap pour annuler.', RESIZE_HELP: 'Appuyez sur Entrée ou Espace pour commencer, utilisez les flèches pour redimensionner sur la grille, puis Entrée pour appliquer ou Échap pour annuler.', MOVE_STARTED: 'Déplacement commencé. Utilisez la grille de 12 colonnes et 32 lignes.', RESIZE_STARTED: 'Redimensionnement commencé depuis le coin inférieur droit.', TARGET_VALID: 'Position cible valide.', TARGET_BOUNDS: 'Position refusée : la cible dépasse la grille de 12 colonnes et 32 lignes.', TARGET_SIZE: 'Taille refusée : les limites de ce type de composant seraient dépassées.', TARGET_COLLISION: 'Position refusée : la cible chevauche un autre composant.', APPLIED: 'Mise en page appliquée au brouillon. Enregistrez le report pour la sauvegarder.', UNCHANGED: 'Mise en page inchangée.', CANCELLED: 'Modification de mise en page annulée.' },
      FILTERS: { TITLE: 'Filtres du report', ALL: 'Tous', CLEAR: 'Réinitialiser', MULTI_HELP: 'Utilisez Ctrl ou Cmd pour sélectionner plusieurs valeurs.', START_DATE: 'Date de début', END_DATE: 'Date de fin' },
      FORMS: { SUBMIT: 'Appliquer', REQUIRED: 'Champ obligatoire', SAVE_VALUES: 'Enregistrer ces valeurs' },
      // Component title editing is named explicitly because the icon-only palette exposes its text through labels and tooltips.
      COMPONENT_MENU: { OPEN: 'Ouvrir le menu du composant', REFERENCE_IN_CHAT: 'Cibler ce composant dans Emye', EDIT_TITLE: 'Modifier le titre', REFRESH: 'Actualiser', EXPORT_PNG: 'Exporter en PNG', EXPORT_XLSX: 'Exporter en Excel (.xlsx)', EXPORT_SOURCE_XLSX: 'Télécharger les données sources (.xlsx)', EXPAND: 'Agrandir', SHRINK: 'Réduire', DELETE: 'Supprimer le composant' },
      // Source export feedback is separate from runtime errors because it never replaces visible chart data.
      SOURCE_EXPORT: { SUCCESS: 'Données sources téléchargées.', UNAVAILABLE: 'Les lignes sources de ce graphique ne peuvent pas être exportées en toute sécurité. Régénérez le graphique.', FORBIDDEN: 'Vous n’êtes pas autorisé à exporter les lignes sources de ce graphique.', FAILED: 'Le téléchargement des données sources a échoué.' },
      // Drill labels explain analytical navigation and row-level evidence in functional HR language.
      DRILL: { HIERARCHY: 'Hiérarchie', ROLL_UP: 'Revenir au niveau précédent', VIEW_SOURCE_ROWS: 'Vérifier les lignes sources', CLICK_TO_DRILL: 'Cliquez sur une valeur pour afficher le niveau de détail suivant.', SOURCE_EVIDENCE: 'Preuve du résultat', SOURCE_DESCRIPTION: 'Ces lignes sont celles utilisées pour calculer le résultat affiché. Les colonnes sont limitées aux informations utiles à sa vérification.', ACTIVE_CONTEXT: 'Contexte du résultat', LEVEL: 'Niveau', EMPTY_VALUE: 'Non renseigné', ROW_COUNT: '{{count}} ligne(s) source(s)', TRUNCATED: 'Le résultat est limité. Affinez les filtres pour voir l’ensemble des lignes.', UNAVAILABLE: 'Le détail de ce composant n’est pas disponible en toute sécurité. Régénérez-le ou affinez les filtres.', CLOSE: 'Fermer', YES: 'Oui', NO: 'Non' },
      // Information explains the reviewed business meaning before exposing row-level evidence.
      // Control-row export is named explicitly so the downloaded workbook remains understandable outside the dialog.
      INFORMATION: { OPEN: 'Comprendre et vérifier {{title}}', VERIFY_CALCULATION: 'Vérifier les lignes sources et le calcul de {{title}}', EYEBROW: 'Comprendre ce résultat', ALIGNED: 'Vérifié avec le besoin initial', POPULATION: 'Population et périmètre', CALCULATION: 'Calcul et formule', FILTERS: 'Filtres et exclusions', SOURCES: 'Sources fonctionnelles', LIMITATIONS: 'Points de vigilance', COMPONENT_TYPE: 'Type :', VISIBLE_ROWS: 'Valeurs affichées :', REFRESHED_AT: 'Actualisé :', EVIDENCE_TITLE: 'Lignes de contrôle', EVIDENCE_DESCRIPTION: 'Ces informations permettent de vérifier la population et le résultat produits.', EXPORT_CONTROL_ROWS: 'Extraire en Excel', LEGACY_DESCRIPTION: 'Ce composant historique ne possède pas encore d’explication fonctionnelle validée. Régénérez-le avec Emye pour documenter précisément sa population, sa formule et ses limites.', SOURCE_UNAVAILABLE: 'Les lignes sources ne peuvent pas être reconstruites en toute sécurité pour ce composant historique.', NO_SOURCE_ROWS: 'Aucune ligne source ne correspond au périmètre courant.' },
      // The composer also explains the local visual reference, its V1 limits, and upload state without treating it as a source.
      CHAT: { TITLE: 'Emye', SUBTITLE: 'Construisez vos graphiques', NEW: 'Nouvelle discussion', COLLAPSE: 'Réduire le chat', EXPAND: 'Ouvrir le chat', YOU: 'Vous', ASSISTANT: 'Emye', EMPTY: 'Décrivez une modification ciblée pour ce report.', THINKING: 'Emye prépare une proposition...', PROMPT: 'Message à Emye', PLACEHOLDER: 'Ajoutez un graphique, changez un filtre, renommez un axe...', REFERENCED_OBJECT: 'Objet ciblé', REMOVE_REFERENCE: 'Ne plus cibler cet objet', SEND: 'Envoyer', VISUAL_REFERENCE_ADD: 'Joindre une référence visuelle', VISUAL_REFERENCE_REMOVE: 'Retirer la référence visuelle', VISUAL_REFERENCE_IMAGE: 'Image', VISUAL_REFERENCE_PDF: 'PDF', VISUAL_REFERENCE_UPLOADING: 'Import de la référence visuelle en cours…', VISUAL_REFERENCE_INVALID_TYPE: 'Format non pris en charge. Utilisez une image PNG, JPEG ou WebP, ou un PDF.', VISUAL_REFERENCE_IMAGE_TOO_LARGE: 'L’image dépasse la limite de 5 Mo.', VISUAL_REFERENCE_PDF_TOO_LARGE: 'Le PDF dépasse la limite de 10 Mo.', VOICE_START: 'Dicter le message avec l’appareil', VOICE_STOP: 'Arrêter la dictée', VOICE_PREPARING: 'Initialisation de la dictée système…', VOICE_LISTENING: 'Écoute en cours…', VOICE_WAITING: 'Commencez à parler, la transcription apparaîtra ici.', VOICE_UNAVAILABLE: 'La dictée vocale n’est pas prise en charge par ce navigateur.', VOICE_PERMISSION_DENIED: 'Autorisez le microphone et la reconnaissance vocale dans les réglages de l’appareil.', VOICE_NO_MICROPHONE: 'Aucun microphone disponible sur l’appareil.', VOICE_NO_SPEECH: 'Aucune parole détectée.', VOICE_LOCAL_UNAVAILABLE: 'La langue de dictée n’est pas installée sur l’appareil.', VOICE_ERROR: 'La reconnaissance vocale de l’appareil a échoué.', MICROPHONE_SELECT: 'Choisir le microphone', MICROPHONE_LOADING: 'Recherche des microphones…', MICROPHONE_DEFAULT: 'Microphone par défaut', MICROPHONE_NUMBER: 'Microphone {{number}}', MICROPHONE_NONE: 'Aucun autre microphone détecté.' },
      AGENT_STOPPED_STEP: 'Non terminée',
      SWARM: {
        PROGRESS: 'Progression',
        TITLE: 'Compagnons Ingénieurs Data',
        COMPLETED_TOTAL: '{{completed}}/{{total}} terminés',
        COMPLETED: '{{completed}} terminés',
        TOTAL: '{{total}} agents',
        ACTIVE: '{{count}} actifs',
        QUEUED: '{{count}} en attente',
        FAILED: '{{count}} en échec',
        LAUNCHED_LIMIT: '{{count}}/{{limit}} lancés',
        LAUNCHED: '{{count}} lancés',
        LAUNCH_LIMIT: '{{limit}} lancements maximum',
        CONCURRENT_LIMIT: '{{limit}} simultanés maximum',
        VISUAL_ACCEPTED_WITHOUT_RECHECK: 'Corrections appliquées après le dernier contrôle, sans nouvelle vérification visuelle.',
      },
      // Pauses preserve validated work without claiming completion or bypassing provider checks.
      PAUSE_REASONS: {
        // Repair continuation preserves work but requires additional AI calls.
        REPAIR_LIMIT: 'Emye a besoin d’une étape de correction supplémentaire. Le travail est conservé ; continuer utilisera de nouveaux appels IA.',
        PROVIDER_CONTENT_FILTER: 'Le fournisseur IA a interrompu la génération en raison de son filtre de contenu. Le travail déjà validé est conservé. Cliquez sur « Continuer la génération » pour demander une reprise : elle reste soumise au même filtre et peut être bloquée à nouveau. Cette action ne contourne pas le filtre.',
        PROVIDER_TRANSIENT: 'Une interruption temporaire du fournisseur IA a mis la génération en pause. Le travail déjà validé est conservé. Cliquez sur « Continuer la génération » pour demander une reprise. Les contrôles du fournisseur restent actifs : la reprise peut être filtrée et ne les contourne pas.',
        OUTPUT_LIMIT: 'La réponse du fournisseur IA a atteint sa limite de sortie. Le travail déjà validé est conservé, mais la génération reste inachevée. Cliquez sur « Continuer la génération » pour demander une reprise. Les contrôles du fournisseur restent actifs : la reprise peut être filtrée et ne les contourne pas.',
        // The correction window may expire despite partial improvements; do not claim that no progress occurred.
        VISUAL_STALLED: 'La validation visuelle reste inachevée après plusieurs corrections. Le travail déjà validé est conservé, mais le report ne peut pas encore être considéré comme prêt. Cliquez sur « Continuer la génération » pour demander une reprise.',
        PATCH_STALLED: 'Les corrections ne progressent plus et la validation du report n’est pas terminée. Le travail déjà validé est conservé, mais le report ne peut pas encore être considéré comme prêt. Cliquez sur « Continuer la génération » pour demander une reprise.',
      },
      // Execution budgets are server-configured; do not promise a hardcoded number of steps in the client.
      AGENT: { PLAN: 'Plan d’exécution', CLARIFICATION_TITLE: 'Précisions nécessaires', CLARIFICATION_PLACEHOLDER: 'Répondez aux questions pour continuer...', QUESTION_PROGRESS: 'Question {{current}} sur {{total}}', FREE_ANSWER: 'Écrire une autre réponse', FREE_ANSWER_PLACEHOLDER: 'Écrivez votre réponse...', NEXT_QUESTION: 'Question suivante', CONTINUATION_TITLE: 'Génération mise en pause', CONTINUATION_DESCRIPTION: 'Emye a conservé son avancement. Continuer autorise de nouveaux appels IA pour terminer le travail.', CONTINUE: 'Continuer la génération', RUN_PHASE: { ANALYZE: 'Analyse', CLARIFY: 'Clarification', PLAN: 'Planification', EXECUTE: 'Exécution', VERIFY_DATA: 'Vérification des données', VERIFY_VISUAL: 'Contrôle visuel', FINALIZE: 'Finalisation' }, RUN_STATUS: { QUEUED: 'La demande est en attente de traitement.', CLARIFICATION_REQUIRED: 'Emye attend vos précisions.', PLANNED: 'Le plan est prêt.', RUNNING: 'Emye exécute le plan.', VERIFYING_DATA: 'Emye vérifie les données.', VERIFYING_VISUAL: 'Emye contrôle le rendu du report.', CONTINUATION_REQUIRED: 'Emye a conservé son avancement et attend votre confirmation pour continuer.', COMPLETED: 'Le report est prêt.', FAILED: 'La génération a échoué.', CANCELLED: 'La génération a été annulée.' }, STEP_STATUS: { PENDING: 'À venir', IN_PROGRESS: 'En cours', COMPLETED: 'Terminée', FAILED: 'Échec' } },
      CONVERSATIONS: { TITLE: 'Discussions', EMPTY: 'Aucune discussion', NEW_TITLE: 'Nouvelle discussion', DELETE: 'Supprimer la discussion', DELETE_TITLE: 'Supprimer la discussion', DELETE_MESSAGE: 'Supprimer définitivement cette discussion et tous ses messages ?', DELETE_SUCCESS: 'Discussion supprimée.' },
      SOURCES: { TITLE: 'Sources', DESCRIPTION: 'Ajoutez uniquement des fichiers CSV ou XLSX propres à ce report (25 Mo maximum). Les ajouts, remplacements et détachements sont appliqués au prochain enregistrement.', UPLOAD: 'Ajouter un fichier', UPLOADING: 'Import sécurisé en cours...', NAME: 'Nom', ROWS: 'Lignes', STATUS: 'Statut', ACTIONS: 'Actions', REPLACE: 'Remplacer', DELETE: 'Détacher', DELETE_TITLE: 'Détacher la source', DELETE_MESSAGE: 'Retirer cette source de la prochaine version ? Les versions précédentes et leurs données restent conservées.', EMPTY: 'Aucune source importée' },
      SHARE: { TITLE: 'Partager', SEARCH: 'Rechercher un administrateur', SEARCH_ACTION: 'Rechercher', CURRENT: 'Accès actuels', ACCESS_LABEL: 'Niveau d’accès de {{name}}', REMOVE: 'Retirer' },
      VERSIONS: { TITLE: 'Versions', RESTORE: 'Restaurer', EMPTY: 'Aucune version', NO_DESCRIPTION: 'Sans description' },
      EXPORT: { TITLE: 'Exporter', FORMAT_PROMPT: 'Vers quel format voulez-vous exporter ?', DESCRIPTION: 'Le backend recalcule et valide les données avant la création locale du fichier.', FORM_NOTICE: 'Formulaire interactif' },
      DELETE: { TITLE: 'Supprimer le report', MESSAGE: 'Cette suppression est définitive. Voulez-vous continuer ?', ACTION: 'Supprimer', COMPONENT_MESSAGE: 'Voulez-vous supprimer ce composant du brouillon ?' },
      UNSAVED: { TITLE: 'Modifications non enregistrées', MESSAGE: 'Enregistrez le report, quittez sans enregistrer ou restez sur cette page.', STAY: 'Rester', DISCARD: 'Quitter sans enregistrer', SAVE: 'Enregistrer et quitter' },
      ACCESSIBILITY: { TABS: 'Onglets du report', DATA_TABLE: 'Données du composant', PAGINATION: 'Pagination', CLOSE: 'Fermer', CROSS_FILTER: 'Filtrer le report avec une valeur du graphique' },
      ENUMS: { ACCESS: { OWNER: 'Propriétaire', EDIT: 'Modification', VIEW: 'Lecture' }, COMPONENT: { CHART: 'Graphique', TABLE: 'Tableau', KPI: 'Indicateur', TEXT: 'Texte', FORM: 'Formulaire' }, CHART: { BAR: 'Barres', LINE: 'Courbe', AREA: 'Aires', PIE: 'Secteurs', DONUT: 'Anneau', SCATTER: 'Nuage de points' }, FILTER: { SELECT: 'Liste', MULTI_SELECT: 'Liste multiple', DATE_RANGE: 'Période', TEXT: 'Texte', NUMBER: 'Nombre' }, FORM: { TEXT: 'Texte', NUMBER: 'Nombre', DATE: 'Date', SELECT: 'Liste', BOOLEAN: 'Oui/Non' }, EXPORT: { RUNTIME: 'Actualisation', PDF: 'PDF', PNG: 'PNG', XLSX: 'XLSX' }, DATASET_STATUS: { READY: 'Prête', INCOMPATIBLE: 'Incompatible', PROCESSING: 'En traitement' } },
      ERRORS: { REPORT_AI_BAD_REQUEST: 'La requête Report IA est invalide.', REPORT_AI_FORBIDDEN: 'Vous n’êtes pas autorisé à effectuer cette action.', REPORT_AI_PERMISSION_REQUIRED: 'La permission Report IA requise est absente.', REPORT_AI_NOT_FOUND: 'Ce report est introuvable ou inaccessible.', REPORT_AI_VERSION_CONFLICT: 'Une version plus récente existe. Rechargez le report avant de réessayer.', REPORT_AI_REVISION_CONFLICT: 'Le composant a changé. La proposition n’a pas été appliquée.', REPORT_AI_DATASET_IN_USE: 'Cette source est encore utilisée par les composants suivants :', REPORT_AI_VALIDATION_FAILED: 'Les données envoyées ne sont pas valides.', REPORT_AI_RATE_LIMITED: 'Trop de demandes. Réessayez dans quelques instants.', REPORT_AI_CANCELLED: 'Ce calcul a été remplacé par une demande plus récente.', REPORT_AI_TIMEOUT: 'Le calcul a dépassé le délai autorisé.', REPORT_AI_INVALID_FILE: 'Le fichier est invalide. Utilisez un CSV ou XLSX conforme aux limites.', REPORT_AI_FILE_TOO_LARGE: 'Le fichier dépasse 25 Mo.', REPORT_AI_EXPORT_TOO_LARGE: 'L’export dépasse le nombre maximal de lignes.', REPORT_AI_SQL_PIPELINE_UNAVAILABLE: 'Le moteur de calcul sécurisé est indisponible.', REPORT_AI_DATABASE_UNAVAILABLE: 'Le stockage Report IA est indisponible.', REPORT_AI_AI_UNAVAILABLE: 'Emye ne peut pas répondre pour le moment.', REPORT_AI_AGENT_INVALID_TOOL_CALL: 'Emye a produit une action invalide.', REPORT_AI_AGENT_INVALID_SQL_OUTPUT: 'Le résultat de vérification des données est invalide.', REPORT_AI_AGENT_INVALID_PATCH_OUTPUT: 'La proposition de modification est invalide.', REPORT_AI_AGENT_INVALID_VISUAL_OUTPUT: 'Le contrôle visuel du report est invalide.', REPORT_AI_AGENT_INVALID_STATE: 'Cette génération ne peut plus être poursuivie.', REPORT_AI_AGENT_RESUME_INVALID_STATE: 'Cette demande de précision a déjà été traitée.', REPORT_AI_AGENT_MODEL_LIMIT: 'Emye a atteint la limite d’étapes autorisée.', REPORT_AI_AGENT_UNKNOWN_TOOL: 'Emye a demandé une action non prise en charge.', REPORT_AI_AGENT_SQL_LIMIT: 'La limite de vérifications des données a été atteinte.', REPORT_AI_AGENT_PATCH_LIMIT: 'La limite de modifications du report a été atteinte.', REPORT_AI_AGENT_VISUAL_LIMIT: 'La limite de contrôles visuels a été atteinte.', REPORT_AI_AGENT_PLAN_REQUIRED: 'Emye n’a pas pu établir un plan valide.', REPORT_AI_AGENT_VISUAL_REVIEW_REQUIRED: 'Le contrôle visuel final n’a pas pu être terminé.', REPORT_AI_MEMORY_UNAVAILABLE: 'La mémoire privée d’Emye est indisponible.', REPORT_AI_MEMORY_LIMIT: 'La mémoire privée d’Emye a atteint sa limite.', REPORT_AI_EXPORT_FAILED: 'L’export n’a pas pu être créé.', REPORT_AI_INTERNAL_ERROR: 'Une erreur est survenue. Réessayez.' },
      // A visual upload failure states that no run started and remains separate from dataset-import feedback.
      TOASTS: { CREATE_SUCCESS: 'Report créé et Version 1 enregistrée.', SAVE_SUCCESS: 'Nouvelle version et aperçu enregistrés.', THUMBNAIL_FAILED: 'L’aperçu du dashboard n’a pas pu être capturé. Le report n’a pas été enregistré.', RENAME_SUCCESS: 'Report renommé et nouvelle version enregistrée.', DUPLICATE_SUCCESS: 'Report dupliqué.', DELETE_SUCCESS: 'Report supprimé.', SHARE_SUCCESS: 'Partage mis à jour.', UPLOAD_SUCCESS: 'Source importée dans le brouillon.', REPLACE_SUCCESS: 'Remplacement ajouté au brouillon.', SOURCE_DETACH_READY: 'Source retirée du brouillon. Enregistrez pour créer la nouvelle version.', VISUAL_REFERENCE_UPLOAD_FAILED: 'La référence visuelle n’a pas pu être importée. Aucun traitement n’a été lancé.', EXPORT_SUCCESS: 'Export créé.', SOURCE_EXPORT_SUCCESS: 'Données sources téléchargées.', RESTORE_SUCCESS: 'Version restaurée.' },
    },
    PROJET: PROJECT,
    CHAT,
    COMMUNITY,
    GENERAL,
    CALENDAR,
    USERDETAILS,
    ONBOARDING,
    QUESTION_REPONSE,
    EVENT,
    FORMATIONS,
    NEWSLETTER,
    SURVEY,
    OSPLANNER,
    IDEA,
    ADMINPARKING,
    TRANSPORT,
    TACHEADMINSTRATIVE,
    DOCUMENT,
    FICHEPOSTE,
    LEAVE,
    DICTIONNAIRE,
    CAREER,
    ...TEMPS,
    ...FORFAIT,
  },
}

Object.assign(locale.data.REPORT_AI.ERRORS, {
  // Companion budget exhaustion stops generation; it is not transient provider throttling.
  REPORT_AI_COMPONENT_ATTEMPT_LIMIT: 'Un ou plusieurs compagnons ont atteint leur nombre maximal de tentatives. La génération est arrêtée ; les résultats non finalisés ne sont pas appliqués au report.',
  REPORT_AI_SWARM_LAUNCH_LIMIT: 'La génération a atteint le nombre maximal de lancements de compagnons. La génération est arrêtée ; les résultats non finalisés ne sont pas appliqués au report.',
  REPORT_AI_AGENT_PLAN_INCOMPLETE: 'Emye n’a pas terminé toutes les étapes du plan.',
  // Credit exhaustion remains actionable and distinct from a temporary AI provider outage.
  REPORT_AI_INSUFFICIENT_CREDITS: 'Le solde de crédits IA est insuffisant pour poursuivre.',
  // Locked edits explain owner-controlled read-only mode without exposing authorization details.
  REPORT_AI_LOCKED: 'Ce dashboard est verrouillé par son propriétaire.',
})

// Owner lock labels remain grouped with the existing workspace and toaster vocabulary.
Object.assign(locale.data.REPORT_AI.WORKSPACE, {
  LOCKED: 'Verrouillé',
  LOCK_REPORT: 'Verrouiller le dashboard',
  UNLOCK_REPORT: 'Déverrouiller le dashboard',
  DUPLICATE_REPORT: 'Dupliquer le dashboard',
})
Object.assign(locale.data.REPORT_AI.TOASTS, {
  LOCK_SUCCESS: 'Le dashboard est verrouillé.',
  UNLOCK_SUCCESS: 'Le dashboard est déverrouillé.',
})
